"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

var React = require("react"),
    React__default = _interopDefault(React);

function _defineProperty(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _objectSpread(n) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {},
        t = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), t.forEach(function (e) {
      _defineProperty(n, e, r[e]);
    });
  }

  return n;
}

function _slicedToArray(e, n) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, n) || _nonIterableRest();
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var n = 0, r = new Array(e.length); n < e.length; n++) {
      r[n] = e[n];
    }

    return r;
  }
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

function _iterableToArrayLimit(e, n) {
  var r = [],
      t = !0,
      a = !1,
      i = void 0;

  try {
    for (var A, o = e[Symbol.iterator](); !(t = (A = o.next()).done) && (r.push(A.value), !n || r.length !== n); t = !0) {
      ;
    }
  } catch (e) {
    a = !0, i = e;
  } finally {
    try {
      t || null == o.return || o.return();
    } finally {
      if (a) throw i;
    }
  }

  return r;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function createCommonjsModule(e, n) {
  return e(n = {
    exports: {}
  }, n.exports), n.exports;
}

var html2canvas = createCommonjsModule(function (module, exports) {
  var N;
  window, N = function N() {
    return (O = {
      "./node_modules/css-line-break/dist/LineBreak.js": function node_modulesCssLineBreakDistLineBreakJs(module, exports, __webpack_require__) {
        eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n    value: true\n});\nexports.LineBreaker = exports.inlineBreakOpportunities = exports.lineBreakAtIndex = exports.codePointsToCharacterClasses = exports.UnicodeTrie = exports.BREAK_ALLOWED = exports.BREAK_NOT_ALLOWED = exports.BREAK_MANDATORY = exports.classes = exports.LETTER_NUMBER_MODIFIER = undefined;\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"]) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); } }; }();\n\nvar _Trie = __webpack_require__(/*! ./Trie */ \"./node_modules/css-line-break/dist/Trie.js\");\n\nvar _linebreakTrie = __webpack_require__(/*! ./linebreak-trie */ \"./node_modules/css-line-break/dist/linebreak-trie.js\");\n\nvar _linebreakTrie2 = _interopRequireDefault(_linebreakTrie);\n\nvar _Util = __webpack_require__(/*! ./Util */ \"./node_modules/css-line-break/dist/Util.js\");\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nfunction _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nvar LETTER_NUMBER_MODIFIER = exports.LETTER_NUMBER_MODIFIER = 50;\n\n// Non-tailorable Line Breaking Classes\nvar BK = 1; //  Cause a line break (after)\nvar CR = 2; //  Cause a line break (after), except between CR and LF\nvar LF = 3; //  Cause a line break (after)\nvar CM = 4; //  Prohibit a line break between the character and the preceding character\nvar NL = 5; //  Cause a line break (after)\nvar SG = 6; //  Do not occur in well-formed text\nvar WJ = 7; //  Prohibit line breaks before and after\nvar ZW = 8; //  Provide a break opportunity\nvar GL = 9; //  Prohibit line breaks before and after\nvar SP = 10; // Enable indirect line breaks\nvar ZWJ = 11; // Prohibit line breaks within joiner sequences\n// Break Opportunities\nvar B2 = 12; //  Provide a line break opportunity before and after the character\nvar BA = 13; //  Generally provide a line break opportunity after the character\nvar BB = 14; //  Generally provide a line break opportunity before the character\nvar HY = 15; //  Provide a line break opportunity after the character, except in numeric context\nvar CB = 16; //   Provide a line break opportunity contingent on additional information\n// Characters Prohibiting Certain Breaks\nvar CL = 17; //  Prohibit line breaks before\nvar CP = 18; //  Prohibit line breaks before\nvar EX = 19; //  Prohibit line breaks before\nvar IN = 20; //  Allow only indirect line breaks between pairs\nvar NS = 21; //  Allow only indirect line breaks before\nvar OP = 22; //  Prohibit line breaks after\nvar QU = 23; //  Act like they are both opening and closing\n// Numeric Context\nvar IS = 24; //  Prevent breaks after any and before numeric\nvar NU = 25; //  Form numeric expressions for line breaking purposes\nvar PO = 26; //  Do not break following a numeric expression\nvar PR = 27; //  Do not break in front of a numeric expression\nvar SY = 28; //  Prevent a break before; and allow a break after\n// Other Characters\nvar AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID\nvar AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters\nvar CJ = 31; //  Treat as NS or ID for strict or normal breaking.\nvar EB = 32; //  Do not break from following Emoji Modifier\nvar EM = 33; //  Do not break from preceding Emoji Base\nvar H2 = 34; //  Form Korean syllable blocks\nvar H3 = 35; //  Form Korean syllable blocks\nvar HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic\nvar ID = 37; //  Break before or after; except in some numeric context\nvar JL = 38; //  Form Korean syllable blocks\nvar JV = 39; //  Form Korean syllable blocks\nvar JT = 40; //  Form Korean syllable blocks\nvar RI = 41; //  Keep pairs together. For pairs; break before and after other classes\nvar SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis\nvar XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions\n\nvar classes = exports.classes = {\n    BK: BK,\n    CR: CR,\n    LF: LF,\n    CM: CM,\n    NL: NL,\n    SG: SG,\n    WJ: WJ,\n    ZW: ZW,\n    GL: GL,\n    SP: SP,\n    ZWJ: ZWJ,\n    B2: B2,\n    BA: BA,\n    BB: BB,\n    HY: HY,\n    CB: CB,\n    CL: CL,\n    CP: CP,\n    EX: EX,\n    IN: IN,\n    NS: NS,\n    OP: OP,\n    QU: QU,\n    IS: IS,\n    NU: NU,\n    PO: PO,\n    PR: PR,\n    SY: SY,\n    AI: AI,\n    AL: AL,\n    CJ: CJ,\n    EB: EB,\n    EM: EM,\n    H2: H2,\n    H3: H3,\n    HL: HL,\n    ID: ID,\n    JL: JL,\n    JV: JV,\n    JT: JT,\n    RI: RI,\n    SA: SA,\n    XX: XX\n};\n\nvar BREAK_MANDATORY = exports.BREAK_MANDATORY = '!';\nvar BREAK_NOT_ALLOWED = exports.BREAK_NOT_ALLOWED = '×';\nvar BREAK_ALLOWED = exports.BREAK_ALLOWED = '÷';\nvar UnicodeTrie = exports.UnicodeTrie = (0, _Trie.createTrieFromBase64)(_linebreakTrie2.default);\n\nvar ALPHABETICS = [AL, HL];\nvar HARD_LINE_BREAKS = [BK, CR, LF, NL];\nvar SPACE = [SP, ZW];\nvar PREFIX_POSTFIX = [PR, PO];\nvar LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);\nvar KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];\nvar HYPHEN = [HY, BA];\n\nvar codePointsToCharacterClasses = exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {\n    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';\n\n    var types = [];\n    var indicies = [];\n    var categories = [];\n    codePoints.forEach(function (codePoint, index) {\n        var classType = UnicodeTrie.get(codePoint);\n        if (classType > LETTER_NUMBER_MODIFIER) {\n            categories.push(true);\n            classType -= LETTER_NUMBER_MODIFIER;\n        } else {\n            categories.push(false);\n        }\n\n        if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {\n            // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0\n            if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {\n                indicies.push(index);\n                return types.push(CB);\n            }\n        }\n\n        if (classType === CM || classType === ZWJ) {\n            // LB10 Treat any remaining combining mark or ZWJ as AL.\n            if (index === 0) {\n                indicies.push(index);\n                return types.push(AL);\n            }\n\n            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of\n            // the base character in all of the following rules. Treat ZWJ as if it were CM.\n            var prev = types[index - 1];\n            if (LINE_BREAKS.indexOf(prev) === -1) {\n                indicies.push(indicies[index - 1]);\n                return types.push(prev);\n            }\n            indicies.push(index);\n            return types.push(AL);\n        }\n\n        indicies.push(index);\n\n        if (classType === CJ) {\n            return types.push(lineBreak === 'strict' ? NS : ID);\n        }\n\n        if (classType === SA) {\n            return types.push(AL);\n        }\n\n        if (classType === AI) {\n            return types.push(AL);\n        }\n\n        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL\n        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised\n        // to take into account the actual line breaking properties for these characters.\n        if (classType === XX) {\n            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {\n                return types.push(ID);\n            } else {\n                return types.push(AL);\n            }\n        }\n\n        types.push(classType);\n    });\n\n    return [indicies, types, categories];\n};\n\nvar isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {\n    var current = classTypes[currentIndex];\n    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {\n        var i = currentIndex;\n        while (i <= classTypes.length) {\n            i++;\n            var next = classTypes[i];\n\n            if (next === b) {\n                return true;\n            }\n\n            if (next !== SP) {\n                break;\n            }\n        }\n    }\n\n    if (current === SP) {\n        var _i = currentIndex;\n\n        while (_i > 0) {\n            _i--;\n            var prev = classTypes[_i];\n\n            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {\n                var n = currentIndex;\n                while (n <= classTypes.length) {\n                    n++;\n                    var _next = classTypes[n];\n\n                    if (_next === b) {\n                        return true;\n                    }\n\n                    if (_next !== SP) {\n                        break;\n                    }\n                }\n            }\n\n            if (prev !== SP) {\n                break;\n            }\n        }\n    }\n    return false;\n};\n\nvar previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {\n    var i = currentIndex;\n    while (i >= 0) {\n        var type = classTypes[i];\n        if (type === SP) {\n            i--;\n        } else {\n            return type;\n        }\n    }\n    return 0;\n};\n\nvar _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {\n    if (indicies[index] === 0) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    var currentIndex = index - 1;\n    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    var beforeIndex = currentIndex - 1;\n    var afterIndex = currentIndex + 1;\n    var current = classTypes[currentIndex];\n\n    // LB4 Always break after hard line breaks.\n    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.\n    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;\n    var next = classTypes[afterIndex];\n\n    if (current === CR && next === LF) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {\n        return BREAK_MANDATORY;\n    }\n\n    // LB6 Do not break before hard line breaks.\n    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB7 Do not break before spaces or zero width space.\n    if (SPACE.indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.\n    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {\n        return BREAK_ALLOWED;\n    }\n\n    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.\n    if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB11 Do not break before or after Word joiner and related characters.\n    if (current === WJ || next === WJ) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB12 Do not break after NBSP and related characters.\n    if (current === GL) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.\n    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.\n    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB14 Do not break after ‘[’, even after spaces.\n    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB15 Do not break within ‘”[’, even with intervening spaces.\n    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.\n    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB17 Do not break within ‘——’, even with intervening spaces.\n    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB18 Break after spaces.\n    if (current === SP) {\n        return BREAK_ALLOWED;\n    }\n\n    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.\n    if (current === QU || next === QU) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB20 Break before and after unresolved CB.\n    if (next === CB || current === CB) {\n        return BREAK_ALLOWED;\n    }\n\n    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.\n    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB21a Don't break after Hebrew + Hyphen.\n    if (before === HL && HYPHEN.indexOf(current) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB21b Don’t break between Solidus and Hebrew letters.\n    if (current === SY && next === HL) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.\n    if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB23 Do not break between digits and letters.\n    if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.\n    if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.\n    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB25 Do not break between the following pairs of classes relevant to numbers:\n    if (\n    // (PR | PO) × ( OP | HY )? NU\n    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||\n    // ( OP | HY ) × NU\n    [OP, HY].indexOf(current) !== -1 && next === NU ||\n    // NU ×\t(NU | SY | IS)\n    current === NU && [NU, SY, IS].indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)\n    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {\n        var prevIndex = currentIndex;\n        while (prevIndex >= 0) {\n            var type = classTypes[prevIndex];\n            if (type === NU) {\n                return BREAK_NOT_ALLOWED;\n            } else if ([SY, IS].indexOf(type) !== -1) {\n                prevIndex--;\n            } else {\n                break;\n            }\n        }\n    }\n\n    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))\n    if ([PR, PO].indexOf(next) !== -1) {\n        var _prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;\n        while (_prevIndex >= 0) {\n            var _type = classTypes[_prevIndex];\n            if (_type === NU) {\n                return BREAK_NOT_ALLOWED;\n            } else if ([SY, IS].indexOf(_type) !== -1) {\n                _prevIndex--;\n            } else {\n                break;\n            }\n        }\n    }\n\n    // LB26 Do not break a Korean syllable.\n    if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB27 Treat a Korean Syllable Block the same as ID.\n    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB28 Do not break between alphabetics (“at”).\n    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).\n    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.\n    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional\n    // indicators preceding the position of the break.\n    if (current === RI && next === RI) {\n        var i = indicies[currentIndex];\n        var count = 1;\n        while (i > 0) {\n            i--;\n            if (classTypes[i] === RI) {\n                count++;\n            } else {\n                break;\n            }\n        }\n        if (count % 2 !== 0) {\n            return BREAK_NOT_ALLOWED;\n        }\n    }\n\n    // LB30b Do not break between an emoji base and an emoji modifier.\n    if (current === EB && next === EM) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    return BREAK_ALLOWED;\n};\n\nvar lineBreakAtIndex = exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {\n    // LB2 Never break at the start of text.\n    if (index === 0) {\n        return BREAK_NOT_ALLOWED;\n    }\n\n    // LB3 Always break at the end of text.\n    if (index >= codePoints.length) {\n        return BREAK_MANDATORY;\n    }\n\n    var _codePointsToCharacte = codePointsToCharacterClasses(codePoints),\n        _codePointsToCharacte2 = _slicedToArray(_codePointsToCharacte, 2),\n        indicies = _codePointsToCharacte2[0],\n        classTypes = _codePointsToCharacte2[1];\n\n    return _lineBreakAtIndex(codePoints, classTypes, indicies, index);\n};\n\nvar cssFormattedClasses = function cssFormattedClasses(codePoints, options) {\n    if (!options) {\n        options = { lineBreak: 'normal', wordBreak: 'normal' };\n    }\n\n    var _codePointsToCharacte3 = codePointsToCharacterClasses(codePoints, options.lineBreak),\n        _codePointsToCharacte4 = _slicedToArray(_codePointsToCharacte3, 3),\n        indicies = _codePointsToCharacte4[0],\n        classTypes = _codePointsToCharacte4[1],\n        isLetterNumber = _codePointsToCharacte4[2];\n\n    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {\n        classTypes = classTypes.map(function (type) {\n            return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;\n        });\n    }\n\n    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (isLetterNumber, i) {\n        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;\n    }) : null;\n\n    return [indicies, classTypes, forbiddenBreakpoints];\n};\n\nvar inlineBreakOpportunities = exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {\n    var codePoints = (0, _Util.toCodePoints)(str);\n    var output = BREAK_NOT_ALLOWED;\n\n    var _cssFormattedClasses = cssFormattedClasses(codePoints, options),\n        _cssFormattedClasses2 = _slicedToArray(_cssFormattedClasses, 3),\n        indicies = _cssFormattedClasses2[0],\n        classTypes = _cssFormattedClasses2[1],\n        forbiddenBreakpoints = _cssFormattedClasses2[2];\n\n    codePoints.forEach(function (codePoint, i) {\n        output += (0, _Util.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? BREAK_MANDATORY : _lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));\n    });\n\n    return output;\n};\n\nvar Break = function () {\n    function Break(codePoints, lineBreak, start, end) {\n        _classCallCheck(this, Break);\n\n        this._codePoints = codePoints;\n        this.required = lineBreak === BREAK_MANDATORY;\n        this.start = start;\n        this.end = end;\n    }\n\n    _createClass(Break, [{\n        key: 'slice',\n        value: function slice() {\n            return _Util.fromCodePoint.apply(undefined, _toConsumableArray(this._codePoints.slice(this.start, this.end)));\n        }\n    }]);\n\n    return Break;\n}();\n\nvar LineBreaker = exports.LineBreaker = function LineBreaker(str, options) {\n    var codePoints = (0, _Util.toCodePoints)(str);\n\n    var _cssFormattedClasses3 = cssFormattedClasses(codePoints, options),\n        _cssFormattedClasses4 = _slicedToArray(_cssFormattedClasses3, 3),\n        indicies = _cssFormattedClasses4[0],\n        classTypes = _cssFormattedClasses4[1],\n        forbiddenBreakpoints = _cssFormattedClasses4[2];\n\n    var length = codePoints.length;\n    var lastEnd = 0;\n    var nextIndex = 0;\n\n    return {\n        next: function next() {\n            if (nextIndex >= length) {\n                return { done: true };\n            }\n            var lineBreak = BREAK_NOT_ALLOWED;\n            while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED) {}\n\n            if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {\n                var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);\n                lastEnd = nextIndex;\n                return { value: value, done: false };\n            }\n\n            return { done: true };\n        }\n    };\n};\n\n//# sourceURL=webpack://html2canvas/./node_modules/css-line-break/dist/LineBreak.js?");
      },
      "./node_modules/css-line-break/dist/Trie.js": function node_modulesCssLineBreakDistTrieJs(module, exports, __webpack_require__) {
        eval('\n\nObject.defineProperty(exports, "__esModule", {\n    value: true\n});\nexports.Trie = exports.createTrieFromBase64 = exports.UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_DATA_MASK = exports.UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_SHIFT_1_2 = exports.UTRIE2_INDEX_SHIFT = exports.UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_2 = undefined;\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _Util = __webpack_require__(/*! ./Util */ "./node_modules/css-line-break/dist/Util.js");\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\n/** Shift size for getting the index-2 table offset. */\nvar UTRIE2_SHIFT_2 = exports.UTRIE2_SHIFT_2 = 5;\n\n/** Shift size for getting the index-1 table offset. */\nvar UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_1 = 6 + 5;\n\n/**\n * Shift size for shifting left the index array values.\n * Increases possible data size with 16-bit index values at the cost\n * of compactability.\n * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.\n */\nvar UTRIE2_INDEX_SHIFT = exports.UTRIE2_INDEX_SHIFT = 2;\n\n/**\n * Difference between the two shift sizes,\n * for getting an index-1 offset from an index-2 offset. 6=11-5\n */\nvar UTRIE2_SHIFT_1_2 = exports.UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;\n\n/**\n * The part of the index-2 table for U+D800..U+DBFF stores values for\n * lead surrogate code _units_ not code _points_.\n * Values for lead surrogate code _points_ are indexed with this portion of the table.\n * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)\n */\nvar UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;\n\n/** Number of entries in a data block. 32=0x20 */\nvar UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;\n/** Mask for getting the lower bits for the in-data-block offset. */\nvar UTRIE2_DATA_MASK = exports.UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;\n\nvar UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;\n/** Count the lengths of both BMP pieces. 2080=0x820 */\nvar UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;\n/**\n * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.\n * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.\n */\nvar UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;\nvar UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */\n/**\n * The index-1 table, only used for supplementary code points, at offset 2112=0x840.\n * Variable length, for code points up to highStart, where the last single-value range starts.\n * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.\n * (For 0x100000 supplementary code points U+10000..U+10ffff.)\n *\n * The part of the index-2 table for supplementary code points starts\n * after this index-1 table.\n *\n * Both the index-1 table and the following part of the index-2 table\n * are omitted completely if there is only BMP data.\n */\nvar UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;\n\n/**\n * Number of index-1 entries for the BMP. 32=0x20\n * This part of the index-1 table is omitted from the serialized form.\n */\nvar UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;\n\n/** Number of entries in an index-2 block. 64=0x40 */\nvar UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;\n/** Mask for getting the lower bits for the in-index-2-block offset. */\nvar UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;\n\nvar createTrieFromBase64 = exports.createTrieFromBase64 = function createTrieFromBase64(base64) {\n    var buffer = (0, _Util.decode)(base64);\n    var view32 = Array.isArray(buffer) ? (0, _Util.polyUint32Array)(buffer) : new Uint32Array(buffer);\n    var view16 = Array.isArray(buffer) ? (0, _Util.polyUint16Array)(buffer) : new Uint16Array(buffer);\n    var headerLength = 24;\n\n    var index = view16.slice(headerLength / 2, view32[4] / 2);\n    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));\n\n    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);\n};\n\nvar Trie = exports.Trie = function () {\n    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {\n        _classCallCheck(this, Trie);\n\n        this.initialValue = initialValue;\n        this.errorValue = errorValue;\n        this.highStart = highStart;\n        this.highValueIndex = highValueIndex;\n        this.index = index;\n        this.data = data;\n    }\n\n    /**\n     * Get the value for a code point as stored in the Trie.\n     *\n     * @param codePoint the code point\n     * @return the value\n     */\n\n\n    _createClass(Trie, [{\n        key: \'get\',\n        value: function get(codePoint) {\n            var ix = void 0;\n            if (codePoint >= 0) {\n                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {\n                    // Ordinary BMP code point, excluding leading surrogates.\n                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.\n                    // 16 bit data is stored in the index array itself.\n                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];\n                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);\n                    return this.data[ix];\n                }\n\n                if (codePoint <= 0xffff) {\n                    // Lead Surrogate Code Point.  A Separate index section is stored for\n                    // lead surrogate code units and code points.\n                    //   The main index has the code unit data.\n                    //   For this function, we need the code point data.\n                    // Note: this expression could be refactored for slightly improved efficiency, but\n                    //       surrogate code points will be so rare in practice that it\'s not worth it.\n                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];\n                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);\n                    return this.data[ix];\n                }\n\n                if (codePoint < this.highStart) {\n                    // Supplemental code point, use two-level lookup.\n                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);\n                    ix = this.index[ix];\n                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;\n                    ix = this.index[ix];\n                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);\n                    return this.data[ix];\n                }\n                if (codePoint <= 0x10ffff) {\n                    return this.data[this.highValueIndex];\n                }\n            }\n\n            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.\n            return this.errorValue;\n        }\n    }]);\n\n    return Trie;\n}();\n\n//# sourceURL=webpack://html2canvas/./node_modules/css-line-break/dist/Trie.js?');
      },
      "./node_modules/css-line-break/dist/Util.js": function node_modulesCssLineBreakDistUtilJs(module, exports, __webpack_require__) {
        eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n    value: true\n});\nvar toCodePoints = exports.toCodePoints = function toCodePoints(str) {\n    var codePoints = [];\n    var i = 0;\n    var length = str.length;\n    while (i < length) {\n        var value = str.charCodeAt(i++);\n        if (value >= 0xd800 && value <= 0xdbff && i < length) {\n            var extra = str.charCodeAt(i++);\n            if ((extra & 0xfc00) === 0xdc00) {\n                codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);\n            } else {\n                codePoints.push(value);\n                i--;\n            }\n        } else {\n            codePoints.push(value);\n        }\n    }\n    return codePoints;\n};\n\nvar fromCodePoint = exports.fromCodePoint = function fromCodePoint() {\n    if (String.fromCodePoint) {\n        return String.fromCodePoint.apply(String, arguments);\n    }\n\n    var length = arguments.length;\n    if (!length) {\n        return '';\n    }\n\n    var codeUnits = [];\n\n    var index = -1;\n    var result = '';\n    while (++index < length) {\n        var codePoint = arguments.length <= index ? undefined : arguments[index];\n        if (codePoint <= 0xffff) {\n            codeUnits.push(codePoint);\n        } else {\n            codePoint -= 0x10000;\n            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);\n        }\n        if (index + 1 === length || codeUnits.length > 0x4000) {\n            result += String.fromCharCode.apply(String, codeUnits);\n            codeUnits.length = 0;\n        }\n    }\n    return result;\n};\n\nvar chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';\n\n// Use a lookup table to find the index.\nvar lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);\nfor (var i = 0; i < chars.length; i++) {\n    lookup[chars.charCodeAt(i)] = i;\n}\n\nvar decode = exports.decode = function decode(base64) {\n    var bufferLength = base64.length * 0.75,\n        len = base64.length,\n        i = void 0,\n        p = 0,\n        encoded1 = void 0,\n        encoded2 = void 0,\n        encoded3 = void 0,\n        encoded4 = void 0;\n\n    if (base64[base64.length - 1] === '=') {\n        bufferLength--;\n        if (base64[base64.length - 2] === '=') {\n            bufferLength--;\n        }\n    }\n\n    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);\n    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);\n\n    for (i = 0; i < len; i += 4) {\n        encoded1 = lookup[base64.charCodeAt(i)];\n        encoded2 = lookup[base64.charCodeAt(i + 1)];\n        encoded3 = lookup[base64.charCodeAt(i + 2)];\n        encoded4 = lookup[base64.charCodeAt(i + 3)];\n\n        bytes[p++] = encoded1 << 2 | encoded2 >> 4;\n        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;\n        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;\n    }\n\n    return buffer;\n};\n\nvar polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {\n    var length = buffer.length;\n    var bytes = [];\n    for (var _i = 0; _i < length; _i += 2) {\n        bytes.push(buffer[_i + 1] << 8 | buffer[_i]);\n    }\n    return bytes;\n};\n\nvar polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {\n    var length = buffer.length;\n    var bytes = [];\n    for (var _i2 = 0; _i2 < length; _i2 += 4) {\n        bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);\n    }\n    return bytes;\n};\n\n//# sourceURL=webpack://html2canvas/./node_modules/css-line-break/dist/Util.js?");
      },
      "./node_modules/css-line-break/dist/index.js": function node_modulesCssLineBreakDistIndexJs(module, exports, __webpack_require__) {
        eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _Util = __webpack_require__(/*! ./Util */ \"./node_modules/css-line-break/dist/Util.js\");\n\nObject.defineProperty(exports, 'toCodePoints', {\n  enumerable: true,\n  get: function get() {\n    return _Util.toCodePoints;\n  }\n});\nObject.defineProperty(exports, 'fromCodePoint', {\n  enumerable: true,\n  get: function get() {\n    return _Util.fromCodePoint;\n  }\n});\n\nvar _LineBreak = __webpack_require__(/*! ./LineBreak */ \"./node_modules/css-line-break/dist/LineBreak.js\");\n\nObject.defineProperty(exports, 'LineBreaker', {\n  enumerable: true,\n  get: function get() {\n    return _LineBreak.LineBreaker;\n  }\n});\n\n//# sourceURL=webpack://html2canvas/./node_modules/css-line-break/dist/index.js?");
      },
      "./node_modules/css-line-break/dist/linebreak-trie.js": function node_modulesCssLineBreakDistLinebreakTrieJs(module, exports, __webpack_require__) {
        eval("\n\nmodule.exports = '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';\n\n//# sourceURL=webpack://html2canvas/./node_modules/css-line-break/dist/linebreak-trie.js?");
      },
      "./src/Angle.js": function srcAngleJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseAngle\", function() { return parseAngle; });\n\n\nvar ANGLE = /([+-]?\\d*\\.?\\d+)(deg|grad|rad|turn)/i;\nvar parseAngle = function parseAngle(angle) {\n  var match = angle.match(ANGLE);\n\n  if (match) {\n    var value = parseFloat(match[1]);\n\n    switch (match[2].toLowerCase()) {\n      case 'deg':\n        return Math.PI * value / 180;\n\n      case 'grad':\n        return Math.PI / 200 * value;\n\n      case 'rad':\n        return value;\n\n      case 'turn':\n        return Math.PI * 2 * value;\n    }\n  }\n\n  return null;\n};\n\n//# sourceURL=webpack://html2canvas/./src/Angle.js?");
      },
      "./src/Bounds.js": function srcBoundsJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bounds", function() { return Bounds; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBounds", function() { return parseBounds; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculatePaddingBox", function() { return calculatePaddingBox; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateContentBox", function() { return calculateContentBox; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseDocumentSize", function() { return parseDocumentSize; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePathForBorder", function() { return parsePathForBorder; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBorderBoxPath", function() { return calculateBorderBoxPath; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculatePaddingBoxPath", function() { return calculatePaddingBoxPath; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBoundCurves", function() { return parseBoundCurves; });\n/* harmony import */ var _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./drawing/Vector */ "./src/drawing/Vector.js");\n/* harmony import */ var _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./drawing/BezierCurve */ "./src/drawing/BezierCurve.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\nvar TOP = 0;\nvar RIGHT = 1;\nvar BOTTOM = 2;\nvar LEFT = 3;\nvar H = 0;\nvar V = 1;\nvar Bounds =\n/*#__PURE__*/\nfunction () {\n  function Bounds(x, y, w, h) {\n    _classCallCheck(this, Bounds);\n\n    this.left = x;\n    this.top = y;\n    this.width = w;\n    this.height = h;\n  }\n\n  _createClass(Bounds, null, [{\n    key: "fromClientRect",\n    value: function fromClientRect(clientRect, scrollX, scrollY) {\n      return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);\n    }\n  }]);\n\n  return Bounds;\n}();\nvar parseBounds = function parseBounds(node, scrollX, scrollY) {\n  return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);\n};\nvar calculatePaddingBox = function calculatePaddingBox(bounds, borders) {\n  return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));\n};\nvar calculateContentBox = function calculateContentBox(bounds, padding, borders) {\n  // TODO support percentage paddings\n  var paddingTop = padding[TOP].value;\n  var paddingRight = padding[RIGHT].value;\n  var paddingBottom = padding[BOTTOM].value;\n  var paddingLeft = padding[LEFT].value;\n  return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));\n};\nvar parseDocumentSize = function parseDocumentSize(document) {\n  var body = document.body;\n  var documentElement = document.documentElement;\n\n  if (!body || !documentElement) {\n    throw new Error( true ? "Unable to get document size" : undefined);\n  }\n\n  var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));\n  var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));\n  return new Bounds(0, 0, width, height);\n};\nvar parsePathForBorder = function parsePathForBorder(curves, borderSide) {\n  switch (borderSide) {\n    case TOP:\n      return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);\n\n    case RIGHT:\n      return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);\n\n    case BOTTOM:\n      return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);\n\n    case LEFT:\n    default:\n      return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);\n  }\n};\n\nvar createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {\n  var path = [];\n\n  if (outer1 instanceof _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"]) {\n    path.push(outer1.subdivide(0.5, false));\n  } else {\n    path.push(outer1);\n  }\n\n  if (outer2 instanceof _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"]) {\n    path.push(outer2.subdivide(0.5, true));\n  } else {\n    path.push(outer2);\n  }\n\n  if (inner2 instanceof _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"]) {\n    path.push(inner2.subdivide(0.5, true).reverse());\n  } else {\n    path.push(inner2);\n  }\n\n  if (inner1 instanceof _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"]) {\n    path.push(inner1.subdivide(0.5, false).reverse());\n  } else {\n    path.push(inner1);\n  }\n\n  return path;\n};\n\nvar calculateBorderBoxPath = function calculateBorderBoxPath(curves) {\n  return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];\n};\nvar calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {\n  return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];\n};\nvar parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {\n  var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width);\n  var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height);\n  var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width);\n  var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height);\n  var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width);\n  var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height);\n  var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width);\n  var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height);\n  var factors = [];\n  factors.push((tlh + trh) / bounds.width);\n  factors.push((blh + brh) / bounds.width);\n  factors.push((tlv + blv) / bounds.height);\n  factors.push((trv + brv) / bounds.height);\n  var maxFactor = Math.max.apply(Math, factors);\n\n  if (maxFactor > 1) {\n    tlh /= maxFactor;\n    tlv /= maxFactor;\n    trh /= maxFactor;\n    trv /= maxFactor;\n    brh /= maxFactor;\n    brv /= maxFactor;\n    blh /= maxFactor;\n    blv /= maxFactor;\n  }\n\n  var topWidth = bounds.width - trh;\n  var rightHeight = bounds.height - brv;\n  var bottomWidth = bounds.width - brh;\n  var leftHeight = bounds.height - blv;\n  return {\n    topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left, bounds.top),\n    topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),\n    topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left + bounds.width, bounds.top),\n    topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),\n    bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left + bounds.width, bounds.top + bounds.height),\n    bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),\n    bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left, bounds.top + bounds.height),\n    bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)\n  };\n};\nvar CORNER = {\n  TOP_LEFT: 0,\n  TOP_RIGHT: 1,\n  BOTTOM_RIGHT: 2,\n  BOTTOM_LEFT: 3\n};\n\nvar getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {\n  var kappa = 4 * ((Math.sqrt(2) - 1) / 3);\n  var ox = r1 * kappa; // control point offset horizontal\n\n  var oy = r2 * kappa; // control point offset vertical\n\n  var xm = x + r1; // x-middle\n\n  var ym = y + r2; // y-middle\n\n  switch (position) {\n    case CORNER.TOP_LEFT:\n      return new _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"](new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x, ym), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x, ym - oy), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm - ox, y), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm, y));\n\n    case CORNER.TOP_RIGHT:\n      return new _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"](new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x, y), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x + ox, y), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm, ym - oy), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm, ym));\n\n    case CORNER.BOTTOM_RIGHT:\n      return new _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"](new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm, y), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm, y + oy), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x + ox, ym), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x, ym));\n\n    case CORNER.BOTTOM_LEFT:\n    default:\n      return new _drawing_BezierCurve__WEBPACK_IMPORTED_MODULE_1__["default"](new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm, ym), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](xm - ox, ym), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x, y + oy), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_0__["default"](x, y));\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/Bounds.js?');
      },
      "./src/Clone.js": function srcCloneJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DocumentCloner", function() { return DocumentCloner; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneWindow", function() { return cloneWindow; });\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Bounds */ "./src/Bounds.js");\n/* harmony import */ var _Proxy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Proxy */ "./src/Proxy.js");\n/* harmony import */ var _ResourceLoader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ResourceLoader */ "./src/ResourceLoader.js");\n/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Util */ "./src/Util.js");\n/* harmony import */ var _parsing_background__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./parsing/background */ "./src/parsing/background.js");\n/* harmony import */ var _renderer_CanvasRenderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./renderer/CanvasRenderer */ "./src/renderer/CanvasRenderer.js");\n/* harmony import */ var _PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./PseudoNodeContent */ "./src/PseudoNodeContent.js");\n\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\n\n\n\n\nvar IGNORE_ATTRIBUTE = \'data-html2canvas-ignore\';\nvar DocumentCloner =\n/*#__PURE__*/\nfunction () {\n  function DocumentCloner(element, options, logger, copyInline, renderer) {\n    _classCallCheck(this, DocumentCloner);\n\n    this.referenceElement = element;\n    this.scrolledElements = [];\n    this.copyStyles = copyInline;\n    this.inlineImages = copyInline;\n    this.logger = logger;\n    this.options = options;\n    this.renderer = renderer;\n    this.resourceLoader = new _ResourceLoader__WEBPACK_IMPORTED_MODULE_2__["default"](options, logger, window);\n    this.pseudoContentData = {\n      counters: {},\n      quoteDepth: 0\n    }; // $FlowFixMe\n\n    this.documentElement = this.cloneNode(element.ownerDocument.documentElement);\n  }\n\n  _createClass(DocumentCloner, [{\n    key: "inlineAllImages",\n    value: function inlineAllImages(node) {\n      var _this = this;\n\n      if (this.inlineImages && node) {\n        var style = node.style;\n        Promise.all(Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["parseBackgroundImage"])(style.backgroundImage).map(function (backgroundImage) {\n          if (backgroundImage.method === \'url\') {\n            return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {\n              return img && typeof img.src === \'string\' ? "url(\\"".concat(img.src, "\\")") : \'none\';\n            }).catch(function (e) {\n              if (true) {\n                _this.logger.log("Unable to load image", e);\n              }\n            });\n          }\n\n          return Promise.resolve("".concat(backgroundImage.prefix).concat(backgroundImage.method, "(").concat(backgroundImage.args.join(\',\'), ")"));\n        })).then(function (backgroundImages) {\n          if (backgroundImages.length > 1) {\n            // TODO Multiple backgrounds somehow broken in Chrome\n            style.backgroundColor = \'\';\n          }\n\n          style.backgroundImage = backgroundImages.join(\',\');\n        });\n\n        if (node instanceof HTMLImageElement) {\n          this.resourceLoader.inlineImage(node.src).then(function (img) {\n            if (img && node instanceof HTMLImageElement && node.parentNode) {\n              var parentNode = node.parentNode;\n              var clonedChild = Object(_Util__WEBPACK_IMPORTED_MODULE_3__["copyCSSStyles"])(node.style, img.cloneNode(false));\n              parentNode.replaceChild(clonedChild, node);\n            }\n          }).catch(function (e) {\n            if (true) {\n              _this.logger.log("Unable to load image", e);\n            }\n          });\n        }\n      }\n    }\n  }, {\n    key: "inlineFonts",\n    value: function inlineFonts(document) {\n      var _this2 = this;\n\n      return Promise.all(Array.from(document.styleSheets).map(function (sheet) {\n        if (sheet.href) {\n          return fetch(sheet.href).then(function (res) {\n            return res.text();\n          }).then(function (text) {\n            return createStyleSheetFontsFromText(text, sheet.href);\n          }).catch(function (e) {\n            if (true) {\n              _this2.logger.log("Unable to load stylesheet", e);\n            }\n\n            return [];\n          });\n        }\n\n        return getSheetFonts(sheet, document);\n      })).then(function (fonts) {\n        return fonts.reduce(function (acc, font) {\n          return acc.concat(font);\n        }, []);\n      }).then(function (fonts) {\n        return Promise.all(fonts.map(function (font) {\n          return fetch(font.formats[0].src).then(function (response) {\n            return response.blob();\n          }).then(function (blob) {\n            return new Promise(function (resolve, reject) {\n              var reader = new FileReader();\n              reader.onerror = reject;\n\n              reader.onload = function () {\n                // $FlowFixMe\n                var result = reader.result;\n                resolve(result);\n              };\n\n              reader.readAsDataURL(blob);\n            });\n          }).then(function (dataUri) {\n            font.fontFace.setProperty(\'src\', "url(\\"".concat(dataUri, "\\")"));\n            return "@font-face {".concat(font.fontFace.cssText, " ");\n          });\n        }));\n      }).then(function (fontCss) {\n        var style = document.createElement(\'style\');\n        style.textContent = fontCss.join(\'\\n\');\n\n        _this2.documentElement.appendChild(style);\n      });\n    }\n  }, {\n    key: "createElementClone",\n    value: function createElementClone(node) {\n      var _this3 = this;\n\n      if (this.copyStyles && node instanceof HTMLCanvasElement) {\n        var img = node.ownerDocument.createElement(\'img\');\n\n        try {\n          img.src = node.toDataURL();\n          return img;\n        } catch (e) {\n          if (true) {\n            this.logger.log("Unable to clone canvas contents, canvas is tainted");\n          }\n        }\n      }\n\n      if (node instanceof HTMLIFrameElement) {\n        var tempIframe = node.cloneNode(false);\n        var iframeKey = generateIframeKey();\n        tempIframe.setAttribute(\'data-html2canvas-internal-iframe-key\', iframeKey);\n\n        var _parseBounds = Object(_Bounds__WEBPACK_IMPORTED_MODULE_0__["parseBounds"])(node, 0, 0),\n            width = _parseBounds.width,\n            height = _parseBounds.height;\n\n        this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {\n          return _this3.renderer(documentElement, {\n            allowTaint: _this3.options.allowTaint,\n            backgroundColor: \'#ffffff\',\n            canvas: null,\n            imageTimeout: _this3.options.imageTimeout,\n            logging: _this3.options.logging,\n            proxy: _this3.options.proxy,\n            removeContainer: _this3.options.removeContainer,\n            scale: _this3.options.scale,\n            foreignObjectRendering: _this3.options.foreignObjectRendering,\n            useCORS: _this3.options.useCORS,\n            target: new _renderer_CanvasRenderer__WEBPACK_IMPORTED_MODULE_5__["default"](),\n            width: width,\n            height: height,\n            x: 0,\n            y: 0,\n            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,\n            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,\n            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,\n            scrollY: documentElement.ownerDocument.defaultView.pageYOffset\n          }, _this3.logger.child(iframeKey));\n        }).then(function (canvas) {\n          return new Promise(function (resolve, reject) {\n            var iframeCanvas = document.createElement(\'img\');\n\n            iframeCanvas.onload = function () {\n              return resolve(canvas);\n            };\n\n            iframeCanvas.onerror = function (event) {\n              // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>\'s point of view\n              // and instead of `onload` cause `onerror` and unhandled rejection warnings\n              // https://github.com/niklasvh/html2canvas/issues/1502\n              iframeCanvas.src == \'data:,\' ? resolve(canvas) : reject(event);\n            };\n\n            iframeCanvas.src = canvas.toDataURL();\n\n            if (tempIframe.parentNode) {\n              tempIframe.parentNode.replaceChild(Object(_Util__WEBPACK_IMPORTED_MODULE_3__["copyCSSStyles"])(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);\n            }\n          });\n        });\n        return tempIframe;\n      }\n\n      try {\n        if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {\n          var css = [].slice.call(node.sheet.cssRules, 0).reduce(function (css, rule) {\n            if (rule && rule.cssText) {\n              return css + rule.cssText;\n            }\n\n            return css;\n          }, \'\');\n          var style = node.cloneNode(false);\n          style.textContent = css;\n          return style;\n        }\n      } catch (e) {\n        // accessing node.sheet.cssRules throws a DOMException\n        this.logger.log(\'Unable to access cssRules property\');\n\n        if (e.name !== \'SecurityError\') {\n          this.logger.log(e);\n          throw e;\n        }\n      }\n\n      return node.cloneNode(false);\n    }\n  }, {\n    key: "cloneNode",\n    value: function cloneNode(node) {\n      var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);\n      var window = node.ownerDocument.defaultView;\n      var style = node instanceof window.HTMLElement ? window.getComputedStyle(node) : null;\n      var styleBefore = node instanceof window.HTMLElement ? window.getComputedStyle(node, \':before\') : null;\n      var styleAfter = node instanceof window.HTMLElement ? window.getComputedStyle(node, \':after\') : null;\n\n      if (this.referenceElement === node && clone instanceof window.HTMLElement) {\n        this.clonedReferenceElement = clone;\n      }\n\n      if (clone instanceof window.HTMLBodyElement) {\n        createPseudoHideStyles(clone);\n      }\n\n      var counters = Object(_PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__["parseCounterReset"])(style, this.pseudoContentData);\n      var contentBefore = Object(_PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__["resolvePseudoContent"])(node, styleBefore, this.pseudoContentData);\n\n      for (var child = node.firstChild; child; child = child.nextSibling) {\n        if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== \'SCRIPT\' && // $FlowFixMe\n        !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== \'function\' || // $FlowFixMe\n        !this.options.ignoreElements(child))) {\n          if (!this.copyStyles || child.nodeName !== \'STYLE\') {\n            clone.appendChild(this.cloneNode(child));\n          }\n        }\n      }\n\n      var contentAfter = Object(_PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__["resolvePseudoContent"])(node, styleAfter, this.pseudoContentData);\n      Object(_PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__["popCounters"])(counters, this.pseudoContentData);\n\n      if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {\n        if (styleBefore) {\n          this.inlineAllImages(inlinePseudoElement(node, clone, styleBefore, contentBefore, PSEUDO_BEFORE));\n        }\n\n        if (styleAfter) {\n          this.inlineAllImages(inlinePseudoElement(node, clone, styleAfter, contentAfter, PSEUDO_AFTER));\n        }\n\n        if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) {\n          Object(_Util__WEBPACK_IMPORTED_MODULE_3__["copyCSSStyles"])(style, clone);\n        }\n\n        this.inlineAllImages(clone);\n\n        if (node.scrollTop !== 0 || node.scrollLeft !== 0) {\n          this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);\n        }\n\n        switch (node.nodeName) {\n          case \'CANVAS\':\n            if (!this.copyStyles) {\n              cloneCanvasContents(node, clone);\n            }\n\n            break;\n\n          case \'TEXTAREA\':\n          case \'SELECT\':\n            clone.value = node.value;\n            break;\n        }\n      }\n\n      return clone;\n    }\n  }]);\n\n  return DocumentCloner;\n}();\n\nvar getSheetFonts = function getSheetFonts(sheet, document) {\n  // $FlowFixMe\n  return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {\n    return rule.type === CSSRule.FONT_FACE_RULE;\n  }).map(function (rule) {\n    var src = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["parseBackgroundImage"])(rule.style.getPropertyValue(\'src\'));\n    var formats = [];\n\n    for (var i = 0; i < src.length; i++) {\n      if (src[i].method === \'url\' && src[i + 1] && src[i + 1].method === \'format\') {\n        var a = document.createElement(\'a\');\n        a.href = src[i].args[0];\n\n        if (document.body) {\n          document.body.appendChild(a);\n        }\n\n        var font = {\n          src: a.href,\n          format: src[i + 1].args[0]\n        };\n        formats.push(font);\n      }\n    }\n\n    return {\n      // TODO select correct format for browser),\n      formats: formats.filter(function (font) {\n        return /^woff/i.test(font.format);\n      }),\n      fontFace: rule.style\n    };\n  }).filter(function (font) {\n    return font.formats.length;\n  });\n};\n\nvar createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {\n  var doc = document.implementation.createHTMLDocument(\'\');\n  var base = document.createElement(\'base\'); // $FlowFixMe\n\n  base.href = baseHref;\n  var style = document.createElement(\'style\');\n  style.textContent = text;\n\n  if (doc.head) {\n    doc.head.appendChild(base);\n  }\n\n  if (doc.body) {\n    doc.body.appendChild(style);\n  }\n\n  return style.sheet ? getSheetFonts(style.sheet, doc) : [];\n};\n\nvar restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {\n  if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {\n    ownerDocument.defaultView.scrollTo(x, y);\n  }\n};\n\nvar cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {\n  try {\n    if (clonedCanvas) {\n      clonedCanvas.width = canvas.width;\n      clonedCanvas.height = canvas.height;\n      var ctx = canvas.getContext(\'2d\');\n      var clonedCtx = clonedCanvas.getContext(\'2d\');\n\n      if (ctx) {\n        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);\n      } else {\n        clonedCtx.drawImage(canvas, 0, 0);\n      }\n    }\n  } catch (e) {}\n};\n\nvar inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {\n  if (!style || !style.content || style.content === \'none\' || style.content === \'-moz-alt-content\' || style.display === \'none\') {\n    return;\n  }\n\n  var anonymousReplacedElement = clone.ownerDocument.createElement(\'html2canvaspseudoelement\');\n  Object(_Util__WEBPACK_IMPORTED_MODULE_3__["copyCSSStyles"])(style, anonymousReplacedElement);\n\n  if (contentItems) {\n    var len = contentItems.length;\n\n    for (var i = 0; i < len; i++) {\n      var item = contentItems[i];\n\n      switch (item.type) {\n        case _PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__["PSEUDO_CONTENT_ITEM_TYPE"].IMAGE:\n          var img = clone.ownerDocument.createElement(\'img\');\n          img.src = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["parseBackgroundImage"])("url(".concat(item.value, ")"))[0].args[0];\n          img.style.opacity = \'1\';\n          anonymousReplacedElement.appendChild(img);\n          break;\n\n        case _PseudoNodeContent__WEBPACK_IMPORTED_MODULE_6__["PSEUDO_CONTENT_ITEM_TYPE"].TEXT:\n          anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));\n          break;\n      }\n    }\n  }\n\n  anonymousReplacedElement.className = "".concat(PSEUDO_HIDE_ELEMENT_CLASS_BEFORE, " ").concat(PSEUDO_HIDE_ELEMENT_CLASS_AFTER);\n  clone.className += pseudoElt === PSEUDO_BEFORE ? " ".concat(PSEUDO_HIDE_ELEMENT_CLASS_BEFORE) : " ".concat(PSEUDO_HIDE_ELEMENT_CLASS_AFTER);\n\n  if (pseudoElt === PSEUDO_BEFORE) {\n    clone.insertBefore(anonymousReplacedElement, clone.firstChild);\n  } else {\n    clone.appendChild(anonymousReplacedElement);\n  }\n\n  return anonymousReplacedElement;\n};\n\nvar URL_REGEXP = /^url\\((.+)\\)$/i;\nvar PSEUDO_BEFORE = \':before\';\nvar PSEUDO_AFTER = \':after\';\nvar PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = \'___html2canvas___pseudoelement_before\';\nvar PSEUDO_HIDE_ELEMENT_CLASS_AFTER = \'___html2canvas___pseudoelement_after\';\nvar PSEUDO_HIDE_ELEMENT_STYLE = "{\\n    content: \\"\\" !important;\\n    display: none !important;\\n}";\n\nvar createPseudoHideStyles = function createPseudoHideStyles(body) {\n  createStyles(body, ".".concat(PSEUDO_HIDE_ELEMENT_CLASS_BEFORE).concat(PSEUDO_BEFORE).concat(PSEUDO_HIDE_ELEMENT_STYLE, "\\n         .").concat(PSEUDO_HIDE_ELEMENT_CLASS_AFTER).concat(PSEUDO_AFTER).concat(PSEUDO_HIDE_ELEMENT_STYLE));\n};\n\nvar createStyles = function createStyles(body, styles) {\n  var style = body.ownerDocument.createElement(\'style\');\n  style.innerHTML = styles;\n  body.appendChild(style);\n};\n\nvar initNode = function initNode(_ref) {\n  var _ref2 = _slicedToArray(_ref, 3),\n      element = _ref2[0],\n      x = _ref2[1],\n      y = _ref2[2];\n\n  element.scrollLeft = x;\n  element.scrollTop = y;\n};\n\nvar generateIframeKey = function generateIframeKey() {\n  return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);\n};\n\nvar DATA_URI_REGEXP = /^data:text\\/(.+);(base64)?,(.*)$/i;\n\nvar getIframeDocumentElement = function getIframeDocumentElement(node, options) {\n  try {\n    return Promise.resolve(node.contentWindow.document.documentElement);\n  } catch (e) {\n    return options.proxy ? Object(_Proxy__WEBPACK_IMPORTED_MODULE_1__["Proxy"])(node.src, options).then(function (html) {\n      var match = html.match(DATA_URI_REGEXP);\n\n      if (!match) {\n        return Promise.reject();\n      }\n\n      return match[2] === \'base64\' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);\n    }).then(function (html) {\n      return createIframeContainer(node.ownerDocument, Object(_Bounds__WEBPACK_IMPORTED_MODULE_0__["parseBounds"])(node, 0, 0)).then(function (cloneIframeContainer) {\n        var cloneWindow = cloneIframeContainer.contentWindow;\n        var documentClone = cloneWindow.document;\n        documentClone.open();\n        documentClone.write(html);\n        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {\n          return documentClone.documentElement;\n        });\n        documentClone.close();\n        return iframeLoad;\n      });\n    }) : Promise.reject();\n  }\n};\n\nvar createIframeContainer = function createIframeContainer(ownerDocument, bounds) {\n  var cloneIframeContainer = ownerDocument.createElement(\'iframe\');\n  cloneIframeContainer.className = \'html2canvas-container\';\n  cloneIframeContainer.style.visibility = \'hidden\';\n  cloneIframeContainer.style.position = \'fixed\';\n  cloneIframeContainer.style.left = \'-10000px\';\n  cloneIframeContainer.style.top = \'0px\';\n  cloneIframeContainer.style.border = \'0\';\n  cloneIframeContainer.width = bounds.width.toString();\n  cloneIframeContainer.height = bounds.height.toString();\n  cloneIframeContainer.scrolling = \'no\'; // ios won\'t scroll without it\n\n  cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, \'true\');\n\n  if (!ownerDocument.body) {\n    return Promise.reject( true ? "Body element not found in Document that is getting rendered" : undefined);\n  }\n\n  ownerDocument.body.appendChild(cloneIframeContainer);\n  return Promise.resolve(cloneIframeContainer);\n};\n\nvar iframeLoader = function iframeLoader(cloneIframeContainer) {\n  var cloneWindow = cloneIframeContainer.contentWindow;\n  var documentClone = cloneWindow.document;\n  return new Promise(function (resolve, reject) {\n    cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {\n      var interval = setInterval(function () {\n        if (documentClone.body.childNodes.length > 0 && documentClone.readyState === \'complete\') {\n          clearInterval(interval);\n          resolve(cloneIframeContainer);\n        }\n      }, 50);\n    };\n  });\n};\n\nvar cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {\n  var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);\n  var scrollX = ownerDocument.defaultView.pageXOffset;\n  var scrollY = ownerDocument.defaultView.pageYOffset;\n  return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {\n    var cloneWindow = cloneIframeContainer.contentWindow;\n    var documentClone = cloneWindow.document;\n    /* Chrome doesn\'t detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle\n         if window url is about:blank, we can assign the url to current by writing onto the document\n         */\n\n    var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {\n      cloner.scrolledElements.forEach(initNode);\n      cloneWindow.scrollTo(bounds.left, bounds.top);\n\n      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {\n        documentClone.documentElement.style.top = -bounds.top + \'px\';\n        documentClone.documentElement.style.left = -bounds.left + \'px\';\n        documentClone.documentElement.style.position = \'absolute\';\n      }\n\n      var result = Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]);\n      var onclone = options.onclone;\n      return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === \'function\' ? Promise.resolve().then(function () {\n        return onclone(documentClone);\n      }).then(function () {\n        return result;\n      }) : result : Promise.reject( true ? "Error finding the ".concat(referenceElement.nodeName, " in the cloned document") : undefined);\n    });\n    documentClone.open();\n    documentClone.write("".concat(serializeDoctype(document.doctype), "<html></html>")); // Chrome scrolls the parent document for some reason after the write to the cloned window???\n\n    restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);\n    documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);\n    documentClone.close();\n    return iframeLoad;\n  });\n};\n\nvar serializeDoctype = function serializeDoctype(doctype) {\n  var str = \'\';\n\n  if (doctype) {\n    str += \'<!DOCTYPE \';\n\n    if (doctype.name) {\n      str += doctype.name;\n    }\n\n    if (doctype.internalSubset) {\n      str += doctype.internalSubset;\n    }\n\n    if (doctype.publicId) {\n      str += "\\"".concat(doctype.publicId, "\\"");\n    }\n\n    if (doctype.systemId) {\n      str += "\\"".concat(doctype.systemId, "\\"");\n    }\n\n    str += \'>\';\n  }\n\n  return str;\n};\n\n//# sourceURL=webpack://html2canvas/./src/Clone.js?');
      },
      "./src/Color.js": function srcColorJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Color; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSPARENT", function() { return TRANSPARENT; });\n // http://dev.w3.org/csswg/css-color/\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nvar HEX3 = /^#([a-f0-9]{3})$/i;\n\nvar hex3 = function hex3(value) {\n  var match = value.match(HEX3);\n\n  if (match) {\n    return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];\n  }\n\n  return false;\n};\n\nvar HEX6 = /^#([a-f0-9]{6})$/i;\n\nvar hex6 = function hex6(value) {\n  var match = value.match(HEX6);\n\n  if (match) {\n    return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];\n  }\n\n  return false;\n};\n\nvar RGB = /^rgb\\(\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*\\)$/;\n\nvar rgb = function rgb(value) {\n  var match = value.match(RGB);\n\n  if (match) {\n    return [Number(match[1]), Number(match[2]), Number(match[3]), null];\n  }\n\n  return false;\n};\n\nvar RGBA = /^rgba\\(\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*,\\s*(\\d?\\.?\\d+)\\s*\\)$/;\n\nvar rgba = function rgba(value) {\n  var match = value.match(RGBA);\n\n  if (match && match.length > 4) {\n    return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];\n  }\n\n  return false;\n};\n\nvar fromArray = function fromArray(array) {\n  return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];\n};\n\nvar namedColor = function namedColor(name) {\n  var color = NAMED_COLORS[name.toLowerCase()];\n  return color ? color : false;\n};\n\nvar Color =\n/*#__PURE__*/\nfunction () {\n  function Color(value) {\n    _classCallCheck(this, Color);\n\n    var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],\n        _ref2 = _slicedToArray(_ref, 4),\n        r = _ref2[0],\n        g = _ref2[1],\n        b = _ref2[2],\n        a = _ref2[3];\n\n    this.r = r;\n    this.g = g;\n    this.b = b;\n    this.a = a;\n  }\n\n  _createClass(Color, [{\n    key: "isTransparent",\n    value: function isTransparent() {\n      return this.a === 0;\n    }\n  }, {\n    key: "toString",\n    value: function toString() {\n      return this.a !== null && this.a !== 1 ? "rgba(".concat(this.r, ",").concat(this.g, ",").concat(this.b, ",").concat(this.a, ")") : "rgb(".concat(this.r, ",").concat(this.g, ",").concat(this.b, ")");\n    }\n  }]);\n\n  return Color;\n}();\n\n\nvar NAMED_COLORS = {\n  transparent: [0, 0, 0, 0],\n  aliceblue: [240, 248, 255, null],\n  antiquewhite: [250, 235, 215, null],\n  aqua: [0, 255, 255, null],\n  aquamarine: [127, 255, 212, null],\n  azure: [240, 255, 255, null],\n  beige: [245, 245, 220, null],\n  bisque: [255, 228, 196, null],\n  black: [0, 0, 0, null],\n  blanchedalmond: [255, 235, 205, null],\n  blue: [0, 0, 255, null],\n  blueviolet: [138, 43, 226, null],\n  brown: [165, 42, 42, null],\n  burlywood: [222, 184, 135, null],\n  cadetblue: [95, 158, 160, null],\n  chartreuse: [127, 255, 0, null],\n  chocolate: [210, 105, 30, null],\n  coral: [255, 127, 80, null],\n  cornflowerblue: [100, 149, 237, null],\n  cornsilk: [255, 248, 220, null],\n  crimson: [220, 20, 60, null],\n  cyan: [0, 255, 255, null],\n  darkblue: [0, 0, 139, null],\n  darkcyan: [0, 139, 139, null],\n  darkgoldenrod: [184, 134, 11, null],\n  darkgray: [169, 169, 169, null],\n  darkgreen: [0, 100, 0, null],\n  darkgrey: [169, 169, 169, null],\n  darkkhaki: [189, 183, 107, null],\n  darkmagenta: [139, 0, 139, null],\n  darkolivegreen: [85, 107, 47, null],\n  darkorange: [255, 140, 0, null],\n  darkorchid: [153, 50, 204, null],\n  darkred: [139, 0, 0, null],\n  darksalmon: [233, 150, 122, null],\n  darkseagreen: [143, 188, 143, null],\n  darkslateblue: [72, 61, 139, null],\n  darkslategray: [47, 79, 79, null],\n  darkslategrey: [47, 79, 79, null],\n  darkturquoise: [0, 206, 209, null],\n  darkviolet: [148, 0, 211, null],\n  deeppink: [255, 20, 147, null],\n  deepskyblue: [0, 191, 255, null],\n  dimgray: [105, 105, 105, null],\n  dimgrey: [105, 105, 105, null],\n  dodgerblue: [30, 144, 255, null],\n  firebrick: [178, 34, 34, null],\n  floralwhite: [255, 250, 240, null],\n  forestgreen: [34, 139, 34, null],\n  fuchsia: [255, 0, 255, null],\n  gainsboro: [220, 220, 220, null],\n  ghostwhite: [248, 248, 255, null],\n  gold: [255, 215, 0, null],\n  goldenrod: [218, 165, 32, null],\n  gray: [128, 128, 128, null],\n  green: [0, 128, 0, null],\n  greenyellow: [173, 255, 47, null],\n  grey: [128, 128, 128, null],\n  honeydew: [240, 255, 240, null],\n  hotpink: [255, 105, 180, null],\n  indianred: [205, 92, 92, null],\n  indigo: [75, 0, 130, null],\n  ivory: [255, 255, 240, null],\n  khaki: [240, 230, 140, null],\n  lavender: [230, 230, 250, null],\n  lavenderblush: [255, 240, 245, null],\n  lawngreen: [124, 252, 0, null],\n  lemonchiffon: [255, 250, 205, null],\n  lightblue: [173, 216, 230, null],\n  lightcoral: [240, 128, 128, null],\n  lightcyan: [224, 255, 255, null],\n  lightgoldenrodyellow: [250, 250, 210, null],\n  lightgray: [211, 211, 211, null],\n  lightgreen: [144, 238, 144, null],\n  lightgrey: [211, 211, 211, null],\n  lightpink: [255, 182, 193, null],\n  lightsalmon: [255, 160, 122, null],\n  lightseagreen: [32, 178, 170, null],\n  lightskyblue: [135, 206, 250, null],\n  lightslategray: [119, 136, 153, null],\n  lightslategrey: [119, 136, 153, null],\n  lightsteelblue: [176, 196, 222, null],\n  lightyellow: [255, 255, 224, null],\n  lime: [0, 255, 0, null],\n  limegreen: [50, 205, 50, null],\n  linen: [250, 240, 230, null],\n  magenta: [255, 0, 255, null],\n  maroon: [128, 0, 0, null],\n  mediumaquamarine: [102, 205, 170, null],\n  mediumblue: [0, 0, 205, null],\n  mediumorchid: [186, 85, 211, null],\n  mediumpurple: [147, 112, 219, null],\n  mediumseagreen: [60, 179, 113, null],\n  mediumslateblue: [123, 104, 238, null],\n  mediumspringgreen: [0, 250, 154, null],\n  mediumturquoise: [72, 209, 204, null],\n  mediumvioletred: [199, 21, 133, null],\n  midnightblue: [25, 25, 112, null],\n  mintcream: [245, 255, 250, null],\n  mistyrose: [255, 228, 225, null],\n  moccasin: [255, 228, 181, null],\n  navajowhite: [255, 222, 173, null],\n  navy: [0, 0, 128, null],\n  oldlace: [253, 245, 230, null],\n  olive: [128, 128, 0, null],\n  olivedrab: [107, 142, 35, null],\n  orange: [255, 165, 0, null],\n  orangered: [255, 69, 0, null],\n  orchid: [218, 112, 214, null],\n  palegoldenrod: [238, 232, 170, null],\n  palegreen: [152, 251, 152, null],\n  paleturquoise: [175, 238, 238, null],\n  palevioletred: [219, 112, 147, null],\n  papayawhip: [255, 239, 213, null],\n  peachpuff: [255, 218, 185, null],\n  peru: [205, 133, 63, null],\n  pink: [255, 192, 203, null],\n  plum: [221, 160, 221, null],\n  powderblue: [176, 224, 230, null],\n  purple: [128, 0, 128, null],\n  rebeccapurple: [102, 51, 153, null],\n  red: [255, 0, 0, null],\n  rosybrown: [188, 143, 143, null],\n  royalblue: [65, 105, 225, null],\n  saddlebrown: [139, 69, 19, null],\n  salmon: [250, 128, 114, null],\n  sandybrown: [244, 164, 96, null],\n  seagreen: [46, 139, 87, null],\n  seashell: [255, 245, 238, null],\n  sienna: [160, 82, 45, null],\n  silver: [192, 192, 192, null],\n  skyblue: [135, 206, 235, null],\n  slateblue: [106, 90, 205, null],\n  slategray: [112, 128, 144, null],\n  slategrey: [112, 128, 144, null],\n  snow: [255, 250, 250, null],\n  springgreen: [0, 255, 127, null],\n  steelblue: [70, 130, 180, null],\n  tan: [210, 180, 140, null],\n  teal: [0, 128, 128, null],\n  thistle: [216, 191, 216, null],\n  tomato: [255, 99, 71, null],\n  turquoise: [64, 224, 208, null],\n  violet: [238, 130, 238, null],\n  wheat: [245, 222, 179, null],\n  white: [255, 255, 255, null],\n  whitesmoke: [245, 245, 245, null],\n  yellow: [255, 255, 0, null],\n  yellowgreen: [154, 205, 50, null]\n};\nvar TRANSPARENT = new Color([0, 0, 0, 0]);\n\n//# sourceURL=webpack://html2canvas/./src/Color.js?');
      },
      "./src/Feature.js": function srcFeatureJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./renderer/ForeignObjectRenderer */ \"./src/renderer/ForeignObjectRenderer.js\");\n\n\n\n\nvar testRangeBounds = function testRangeBounds(document) {\n  var TEST_HEIGHT = 123;\n\n  if (document.createRange) {\n    var range = document.createRange();\n\n    if (range.getBoundingClientRect) {\n      var testElement = document.createElement('boundtest');\n      testElement.style.height = \"\".concat(TEST_HEIGHT, \"px\");\n      testElement.style.display = 'block';\n      document.body.appendChild(testElement);\n      range.selectNode(testElement);\n      var rangeBounds = range.getBoundingClientRect();\n      var rangeHeight = Math.round(rangeBounds.height);\n      document.body.removeChild(testElement);\n\n      if (rangeHeight === TEST_HEIGHT) {\n        return true;\n      }\n    }\n  }\n\n  return false;\n};\n\nvar testCORS = function testCORS() {\n  return typeof new Image().crossOrigin !== 'undefined';\n};\n\nvar testResponseType = function testResponseType() {\n  return typeof new XMLHttpRequest().responseType === 'string';\n};\n\nvar testSVG = function testSVG(document) {\n  var img = new Image();\n  var canvas = document.createElement('canvas');\n  var ctx = canvas.getContext('2d');\n  img.src = \"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>\";\n\n  try {\n    ctx.drawImage(img, 0, 0);\n    canvas.toDataURL();\n  } catch (e) {\n    return false;\n  }\n\n  return true;\n};\n\nvar isGreenPixel = function isGreenPixel(data) {\n  return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;\n};\n\nvar testForeignObject = function testForeignObject(document) {\n  var canvas = document.createElement('canvas');\n  var size = 100;\n  canvas.width = size;\n  canvas.height = size;\n  var ctx = canvas.getContext('2d');\n  ctx.fillStyle = 'rgb(0, 255, 0)';\n  ctx.fillRect(0, 0, size, size);\n  var img = new Image();\n  var greenImageSrc = canvas.toDataURL();\n  img.src = greenImageSrc;\n  var svg = Object(_renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_0__[\"createForeignObjectSVG\"])(size, size, 0, 0, img);\n  ctx.fillStyle = 'red';\n  ctx.fillRect(0, 0, size, size);\n  return Object(_renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_0__[\"loadSerializedSVG\"])(svg).then(function (img) {\n    ctx.drawImage(img, 0, 0);\n    var data = ctx.getImageData(0, 0, size, size).data;\n    ctx.fillStyle = 'red';\n    ctx.fillRect(0, 0, size, size);\n    var node = document.createElement('div');\n    node.style.backgroundImage = \"url(\".concat(greenImageSrc, \")\");\n    node.style.height = \"\".concat(size, \"px\"); // Firefox 55 does not render inline <img /> tags\n\n    return isGreenPixel(data) ? Object(_renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_0__[\"loadSerializedSVG\"])(Object(_renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_0__[\"createForeignObjectSVG\"])(size, size, 0, 0, node)) : Promise.reject(false);\n  }).then(function (img) {\n    ctx.drawImage(img, 0, 0); // Edge does not render background-images\n\n    return isGreenPixel(ctx.getImageData(0, 0, size, size).data);\n  }).catch(function (e) {\n    return false;\n  });\n};\n\nvar FEATURES = {\n  // $FlowFixMe - get/set properties not yet supported\n  get SUPPORT_RANGE_BOUNDS() {\n    'use strict';\n\n    var value = testRangeBounds(document);\n    Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {\n      value: value\n    });\n    return value;\n  },\n\n  // $FlowFixMe - get/set properties not yet supported\n  get SUPPORT_SVG_DRAWING() {\n    'use strict';\n\n    var value = testSVG(document);\n    Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {\n      value: value\n    });\n    return value;\n  },\n\n  // $FlowFixMe - get/set properties not yet supported\n  get SUPPORT_FOREIGNOBJECT_DRAWING() {\n    'use strict';\n\n    var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);\n    Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {\n      value: value\n    });\n    return value;\n  },\n\n  // $FlowFixMe - get/set properties not yet supported\n  get SUPPORT_CORS_IMAGES() {\n    'use strict';\n\n    var value = testCORS();\n    Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {\n      value: value\n    });\n    return value;\n  },\n\n  // $FlowFixMe - get/set properties not yet supported\n  get SUPPORT_RESPONSE_TYPE() {\n    'use strict';\n\n    var value = testResponseType();\n    Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {\n      value: value\n    });\n    return value;\n  },\n\n  // $FlowFixMe - get/set properties not yet supported\n  get SUPPORT_CORS_XHR() {\n    'use strict';\n\n    var value = 'withCredentials' in new XMLHttpRequest();\n    Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {\n      value: value\n    });\n    return value;\n  }\n\n};\n/* harmony default export */ __webpack_exports__[\"default\"] = (FEATURES);\n\n//# sourceURL=webpack://html2canvas/./src/Feature.js?");
      },
      "./src/Font.js": function srcFontJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"FontMetrics\", function() { return FontMetrics; });\n/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Util */ \"./src/Util.js\");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nvar SAMPLE_TEXT = 'Hidden Text';\n\nvar FontMetrics =\n/*#__PURE__*/\nfunction () {\n  function FontMetrics(document) {\n    _classCallCheck(this, FontMetrics);\n\n    this._data = {};\n    this._document = document;\n  }\n\n  _createClass(FontMetrics, [{\n    key: \"_parseMetrics\",\n    value: function _parseMetrics(font) {\n      var container = this._document.createElement('div');\n\n      var img = this._document.createElement('img');\n\n      var span = this._document.createElement('span');\n\n      var body = this._document.body;\n\n      if (!body) {\n        throw new Error( true ? 'No document found for font metrics' : undefined);\n      }\n\n      container.style.visibility = 'hidden';\n      container.style.fontFamily = font.fontFamily;\n      container.style.fontSize = font.fontSize;\n      container.style.margin = '0';\n      container.style.padding = '0';\n      body.appendChild(container);\n      img.src = _Util__WEBPACK_IMPORTED_MODULE_0__[\"SMALL_IMAGE\"];\n      img.width = 1;\n      img.height = 1;\n      img.style.margin = '0';\n      img.style.padding = '0';\n      img.style.verticalAlign = 'baseline';\n      span.style.fontFamily = font.fontFamily;\n      span.style.fontSize = font.fontSize;\n      span.style.margin = '0';\n      span.style.padding = '0';\n      span.appendChild(this._document.createTextNode(SAMPLE_TEXT));\n      container.appendChild(span);\n      container.appendChild(img);\n      var baseline = img.offsetTop - span.offsetTop + 2;\n      container.removeChild(span);\n      container.appendChild(this._document.createTextNode(SAMPLE_TEXT));\n      container.style.lineHeight = 'normal';\n      img.style.verticalAlign = 'super';\n      var middle = img.offsetTop - container.offsetTop + 2;\n      body.removeChild(container);\n      return {\n        baseline: baseline,\n        middle: middle\n      };\n    }\n  }, {\n    key: \"getMetrics\",\n    value: function getMetrics(font) {\n      var key = \"\".concat(font.fontFamily, \" \").concat(font.fontSize);\n\n      if (this._data[key] === undefined) {\n        this._data[key] = this._parseMetrics(font);\n      }\n\n      return this._data[key];\n    }\n  }]);\n\n  return FontMetrics;\n}();\n\n//# sourceURL=webpack://html2canvas/./src/Font.js?");
      },
      "./src/Gradient.js": function srcGradientJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"GRADIENT_TYPE\", function() { return GRADIENT_TYPE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"RADIAL_GRADIENT_SHAPE\", function() { return RADIAL_GRADIENT_SHAPE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"LinearGradient\", function() { return LinearGradient; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"RadialGradient\", function() { return RadialGradient; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseGradient\", function() { return parseGradient; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"transformWebkitRadialGradientArgs\", function() { return transformWebkitRadialGradientArgs; });\n/* harmony import */ var _NodeContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NodeContainer */ \"./src/NodeContainer.js\");\n/* harmony import */ var _Angle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Angle */ \"./src/Angle.js\");\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Color */ \"./src/Color.js\");\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Length */ \"./src/Length.js\");\n/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Util */ \"./src/Util.js\");\n\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\n\n\n\n\n\nvar SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;\nvar PERCENTAGE_ANGLES = /^([+-]?\\d*\\.?\\d+)% ([+-]?\\d*\\.?\\d+)%$/i;\nvar ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;\nvar FROM_TO_COLORSTOP = /^(from|to|color-stop)\\((?:([\\d.]+)(%)?,\\s*)?(.+?)\\)$/i;\nvar RADIAL_SHAPE_DEFINITION = /^\\s*(circle|ellipse)?\\s*((?:([\\d.]+)(px|r?em|%)\\s*(?:([\\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\\s*(?:at\\s*(?:(left|center|right)|([\\d.]+)(px|r?em|%))\\s+(?:(top|center|bottom)|([\\d.]+)(px|r?em|%)))?(?:\\s|$)/i;\nvar GRADIENT_TYPE = {\n  LINEAR_GRADIENT: 0,\n  RADIAL_GRADIENT: 1\n};\nvar RADIAL_GRADIENT_SHAPE = {\n  CIRCLE: 0,\n  ELLIPSE: 1\n};\nvar LENGTH_FOR_POSITION = {\n  left: new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('0%'),\n  top: new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('0%'),\n  center: new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('50%'),\n  right: new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('100%'),\n  bottom: new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('100%')\n};\nvar LinearGradient = function LinearGradient(colorStops, direction) {\n  _classCallCheck(this, LinearGradient);\n\n  this.type = GRADIENT_TYPE.LINEAR_GRADIENT;\n  this.colorStops = colorStops;\n  this.direction = direction;\n};\nvar RadialGradient = function RadialGradient(colorStops, shape, center, radius) {\n  _classCallCheck(this, RadialGradient);\n\n  this.type = GRADIENT_TYPE.RADIAL_GRADIENT;\n  this.colorStops = colorStops;\n  this.shape = shape;\n  this.center = center;\n  this.radius = radius;\n};\nvar parseGradient = function parseGradient(container, _ref, bounds) {\n  var args = _ref.args,\n      method = _ref.method,\n      prefix = _ref.prefix;\n\n  if (method === 'linear-gradient') {\n    return parseLinearGradient(args, bounds, !!prefix);\n  } else if (method === 'gradient' && args[0] === 'linear') {\n    // TODO handle correct angle\n    return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);\n  } else if (method === 'radial-gradient') {\n    return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);\n  } else if (method === 'gradient' && args[0] === 'radial') {\n    return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);\n  }\n};\n\nvar parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {\n  var colorStops = [];\n\n  for (var i = firstColorStopIndex; i < args.length; i++) {\n    var value = args[i];\n    var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);\n    var lastSpaceIndex = value.lastIndexOf(' ');\n    var color = new _Color__WEBPACK_IMPORTED_MODULE_2__[\"default\"](HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);\n    var stop = HAS_LENGTH ? new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"](value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('0%') : i === args.length - 1 ? new _Length__WEBPACK_IMPORTED_MODULE_3__[\"default\"]('100%') : null;\n    colorStops.push({\n      color: color,\n      stop: stop\n    });\n  }\n\n  var absoluteValuedColorStops = colorStops.map(function (_ref2) {\n    var color = _ref2.color,\n        stop = _ref2.stop;\n    var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;\n    return {\n      color: color,\n      // $FlowFixMe\n      stop: absoluteStop\n    };\n  });\n  var previousColorStop = absoluteValuedColorStops[0].stop;\n\n  for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {\n    if (previousColorStop !== null) {\n      var _stop = absoluteValuedColorStops[_i].stop;\n\n      if (_stop === null) {\n        var n = _i;\n\n        while (absoluteValuedColorStops[n].stop === null) {\n          n++;\n        }\n\n        var steps = n - _i + 1;\n        var nextColorStep = absoluteValuedColorStops[n].stop;\n        var stepSize = (nextColorStep - previousColorStop) / steps;\n\n        for (; _i < n; _i++) {\n          previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;\n        }\n      } else {\n        previousColorStop = _stop;\n      }\n    }\n  }\n\n  return absoluteValuedColorStops;\n};\n\nvar parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {\n  var angle = Object(_Angle__WEBPACK_IMPORTED_MODULE_1__[\"parseAngle\"])(args[0]);\n  var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);\n  var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);\n  var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection( // if there is a prefix, the 0° angle points due East (instead of North per W3C)\n  hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);\n  var firstColorStopIndex = HAS_DIRECTION ? 1 : 0; // TODO: Fix some inaccuracy with color stops with px values\n\n  var lineLength = Math.min(Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);\n  return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);\n};\n\nvar parseRadialGradient = function parseRadialGradient(container, args, bounds) {\n  var m = args[0].match(RADIAL_SHAPE_DEFINITION);\n  var shape = m && (m[1] === 'circle' || // explicit shape specification\n  m[3] !== undefined && m[5] === undefined) // only one radius coordinate\n  ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;\n  var radius = {};\n  var center = {};\n\n  if (m) {\n    // Radius\n    if (m[3] !== undefined) {\n      radius.x = Object(_Length__WEBPACK_IMPORTED_MODULE_3__[\"calculateLengthFromValueWithUnit\"])(container, m[3], m[4]).getAbsoluteValue(bounds.width);\n    }\n\n    if (m[5] !== undefined) {\n      radius.y = Object(_Length__WEBPACK_IMPORTED_MODULE_3__[\"calculateLengthFromValueWithUnit\"])(container, m[5], m[6]).getAbsoluteValue(bounds.height);\n    } // Position\n\n\n    if (m[7]) {\n      center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];\n    } else if (m[8] !== undefined) {\n      center.x = Object(_Length__WEBPACK_IMPORTED_MODULE_3__[\"calculateLengthFromValueWithUnit\"])(container, m[8], m[9]);\n    }\n\n    if (m[10]) {\n      center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];\n    } else if (m[11] !== undefined) {\n      center.y = Object(_Length__WEBPACK_IMPORTED_MODULE_3__[\"calculateLengthFromValueWithUnit\"])(container, m[11], m[12]);\n    }\n  }\n\n  var gradientCenter = {\n    x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),\n    y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)\n  };\n  var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);\n  return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);\n};\n\nvar calculateGradientDirection = function calculateGradientDirection(radian, bounds) {\n  var width = bounds.width;\n  var height = bounds.height;\n  var HALF_WIDTH = width * 0.5;\n  var HALF_HEIGHT = height * 0.5;\n  var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));\n  var HALF_LINE_LENGTH = lineLength / 2;\n  var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;\n  var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;\n  var x1 = width - x0;\n  var y1 = height - y0;\n  return {\n    x0: x0,\n    x1: x1,\n    y0: y0,\n    y1: y1\n  };\n};\n\nvar parseTopRight = function parseTopRight(bounds) {\n  return Math.acos(bounds.width / 2 / (Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(bounds.width, bounds.height) / 2));\n};\n\nvar parseSideOrCorner = function parseSideOrCorner(side, bounds) {\n  switch (side) {\n    case 'bottom':\n    case 'to top':\n      return calculateGradientDirection(0, bounds);\n\n    case 'left':\n    case 'to right':\n      return calculateGradientDirection(Math.PI / 2, bounds);\n\n    case 'right':\n    case 'to left':\n      return calculateGradientDirection(3 * Math.PI / 2, bounds);\n\n    case 'top right':\n    case 'right top':\n    case 'to bottom left':\n    case 'to left bottom':\n      return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);\n\n    case 'top left':\n    case 'left top':\n    case 'to bottom right':\n    case 'to right bottom':\n      return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);\n\n    case 'bottom left':\n    case 'left bottom':\n    case 'to top right':\n    case 'to right top':\n      return calculateGradientDirection(parseTopRight(bounds), bounds);\n\n    case 'bottom right':\n    case 'right bottom':\n    case 'to top left':\n    case 'to left top':\n      return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);\n\n    case 'top':\n    case 'to bottom':\n    default:\n      return calculateGradientDirection(Math.PI, bounds);\n  }\n};\n\nvar parsePercentageAngle = function parsePercentageAngle(angle, bounds) {\n  var _angle$split$map = angle.split(' ').map(parseFloat),\n      _angle$split$map2 = _slicedToArray(_angle$split$map, 2),\n      left = _angle$split$map2[0],\n      top = _angle$split$map2[1];\n\n  var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);\n  return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);\n};\n\nvar findCorner = function findCorner(bounds, x, y, closest) {\n  var corners = [{\n    x: 0,\n    y: 0\n  }, {\n    x: 0,\n    y: bounds.height\n  }, {\n    x: bounds.width,\n    y: 0\n  }, {\n    x: bounds.width,\n    y: bounds.height\n  }]; // $FlowFixMe\n\n  return corners.reduce(function (stat, corner) {\n    var d = Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x - corner.x, y - corner.y);\n\n    if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {\n      return {\n        optimumCorner: corner,\n        optimumDistance: d\n      };\n    }\n\n    return stat;\n  }, {\n    optimumDistance: closest ? Infinity : -Infinity,\n    optimumCorner: null\n  }).optimumCorner;\n};\n\nvar calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {\n  var x = center.x;\n  var y = center.y;\n  var rx = 0;\n  var ry = 0;\n\n  switch (extent) {\n    case 'closest-side':\n      // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.\n      // If the shape is an ellipse, it exactly meets the closest side in each dimension.\n      if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {\n        rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));\n      } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {\n        rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));\n        ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));\n      }\n\n      break;\n\n    case 'closest-corner':\n      // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.\n      // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.\n      if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {\n        rx = ry = Math.min(Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x, y), Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x, y - bounds.height), Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x - bounds.width, y), Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x - bounds.width, y - bounds.height));\n      } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {\n        // Compute the ratio ry/rx (which is to be the same as for \"closest-side\")\n        var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));\n        var corner = findCorner(bounds, x, y, true);\n        rx = Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(corner.x - x, (corner.y - y) / c);\n        ry = c * rx;\n      }\n\n      break;\n\n    case 'farthest-side':\n      // Same as closest-side, except the ending shape is sized based on the farthest side(s)\n      if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {\n        rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));\n      } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {\n        rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));\n        ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));\n      }\n\n      break;\n\n    case 'farthest-corner':\n      // Same as closest-corner, except the ending shape is sized based on the farthest corner.\n      // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.\n      if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {\n        rx = ry = Math.max(Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x, y), Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x, y - bounds.height), Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x - bounds.width, y), Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(x - bounds.width, y - bounds.height));\n      } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {\n        // Compute the ratio ry/rx (which is to be the same as for \"farthest-side\")\n        var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));\n\n        var _corner = findCorner(bounds, x, y, false);\n\n        rx = Object(_Util__WEBPACK_IMPORTED_MODULE_4__[\"distance\"])(_corner.x - x, (_corner.y - y) / _c);\n        ry = _c * rx;\n      }\n\n      break;\n\n    default:\n      // pixel or percentage values\n      rx = radius.x || 0;\n      ry = radius.y !== undefined ? radius.y : rx;\n      break;\n  }\n\n  return {\n    x: rx,\n    y: ry\n  };\n};\n\nvar transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {\n  var shape = '';\n  var radius = '';\n  var extent = '';\n  var position = '';\n  var idx = 0;\n  var POSITION = /^(left|center|right|\\d+(?:px|r?em|%)?)(?:\\s+(top|center|bottom|\\d+(?:px|r?em|%)?))?$/i;\n  var SHAPE_AND_EXTENT = /^(circle|ellipse)?\\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;\n  var RADIUS = /^\\d+(px|r?em|%)?(?:\\s+\\d+(px|r?em|%)?)?$/i;\n  var matchStartPosition = args[idx].match(POSITION);\n\n  if (matchStartPosition) {\n    idx++;\n  }\n\n  var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);\n\n  if (matchShapeExtent) {\n    shape = matchShapeExtent[1] || '';\n    extent = matchShapeExtent[2] || '';\n\n    if (extent === 'contain') {\n      extent = 'closest-side';\n    } else if (extent === 'cover') {\n      extent = 'farthest-corner';\n    }\n\n    idx++;\n  }\n\n  var matchStartRadius = args[idx].match(RADIUS);\n\n  if (matchStartRadius) {\n    idx++;\n  }\n\n  var matchEndPosition = args[idx].match(POSITION);\n\n  if (matchEndPosition) {\n    idx++;\n  }\n\n  var matchEndRadius = args[idx].match(RADIUS);\n\n  if (matchEndRadius) {\n    idx++;\n  }\n\n  var matchPosition = matchEndPosition || matchStartPosition;\n\n  if (matchPosition && matchPosition[1]) {\n    position = matchPosition[1] + (/^\\d+$/.test(matchPosition[1]) ? 'px' : '');\n\n    if (matchPosition[2]) {\n      position += ' ' + matchPosition[2] + (/^\\d+$/.test(matchPosition[2]) ? 'px' : '');\n    }\n  }\n\n  var matchRadius = matchEndRadius || matchStartRadius;\n\n  if (matchRadius) {\n    radius = matchRadius[0];\n\n    if (!matchRadius[1]) {\n      radius += 'px';\n    }\n  }\n\n  if (position && !shape && !radius && !extent) {\n    radius = position;\n    position = '';\n  }\n\n  if (position) {\n    position = \"at \".concat(position);\n  }\n\n  return [[shape, extent, radius, position].filter(function (s) {\n    return !!s;\n  }).join(' ')].concat(args.slice(idx));\n};\n\nvar transformObsoleteColorStops = function transformObsoleteColorStops(args) {\n  return args.map(function (color) {\n    return color.match(FROM_TO_COLORSTOP);\n  }) // $FlowFixMe\n  .map(function (v, index) {\n    if (!v) {\n      return args[index];\n    }\n\n    switch (v[1]) {\n      case 'from':\n        return \"\".concat(v[4], \" 0%\");\n\n      case 'to':\n        return \"\".concat(v[4], \" 100%\");\n\n      case 'color-stop':\n        if (v[3] === '%') {\n          return \"\".concat(v[4], \" \").concat(v[2]);\n        }\n\n        return \"\".concat(v[4], \" \").concat(parseFloat(v[2]) * 100, \"%\");\n    }\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/Gradient.js?");
      },
      "./src/Input.js": function srcInputJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"INPUT_COLOR\", function() { return INPUT_COLOR; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"INPUT_BORDERS\", function() { return INPUT_BORDERS; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"INPUT_BACKGROUND\", function() { return INPUT_BACKGROUND; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"getInputBorderRadius\", function() { return getInputBorderRadius; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"inlineInputElement\", function() { return inlineInputElement; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"inlineTextAreaElement\", function() { return inlineTextAreaElement; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"inlineSelectElement\", function() { return inlineSelectElement; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"reformatInputBounds\", function() { return reformatInputBounds; });\n/* harmony import */ var _TextContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextContainer */ \"./src/TextContainer.js\");\n/* harmony import */ var _parsing_background__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parsing/background */ \"./src/parsing/background.js\");\n/* harmony import */ var _parsing_border__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./parsing/border */ \"./src/parsing/border.js\");\n/* harmony import */ var _drawing_Circle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./drawing/Circle */ \"./src/drawing/Circle.js\");\n/* harmony import */ var _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./drawing/Vector */ \"./src/drawing/Vector.js\");\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Color */ \"./src/Color.js\");\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Length */ \"./src/Length.js\");\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Bounds */ \"./src/Bounds.js\");\n/* harmony import */ var _TextBounds__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TextBounds */ \"./src/TextBounds.js\");\n/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Util */ \"./src/Util.js\");\n\n\n\n\n\n\n\n\n\n\n\n\nvar INPUT_COLOR = new _Color__WEBPACK_IMPORTED_MODULE_5__[\"default\"]([42, 42, 42]);\nvar INPUT_BORDER_COLOR = new _Color__WEBPACK_IMPORTED_MODULE_5__[\"default\"]([165, 165, 165]);\nvar INPUT_BACKGROUND_COLOR = new _Color__WEBPACK_IMPORTED_MODULE_5__[\"default\"]([222, 222, 222]);\nvar INPUT_BORDER = {\n  borderWidth: 1,\n  borderColor: INPUT_BORDER_COLOR,\n  borderStyle: _parsing_border__WEBPACK_IMPORTED_MODULE_2__[\"BORDER_STYLE\"].SOLID\n};\nvar INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];\nvar INPUT_BACKGROUND = {\n  backgroundColor: INPUT_BACKGROUND_COLOR,\n  backgroundImage: [],\n  backgroundClip: _parsing_background__WEBPACK_IMPORTED_MODULE_1__[\"BACKGROUND_CLIP\"].PADDING_BOX,\n  backgroundOrigin: _parsing_background__WEBPACK_IMPORTED_MODULE_1__[\"BACKGROUND_ORIGIN\"].PADDING_BOX\n};\nvar RADIO_BORDER_RADIUS = new _Length__WEBPACK_IMPORTED_MODULE_6__[\"default\"]('50%');\nvar RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];\nvar INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];\nvar CHECKBOX_BORDER_RADIUS = new _Length__WEBPACK_IMPORTED_MODULE_6__[\"default\"]('3px');\nvar CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];\nvar INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];\nvar getInputBorderRadius = function getInputBorderRadius(node) {\n  return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;\n};\nvar inlineInputElement = function inlineInputElement(node, container) {\n  if (node.type === 'radio' || node.type === 'checkbox') {\n    if (node.checked) {\n      var size = Math.min(container.bounds.width, container.bounds.height);\n      container.childNodes.push(node.type === 'checkbox' ? [new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_4__[\"default\"](container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _drawing_Circle__WEBPACK_IMPORTED_MODULE_3__[\"default\"](container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));\n    }\n  } else {\n    inlineFormElement(getInputValue(node), node, container, false);\n  }\n};\nvar inlineTextAreaElement = function inlineTextAreaElement(node, container) {\n  inlineFormElement(node.value, node, container, true);\n};\nvar inlineSelectElement = function inlineSelectElement(node, container) {\n  var option = node.options[node.selectedIndex || 0];\n  inlineFormElement(option ? option.text || '' : '', node, container, false);\n};\nvar reformatInputBounds = function reformatInputBounds(bounds) {\n  if (bounds.width > bounds.height) {\n    bounds.left += (bounds.width - bounds.height) / 2;\n    bounds.width = bounds.height;\n  } else if (bounds.width < bounds.height) {\n    bounds.top += (bounds.height - bounds.width) / 2;\n    bounds.height = bounds.width;\n  }\n\n  return bounds;\n};\n\nvar inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {\n  var body = node.ownerDocument.body;\n\n  if (value.length > 0 && body) {\n    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');\n    Object(_Util__WEBPACK_IMPORTED_MODULE_9__[\"copyCSSStyles\"])(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);\n    wrapper.style.position = 'absolute';\n    wrapper.style.left = \"\".concat(container.bounds.left, \"px\");\n    wrapper.style.top = \"\".concat(container.bounds.top, \"px\");\n\n    if (!allowLinebreak) {\n      wrapper.style.whiteSpace = 'nowrap';\n    }\n\n    var text = node.ownerDocument.createTextNode(value);\n    wrapper.appendChild(text);\n    body.appendChild(wrapper);\n    container.childNodes.push(_TextContainer__WEBPACK_IMPORTED_MODULE_0__[\"default\"].fromTextNode(text, container));\n    body.removeChild(wrapper);\n  }\n};\n\nvar getInputValue = function getInputValue(node) {\n  var value = node.type === 'password' ? new Array(node.value.length + 1).join(\"\\u2022\") : node.value;\n  return value.length === 0 ? node.placeholder || '' : value;\n};\n\n//# sourceURL=webpack://html2canvas/./src/Input.js?");
      },
      "./src/Length.js": function srcLengthJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LENGTH_TYPE", function() { return LENGTH_TYPE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Length; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateLengthFromValueWithUnit", function() { return calculateLengthFromValueWithUnit; });\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nvar LENGTH_WITH_UNIT = /([\\d.]+)(px|r?em|%)/i;\nvar LENGTH_TYPE = {\n  PX: 0,\n  PERCENTAGE: 1\n};\n\nvar Length =\n/*#__PURE__*/\nfunction () {\n  function Length(value) {\n    _classCallCheck(this, Length);\n\n    this.type = value.substr(value.length - 1) === \'%\' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;\n    var parsedValue = parseFloat(value);\n\n    if ( true && isNaN(parsedValue)) {\n      console.error("Invalid value given for Length: \\"".concat(value, "\\""));\n    }\n\n    this.value = isNaN(parsedValue) ? 0 : parsedValue;\n  }\n\n  _createClass(Length, [{\n    key: "isPercentage",\n    value: function isPercentage() {\n      return this.type === LENGTH_TYPE.PERCENTAGE;\n    }\n  }, {\n    key: "getAbsoluteValue",\n    value: function getAbsoluteValue(parentLength) {\n      return this.isPercentage() ? parentLength * (this.value / 100) : this.value;\n    }\n  }], [{\n    key: "create",\n    value: function create(v) {\n      return new Length(v);\n    }\n  }]);\n\n  return Length;\n}();\n\n\n\nvar getRootFontSize = function getRootFontSize(container) {\n  var parent = container.parent;\n  return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);\n};\n\nvar calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {\n  switch (unit) {\n    case \'px\':\n    case \'%\':\n      return new Length(value + unit);\n\n    case \'em\':\n    case \'rem\':\n      var length = new Length(value);\n      length.value *= unit === \'em\' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);\n      return length;\n\n    default:\n      // TODO: handle correctly if unknown unit is used\n      return new Length(\'0\');\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/Length.js?');
      },
      "./src/ListItem.js": function srcListItemJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"getListOwner\", function() { return getListOwner; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"inlineListItemElement\", function() { return inlineListItemElement; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"createCounterText\", function() { return createCounterText; });\n/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Util */ \"./src/Util.js\");\n/* harmony import */ var _NodeContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NodeContainer */ \"./src/NodeContainer.js\");\n/* harmony import */ var _TextContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TextContainer */ \"./src/TextContainer.js\");\n/* harmony import */ var _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./parsing/listStyle */ \"./src/parsing/listStyle.js\");\n/* harmony import */ var _Unicode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Unicode */ \"./src/Unicode.js\");\n\n\n\n\n\n\n // Margin between the enumeration and the list item content\n\nvar MARGIN_RIGHT = 7;\nvar ancestorTypes = ['OL', 'UL', 'MENU'];\nvar getListOwner = function getListOwner(container) {\n  var parent = container.parent;\n\n  if (!parent) {\n    return null;\n  }\n\n  do {\n    var isAncestor = ancestorTypes.indexOf(parent.tagName) !== -1;\n\n    if (isAncestor) {\n      return parent;\n    }\n\n    parent = parent.parent;\n  } while (parent);\n\n  return container.parent;\n};\nvar inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {\n  var listStyle = container.style.listStyle;\n\n  if (!listStyle) {\n    return;\n  }\n\n  var style = node.ownerDocument.defaultView.getComputedStyle(node, null);\n  var wrapper = node.ownerDocument.createElement('html2canvaswrapper');\n  Object(_Util__WEBPACK_IMPORTED_MODULE_0__[\"copyCSSStyles\"])(style, wrapper);\n  wrapper.style.position = 'absolute';\n  wrapper.style.bottom = 'auto';\n  wrapper.style.display = 'block';\n  wrapper.style.letterSpacing = 'normal';\n\n  switch (listStyle.listStylePosition) {\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_POSITION\"].OUTSIDE:\n      wrapper.style.left = 'auto';\n      wrapper.style.right = \"\".concat(node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + MARGIN_RIGHT, \"px\");\n      wrapper.style.textAlign = 'right';\n      break;\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_POSITION\"].INSIDE:\n      wrapper.style.left = \"\".concat(container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width), \"px\");\n      wrapper.style.right = 'auto';\n      wrapper.style.textAlign = 'left';\n      break;\n  }\n\n  var text;\n  var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);\n  var styleImage = listStyle.listStyleImage;\n\n  if (styleImage) {\n    if (styleImage.method === 'url') {\n      var image = node.ownerDocument.createElement('img');\n      image.src = styleImage.args[0];\n      wrapper.style.top = \"\".concat(container.bounds.top - MARGIN_TOP, \"px\");\n      wrapper.style.width = 'auto';\n      wrapper.style.height = 'auto';\n      wrapper.appendChild(image);\n    } else {\n      var size = parseFloat(container.style.font.fontSize) * 0.5;\n      wrapper.style.top = \"\".concat(container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size, \"px\");\n      wrapper.style.width = \"\".concat(size, \"px\");\n      wrapper.style.height = \"\".concat(size, \"px\");\n      wrapper.style.backgroundImage = style.listStyleImage;\n    }\n  } else if (typeof container.listIndex === 'number') {\n    text = node.ownerDocument.createTextNode(createCounterText(container.listIndex, listStyle.listStyleType, true));\n    wrapper.appendChild(text);\n    wrapper.style.top = \"\".concat(container.bounds.top - MARGIN_TOP, \"px\");\n  } // $FlowFixMe\n\n\n  var body = node.ownerDocument.body;\n  body.appendChild(wrapper);\n\n  if (text) {\n    container.childNodes.push(_TextContainer__WEBPACK_IMPORTED_MODULE_2__[\"default\"].fromTextNode(text, container));\n    body.removeChild(wrapper);\n  } else {\n    // $FlowFixMe\n    container.childNodes.push(new _NodeContainer__WEBPACK_IMPORTED_MODULE_1__[\"default\"](wrapper, container, resourceLoader, 0));\n  }\n};\nvar ROMAN_UPPER = {\n  integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],\n  values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']\n};\nvar ARMENIAN = {\n  integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],\n  values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']\n};\nvar HEBREW = {\n  integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],\n  values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']\n};\nvar GEORGIAN = {\n  integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],\n  values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']\n};\n\nvar createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {\n  if (value < min || value > max) {\n    return createCounterText(value, fallback, suffix.length > 0);\n  }\n\n  return symbols.integers.reduce(function (string, integer, index) {\n    while (value >= integer) {\n      value -= integer;\n      string += symbols.values[index];\n    }\n\n    return string;\n  }, '') + suffix;\n};\n\nvar createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {\n  var string = '';\n\n  do {\n    if (!isNumeric) {\n      value--;\n    }\n\n    string = resolver(value) + string;\n    value /= codePointRangeLength;\n  } while (value * codePointRangeLength >= codePointRangeLength);\n\n  return string;\n};\n\nvar createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {\n  var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;\n  return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {\n    return Object(_Unicode__WEBPACK_IMPORTED_MODULE_4__[\"fromCodePoint\"])(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);\n  }) + suffix);\n};\n\nvar createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {\n  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';\n  var codePointRangeLength = symbols.length;\n  return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {\n    return symbols[Math.floor(codePoint % codePointRangeLength)];\n  }) + suffix;\n};\n\nvar CJK_ZEROS = 1 << 0;\nvar CJK_TEN_COEFFICIENTS = 1 << 1;\nvar CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;\nvar CJK_HUNDRED_COEFFICIENTS = 1 << 3;\n\nvar createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {\n  if (value < -9999 || value > 9999) {\n    return createCounterText(value, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CJK_DECIMAL, suffix.length > 0);\n  }\n\n  var tmp = Math.abs(value);\n  var string = suffix;\n\n  if (tmp === 0) {\n    return numbers[0] + string;\n  }\n\n  for (var digit = 0; tmp > 0 && digit <= 4; digit++) {\n    var coefficient = tmp % 10;\n\n    if (coefficient === 0 && Object(_Util__WEBPACK_IMPORTED_MODULE_0__[\"contains\"])(flags, CJK_ZEROS) && string !== '') {\n      string = numbers[coefficient] + string;\n    } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && Object(_Util__WEBPACK_IMPORTED_MODULE_0__[\"contains\"])(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && Object(_Util__WEBPACK_IMPORTED_MODULE_0__[\"contains\"])(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && Object(_Util__WEBPACK_IMPORTED_MODULE_0__[\"contains\"])(flags, CJK_HUNDRED_COEFFICIENTS)) {\n      string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;\n    } else if (coefficient === 1 && digit > 0) {\n      string = multipliers[digit - 1] + string;\n    }\n\n    tmp = Math.floor(tmp / 10);\n  }\n\n  return (value < 0 ? negativeSign : '') + string;\n};\n\nvar CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';\nvar CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';\nvar JAPANESE_NEGATIVE = 'マイナス';\nvar KOREAN_NEGATIVE = '마이너스';\nvar createCounterText = function createCounterText(value, type, appendSuffix) {\n  var defaultSuffix = appendSuffix ? '. ' : '';\n  var cjkSuffix = appendSuffix ? '、' : '';\n  var koreanSuffix = appendSuffix ? ', ' : '';\n\n  switch (type) {\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DISC:\n      return '•';\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CIRCLE:\n      return '◦';\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].SQUARE:\n      return '◾';\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL_LEADING_ZERO:\n      var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);\n      return string.length < 4 ? \"0\".concat(string) : string;\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CJK_DECIMAL:\n      return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].LOWER_ROMAN:\n      return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL, defaultSuffix).toLowerCase();\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].UPPER_ROMAN:\n      return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].LOWER_GREEK:\n      return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].LOWER_ALPHA:\n      return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].UPPER_ALPHA:\n      return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].ARABIC_INDIC:\n      return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].ARMENIAN:\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].UPPER_ARMENIAN:\n      return createAdditiveCounter(value, 1, 9999, ARMENIAN, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].LOWER_ARMENIAN:\n      return createAdditiveCounter(value, 1, 9999, ARMENIAN, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL, defaultSuffix).toLowerCase();\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].BENGALI:\n      return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CAMBODIAN:\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KHMER:\n      return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CJK_EARTHLY_BRANCH:\n      return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CJK_HEAVENLY_STEM:\n      return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].CJK_IDEOGRAPHIC:\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].TRAD_CHINESE_INFORMAL:\n      return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].TRAD_CHINESE_FORMAL:\n      return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].SIMP_CHINESE_INFORMAL:\n      return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].SIMP_CHINESE_FORMAL:\n      return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].JAPANESE_INFORMAL:\n      return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].JAPANESE_FORMAL:\n      return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KOREAN_HANGUL_FORMAL:\n      return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KOREAN_HANJA_INFORMAL:\n      return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KOREAN_HANJA_FORMAL:\n      return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DEVANAGARI:\n      return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].GEORGIAN:\n      return createAdditiveCounter(value, 1, 19999, GEORGIAN, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].GUJARATI:\n      return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].GURMUKHI:\n      return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].HEBREW:\n      return createAdditiveCounter(value, 1, 10999, HEBREW, _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].HIRAGANA:\n      return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].HIRAGANA_IROHA:\n      return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KANNADA:\n      return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KATAKANA:\n      return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].KATAKANA_IROHA:\n      return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].LAO:\n      return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].MONGOLIAN:\n      return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].MYANMAR:\n      return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].ORIYA:\n      return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].PERSIAN:\n      return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].TAMIL:\n      return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].TELUGU:\n      return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].THAI:\n      return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].TIBETAN:\n      return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);\n\n    case _parsing_listStyle__WEBPACK_IMPORTED_MODULE_3__[\"LIST_STYLE_TYPE\"].DECIMAL:\n    default:\n      return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/ListItem.js?");
      },
      "./src/Logger.js": function srcLoggerJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Logger; });\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nvar Logger =\n/*#__PURE__*/\nfunction () {\n  function Logger(enabled, id, start) {\n    _classCallCheck(this, Logger);\n\n    this.enabled = typeof window !== \'undefined\' && enabled;\n    this.start = start ? start : Date.now();\n    this.id = id;\n  }\n\n  _createClass(Logger, [{\n    key: "child",\n    value: function child(id) {\n      return new Logger(this.enabled, id, this.start);\n    } // eslint-disable-next-line flowtype/no-weak-types\n\n  }, {\n    key: "log",\n    value: function log() {\n      if (this.enabled && window.console && window.console.log) {\n        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {\n          args[_key] = arguments[_key];\n        }\n\n        Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + \'ms\', this.id ? "html2canvas (".concat(this.id, "):") : \'html2canvas:\'].concat([].slice.call(args, 0)));\n      }\n    } // eslint-disable-next-line flowtype/no-weak-types\n\n  }, {\n    key: "error",\n    value: function error() {\n      if (this.enabled && window.console && window.console.error) {\n        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {\n          args[_key2] = arguments[_key2];\n        }\n\n        Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + \'ms\', this.id ? "html2canvas (".concat(this.id, "):") : \'html2canvas:\'].concat([].slice.call(args, 0)));\n      }\n    }\n  }]);\n\n  return Logger;\n}();\n\n\n\n//# sourceURL=webpack://html2canvas/./src/Logger.js?');
      },
      "./src/NodeContainer.js": function srcNodeContainerJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NodeContainer; });\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Color */ "./src/Color.js");\n/* harmony import */ var _Util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Util */ "./src/Util.js");\n/* harmony import */ var _parsing_background__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./parsing/background */ "./src/parsing/background.js");\n/* harmony import */ var _parsing_border__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./parsing/border */ "./src/parsing/border.js");\n/* harmony import */ var _parsing_borderRadius__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./parsing/borderRadius */ "./src/parsing/borderRadius.js");\n/* harmony import */ var _parsing_display__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./parsing/display */ "./src/parsing/display.js");\n/* harmony import */ var _parsing_float__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./parsing/float */ "./src/parsing/float.js");\n/* harmony import */ var _parsing_font__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./parsing/font */ "./src/parsing/font.js");\n/* harmony import */ var _parsing_letterSpacing__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./parsing/letterSpacing */ "./src/parsing/letterSpacing.js");\n/* harmony import */ var _parsing_lineBreak__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./parsing/lineBreak */ "./src/parsing/lineBreak.js");\n/* harmony import */ var _parsing_listStyle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./parsing/listStyle */ "./src/parsing/listStyle.js");\n/* harmony import */ var _parsing_margin__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./parsing/margin */ "./src/parsing/margin.js");\n/* harmony import */ var _parsing_overflow__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./parsing/overflow */ "./src/parsing/overflow.js");\n/* harmony import */ var _parsing_overflowWrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./parsing/overflowWrap */ "./src/parsing/overflowWrap.js");\n/* harmony import */ var _parsing_padding__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./parsing/padding */ "./src/parsing/padding.js");\n/* harmony import */ var _parsing_position__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./parsing/position */ "./src/parsing/position.js");\n/* harmony import */ var _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./parsing/textDecoration */ "./src/parsing/textDecoration.js");\n/* harmony import */ var _parsing_textShadow__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./parsing/textShadow */ "./src/parsing/textShadow.js");\n/* harmony import */ var _parsing_textTransform__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./parsing/textTransform */ "./src/parsing/textTransform.js");\n/* harmony import */ var _parsing_transform__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./parsing/transform */ "./src/parsing/transform.js");\n/* harmony import */ var _parsing_visibility__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./parsing/visibility */ "./src/parsing/visibility.js");\n/* harmony import */ var _parsing_word_break__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./parsing/word-break */ "./src/parsing/word-break.js");\n/* harmony import */ var _parsing_zIndex__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./parsing/zIndex */ "./src/parsing/zIndex.js");\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Bounds */ "./src/Bounds.js");\n/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./Input */ "./src/Input.js");\n/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./ListItem */ "./src/ListItem.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nvar INPUT_TAGS = [\'INPUT\', \'TEXTAREA\', \'SELECT\'];\n\nvar NodeContainer =\n/*#__PURE__*/\nfunction () {\n  function NodeContainer(node, parent, resourceLoader, index) {\n    var _this = this;\n\n    _classCallCheck(this, NodeContainer);\n\n    this.parent = parent;\n    this.tagName = node.tagName;\n    this.index = index;\n    this.childNodes = [];\n    this.listItems = [];\n\n    if (typeof node.start === \'number\') {\n      this.listStart = node.start;\n    }\n\n    var defaultView = node.ownerDocument.defaultView;\n    var scrollX = defaultView.pageXOffset;\n    var scrollY = defaultView.pageYOffset;\n    var style = defaultView.getComputedStyle(node, null);\n    var display = Object(_parsing_display__WEBPACK_IMPORTED_MODULE_5__["parseDisplay"])(style.display);\n    var IS_INPUT = node.type === \'radio\' || node.type === \'checkbox\';\n    var position = Object(_parsing_position__WEBPACK_IMPORTED_MODULE_15__["parsePosition"])(style.position);\n    this.style = {\n      background: IS_INPUT ? _Input__WEBPACK_IMPORTED_MODULE_24__["INPUT_BACKGROUND"] : Object(_parsing_background__WEBPACK_IMPORTED_MODULE_2__["parseBackground"])(style, resourceLoader),\n      border: IS_INPUT ? _Input__WEBPACK_IMPORTED_MODULE_24__["INPUT_BORDERS"] : Object(_parsing_border__WEBPACK_IMPORTED_MODULE_3__["parseBorder"])(style),\n      borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? Object(_Input__WEBPACK_IMPORTED_MODULE_24__["getInputBorderRadius"])(node) : Object(_parsing_borderRadius__WEBPACK_IMPORTED_MODULE_4__["parseBorderRadius"])(style),\n      color: IS_INPUT ? _Input__WEBPACK_IMPORTED_MODULE_24__["INPUT_COLOR"] : new _Color__WEBPACK_IMPORTED_MODULE_0__["default"](style.color),\n      display: display,\n      float: Object(_parsing_float__WEBPACK_IMPORTED_MODULE_6__["parseCSSFloat"])(style.float),\n      font: Object(_parsing_font__WEBPACK_IMPORTED_MODULE_7__["parseFont"])(style),\n      letterSpacing: Object(_parsing_letterSpacing__WEBPACK_IMPORTED_MODULE_8__["parseLetterSpacing"])(style.letterSpacing),\n      listStyle: display === _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].LIST_ITEM ? Object(_parsing_listStyle__WEBPACK_IMPORTED_MODULE_10__["parseListStyle"])(style) : null,\n      lineBreak: Object(_parsing_lineBreak__WEBPACK_IMPORTED_MODULE_9__["parseLineBreak"])(style.lineBreak),\n      margin: Object(_parsing_margin__WEBPACK_IMPORTED_MODULE_11__["parseMargin"])(style),\n      opacity: parseFloat(style.opacity),\n      overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? Object(_parsing_overflow__WEBPACK_IMPORTED_MODULE_12__["parseOverflow"])(style.overflow) : _parsing_overflow__WEBPACK_IMPORTED_MODULE_12__["OVERFLOW"].HIDDEN,\n      overflowWrap: Object(_parsing_overflowWrap__WEBPACK_IMPORTED_MODULE_13__["parseOverflowWrap"])(style.overflowWrap ? style.overflowWrap : style.wordWrap),\n      padding: Object(_parsing_padding__WEBPACK_IMPORTED_MODULE_14__["parsePadding"])(style),\n      position: position,\n      textDecoration: Object(_parsing_textDecoration__WEBPACK_IMPORTED_MODULE_16__["parseTextDecoration"])(style),\n      textShadow: Object(_parsing_textShadow__WEBPACK_IMPORTED_MODULE_17__["parseTextShadow"])(style.textShadow),\n      textTransform: Object(_parsing_textTransform__WEBPACK_IMPORTED_MODULE_18__["parseTextTransform"])(style.textTransform),\n      transform: Object(_parsing_transform__WEBPACK_IMPORTED_MODULE_19__["parseTransform"])(style),\n      visibility: Object(_parsing_visibility__WEBPACK_IMPORTED_MODULE_20__["parseVisibility"])(style.visibility),\n      wordBreak: Object(_parsing_word_break__WEBPACK_IMPORTED_MODULE_21__["parseWordBreak"])(style.wordBreak),\n      zIndex: Object(_parsing_zIndex__WEBPACK_IMPORTED_MODULE_22__["parseZIndex"])(position !== _parsing_position__WEBPACK_IMPORTED_MODULE_15__["POSITION"].STATIC ? style.zIndex : \'auto\')\n    };\n\n    if (this.isTransformed()) {\n      // getBoundingClientRect provides values post-transform, we want them without the transformation\n      node.style.transform = \'matrix(1,0,0,1,0,0)\';\n    }\n\n    if (display === _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].LIST_ITEM) {\n      var listOwner = Object(_ListItem__WEBPACK_IMPORTED_MODULE_25__["getListOwner"])(this);\n\n      if (listOwner) {\n        var listIndex = listOwner.listItems.length;\n        listOwner.listItems.push(this);\n        this.listIndex = node.hasAttribute(\'value\') && typeof node.value === \'number\' ? node.value : listIndex === 0 ? typeof listOwner.listStart === \'number\' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;\n      }\n    } // TODO move bound retrieval for all nodes to a later stage?\n\n\n    if (node.tagName === \'IMG\') {\n      node.addEventListener(\'load\', function () {\n        _this.bounds = Object(_Bounds__WEBPACK_IMPORTED_MODULE_23__["parseBounds"])(node, scrollX, scrollY);\n        _this.curvedBounds = Object(_Bounds__WEBPACK_IMPORTED_MODULE_23__["parseBoundCurves"])(_this.bounds, _this.style.border, _this.style.borderRadius);\n      });\n    }\n\n    this.image = getImage(node, resourceLoader);\n    this.bounds = IS_INPUT ? Object(_Input__WEBPACK_IMPORTED_MODULE_24__["reformatInputBounds"])(Object(_Bounds__WEBPACK_IMPORTED_MODULE_23__["parseBounds"])(node, scrollX, scrollY)) : Object(_Bounds__WEBPACK_IMPORTED_MODULE_23__["parseBounds"])(node, scrollX, scrollY);\n    this.curvedBounds = Object(_Bounds__WEBPACK_IMPORTED_MODULE_23__["parseBoundCurves"])(this.bounds, this.style.border, this.style.borderRadius);\n\n    if (true) {\n      this.name = "".concat(node.tagName.toLowerCase()).concat(node.id ? "#".concat(node.id) : \'\').concat(node.className.toString().split(\' \').map(function (s) {\n        return s.length ? ".".concat(s) : \'\';\n      }).join(\'\'));\n    }\n  }\n\n  _createClass(NodeContainer, [{\n    key: "getClipPaths",\n    value: function getClipPaths() {\n      var parentClips = this.parent ? this.parent.getClipPaths() : [];\n      var isClipped = this.style.overflow !== _parsing_overflow__WEBPACK_IMPORTED_MODULE_12__["OVERFLOW"].VISIBLE;\n      return isClipped ? parentClips.concat([Object(_Bounds__WEBPACK_IMPORTED_MODULE_23__["calculatePaddingBoxPath"])(this.curvedBounds)]) : parentClips;\n    }\n  }, {\n    key: "isInFlow",\n    value: function isInFlow() {\n      return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();\n    }\n  }, {\n    key: "isVisible",\n    value: function isVisible() {\n      return !Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].NONE) && this.style.opacity > 0 && this.style.visibility === _parsing_visibility__WEBPACK_IMPORTED_MODULE_20__["VISIBILITY"].VISIBLE;\n    }\n  }, {\n    key: "isAbsolutelyPositioned",\n    value: function isAbsolutelyPositioned() {\n      return this.style.position !== _parsing_position__WEBPACK_IMPORTED_MODULE_15__["POSITION"].STATIC && this.style.position !== _parsing_position__WEBPACK_IMPORTED_MODULE_15__["POSITION"].RELATIVE;\n    }\n  }, {\n    key: "isPositioned",\n    value: function isPositioned() {\n      return this.style.position !== _parsing_position__WEBPACK_IMPORTED_MODULE_15__["POSITION"].STATIC;\n    }\n  }, {\n    key: "isFloating",\n    value: function isFloating() {\n      return this.style.float !== _parsing_float__WEBPACK_IMPORTED_MODULE_6__["FLOAT"].NONE;\n    }\n  }, {\n    key: "isRootElement",\n    value: function isRootElement() {\n      return this.parent === null;\n    }\n  }, {\n    key: "isTransformed",\n    value: function isTransformed() {\n      return this.style.transform !== null;\n    }\n  }, {\n    key: "isPositionedWithZIndex",\n    value: function isPositionedWithZIndex() {\n      return this.isPositioned() && !this.style.zIndex.auto;\n    }\n  }, {\n    key: "isInlineLevel",\n    value: function isInlineLevel() {\n      return Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE) || Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_BLOCK) || Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_FLEX) || Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_GRID) || Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_LIST_ITEM) || Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_TABLE);\n    }\n  }, {\n    key: "isInlineBlockOrInlineTable",\n    value: function isInlineBlockOrInlineTable() {\n      return Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_BLOCK) || Object(_Util__WEBPACK_IMPORTED_MODULE_1__["contains"])(this.style.display, _parsing_display__WEBPACK_IMPORTED_MODULE_5__["DISPLAY"].INLINE_TABLE);\n    }\n  }]);\n\n  return NodeContainer;\n}();\n\n\n\nvar getImage = function getImage(node, resourceLoader) {\n  if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {\n    var s = new XMLSerializer();\n    return resourceLoader.loadImage("data:image/svg+xml,".concat(encodeURIComponent(s.serializeToString(node))));\n  }\n\n  switch (node.tagName) {\n    case \'IMG\':\n      // $FlowFixMe\n      var img = node;\n      return resourceLoader.loadImage(img.currentSrc || img.src);\n\n    case \'CANVAS\':\n      // $FlowFixMe\n      var canvas = node;\n      return resourceLoader.loadCanvas(canvas);\n\n    case \'IFRAME\':\n      var iframeKey = node.getAttribute(\'data-html2canvas-internal-iframe-key\');\n\n      if (iframeKey) {\n        return iframeKey;\n      }\n\n      break;\n  }\n\n  return null;\n};\n\n//# sourceURL=webpack://html2canvas/./src/NodeContainer.js?');
      },
      "./src/NodeParser.js": function srcNodeParserJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NodeParser", function() { return NodeParser; });\n/* harmony import */ var _StackingContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StackingContext */ "./src/StackingContext.js");\n/* harmony import */ var _NodeContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NodeContainer */ "./src/NodeContainer.js");\n/* harmony import */ var _TextContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TextContainer */ "./src/TextContainer.js");\n/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Input */ "./src/Input.js");\n/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ListItem */ "./src/ListItem.js");\n/* harmony import */ var _parsing_listStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./parsing/listStyle */ "./src/parsing/listStyle.js");\n\n\n\n\n\n\n\n\nvar NodeParser = function NodeParser(node, resourceLoader, logger) {\n  if (true) {\n    logger.log("Starting node parsing");\n  }\n\n  var index = 0;\n  var container = new _NodeContainer__WEBPACK_IMPORTED_MODULE_1__["default"](node, null, resourceLoader, index++);\n  var stack = new _StackingContext__WEBPACK_IMPORTED_MODULE_0__["default"](container, null, true);\n  parseNodeTree(node, container, stack, resourceLoader, index);\n\n  if (true) {\n    logger.log("Finished parsing node tree");\n  }\n\n  return stack;\n};\nvar IGNORED_NODE_NAMES = [\'SCRIPT\', \'HEAD\', \'TITLE\', \'OBJECT\', \'BR\', \'OPTION\'];\n\nvar parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {\n  if ( true && index > 50000) {\n    throw new Error("Recursion error while parsing node tree");\n  }\n\n  for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {\n    nextNode = childNode.nextSibling;\n    var defaultView = childNode.ownerDocument.defaultView;\n\n    if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {\n      if (childNode.data.trim().length > 0) {\n        parent.childNodes.push(_TextContainer__WEBPACK_IMPORTED_MODULE_2__["default"].fromTextNode(childNode, parent));\n      }\n    } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {\n      if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {\n        var container = new _NodeContainer__WEBPACK_IMPORTED_MODULE_1__["default"](childNode, parent, resourceLoader, index++);\n\n        if (container.isVisible()) {\n          if (childNode.tagName === \'INPUT\') {\n            // $FlowFixMe\n            Object(_Input__WEBPACK_IMPORTED_MODULE_3__["inlineInputElement"])(childNode, container);\n          } else if (childNode.tagName === \'TEXTAREA\') {\n            // $FlowFixMe\n            Object(_Input__WEBPACK_IMPORTED_MODULE_3__["inlineTextAreaElement"])(childNode, container);\n          } else if (childNode.tagName === \'SELECT\') {\n            // $FlowFixMe\n            Object(_Input__WEBPACK_IMPORTED_MODULE_3__["inlineSelectElement"])(childNode, container);\n          } else if (container.style.listStyle && container.style.listStyle.listStyleType !== _parsing_listStyle__WEBPACK_IMPORTED_MODULE_5__["LIST_STYLE_TYPE"].NONE) {\n            Object(_ListItem__WEBPACK_IMPORTED_MODULE_4__["inlineListItemElement"])(childNode, container, resourceLoader);\n          }\n\n          var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== \'TEXTAREA\';\n          var treatAsRealStackingContext = createsRealStackingContext(container, childNode);\n\n          if (treatAsRealStackingContext || createsStackingContext(container)) {\n            // for treatAsRealStackingContext:false, any positioned descendants and descendants\n            // which actually create a new stacking context should be considered part of the parent stacking context\n            var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;\n            var childStack = new _StackingContext__WEBPACK_IMPORTED_MODULE_0__["default"](container, parentStack, treatAsRealStackingContext);\n            parentStack.contexts.push(childStack);\n\n            if (SHOULD_TRAVERSE_CHILDREN) {\n              parseNodeTree(childNode, container, childStack, resourceLoader, index);\n            }\n          } else {\n            stack.children.push(container);\n\n            if (SHOULD_TRAVERSE_CHILDREN) {\n              parseNodeTree(childNode, container, stack, resourceLoader, index);\n            }\n          }\n        }\n      }\n    } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {\n      var _container = new _NodeContainer__WEBPACK_IMPORTED_MODULE_1__["default"](childNode, parent, resourceLoader, index++);\n\n      var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);\n\n      if (_treatAsRealStackingContext || createsStackingContext(_container)) {\n        // for treatAsRealStackingContext:false, any positioned descendants and descendants\n        // which actually create a new stacking context should be considered part of the parent stacking context\n        var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;\n\n        var _childStack = new _StackingContext__WEBPACK_IMPORTED_MODULE_0__["default"](_container, _parentStack, _treatAsRealStackingContext);\n\n        _parentStack.contexts.push(_childStack);\n      } else {\n        stack.children.push(_container);\n      }\n    }\n  }\n};\n\nvar createsRealStackingContext = function createsRealStackingContext(container, node) {\n  return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);\n};\n\nvar createsStackingContext = function createsStackingContext(container) {\n  return container.isPositioned() || container.isFloating();\n};\n\nvar isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {\n  return node.nodeName === \'BODY\' && container.parent instanceof _NodeContainer__WEBPACK_IMPORTED_MODULE_1__["default"] && container.parent.style.background.backgroundColor.isTransparent();\n};\n\n//# sourceURL=webpack://html2canvas/./src/NodeParser.js?');
      },
      "./src/Proxy.js": function srcProxyJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Proxy", function() { return Proxy; });\n/* harmony import */ var _Feature__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Feature */ "./src/Feature.js");\n\n\n\nvar Proxy = function Proxy(src, options) {\n  if (!options.proxy) {\n    return Promise.reject( true ? \'No proxy defined\' : undefined);\n  }\n\n  var proxy = options.proxy;\n  return new Promise(function (resolve, reject) {\n    var responseType = _Feature__WEBPACK_IMPORTED_MODULE_0__["default"].SUPPORT_CORS_XHR && _Feature__WEBPACK_IMPORTED_MODULE_0__["default"].SUPPORT_RESPONSE_TYPE ? \'blob\' : \'text\';\n    var xhr = _Feature__WEBPACK_IMPORTED_MODULE_0__["default"].SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();\n\n    xhr.onload = function () {\n      if (xhr instanceof XMLHttpRequest) {\n        if (xhr.status === 200) {\n          if (responseType === \'text\') {\n            resolve(xhr.response);\n          } else {\n            var reader = new FileReader(); // $FlowFixMe\n\n            reader.addEventListener(\'load\', function () {\n              return resolve(reader.result);\n            }, false); // $FlowFixMe\n\n            reader.addEventListener(\'error\', function (e) {\n              return reject(e);\n            }, false);\n            reader.readAsDataURL(xhr.response);\n          }\n        } else {\n          reject( true ? "Failed to proxy resource ".concat(src.substring(0, 256), " with status code ").concat(xhr.status) : undefined);\n        }\n      } else {\n        resolve(xhr.responseText);\n      }\n    };\n\n    xhr.onerror = reject;\n    xhr.open(\'GET\', "".concat(proxy, "?url=").concat(encodeURIComponent(src), "&responseType=").concat(responseType));\n\n    if (responseType !== \'text\' && xhr instanceof XMLHttpRequest) {\n      xhr.responseType = responseType;\n    }\n\n    if (options.imageTimeout) {\n      var timeout = options.imageTimeout;\n      xhr.timeout = timeout;\n\n      xhr.ontimeout = function () {\n        return reject( true ? "Timed out (".concat(timeout, "ms) proxying ").concat(src.substring(0, 256)) : undefined);\n      };\n    }\n\n    xhr.send();\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/Proxy.js?');
      },
      "./src/PseudoNodeContent.js": function srcPseudoNodeContentJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"PSEUDO_CONTENT_ITEM_TYPE\", function() { return PSEUDO_CONTENT_ITEM_TYPE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TOKEN_TYPE\", function() { return TOKEN_TYPE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseCounterReset\", function() { return parseCounterReset; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"popCounters\", function() { return popCounters; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"resolvePseudoContent\", function() { return resolvePseudoContent; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseContent\", function() { return parseContent; });\n/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ListItem */ \"./src/ListItem.js\");\n/* harmony import */ var _parsing_listStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parsing/listStyle */ \"./src/parsing/listStyle.js\");\n\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError(\"Invalid attempt to destructure non-iterable instance\"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i[\"return\"] != null) _i[\"return\"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\nvar PSEUDO_CONTENT_ITEM_TYPE = {\n  TEXT: 0,\n  IMAGE: 1\n};\nvar TOKEN_TYPE = {\n  STRING: 0,\n  ATTRIBUTE: 1,\n  URL: 2,\n  COUNTER: 3,\n  COUNTERS: 4,\n  OPENQUOTE: 5,\n  CLOSEQUOTE: 6\n};\nvar parseCounterReset = function parseCounterReset(style, data) {\n  if (!style || !style.counterReset || style.counterReset === 'none') {\n    return [];\n  }\n\n  var counterNames = [];\n  var counterResets = style.counterReset.split(/\\s*,\\s*/);\n  var lenCounterResets = counterResets.length;\n\n  for (var i = 0; i < lenCounterResets; i++) {\n    var _counterResets$i$spli = counterResets[i].split(/\\s+/),\n        _counterResets$i$spli2 = _slicedToArray(_counterResets$i$spli, 2),\n        counterName = _counterResets$i$spli2[0],\n        initialValue = _counterResets$i$spli2[1];\n\n    counterNames.push(counterName);\n    var counter = data.counters[counterName];\n\n    if (!counter) {\n      counter = data.counters[counterName] = [];\n    }\n\n    counter.push(parseInt(initialValue || 0, 10));\n  }\n\n  return counterNames;\n};\nvar popCounters = function popCounters(counterNames, data) {\n  var lenCounters = counterNames.length;\n\n  for (var i = 0; i < lenCounters; i++) {\n    data.counters[counterNames[i]].pop();\n  }\n};\nvar resolvePseudoContent = function resolvePseudoContent(node, style, data) {\n  if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {\n    return null;\n  }\n\n  var tokens = parseContent(style.content);\n  var len = tokens.length;\n  var contentItems = [];\n  var s = ''; // increment the counter (if there is a \"counter-increment\" declaration)\n\n  var counterIncrement = style.counterIncrement;\n\n  if (counterIncrement && counterIncrement !== 'none') {\n    var _counterIncrement$spl = counterIncrement.split(/\\s+/),\n        _counterIncrement$spl2 = _slicedToArray(_counterIncrement$spl, 2),\n        counterName = _counterIncrement$spl2[0],\n        incrementValue = _counterIncrement$spl2[1];\n\n    var counter = data.counters[counterName];\n\n    if (counter) {\n      counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);\n    }\n  } // build the content string\n\n\n  for (var i = 0; i < len; i++) {\n    var token = tokens[i];\n\n    switch (token.type) {\n      case TOKEN_TYPE.STRING:\n        s += token.value || '';\n        break;\n\n      case TOKEN_TYPE.ATTRIBUTE:\n        if (node instanceof HTMLElement && token.value) {\n          s += node.getAttribute(token.value) || '';\n        }\n\n        break;\n\n      case TOKEN_TYPE.COUNTER:\n        var _counter = data.counters[token.name || ''];\n\n        if (_counter) {\n          s += formatCounterValue([_counter[_counter.length - 1]], '', token.format);\n        }\n\n        break;\n\n      case TOKEN_TYPE.COUNTERS:\n        var counters = data.counters[token.name || ''];\n\n        if (counters) {\n          s += formatCounterValue(counters, token.glue, token.format);\n        }\n\n        break;\n\n      case TOKEN_TYPE.OPENQUOTE:\n        s += getQuote(style, true, data.quoteDepth);\n        data.quoteDepth++;\n        break;\n\n      case TOKEN_TYPE.CLOSEQUOTE:\n        data.quoteDepth--;\n        s += getQuote(style, false, data.quoteDepth);\n        break;\n\n      case TOKEN_TYPE.URL:\n        if (s) {\n          contentItems.push({\n            type: PSEUDO_CONTENT_ITEM_TYPE.TEXT,\n            value: s\n          });\n          s = '';\n        }\n\n        contentItems.push({\n          type: PSEUDO_CONTENT_ITEM_TYPE.IMAGE,\n          value: token.value || ''\n        });\n        break;\n    }\n  }\n\n  if (s) {\n    contentItems.push({\n      type: PSEUDO_CONTENT_ITEM_TYPE.TEXT,\n      value: s\n    });\n  }\n\n  return contentItems;\n};\nvar parseContent = function parseContent(content, cache) {\n  if (cache && cache[content]) {\n    return cache[content];\n  }\n\n  var tokens = [];\n  var len = content.length;\n  var isString = false;\n  var isEscaped = false;\n  var isFunction = false;\n  var str = '';\n  var functionName = '';\n  var args = [];\n\n  for (var i = 0; i < len; i++) {\n    var c = content.charAt(i);\n\n    switch (c) {\n      case \"'\":\n      case '\"':\n        if (isEscaped) {\n          str += c;\n        } else {\n          isString = !isString;\n\n          if (!isFunction && !isString) {\n            tokens.push({\n              type: TOKEN_TYPE.STRING,\n              value: str\n            });\n            str = '';\n          }\n        }\n\n        break;\n\n      case '\\\\':\n        if (isEscaped) {\n          str += c;\n          isEscaped = false;\n        } else {\n          isEscaped = true;\n        }\n\n        break;\n\n      case '(':\n        if (isString) {\n          str += c;\n        } else {\n          isFunction = true;\n          functionName = str;\n          str = '';\n          args = [];\n        }\n\n        break;\n\n      case ')':\n        if (isString) {\n          str += c;\n        } else if (isFunction) {\n          if (str) {\n            args.push(str);\n          }\n\n          switch (functionName) {\n            case 'attr':\n              if (args.length > 0) {\n                tokens.push({\n                  type: TOKEN_TYPE.ATTRIBUTE,\n                  value: args[0]\n                });\n              }\n\n              break;\n\n            case 'counter':\n              if (args.length > 0) {\n                var counter = {\n                  type: TOKEN_TYPE.COUNTER,\n                  name: args[0]\n                };\n\n                if (args.length > 1) {\n                  counter.format = args[1];\n                }\n\n                tokens.push(counter);\n              }\n\n              break;\n\n            case 'counters':\n              if (args.length > 0) {\n                var counters = {\n                  type: TOKEN_TYPE.COUNTERS,\n                  name: args[0]\n                };\n\n                if (args.length > 1) {\n                  counters.glue = args[1];\n                }\n\n                if (args.length > 2) {\n                  counters.format = args[2];\n                }\n\n                tokens.push(counters);\n              }\n\n              break;\n\n            case 'url':\n              if (args.length > 0) {\n                tokens.push({\n                  type: TOKEN_TYPE.URL,\n                  value: args[0]\n                });\n              }\n\n              break;\n          }\n\n          isFunction = false;\n          str = '';\n        }\n\n        break;\n\n      case ',':\n        if (isString) {\n          str += c;\n        } else if (isFunction) {\n          args.push(str);\n          str = '';\n        }\n\n        break;\n\n      case ' ':\n      case '\\t':\n        if (isString) {\n          str += c;\n        } else if (str) {\n          addOtherToken(tokens, str);\n          str = '';\n        }\n\n        break;\n\n      default:\n        str += c;\n    }\n\n    if (c !== '\\\\') {\n      isEscaped = false;\n    }\n  }\n\n  if (str) {\n    addOtherToken(tokens, str);\n  }\n\n  if (cache) {\n    cache[content] = tokens;\n  }\n\n  return tokens;\n};\n\nvar addOtherToken = function addOtherToken(tokens, identifier) {\n  switch (identifier) {\n    case 'open-quote':\n      tokens.push({\n        type: TOKEN_TYPE.OPENQUOTE\n      });\n      break;\n\n    case 'close-quote':\n      tokens.push({\n        type: TOKEN_TYPE.CLOSEQUOTE\n      });\n      break;\n  }\n};\n\nvar getQuote = function getQuote(style, isOpening, quoteDepth) {\n  var quotes = style.quotes ? style.quotes.split(/\\s+/) : [\"'\\\"'\", \"'\\\"'\"];\n  var idx = quoteDepth * 2;\n\n  if (idx >= quotes.length) {\n    idx = quotes.length - 2;\n  }\n\n  if (!isOpening) {\n    ++idx;\n  }\n\n  return quotes[idx].replace(/^[\"']|[\"']$/g, '');\n};\n\nvar formatCounterValue = function formatCounterValue(counter, glue, format) {\n  var len = counter.length;\n  var result = '';\n\n  for (var i = 0; i < len; i++) {\n    if (i > 0) {\n      result += glue || '';\n    }\n\n    result += Object(_ListItem__WEBPACK_IMPORTED_MODULE_0__[\"createCounterText\"])(counter[i], Object(_parsing_listStyle__WEBPACK_IMPORTED_MODULE_1__[\"parseListStyleType\"])(format || 'decimal'), false);\n  }\n\n  return result;\n};\n\n//# sourceURL=webpack://html2canvas/./src/PseudoNodeContent.js?");
      },
      "./src/Renderer.js": function srcRendererJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Renderer; });\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Bounds */ "./src/Bounds.js");\n/* harmony import */ var _Font__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Font */ "./src/Font.js");\n/* harmony import */ var _Gradient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Gradient */ "./src/Gradient.js");\n/* harmony import */ var _TextContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TextContainer */ "./src/TextContainer.js");\n/* harmony import */ var _parsing_background__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./parsing/background */ "./src/parsing/background.js");\n/* harmony import */ var _parsing_border__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./parsing/border */ "./src/parsing/border.js");\n\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\n\n\n\n\nvar Renderer =\n/*#__PURE__*/\nfunction () {\n  function Renderer(target, options) {\n    _classCallCheck(this, Renderer);\n\n    this.target = target;\n    this.options = options;\n    target.render(options);\n  }\n\n  _createClass(Renderer, [{\n    key: "renderNode",\n    value: function renderNode(container) {\n      if (container.isVisible()) {\n        this.renderNodeBackgroundAndBorders(container);\n        this.renderNodeContent(container);\n      }\n    }\n  }, {\n    key: "renderNodeContent",\n    value: function renderNodeContent(container) {\n      var _this = this;\n\n      var callback = function callback() {\n        if (container.childNodes.length) {\n          container.childNodes.forEach(function (child) {\n            if (child instanceof _TextContainer__WEBPACK_IMPORTED_MODULE_3__["default"]) {\n              var style = child.parent.style;\n\n              _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);\n            } else {\n              _this.target.drawShape(child, container.style.color);\n            }\n          });\n        }\n\n        if (container.image) {\n          var _image = _this.options.imageStore.get(container.image);\n\n          if (_image) {\n            var contentBox = Object(_Bounds__WEBPACK_IMPORTED_MODULE_0__["calculateContentBox"])(container.bounds, container.style.padding, container.style.border);\n\n            var _width = typeof _image.width === \'number\' && _image.width > 0 ? _image.width : contentBox.width;\n\n            var _height = typeof _image.height === \'number\' && _image.height > 0 ? _image.height : contentBox.height;\n\n            if (_width > 0 && _height > 0) {\n              _this.target.clip([Object(_Bounds__WEBPACK_IMPORTED_MODULE_0__["calculatePaddingBoxPath"])(container.curvedBounds)], function () {\n                _this.target.drawImage(_image, new _Bounds__WEBPACK_IMPORTED_MODULE_0__["Bounds"](0, 0, _width, _height), contentBox);\n              });\n            }\n          }\n        }\n      };\n\n      var paths = container.getClipPaths();\n\n      if (paths.length) {\n        this.target.clip(paths, callback);\n      } else {\n        callback();\n      }\n    }\n  }, {\n    key: "renderNodeBackgroundAndBorders",\n    value: function renderNodeBackgroundAndBorders(container) {\n      var _this2 = this;\n\n      var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;\n      var hasRenderableBorders = container.style.border.some(function (border) {\n        return border.borderStyle !== _parsing_border__WEBPACK_IMPORTED_MODULE_5__["BORDER_STYLE"].NONE && !border.borderColor.isTransparent();\n      });\n\n      var callback = function callback() {\n        var backgroundPaintingArea = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroungPaintingArea"])(container.curvedBounds, container.style.background.backgroundClip);\n\n        if (HAS_BACKGROUND) {\n          _this2.target.clip([backgroundPaintingArea], function () {\n            if (!container.style.background.backgroundColor.isTransparent()) {\n              _this2.target.fill(container.style.background.backgroundColor);\n            }\n\n            _this2.renderBackgroundImage(container);\n          });\n        }\n\n        container.style.border.forEach(function (border, side) {\n          if (border.borderStyle !== _parsing_border__WEBPACK_IMPORTED_MODULE_5__["BORDER_STYLE"].NONE && !border.borderColor.isTransparent()) {\n            _this2.renderBorder(border, side, container.curvedBounds);\n          }\n        });\n      };\n\n      if (HAS_BACKGROUND || hasRenderableBorders) {\n        var paths = container.parent ? container.parent.getClipPaths() : [];\n\n        if (paths.length) {\n          this.target.clip(paths, callback);\n        } else {\n          callback();\n        }\n      }\n    }\n  }, {\n    key: "renderBackgroundImage",\n    value: function renderBackgroundImage(container) {\n      var _this3 = this;\n\n      container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {\n        if (backgroundImage.source.method === \'url\' && backgroundImage.source.args.length) {\n          _this3.renderBackgroundRepeat(container, backgroundImage);\n        } else if (/gradient/i.test(backgroundImage.source.method)) {\n          _this3.renderBackgroundGradient(container, backgroundImage);\n        }\n      });\n    }\n  }, {\n    key: "renderBackgroundRepeat",\n    value: function renderBackgroundRepeat(container, background) {\n      var image = this.options.imageStore.get(background.source.args[0]);\n\n      if (image) {\n        var backgroundPositioningArea = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroungPositioningArea"])(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);\n        var backgroundImageSize = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroundSize"])(background, image, backgroundPositioningArea);\n        var position = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroundPosition"])(background.position, backgroundImageSize, backgroundPositioningArea);\n\n        var _path = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroundRepeatPath"])(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);\n\n        var _offsetX = Math.round(backgroundPositioningArea.left + position.x);\n\n        var _offsetY = Math.round(backgroundPositioningArea.top + position.y);\n\n        this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);\n      }\n    }\n  }, {\n    key: "renderBackgroundGradient",\n    value: function renderBackgroundGradient(container, background) {\n      var backgroundPositioningArea = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroungPositioningArea"])(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);\n      var backgroundImageSize = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateGradientBackgroundSize"])(background, backgroundPositioningArea);\n      var position = Object(_parsing_background__WEBPACK_IMPORTED_MODULE_4__["calculateBackgroundPosition"])(background.position, backgroundImageSize, backgroundPositioningArea);\n      var gradientBounds = new _Bounds__WEBPACK_IMPORTED_MODULE_0__["Bounds"](Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);\n      var gradient = Object(_Gradient__WEBPACK_IMPORTED_MODULE_2__["parseGradient"])(container, background.source, gradientBounds);\n\n      if (gradient) {\n        switch (gradient.type) {\n          case _Gradient__WEBPACK_IMPORTED_MODULE_2__["GRADIENT_TYPE"].LINEAR_GRADIENT:\n            // $FlowFixMe\n            this.target.renderLinearGradient(gradientBounds, gradient);\n            break;\n\n          case _Gradient__WEBPACK_IMPORTED_MODULE_2__["GRADIENT_TYPE"].RADIAL_GRADIENT:\n            // $FlowFixMe\n            this.target.renderRadialGradient(gradientBounds, gradient);\n            break;\n        }\n      }\n    }\n  }, {\n    key: "renderBorder",\n    value: function renderBorder(border, side, curvePoints) {\n      this.target.drawShape(Object(_Bounds__WEBPACK_IMPORTED_MODULE_0__["parsePathForBorder"])(curvePoints, side), border.borderColor);\n    }\n  }, {\n    key: "renderStack",\n    value: function renderStack(stack) {\n      var _this4 = this;\n\n      if (stack.container.isVisible()) {\n        var _opacity = stack.getOpacity();\n\n        if (_opacity !== this._opacity) {\n          this.target.setOpacity(stack.getOpacity());\n          this._opacity = _opacity;\n        }\n\n        var transform = stack.container.style.transform;\n\n        if (transform !== null) {\n          this.target.transform(stack.container.bounds.left + transform.transformOrigin[0].value, stack.container.bounds.top + transform.transformOrigin[1].value, transform.transform, function () {\n            return _this4.renderStackContent(stack);\n          });\n        } else {\n          this.renderStackContent(stack);\n        }\n      }\n    }\n  }, {\n    key: "renderStackContent",\n    value: function renderStackContent(stack) {\n      var _splitStackingContext = splitStackingContexts(stack),\n          _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),\n          negativeZIndex = _splitStackingContext2[0],\n          zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],\n          positiveZIndex = _splitStackingContext2[2],\n          nonPositionedFloats = _splitStackingContext2[3],\n          nonPositionedInlineLevel = _splitStackingContext2[4];\n\n      var _splitDescendants = splitDescendants(stack),\n          _splitDescendants2 = _slicedToArray(_splitDescendants, 2),\n          inlineLevel = _splitDescendants2[0],\n          nonInlineLevel = _splitDescendants2[1]; // https://www.w3.org/TR/css-position-3/#painting-order\n      // 1. the background and borders of the element forming the stacking context.\n\n\n      this.renderNodeBackgroundAndBorders(stack.container); // 2. the child stacking contexts with negative stack levels (most negative first).\n\n      negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this); // 3. For all its in-flow, non-positioned, block-level descendants in tree order:\n\n      this.renderNodeContent(stack.container);\n      nonInlineLevel.forEach(this.renderNode, this); // 4. All non-positioned floating descendants, in tree order. For each one of these,\n      // treat the element as if it created a new stacking context, but any positioned descendants and descendants\n      // which actually create a new stacking context should be considered part of the parent stacking context,\n      // not this new one.\n\n      nonPositionedFloats.forEach(this.renderStack, this); // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.\n\n      nonPositionedInlineLevel.forEach(this.renderStack, this);\n      inlineLevel.forEach(this.renderNode, this); // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:\n      //  All positioned descendants with \'z-index: auto\' or \'z-index: 0\', in tree order.\n      //  For those with \'z-index: auto\', treat the element as if it created a new stacking context,\n      //  but any positioned descendants and descendants which actually create a new stacking context should be\n      //  considered part of the parent stacking context, not this new one. For those with \'z-index: 0\',\n      //  treat the stacking context generated atomically.\n      //\n      //  All opacity descendants with opacity less than 1\n      //\n      //  All transform descendants with transform other than none\n\n      zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this); // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index\n      // order (smallest first) then tree order.\n\n      positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);\n    }\n  }, {\n    key: "render",\n    value: function render(stack) {\n      var _this5 = this;\n\n      if (this.options.backgroundColor) {\n        this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);\n      }\n\n      this.renderStack(stack);\n      var target = this.target.getTarget();\n\n      if (true) {\n        return target.then(function (output) {\n          _this5.options.logger.log("Render completed");\n\n          return output;\n        });\n      }\n\n      return target;\n    }\n  }]);\n\n  return Renderer;\n}();\n\n\n\nvar splitDescendants = function splitDescendants(stack) {\n  var inlineLevel = [];\n  var nonInlineLevel = [];\n  var length = stack.children.length;\n\n  for (var i = 0; i < length; i++) {\n    var child = stack.children[i];\n\n    if (child.isInlineLevel()) {\n      inlineLevel.push(child);\n    } else {\n      nonInlineLevel.push(child);\n    }\n  }\n\n  return [inlineLevel, nonInlineLevel];\n};\n\nvar splitStackingContexts = function splitStackingContexts(stack) {\n  var negativeZIndex = [];\n  var zeroOrAutoZIndexOrTransformedOrOpacity = [];\n  var positiveZIndex = [];\n  var nonPositionedFloats = [];\n  var nonPositionedInlineLevel = [];\n  var length = stack.contexts.length;\n\n  for (var i = 0; i < length; i++) {\n    var child = stack.contexts[i];\n\n    if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {\n      if (child.container.style.zIndex.order < 0) {\n        negativeZIndex.push(child);\n      } else if (child.container.style.zIndex.order > 0) {\n        positiveZIndex.push(child);\n      } else {\n        zeroOrAutoZIndexOrTransformedOrOpacity.push(child);\n      }\n    } else {\n      if (child.container.isFloating()) {\n        nonPositionedFloats.push(child);\n      } else {\n        nonPositionedInlineLevel.push(child);\n      }\n    }\n  }\n\n  return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];\n};\n\nvar sortByZIndex = function sortByZIndex(a, b) {\n  if (a.container.style.zIndex.order > b.container.style.zIndex.order) {\n    return 1;\n  } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {\n    return -1;\n  }\n\n  return a.container.index > b.container.index ? 1 : -1;\n};\n\n//# sourceURL=webpack://html2canvas/./src/Renderer.js?');
      },
      "./src/ResourceLoader.js": function srcResourceLoaderJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceLoader; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceStore", function() { return ResourceStore; });\n/* harmony import */ var _Feature__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Feature */ "./src/Feature.js");\n/* harmony import */ var _Proxy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Proxy */ "./src/Proxy.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\nvar ResourceLoader =\n/*#__PURE__*/\nfunction () {\n  function ResourceLoader(options, logger, window) {\n    _classCallCheck(this, ResourceLoader);\n\n    this.options = options;\n    this._window = window;\n    this.origin = this.getOrigin(window.location.href);\n    this.cache = {};\n    this.logger = logger;\n    this._index = 0;\n  }\n\n  _createClass(ResourceLoader, [{\n    key: "loadImage",\n    value: function loadImage(src) {\n      var _this = this;\n\n      if (this.hasResourceInCache(src)) {\n        return src;\n      }\n\n      if (isBlobImage(src)) {\n        this.cache[src] = _loadImage(src, this.options.imageTimeout || 0);\n        return src;\n      }\n\n      if (!isSVG(src) || _Feature__WEBPACK_IMPORTED_MODULE_0__["default"].SUPPORT_SVG_DRAWING) {\n        if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {\n          return this.addImage(src, src, false);\n        } else if (!this.isSameOrigin(src)) {\n          if (typeof this.options.proxy === \'string\') {\n            this.cache[src] = Object(_Proxy__WEBPACK_IMPORTED_MODULE_1__["Proxy"])(src, this.options).then(function (src) {\n              return _loadImage(src, _this.options.imageTimeout || 0);\n            });\n            return src;\n          } else if (this.options.useCORS === true && _Feature__WEBPACK_IMPORTED_MODULE_0__["default"].SUPPORT_CORS_IMAGES) {\n            return this.addImage(src, src, true);\n          }\n        }\n      }\n    }\n  }, {\n    key: "inlineImage",\n    value: function inlineImage(src) {\n      var _this2 = this;\n\n      if (isInlineImage(src)) {\n        return _loadImage(src, this.options.imageTimeout || 0);\n      }\n\n      if (this.hasResourceInCache(src)) {\n        return this.cache[src];\n      }\n\n      if (!this.isSameOrigin(src) && typeof this.options.proxy === \'string\') {\n        return this.cache[src] = Object(_Proxy__WEBPACK_IMPORTED_MODULE_1__["Proxy"])(src, this.options).then(function (src) {\n          return _loadImage(src, _this2.options.imageTimeout || 0);\n        });\n      }\n\n      return this.xhrImage(src);\n    }\n  }, {\n    key: "xhrImage",\n    value: function xhrImage(src) {\n      var _this3 = this;\n\n      this.cache[src] = new Promise(function (resolve, reject) {\n        var xhr = new XMLHttpRequest();\n\n        xhr.onreadystatechange = function () {\n          if (xhr.readyState === 4) {\n            if (xhr.status !== 200) {\n              reject("Failed to fetch image ".concat(src.substring(0, 256), " with status code ").concat(xhr.status));\n            } else {\n              var reader = new FileReader();\n              reader.addEventListener(\'load\', function () {\n                // $FlowFixMe\n                var result = reader.result;\n                resolve(result);\n              }, false);\n              reader.addEventListener(\'error\', function (e) {\n                return reject(e);\n              }, false);\n              reader.readAsDataURL(xhr.response);\n            }\n          }\n        };\n\n        xhr.responseType = \'blob\';\n\n        if (_this3.options.imageTimeout) {\n          var timeout = _this3.options.imageTimeout;\n          xhr.timeout = timeout;\n\n          xhr.ontimeout = function () {\n            return reject( true ? "Timed out (".concat(timeout, "ms) fetching ").concat(src.substring(0, 256)) : undefined);\n          };\n        }\n\n        xhr.open(\'GET\', src, true);\n        xhr.send();\n      }).then(function (src) {\n        return _loadImage(src, _this3.options.imageTimeout || 0);\n      });\n      return this.cache[src];\n    }\n  }, {\n    key: "loadCanvas",\n    value: function loadCanvas(node) {\n      var key = String(this._index++);\n      this.cache[key] = Promise.resolve(node);\n      return key;\n    }\n  }, {\n    key: "hasResourceInCache",\n    value: function hasResourceInCache(key) {\n      return typeof this.cache[key] !== \'undefined\';\n    }\n  }, {\n    key: "addImage",\n    value: function addImage(key, src, useCORS) {\n      var _this4 = this;\n\n      if (true) {\n        this.logger.log("Added image ".concat(key.substring(0, 256)));\n      }\n\n      this.cache[key] = new Promise(function (resolve, reject) {\n        var img = new Image();\n\n        img.onload = function () {\n          return resolve(img);\n        }; //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous\n\n\n        if (isInlineBase64Image(src) || useCORS) {\n          img.crossOrigin = \'anonymous\';\n        }\n\n        img.onerror = reject;\n        img.src = src;\n\n        if (img.complete === true) {\n          // Inline XML images may fail to parse, throwing an Error later on\n          setTimeout(function () {\n            resolve(img);\n          }, 500);\n        }\n\n        if (_this4.options.imageTimeout) {\n          var timeout = _this4.options.imageTimeout;\n          setTimeout(function () {\n            return reject( true ? "Timed out (".concat(timeout, "ms) fetching ").concat(src.substring(0, 256)) : undefined);\n          }, timeout);\n        }\n      });\n      return key;\n    }\n  }, {\n    key: "isSameOrigin",\n    value: function isSameOrigin(url) {\n      return this.getOrigin(url) === this.origin;\n    }\n  }, {\n    key: "getOrigin",\n    value: function getOrigin(url) {\n      var link = this._link || (this._link = this._window.document.createElement(\'a\'));\n\n      link.href = url;\n      link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/\n\n      return link.protocol + link.hostname + link.port;\n    }\n  }, {\n    key: "ready",\n    value: function ready() {\n      var _this5 = this;\n\n      var keys = Object.keys(this.cache);\n      var values = keys.map(function (str) {\n        return _this5.cache[str].catch(function (e) {\n          if (true) {\n            _this5.logger.log("Unable to load image", e);\n          }\n\n          return null;\n        });\n      });\n      return Promise.all(values).then(function (images) {\n        if (true) {\n          _this5.logger.log("Finished loading ".concat(images.length, " images"), images);\n        }\n\n        return new ResourceStore(keys, images);\n      });\n    }\n  }]);\n\n  return ResourceLoader;\n}();\n\n\nvar ResourceStore =\n/*#__PURE__*/\nfunction () {\n  function ResourceStore(keys, resources) {\n    _classCallCheck(this, ResourceStore);\n\n    this._keys = keys;\n    this._resources = resources;\n  }\n\n  _createClass(ResourceStore, [{\n    key: "get",\n    value: function get(key) {\n      var index = this._keys.indexOf(key);\n\n      return index === -1 ? null : this._resources[index];\n    }\n  }]);\n\n  return ResourceStore;\n}();\nvar INLINE_SVG = /^data:image\\/svg\\+xml/i;\nvar INLINE_BASE64 = /^data:image\\/.*;base64,/i;\nvar INLINE_IMG = /^data:image\\/.*/i;\n\nvar isInlineImage = function isInlineImage(src) {\n  return INLINE_IMG.test(src);\n};\n\nvar isInlineBase64Image = function isInlineBase64Image(src) {\n  return INLINE_BASE64.test(src);\n};\n\nvar isBlobImage = function isBlobImage(src) {\n  return src.substr(0, 4) === \'blob\';\n};\n\nvar isSVG = function isSVG(src) {\n  return src.substr(-3).toLowerCase() === \'svg\' || INLINE_SVG.test(src);\n};\n\nvar _loadImage = function _loadImage(src, timeout) {\n  return new Promise(function (resolve, reject) {\n    var img = new Image();\n\n    img.onload = function () {\n      return resolve(img);\n    };\n\n    img.onerror = reject;\n    img.src = src;\n\n    if (img.complete === true) {\n      // Inline XML images may fail to parse, throwing an Error later on\n      setTimeout(function () {\n        resolve(img);\n      }, 500);\n    }\n\n    if (timeout) {\n      setTimeout(function () {\n        return reject( true ? "Timed out (".concat(timeout, "ms) loading image") : undefined);\n      }, timeout);\n    }\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/ResourceLoader.js?');
      },
      "./src/StackingContext.js": function srcStackingContextJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StackingContext; });\n/* harmony import */ var _NodeContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NodeContainer */ "./src/NodeContainer.js");\n/* harmony import */ var _parsing_position__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parsing/position */ "./src/parsing/position.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\nvar StackingContext =\n/*#__PURE__*/\nfunction () {\n  function StackingContext(container, parent, treatAsRealStackingContext) {\n    _classCallCheck(this, StackingContext);\n\n    this.container = container;\n    this.parent = parent;\n    this.contexts = [];\n    this.children = [];\n    this.treatAsRealStackingContext = treatAsRealStackingContext;\n  }\n\n  _createClass(StackingContext, [{\n    key: "getOpacity",\n    value: function getOpacity() {\n      return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;\n    }\n  }, {\n    key: "getRealParentStackingContext",\n    value: function getRealParentStackingContext() {\n      return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();\n    }\n  }]);\n\n  return StackingContext;\n}();\n\n\n\n//# sourceURL=webpack://html2canvas/./src/StackingContext.js?');
      },
      "./src/TextBounds.js": function srcTextBoundsJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextBounds", function() { return TextBounds; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseTextBounds", function() { return parseTextBounds; });\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Bounds */ "./src/Bounds.js");\n/* harmony import */ var _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parsing/textDecoration */ "./src/parsing/textDecoration.js");\n/* harmony import */ var _Feature__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Feature */ "./src/Feature.js");\n/* harmony import */ var _Unicode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Unicode */ "./src/Unicode.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\n\n\n\n\nvar TextBounds = function TextBounds(text, bounds) {\n  _classCallCheck(this, TextBounds);\n\n  this.text = text;\n  this.bounds = bounds;\n};\nvar parseTextBounds = function parseTextBounds(value, parent, node) {\n  var letterRendering = parent.style.letterSpacing !== 0;\n  var textList = letterRendering ? Object(_Unicode__WEBPACK_IMPORTED_MODULE_3__["toCodePoints"])(value).map(function (i) {\n    return Object(_Unicode__WEBPACK_IMPORTED_MODULE_3__["fromCodePoint"])(i);\n  }) : Object(_Unicode__WEBPACK_IMPORTED_MODULE_3__["breakWords"])(value, parent);\n  var length = textList.length;\n  var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;\n  var scrollX = defaultView ? defaultView.pageXOffset : 0;\n  var scrollY = defaultView ? defaultView.pageYOffset : 0;\n  var textBounds = [];\n  var offset = 0;\n\n  for (var i = 0; i < length; i++) {\n    var text = textList[i];\n\n    if (parent.style.textDecoration !== _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_1__["TEXT_DECORATION"].NONE || text.trim().length > 0) {\n      if (_Feature__WEBPACK_IMPORTED_MODULE_2__["default"].SUPPORT_RANGE_BOUNDS) {\n        textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));\n      } else {\n        var replacementNode = node.splitText(text.length);\n        textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));\n        node = replacementNode;\n      }\n    } else if (!_Feature__WEBPACK_IMPORTED_MODULE_2__["default"].SUPPORT_RANGE_BOUNDS) {\n      node = node.splitText(text.length);\n    }\n\n    offset += text.length;\n  }\n\n  return textBounds;\n};\n\nvar getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {\n  var wrapper = node.ownerDocument.createElement(\'html2canvaswrapper\');\n  wrapper.appendChild(node.cloneNode(true));\n  var parentNode = node.parentNode;\n\n  if (parentNode) {\n    parentNode.replaceChild(wrapper, node);\n    var bounds = Object(_Bounds__WEBPACK_IMPORTED_MODULE_0__["parseBounds"])(wrapper, scrollX, scrollY);\n\n    if (wrapper.firstChild) {\n      parentNode.replaceChild(wrapper.firstChild, wrapper);\n    }\n\n    return bounds;\n  }\n\n  return new _Bounds__WEBPACK_IMPORTED_MODULE_0__["Bounds"](0, 0, 0, 0);\n};\n\nvar getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {\n  var range = node.ownerDocument.createRange();\n  range.setStart(node, offset);\n  range.setEnd(node, offset + length);\n  return _Bounds__WEBPACK_IMPORTED_MODULE_0__["Bounds"].fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);\n};\n\n//# sourceURL=webpack://html2canvas/./src/TextBounds.js?');
      },
      "./src/TextContainer.js": function srcTextContainerJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextContainer; });\n/* harmony import */ var _parsing_textTransform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./parsing/textTransform */ "./src/parsing/textTransform.js");\n/* harmony import */ var _TextBounds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TextBounds */ "./src/TextBounds.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\nvar TextContainer =\n/*#__PURE__*/\nfunction () {\n  function TextContainer(text, parent, bounds) {\n    _classCallCheck(this, TextContainer);\n\n    this.text = text;\n    this.parent = parent;\n    this.bounds = bounds;\n  }\n\n  _createClass(TextContainer, null, [{\n    key: "fromTextNode",\n    value: function fromTextNode(node, parent) {\n      var text = transform(node.data, parent.style.textTransform);\n      return new TextContainer(text, parent, Object(_TextBounds__WEBPACK_IMPORTED_MODULE_1__["parseTextBounds"])(text, parent, node));\n    }\n  }]);\n\n  return TextContainer;\n}();\n\n\nvar CAPITALIZE = /(^|\\s|:|-|\\(|\\))([a-z])/g;\n\nvar transform = function transform(text, _transform) {\n  switch (_transform) {\n    case _parsing_textTransform__WEBPACK_IMPORTED_MODULE_0__["TEXT_TRANSFORM"].LOWERCASE:\n      return text.toLowerCase();\n\n    case _parsing_textTransform__WEBPACK_IMPORTED_MODULE_0__["TEXT_TRANSFORM"].CAPITALIZE:\n      return text.replace(CAPITALIZE, capitalize);\n\n    case _parsing_textTransform__WEBPACK_IMPORTED_MODULE_0__["TEXT_TRANSFORM"].UPPERCASE:\n      return text.toUpperCase();\n\n    default:\n      return text;\n  }\n};\n\nfunction capitalize(m, p1, p2) {\n  if (m.length > 0) {\n    return p1 + p2.toUpperCase();\n  }\n\n  return m;\n}\n\n//# sourceURL=webpack://html2canvas/./src/TextContainer.js?');
      },
      "./src/Unicode.js": function srcUnicodeJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "breakWords", function() { return breakWords; });\n/* harmony import */ var css_line_break__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! css-line-break */ "./node_modules/css-line-break/dist/index.js");\n/* harmony import */ var css_line_break__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(css_line_break__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _parsing_overflowWrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parsing/overflowWrap */ "./src/parsing/overflowWrap.js");\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toCodePoints", function() { return css_line_break__WEBPACK_IMPORTED_MODULE_0__["toCodePoints"]; });\n\n/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromCodePoint", function() { return css_line_break__WEBPACK_IMPORTED_MODULE_0__["fromCodePoint"]; });\n\n\n\n\n\n\nvar breakWords = function breakWords(str, parent) {\n  var breaker = Object(css_line_break__WEBPACK_IMPORTED_MODULE_0__["LineBreaker"])(str, {\n    lineBreak: parent.style.lineBreak,\n    wordBreak: parent.style.overflowWrap === _parsing_overflowWrap__WEBPACK_IMPORTED_MODULE_1__["OVERFLOW_WRAP"].BREAK_WORD ? \'break-word\' : parent.style.wordBreak\n  });\n  var words = [];\n  var bk;\n\n  while (!(bk = breaker.next()).done) {\n    words.push(bk.value.slice());\n  }\n\n  return words;\n};\n\n//# sourceURL=webpack://html2canvas/./src/Unicode.js?');
      },
      "./src/Util.js": function srcUtilJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return contains; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distance", function() { return distance; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyCSSStyles", function() { return copyCSSStyles; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMALL_IMAGE", function() { return SMALL_IMAGE; });\n\n\nvar contains = function contains(bit, value) {\n  return (bit & value) !== 0;\n};\nvar distance = function distance(a, b) {\n  return Math.sqrt(a * a + b * b);\n};\nvar copyCSSStyles = function copyCSSStyles(style, target) {\n  // Edge does not provide value for cssText\n  for (var i = style.length - 1; i >= 0; i--) {\n    var property = style.item(i); // Safari shows pseudoelements if content is set\n\n    if (property !== \'content\') {\n      target.style.setProperty(property, style.getPropertyValue(property));\n    }\n  }\n\n  return target;\n};\nvar SMALL_IMAGE = \'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\';\n\n//# sourceURL=webpack://html2canvas/./src/Util.js?');
      },
      "./src/Window.js": function srcWindowJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderElement", function() { return renderElement; });\n/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Logger */ "./src/Logger.js");\n/* harmony import */ var _NodeParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NodeParser */ "./src/NodeParser.js");\n/* harmony import */ var _Renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Renderer */ "./src/Renderer.js");\n/* harmony import */ var _renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./renderer/ForeignObjectRenderer */ "./src/renderer/ForeignObjectRenderer.js");\n/* harmony import */ var _Feature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Feature */ "./src/Feature.js");\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Bounds */ "./src/Bounds.js");\n/* harmony import */ var _Clone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Clone */ "./src/Clone.js");\n/* harmony import */ var _Font__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Font */ "./src/Font.js");\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Color */ "./src/Color.js");\n\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\n\n\n\n\n\n\n\n\n\nvar renderElement = function renderElement(element, options, logger) {\n  var ownerDocument = element.ownerDocument;\n  var windowBounds = new _Bounds__WEBPACK_IMPORTED_MODULE_5__["Bounds"](options.scrollX, options.scrollY, options.windowWidth, options.windowHeight); // http://www.w3.org/TR/css3-background/#special-backgrounds\n\n  var documentBackgroundColor = ownerDocument.documentElement ? new _Color__WEBPACK_IMPORTED_MODULE_8__["default"](getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color__WEBPACK_IMPORTED_MODULE_8__["TRANSPARENT"];\n  var bodyBackgroundColor = ownerDocument.body ? new _Color__WEBPACK_IMPORTED_MODULE_8__["default"](getComputedStyle(ownerDocument.body).backgroundColor) : _Color__WEBPACK_IMPORTED_MODULE_8__["TRANSPARENT"];\n  var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color__WEBPACK_IMPORTED_MODULE_8__["default"](options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color__WEBPACK_IMPORTED_MODULE_8__["default"](options.backgroundColor) : null;\n  return (options.foreignObjectRendering ? // $FlowFixMe\n  _Feature__WEBPACK_IMPORTED_MODULE_4__["default"].SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {\n    return supportForeignObject ? function (cloner) {\n      if (true) {\n        logger.log("Document cloned, using foreignObject rendering");\n      }\n\n      return cloner.inlineFonts(ownerDocument).then(function () {\n        return cloner.resourceLoader.ready();\n      }).then(function () {\n        var renderer = new _renderer_ForeignObjectRenderer__WEBPACK_IMPORTED_MODULE_3__["default"](cloner.documentElement);\n        var defaultView = ownerDocument.defaultView;\n        var scrollX = defaultView.pageXOffset;\n        var scrollY = defaultView.pageYOffset;\n        var isDocument = element.tagName === \'HTML\' || element.tagName === \'BODY\';\n\n        var _ref = isDocument ? Object(_Bounds__WEBPACK_IMPORTED_MODULE_5__["parseDocumentSize"])(ownerDocument) : Object(_Bounds__WEBPACK_IMPORTED_MODULE_5__["parseBounds"])(element, scrollX, scrollY),\n            width = _ref.width,\n            height = _ref.height,\n            left = _ref.left,\n            top = _ref.top;\n\n        return renderer.render({\n          backgroundColor: backgroundColor,\n          logger: logger,\n          scale: options.scale,\n          x: typeof options.x === \'number\' ? options.x : left,\n          y: typeof options.y === \'number\' ? options.y : top,\n          width: typeof options.width === \'number\' ? options.width : Math.ceil(width),\n          height: typeof options.height === \'number\' ? options.height : Math.ceil(height),\n          windowWidth: options.windowWidth,\n          windowHeight: options.windowHeight,\n          scrollX: options.scrollX,\n          scrollY: options.scrollY\n        });\n      });\n    }(new _Clone__WEBPACK_IMPORTED_MODULE_6__["DocumentCloner"](element, options, logger, true, renderElement)) : Object(_Clone__WEBPACK_IMPORTED_MODULE_6__["cloneWindow"])(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref2) {\n      var _ref3 = _slicedToArray(_ref2, 3),\n          container = _ref3[0],\n          clonedElement = _ref3[1],\n          resourceLoader = _ref3[2];\n\n      if (true) {\n        logger.log("Document cloned, using computed rendering");\n      }\n\n      var stack = Object(_NodeParser__WEBPACK_IMPORTED_MODULE_1__["NodeParser"])(clonedElement, resourceLoader, logger);\n      var clonedDocument = clonedElement.ownerDocument;\n\n      if (backgroundColor === stack.container.style.background.backgroundColor) {\n        stack.container.style.background.backgroundColor = _Color__WEBPACK_IMPORTED_MODULE_8__["TRANSPARENT"];\n      }\n\n      return resourceLoader.ready().then(function (imageStore) {\n        var fontMetrics = new _Font__WEBPACK_IMPORTED_MODULE_7__["FontMetrics"](clonedDocument);\n\n        if (true) {\n          logger.log("Starting renderer");\n        }\n\n        var defaultView = clonedDocument.defaultView;\n        var scrollX = defaultView.pageXOffset;\n        var scrollY = defaultView.pageYOffset;\n        var isDocument = clonedElement.tagName === \'HTML\' || clonedElement.tagName === \'BODY\';\n\n        var _ref4 = isDocument ? Object(_Bounds__WEBPACK_IMPORTED_MODULE_5__["parseDocumentSize"])(ownerDocument) : Object(_Bounds__WEBPACK_IMPORTED_MODULE_5__["parseBounds"])(clonedElement, scrollX, scrollY),\n            width = _ref4.width,\n            height = _ref4.height,\n            left = _ref4.left,\n            top = _ref4.top;\n\n        var renderOptions = {\n          backgroundColor: backgroundColor,\n          fontMetrics: fontMetrics,\n          imageStore: imageStore,\n          logger: logger,\n          scale: options.scale,\n          x: typeof options.x === \'number\' ? options.x : left,\n          y: typeof options.y === \'number\' ? options.y : top,\n          width: typeof options.width === \'number\' ? options.width : Math.ceil(width),\n          height: typeof options.height === \'number\' ? options.height : Math.ceil(height)\n        };\n\n        if (Array.isArray(options.target)) {\n          return Promise.all(options.target.map(function (target) {\n            var renderer = new _Renderer__WEBPACK_IMPORTED_MODULE_2__["default"](target, renderOptions);\n            return renderer.render(stack);\n          }));\n        } else {\n          var renderer = new _Renderer__WEBPACK_IMPORTED_MODULE_2__["default"](options.target, renderOptions);\n          var canvas = renderer.render(stack);\n\n          if (options.removeContainer === true) {\n            if (container.parentNode) {\n              container.parentNode.removeChild(container);\n            } else if (true) {\n              logger.log("Cannot detach cloned iframe as it is not in the DOM anymore");\n            }\n          }\n\n          return canvas;\n        }\n      });\n    });\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/Window.js?');
      },
      "./src/drawing/BezierCurve.js": function srcDrawingBezierCurveJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BezierCurve; });\n/* harmony import */ var _Path__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Path */ "./src/drawing/Path.js");\n/* harmony import */ var _Vector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Vector */ "./src/drawing/Vector.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\nvar lerp = function lerp(a, b, t) {\n  return new _Vector__WEBPACK_IMPORTED_MODULE_1__["default"](a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);\n};\n\nvar BezierCurve =\n/*#__PURE__*/\nfunction () {\n  function BezierCurve(start, startControl, endControl, end) {\n    _classCallCheck(this, BezierCurve);\n\n    this.type = _Path__WEBPACK_IMPORTED_MODULE_0__["PATH"].BEZIER_CURVE;\n    this.start = start;\n    this.startControl = startControl;\n    this.endControl = endControl;\n    this.end = end;\n  }\n\n  _createClass(BezierCurve, [{\n    key: "subdivide",\n    value: function subdivide(t, firstHalf) {\n      var ab = lerp(this.start, this.startControl, t);\n      var bc = lerp(this.startControl, this.endControl, t);\n      var cd = lerp(this.endControl, this.end, t);\n      var abbc = lerp(ab, bc, t);\n      var bccd = lerp(bc, cd, t);\n      var dest = lerp(abbc, bccd, t);\n      return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);\n    }\n  }, {\n    key: "reverse",\n    value: function reverse() {\n      return new BezierCurve(this.end, this.endControl, this.startControl, this.start);\n    }\n  }]);\n\n  return BezierCurve;\n}();\n\n\n\n//# sourceURL=webpack://html2canvas/./src/drawing/BezierCurve.js?');
      },
      "./src/drawing/Circle.js": function srcDrawingCircleJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Circle; });\n/* harmony import */ var _Path__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Path */ "./src/drawing/Path.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\n\n\nvar Circle = function Circle(x, y, radius) {\n  _classCallCheck(this, Circle);\n\n  this.type = _Path__WEBPACK_IMPORTED_MODULE_0__["PATH"].CIRCLE;\n  this.x = x;\n  this.y = y;\n  this.radius = radius;\n\n  if (true) {\n    if (isNaN(x)) {\n      console.error("Invalid x value given for Circle");\n    }\n\n    if (isNaN(y)) {\n      console.error("Invalid y value given for Circle");\n    }\n\n    if (isNaN(radius)) {\n      console.error("Invalid radius value given for Circle");\n    }\n  }\n};\n\n\n\n//# sourceURL=webpack://html2canvas/./src/drawing/Circle.js?');
      },
      "./src/drawing/Path.js": function srcDrawingPathJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PATH", function() { return PATH; });\n\n\nvar PATH = {\n  VECTOR: 0,\n  BEZIER_CURVE: 1,\n  CIRCLE: 2\n};\n\n//# sourceURL=webpack://html2canvas/./src/drawing/Path.js?');
      },
      "./src/drawing/Size.js": function srcDrawingSizeJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Size; });\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nvar Size = function Size(width, height) {\n  _classCallCheck(this, Size);\n\n  this.width = width;\n  this.height = height;\n};\n\n\n\n//# sourceURL=webpack://html2canvas/./src/drawing/Size.js?');
      },
      "./src/drawing/Vector.js": function srcDrawingVectorJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Vector; });\n/* harmony import */ var _Path__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Path */ "./src/drawing/Path.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\n\n\nvar Vector = function Vector(x, y) {\n  _classCallCheck(this, Vector);\n\n  this.type = _Path__WEBPACK_IMPORTED_MODULE_0__["PATH"].VECTOR;\n  this.x = x;\n  this.y = y;\n\n  if (true) {\n    if (isNaN(x)) {\n      console.error("Invalid x value given for Vector");\n    }\n\n    if (isNaN(y)) {\n      console.error("Invalid y value given for Vector");\n    }\n  }\n};\n\n\n\n//# sourceURL=webpack://html2canvas/./src/drawing/Vector.js?');
      },
      "./src/index.js": function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _renderer_CanvasRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./renderer/CanvasRenderer */ "./src/renderer/CanvasRenderer.js");\n/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Logger */ "./src/Logger.js");\n/* harmony import */ var _Window__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Window */ "./src/Window.js");\n\n\nfunction _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === \'function\') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }\n\nfunction _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }\n\n\n\n\n\nvar html2canvas = function html2canvas(element, conf) {\n  var config = conf || {};\n  var logger = new _Logger__WEBPACK_IMPORTED_MODULE_1__["default"](typeof config.logging === \'boolean\' ? config.logging : true);\n  logger.log("html2canvas ".concat("1.0.0-rc.1"));\n\n  if ( true && typeof config.onrendered === \'function\') {\n    logger.error("onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value");\n  }\n\n  var ownerDocument = element.ownerDocument;\n\n  if (!ownerDocument) {\n    return Promise.reject("Provided element is not within a Document");\n  }\n\n  var defaultView = ownerDocument.defaultView;\n  var defaultOptions = {\n    allowTaint: false,\n    backgroundColor: \'#ffffff\',\n    imageTimeout: 15000,\n    logging: true,\n    proxy: null,\n    removeContainer: true,\n    foreignObjectRendering: false,\n    scale: defaultView.devicePixelRatio || 1,\n    target: new _renderer_CanvasRenderer__WEBPACK_IMPORTED_MODULE_0__["default"](config.canvas),\n    useCORS: false,\n    windowWidth: defaultView.innerWidth,\n    windowHeight: defaultView.innerHeight,\n    scrollX: defaultView.pageXOffset,\n    scrollY: defaultView.pageYOffset\n  };\n  var result = Object(_Window__WEBPACK_IMPORTED_MODULE_2__["renderElement"])(element, _objectSpread({}, defaultOptions, config), logger);\n\n  if (true) {\n    return result.catch(function (e) {\n      logger.error(e);\n      throw e;\n    });\n  }\n\n  return result;\n};\n\nhtml2canvas.CanvasRenderer = _renderer_CanvasRenderer__WEBPACK_IMPORTED_MODULE_0__["default"];\n/* harmony default export */ __webpack_exports__["default"] = (html2canvas);\n\n//# sourceURL=webpack://html2canvas/./src/index.js?');
      },
      "./src/parsing/background.js": function srcParsingBackgroundJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKGROUND_REPEAT", function() { return BACKGROUND_REPEAT; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKGROUND_SIZE", function() { return BACKGROUND_SIZE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKGROUND_CLIP", function() { return BACKGROUND_CLIP; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKGROUND_ORIGIN", function() { return BACKGROUND_ORIGIN; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBackgroundSize", function() { return calculateBackgroundSize; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateGradientBackgroundSize", function() { return calculateGradientBackgroundSize; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBackgroungPaintingArea", function() { return calculateBackgroungPaintingArea; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBackgroungPositioningArea", function() { return calculateBackgroungPositioningArea; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBackgroundPosition", function() { return calculateBackgroundPosition; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBackgroundRepeatPath", function() { return calculateBackgroundRepeatPath; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBackground", function() { return parseBackground; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBackgroundImage", function() { return parseBackgroundImage; });\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Color */ "./src/Color.js");\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Length */ "./src/Length.js");\n/* harmony import */ var _drawing_Size__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../drawing/Size */ "./src/drawing/Size.js");\n/* harmony import */ var _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../drawing/Vector */ "./src/drawing/Vector.js");\n/* harmony import */ var _Bounds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Bounds */ "./src/Bounds.js");\n/* harmony import */ var _padding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./padding */ "./src/parsing/padding.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\n\n\n\n\n\n\nvar BACKGROUND_REPEAT = {\n  REPEAT: 0,\n  NO_REPEAT: 1,\n  REPEAT_X: 2,\n  REPEAT_Y: 3\n};\nvar BACKGROUND_SIZE = {\n  AUTO: 0,\n  CONTAIN: 1,\n  COVER: 2,\n  LENGTH: 3\n};\nvar BACKGROUND_CLIP = {\n  BORDER_BOX: 0,\n  PADDING_BOX: 1,\n  CONTENT_BOX: 2\n};\nvar BACKGROUND_ORIGIN = BACKGROUND_CLIP;\nvar AUTO = \'auto\';\n\nvar BackgroundSize = function BackgroundSize(size) {\n  _classCallCheck(this, BackgroundSize);\n\n  switch (size) {\n    case \'contain\':\n      this.size = BACKGROUND_SIZE.CONTAIN;\n      break;\n\n    case \'cover\':\n      this.size = BACKGROUND_SIZE.COVER;\n      break;\n\n    case \'auto\':\n      this.size = BACKGROUND_SIZE.AUTO;\n      break;\n\n    default:\n      this.value = new _Length__WEBPACK_IMPORTED_MODULE_1__["default"](size);\n  }\n};\n\nvar calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {\n  var width = 0;\n  var height = 0;\n  var size = backgroundImage.size;\n\n  if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {\n    var targetRatio = bounds.width / bounds.height;\n    var currentRatio = image.width / image.height;\n    return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _drawing_Size__WEBPACK_IMPORTED_MODULE_2__["default"](bounds.width, bounds.width / currentRatio) : new _drawing_Size__WEBPACK_IMPORTED_MODULE_2__["default"](bounds.height * currentRatio, bounds.height);\n  }\n\n  if (size[0].value) {\n    width = size[0].value.getAbsoluteValue(bounds.width);\n  }\n\n  if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {\n    height = image.height;\n  } else if (size[1].size === BACKGROUND_SIZE.AUTO) {\n    height = width / image.width * image.height;\n  } else if (size[1].value) {\n    height = size[1].value.getAbsoluteValue(bounds.height);\n  }\n\n  if (size[0].size === BACKGROUND_SIZE.AUTO) {\n    width = height / image.height * image.width;\n  }\n\n  return new _drawing_Size__WEBPACK_IMPORTED_MODULE_2__["default"](width, height);\n};\nvar calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {\n  var size = backgroundImage.size;\n  var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;\n  var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;\n  return new _drawing_Size__WEBPACK_IMPORTED_MODULE_2__["default"](width, height);\n};\nvar AUTO_SIZE = new BackgroundSize(AUTO);\nvar calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {\n  switch (clip) {\n    case BACKGROUND_CLIP.BORDER_BOX:\n      return Object(_Bounds__WEBPACK_IMPORTED_MODULE_4__["calculateBorderBoxPath"])(curves);\n\n    case BACKGROUND_CLIP.PADDING_BOX:\n    default:\n      return Object(_Bounds__WEBPACK_IMPORTED_MODULE_4__["calculatePaddingBoxPath"])(curves);\n  }\n};\nvar calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {\n  var paddingBox = Object(_Bounds__WEBPACK_IMPORTED_MODULE_4__["calculatePaddingBox"])(bounds, border);\n\n  switch (backgroundOrigin) {\n    case BACKGROUND_ORIGIN.BORDER_BOX:\n      return bounds;\n\n    case BACKGROUND_ORIGIN.CONTENT_BOX:\n      var paddingLeft = padding[_padding__WEBPACK_IMPORTED_MODULE_5__["PADDING_SIDES"].LEFT].getAbsoluteValue(bounds.width);\n      var paddingRight = padding[_padding__WEBPACK_IMPORTED_MODULE_5__["PADDING_SIDES"].RIGHT].getAbsoluteValue(bounds.width);\n      var paddingTop = padding[_padding__WEBPACK_IMPORTED_MODULE_5__["PADDING_SIDES"].TOP].getAbsoluteValue(bounds.width);\n      var paddingBottom = padding[_padding__WEBPACK_IMPORTED_MODULE_5__["PADDING_SIDES"].BOTTOM].getAbsoluteValue(bounds.width);\n      return new _Bounds__WEBPACK_IMPORTED_MODULE_4__["Bounds"](paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);\n\n    case BACKGROUND_ORIGIN.PADDING_BOX:\n    default:\n      return paddingBox;\n  }\n};\nvar calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {\n  return new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));\n};\nvar calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {\n  var repeat = background.repeat;\n\n  switch (repeat) {\n    case BACKGROUND_REPEAT.REPEAT_X:\n      return [new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];\n\n    case BACKGROUND_REPEAT.REPEAT_Y:\n      return [new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];\n\n    case BACKGROUND_REPEAT.NO_REPEAT:\n      return [new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];\n\n    default:\n      return [new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left), Math.round(bounds.top)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _drawing_Vector__WEBPACK_IMPORTED_MODULE_3__["default"](Math.round(bounds.left), Math.round(bounds.height + bounds.top))];\n  }\n};\nvar parseBackground = function parseBackground(style, resourceLoader) {\n  return {\n    backgroundColor: new _Color__WEBPACK_IMPORTED_MODULE_0__["default"](style.backgroundColor),\n    backgroundImage: parseBackgroundImages(style, resourceLoader),\n    backgroundClip: parseBackgroundClip(style.backgroundClip),\n    backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)\n  };\n};\n\nvar parseBackgroundClip = function parseBackgroundClip(backgroundClip) {\n  switch (backgroundClip) {\n    case \'padding-box\':\n      return BACKGROUND_CLIP.PADDING_BOX;\n\n    case \'content-box\':\n      return BACKGROUND_CLIP.CONTENT_BOX;\n  }\n\n  return BACKGROUND_CLIP.BORDER_BOX;\n};\n\nvar parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {\n  switch (backgroundOrigin) {\n    case \'padding-box\':\n      return BACKGROUND_ORIGIN.PADDING_BOX;\n\n    case \'content-box\':\n      return BACKGROUND_ORIGIN.CONTENT_BOX;\n  }\n\n  return BACKGROUND_ORIGIN.BORDER_BOX;\n};\n\nvar parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {\n  switch (backgroundRepeat.trim()) {\n    case \'no-repeat\':\n      return BACKGROUND_REPEAT.NO_REPEAT;\n\n    case \'repeat-x\':\n    case \'repeat no-repeat\':\n      return BACKGROUND_REPEAT.REPEAT_X;\n\n    case \'repeat-y\':\n    case \'no-repeat repeat\':\n      return BACKGROUND_REPEAT.REPEAT_Y;\n\n    case \'repeat\':\n      return BACKGROUND_REPEAT.REPEAT;\n  }\n\n  if (true) {\n    console.error("Invalid background-repeat value \\"".concat(backgroundRepeat, "\\""));\n  }\n\n  return BACKGROUND_REPEAT.REPEAT;\n};\n\nvar parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {\n  var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {\n    if (backgroundImage.method === \'url\') {\n      var key = resourceLoader.loadImage(backgroundImage.args[0]);\n      backgroundImage.args = key ? [key] : [];\n    }\n\n    return backgroundImage;\n  });\n  var positions = style.backgroundPosition.split(\',\');\n  var repeats = style.backgroundRepeat.split(\',\');\n  var sizes = style.backgroundSize.split(\',\');\n  return sources.map(function (source, index) {\n    var size = (sizes[index] || AUTO).trim().split(\' \').map(parseBackgroundSize);\n    var position = (positions[index] || AUTO).trim().split(\' \').map(parseBackgoundPosition);\n    return {\n      source: source,\n      repeat: parseBackgroundRepeat(typeof repeats[index] === \'string\' ? repeats[index] : repeats[0]),\n      size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],\n      position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]\n    };\n  });\n};\n\nvar parseBackgroundSize = function parseBackgroundSize(size) {\n  return size === \'auto\' ? AUTO_SIZE : new BackgroundSize(size);\n};\n\nvar parseBackgoundPosition = function parseBackgoundPosition(position) {\n  switch (position) {\n    case \'bottom\':\n    case \'right\':\n      return new _Length__WEBPACK_IMPORTED_MODULE_1__["default"](\'100%\');\n\n    case \'left\':\n    case \'top\':\n      return new _Length__WEBPACK_IMPORTED_MODULE_1__["default"](\'0%\');\n\n    case \'auto\':\n      return new _Length__WEBPACK_IMPORTED_MODULE_1__["default"](\'0\');\n  }\n\n  return new _Length__WEBPACK_IMPORTED_MODULE_1__["default"](position);\n};\n\nvar parseBackgroundImage = function parseBackgroundImage(image) {\n  var whitespace = /^\\s$/;\n  var results = [];\n  var args = [];\n  var method = \'\';\n  var quote = null;\n  var definition = \'\';\n  var mode = 0;\n  var numParen = 0;\n\n  var appendResult = function appendResult() {\n    var prefix = \'\';\n\n    if (method) {\n      if (definition.substr(0, 1) === \'"\') {\n        definition = definition.substr(1, definition.length - 2);\n      }\n\n      if (definition) {\n        args.push(definition.trim());\n      }\n\n      var prefix_i = method.indexOf(\'-\', 1) + 1;\n\n      if (method.substr(0, 1) === \'-\' && prefix_i > 0) {\n        prefix = method.substr(0, prefix_i).toLowerCase();\n        method = method.substr(prefix_i);\n      }\n\n      method = method.toLowerCase();\n\n      if (method !== \'none\') {\n        results.push({\n          prefix: prefix,\n          method: method,\n          args: args\n        });\n      }\n    }\n\n    args = [];\n    method = definition = \'\';\n  };\n\n  image.split(\'\').forEach(function (c) {\n    if (mode === 0 && whitespace.test(c)) {\n      return;\n    }\n\n    switch (c) {\n      case \'"\':\n        if (!quote) {\n          quote = c;\n        } else if (quote === c) {\n          quote = null;\n        }\n\n        break;\n\n      case \'(\':\n        if (quote) {\n          break;\n        } else if (mode === 0) {\n          mode = 1;\n          return;\n        } else {\n          numParen++;\n        }\n\n        break;\n\n      case \')\':\n        if (quote) {\n          break;\n        } else if (mode === 1) {\n          if (numParen === 0) {\n            mode = 0;\n            appendResult();\n            return;\n          } else {\n            numParen--;\n          }\n        }\n\n        break;\n\n      case \',\':\n        if (quote) {\n          break;\n        } else if (mode === 0) {\n          appendResult();\n          return;\n        } else if (mode === 1) {\n          if (numParen === 0 && !method.match(/^url$/i)) {\n            args.push(definition.trim());\n            definition = \'\';\n            return;\n          }\n        }\n\n        break;\n    }\n\n    if (mode === 0) {\n      method += c;\n    } else {\n      definition += c;\n    }\n  });\n  appendResult();\n  return results;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/background.js?');
      },
      "./src/parsing/border.js": function srcParsingBorderJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_STYLE", function() { return BORDER_STYLE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_SIDES", function() { return BORDER_SIDES; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBorder", function() { return parseBorder; });\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Color */ "./src/Color.js");\n\n\n\nvar BORDER_STYLE = {\n  NONE: 0,\n  SOLID: 1\n};\nvar BORDER_SIDES = {\n  TOP: 0,\n  RIGHT: 1,\n  BOTTOM: 2,\n  LEFT: 3\n};\nvar SIDES = Object.keys(BORDER_SIDES).map(function (s) {\n  return s.toLowerCase();\n});\n\nvar parseBorderStyle = function parseBorderStyle(style) {\n  switch (style) {\n    case \'none\':\n      return BORDER_STYLE.NONE;\n  }\n\n  return BORDER_STYLE.SOLID;\n};\n\nvar parseBorder = function parseBorder(style) {\n  return SIDES.map(function (side) {\n    var borderColor = new _Color__WEBPACK_IMPORTED_MODULE_0__["default"](style.getPropertyValue("border-".concat(side, "-color")));\n    var borderStyle = parseBorderStyle(style.getPropertyValue("border-".concat(side, "-style")));\n    var borderWidth = parseFloat(style.getPropertyValue("border-".concat(side, "-width")));\n    return {\n      borderColor: borderColor,\n      borderStyle: borderStyle,\n      borderWidth: isNaN(borderWidth) ? 0 : borderWidth\n    };\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/border.js?');
      },
      "./src/parsing/borderRadius.js": function srcParsingBorderRadiusJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBorderRadius", function() { return parseBorderRadius; });\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Length */ "./src/Length.js");\n\n\nfunction _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }\n\nfunction _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }\n\nfunction _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }\n\nfunction _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }\n\n\nvar SIDES = [\'top-left\', \'top-right\', \'bottom-right\', \'bottom-left\'];\nvar parseBorderRadius = function parseBorderRadius(style) {\n  return SIDES.map(function (side) {\n    var value = style.getPropertyValue("border-".concat(side, "-radius"));\n\n    var _value$split$map = value.split(\' \').map(_Length__WEBPACK_IMPORTED_MODULE_0__["default"].create),\n        _value$split$map2 = _slicedToArray(_value$split$map, 2),\n        horizontal = _value$split$map2[0],\n        vertical = _value$split$map2[1];\n\n    return typeof vertical === \'undefined\' ? [horizontal, horizontal] : [horizontal, vertical];\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/borderRadius.js?');
      },
      "./src/parsing/display.js": function srcParsingDisplayJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"DISPLAY\", function() { return DISPLAY; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseDisplay\", function() { return parseDisplay; });\n\n\nvar DISPLAY = {\n  NONE: 1 << 0,\n  BLOCK: 1 << 1,\n  INLINE: 1 << 2,\n  RUN_IN: 1 << 3,\n  FLOW: 1 << 4,\n  FLOW_ROOT: 1 << 5,\n  TABLE: 1 << 6,\n  FLEX: 1 << 7,\n  GRID: 1 << 8,\n  RUBY: 1 << 9,\n  SUBGRID: 1 << 10,\n  LIST_ITEM: 1 << 11,\n  TABLE_ROW_GROUP: 1 << 12,\n  TABLE_HEADER_GROUP: 1 << 13,\n  TABLE_FOOTER_GROUP: 1 << 14,\n  TABLE_ROW: 1 << 15,\n  TABLE_CELL: 1 << 16,\n  TABLE_COLUMN_GROUP: 1 << 17,\n  TABLE_COLUMN: 1 << 18,\n  TABLE_CAPTION: 1 << 19,\n  RUBY_BASE: 1 << 20,\n  RUBY_TEXT: 1 << 21,\n  RUBY_BASE_CONTAINER: 1 << 22,\n  RUBY_TEXT_CONTAINER: 1 << 23,\n  CONTENTS: 1 << 24,\n  INLINE_BLOCK: 1 << 25,\n  INLINE_LIST_ITEM: 1 << 26,\n  INLINE_TABLE: 1 << 27,\n  INLINE_FLEX: 1 << 28,\n  INLINE_GRID: 1 << 29\n};\n\nvar parseDisplayValue = function parseDisplayValue(display) {\n  switch (display) {\n    case 'block':\n      return DISPLAY.BLOCK;\n\n    case 'inline':\n      return DISPLAY.INLINE;\n\n    case 'run-in':\n      return DISPLAY.RUN_IN;\n\n    case 'flow':\n      return DISPLAY.FLOW;\n\n    case 'flow-root':\n      return DISPLAY.FLOW_ROOT;\n\n    case 'table':\n      return DISPLAY.TABLE;\n\n    case 'flex':\n      return DISPLAY.FLEX;\n\n    case 'grid':\n      return DISPLAY.GRID;\n\n    case 'ruby':\n      return DISPLAY.RUBY;\n\n    case 'subgrid':\n      return DISPLAY.SUBGRID;\n\n    case 'list-item':\n      return DISPLAY.LIST_ITEM;\n\n    case 'table-row-group':\n      return DISPLAY.TABLE_ROW_GROUP;\n\n    case 'table-header-group':\n      return DISPLAY.TABLE_HEADER_GROUP;\n\n    case 'table-footer-group':\n      return DISPLAY.TABLE_FOOTER_GROUP;\n\n    case 'table-row':\n      return DISPLAY.TABLE_ROW;\n\n    case 'table-cell':\n      return DISPLAY.TABLE_CELL;\n\n    case 'table-column-group':\n      return DISPLAY.TABLE_COLUMN_GROUP;\n\n    case 'table-column':\n      return DISPLAY.TABLE_COLUMN;\n\n    case 'table-caption':\n      return DISPLAY.TABLE_CAPTION;\n\n    case 'ruby-base':\n      return DISPLAY.RUBY_BASE;\n\n    case 'ruby-text':\n      return DISPLAY.RUBY_TEXT;\n\n    case 'ruby-base-container':\n      return DISPLAY.RUBY_BASE_CONTAINER;\n\n    case 'ruby-text-container':\n      return DISPLAY.RUBY_TEXT_CONTAINER;\n\n    case 'contents':\n      return DISPLAY.CONTENTS;\n\n    case 'inline-block':\n      return DISPLAY.INLINE_BLOCK;\n\n    case 'inline-list-item':\n      return DISPLAY.INLINE_LIST_ITEM;\n\n    case 'inline-table':\n      return DISPLAY.INLINE_TABLE;\n\n    case 'inline-flex':\n      return DISPLAY.INLINE_FLEX;\n\n    case 'inline-grid':\n      return DISPLAY.INLINE_GRID;\n  }\n\n  return DISPLAY.NONE;\n};\n\nvar setDisplayBit = function setDisplayBit(bit, display) {\n  return bit | parseDisplayValue(display);\n};\n\nvar parseDisplay = function parseDisplay(display) {\n  return display.split(' ').reduce(setDisplayBit, 0);\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/display.js?");
      },
      "./src/parsing/float.js": function srcParsingFloatJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"FLOAT\", function() { return FLOAT; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseCSSFloat\", function() { return parseCSSFloat; });\n\n\nvar FLOAT = {\n  NONE: 0,\n  LEFT: 1,\n  RIGHT: 2,\n  INLINE_START: 3,\n  INLINE_END: 4\n};\nvar parseCSSFloat = function parseCSSFloat(float) {\n  switch (float) {\n    case 'left':\n      return FLOAT.LEFT;\n\n    case 'right':\n      return FLOAT.RIGHT;\n\n    case 'inline-start':\n      return FLOAT.INLINE_START;\n\n    case 'inline-end':\n      return FLOAT.INLINE_END;\n  }\n\n  return FLOAT.NONE;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/float.js?");
      },
      "./src/parsing/font.js": function srcParsingFontJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseFont\", function() { return parseFont; });\n\n\nvar parseFontWeight = function parseFontWeight(weight) {\n  switch (weight) {\n    case 'normal':\n      return 400;\n\n    case 'bold':\n      return 700;\n  }\n\n  var value = parseInt(weight, 10);\n  return isNaN(value) ? 400 : value;\n};\n\nvar parseFont = function parseFont(style) {\n  var fontFamily = style.fontFamily;\n  var fontSize = style.fontSize;\n  var fontStyle = style.fontStyle;\n  var fontVariant = style.fontVariant;\n  var fontWeight = parseFontWeight(style.fontWeight);\n  return {\n    fontFamily: fontFamily,\n    fontSize: fontSize,\n    fontStyle: fontStyle,\n    fontVariant: fontVariant,\n    fontWeight: fontWeight\n  };\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/font.js?");
      },
      "./src/parsing/letterSpacing.js": function srcParsingLetterSpacingJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseLetterSpacing\", function() { return parseLetterSpacing; });\n\n\nvar parseLetterSpacing = function parseLetterSpacing(letterSpacing) {\n  if (letterSpacing === 'normal') {\n    return 0;\n  }\n\n  var value = parseFloat(letterSpacing);\n  return isNaN(value) ? 0 : value;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/letterSpacing.js?");
      },
      "./src/parsing/lineBreak.js": function srcParsingLineBreakJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"LINE_BREAK\", function() { return LINE_BREAK; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseLineBreak\", function() { return parseLineBreak; });\n\n\nvar LINE_BREAK = {\n  NORMAL: 'normal',\n  STRICT: 'strict'\n};\nvar parseLineBreak = function parseLineBreak(wordBreak) {\n  switch (wordBreak) {\n    case 'strict':\n      return LINE_BREAK.STRICT;\n\n    case 'normal':\n    default:\n      return LINE_BREAK.NORMAL;\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/lineBreak.js?");
      },
      "./src/parsing/listStyle.js": function srcParsingListStyleJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"LIST_STYLE_POSITION\", function() { return LIST_STYLE_POSITION; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"LIST_STYLE_TYPE\", function() { return LIST_STYLE_TYPE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseListStyleType\", function() { return parseListStyleType; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseListStyle\", function() { return parseListStyle; });\n/* harmony import */ var _background__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./background */ \"./src/parsing/background.js\");\n\n\n\nvar LIST_STYLE_POSITION = {\n  INSIDE: 0,\n  OUTSIDE: 1\n};\nvar LIST_STYLE_TYPE = {\n  NONE: -1,\n  DISC: 0,\n  CIRCLE: 1,\n  SQUARE: 2,\n  DECIMAL: 3,\n  CJK_DECIMAL: 4,\n  DECIMAL_LEADING_ZERO: 5,\n  LOWER_ROMAN: 6,\n  UPPER_ROMAN: 7,\n  LOWER_GREEK: 8,\n  LOWER_ALPHA: 9,\n  UPPER_ALPHA: 10,\n  ARABIC_INDIC: 11,\n  ARMENIAN: 12,\n  BENGALI: 13,\n  CAMBODIAN: 14,\n  CJK_EARTHLY_BRANCH: 15,\n  CJK_HEAVENLY_STEM: 16,\n  CJK_IDEOGRAPHIC: 17,\n  DEVANAGARI: 18,\n  ETHIOPIC_NUMERIC: 19,\n  GEORGIAN: 20,\n  GUJARATI: 21,\n  GURMUKHI: 22,\n  HEBREW: 22,\n  HIRAGANA: 23,\n  HIRAGANA_IROHA: 24,\n  JAPANESE_FORMAL: 25,\n  JAPANESE_INFORMAL: 26,\n  KANNADA: 27,\n  KATAKANA: 28,\n  KATAKANA_IROHA: 29,\n  KHMER: 30,\n  KOREAN_HANGUL_FORMAL: 31,\n  KOREAN_HANJA_FORMAL: 32,\n  KOREAN_HANJA_INFORMAL: 33,\n  LAO: 34,\n  LOWER_ARMENIAN: 35,\n  MALAYALAM: 36,\n  MONGOLIAN: 37,\n  MYANMAR: 38,\n  ORIYA: 39,\n  PERSIAN: 40,\n  SIMP_CHINESE_FORMAL: 41,\n  SIMP_CHINESE_INFORMAL: 42,\n  TAMIL: 43,\n  TELUGU: 44,\n  THAI: 45,\n  TIBETAN: 46,\n  TRAD_CHINESE_FORMAL: 47,\n  TRAD_CHINESE_INFORMAL: 48,\n  UPPER_ARMENIAN: 49,\n  DISCLOSURE_OPEN: 50,\n  DISCLOSURE_CLOSED: 51\n};\nvar parseListStyleType = function parseListStyleType(type) {\n  switch (type) {\n    case 'disc':\n      return LIST_STYLE_TYPE.DISC;\n\n    case 'circle':\n      return LIST_STYLE_TYPE.CIRCLE;\n\n    case 'square':\n      return LIST_STYLE_TYPE.SQUARE;\n\n    case 'decimal':\n      return LIST_STYLE_TYPE.DECIMAL;\n\n    case 'cjk-decimal':\n      return LIST_STYLE_TYPE.CJK_DECIMAL;\n\n    case 'decimal-leading-zero':\n      return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;\n\n    case 'lower-roman':\n      return LIST_STYLE_TYPE.LOWER_ROMAN;\n\n    case 'upper-roman':\n      return LIST_STYLE_TYPE.UPPER_ROMAN;\n\n    case 'lower-greek':\n      return LIST_STYLE_TYPE.LOWER_GREEK;\n\n    case 'lower-alpha':\n      return LIST_STYLE_TYPE.LOWER_ALPHA;\n\n    case 'upper-alpha':\n      return LIST_STYLE_TYPE.UPPER_ALPHA;\n\n    case 'arabic-indic':\n      return LIST_STYLE_TYPE.ARABIC_INDIC;\n\n    case 'armenian':\n      return LIST_STYLE_TYPE.ARMENIAN;\n\n    case 'bengali':\n      return LIST_STYLE_TYPE.BENGALI;\n\n    case 'cambodian':\n      return LIST_STYLE_TYPE.CAMBODIAN;\n\n    case 'cjk-earthly-branch':\n      return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;\n\n    case 'cjk-heavenly-stem':\n      return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;\n\n    case 'cjk-ideographic':\n      return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;\n\n    case 'devanagari':\n      return LIST_STYLE_TYPE.DEVANAGARI;\n\n    case 'ethiopic-numeric':\n      return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;\n\n    case 'georgian':\n      return LIST_STYLE_TYPE.GEORGIAN;\n\n    case 'gujarati':\n      return LIST_STYLE_TYPE.GUJARATI;\n\n    case 'gurmukhi':\n      return LIST_STYLE_TYPE.GURMUKHI;\n\n    case 'hebrew':\n      return LIST_STYLE_TYPE.HEBREW;\n\n    case 'hiragana':\n      return LIST_STYLE_TYPE.HIRAGANA;\n\n    case 'hiragana-iroha':\n      return LIST_STYLE_TYPE.HIRAGANA_IROHA;\n\n    case 'japanese-formal':\n      return LIST_STYLE_TYPE.JAPANESE_FORMAL;\n\n    case 'japanese-informal':\n      return LIST_STYLE_TYPE.JAPANESE_INFORMAL;\n\n    case 'kannada':\n      return LIST_STYLE_TYPE.KANNADA;\n\n    case 'katakana':\n      return LIST_STYLE_TYPE.KATAKANA;\n\n    case 'katakana-iroha':\n      return LIST_STYLE_TYPE.KATAKANA_IROHA;\n\n    case 'khmer':\n      return LIST_STYLE_TYPE.KHMER;\n\n    case 'korean-hangul-formal':\n      return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;\n\n    case 'korean-hanja-formal':\n      return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;\n\n    case 'korean-hanja-informal':\n      return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;\n\n    case 'lao':\n      return LIST_STYLE_TYPE.LAO;\n\n    case 'lower-armenian':\n      return LIST_STYLE_TYPE.LOWER_ARMENIAN;\n\n    case 'malayalam':\n      return LIST_STYLE_TYPE.MALAYALAM;\n\n    case 'mongolian':\n      return LIST_STYLE_TYPE.MONGOLIAN;\n\n    case 'myanmar':\n      return LIST_STYLE_TYPE.MYANMAR;\n\n    case 'oriya':\n      return LIST_STYLE_TYPE.ORIYA;\n\n    case 'persian':\n      return LIST_STYLE_TYPE.PERSIAN;\n\n    case 'simp-chinese-formal':\n      return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;\n\n    case 'simp-chinese-informal':\n      return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;\n\n    case 'tamil':\n      return LIST_STYLE_TYPE.TAMIL;\n\n    case 'telugu':\n      return LIST_STYLE_TYPE.TELUGU;\n\n    case 'thai':\n      return LIST_STYLE_TYPE.THAI;\n\n    case 'tibetan':\n      return LIST_STYLE_TYPE.TIBETAN;\n\n    case 'trad-chinese-formal':\n      return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;\n\n    case 'trad-chinese-informal':\n      return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;\n\n    case 'upper-armenian':\n      return LIST_STYLE_TYPE.UPPER_ARMENIAN;\n\n    case 'disclosure-open':\n      return LIST_STYLE_TYPE.DISCLOSURE_OPEN;\n\n    case 'disclosure-closed':\n      return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;\n\n    case 'none':\n    default:\n      return LIST_STYLE_TYPE.NONE;\n  }\n};\nvar parseListStyle = function parseListStyle(style) {\n  var listStyleImage = Object(_background__WEBPACK_IMPORTED_MODULE_0__[\"parseBackgroundImage\"])(style.getPropertyValue('list-style-image'));\n  return {\n    listStyleType: parseListStyleType(style.getPropertyValue('list-style-type')),\n    listStyleImage: listStyleImage.length ? listStyleImage[0] : null,\n    listStylePosition: parseListStylePosition(style.getPropertyValue('list-style-position'))\n  };\n};\n\nvar parseListStylePosition = function parseListStylePosition(position) {\n  switch (position) {\n    case 'inside':\n      return LIST_STYLE_POSITION.INSIDE;\n\n    case 'outside':\n    default:\n      return LIST_STYLE_POSITION.OUTSIDE;\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/listStyle.js?");
      },
      "./src/parsing/margin.js": function srcParsingMarginJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseMargin\", function() { return parseMargin; });\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Length */ \"./src/Length.js\");\n\n\n\nvar SIDES = ['top', 'right', 'bottom', 'left'];\nvar parseMargin = function parseMargin(style) {\n  return SIDES.map(function (side) {\n    return new _Length__WEBPACK_IMPORTED_MODULE_0__[\"default\"](style.getPropertyValue(\"margin-\".concat(side)));\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/margin.js?");
      },
      "./src/parsing/overflow.js": function srcParsingOverflowJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"OVERFLOW\", function() { return OVERFLOW; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseOverflow\", function() { return parseOverflow; });\n\n\nvar OVERFLOW = {\n  VISIBLE: 0,\n  HIDDEN: 1,\n  SCROLL: 2,\n  AUTO: 3\n};\nvar parseOverflow = function parseOverflow(overflow) {\n  switch (overflow) {\n    case 'hidden':\n      return OVERFLOW.HIDDEN;\n\n    case 'scroll':\n      return OVERFLOW.SCROLL;\n\n    case 'auto':\n      return OVERFLOW.AUTO;\n\n    case 'visible':\n    default:\n      return OVERFLOW.VISIBLE;\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/overflow.js?");
      },
      "./src/parsing/overflowWrap.js": function srcParsingOverflowWrapJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"OVERFLOW_WRAP\", function() { return OVERFLOW_WRAP; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseOverflowWrap\", function() { return parseOverflowWrap; });\n\n\nvar OVERFLOW_WRAP = {\n  NORMAL: 0,\n  BREAK_WORD: 1\n};\nvar parseOverflowWrap = function parseOverflowWrap(overflow) {\n  switch (overflow) {\n    case 'break-word':\n      return OVERFLOW_WRAP.BREAK_WORD;\n\n    case 'normal':\n    default:\n      return OVERFLOW_WRAP.NORMAL;\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/overflowWrap.js?");
      },
      "./src/parsing/padding.js": function srcParsingPaddingJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PADDING_SIDES", function() { return PADDING_SIDES; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePadding", function() { return parsePadding; });\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Length */ "./src/Length.js");\n\n\n\nvar PADDING_SIDES = {\n  TOP: 0,\n  RIGHT: 1,\n  BOTTOM: 2,\n  LEFT: 3\n};\nvar SIDES = [\'top\', \'right\', \'bottom\', \'left\'];\nvar parsePadding = function parsePadding(style) {\n  return SIDES.map(function (side) {\n    return new _Length__WEBPACK_IMPORTED_MODULE_0__["default"](style.getPropertyValue("padding-".concat(side)));\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/padding.js?');
      },
      "./src/parsing/position.js": function srcParsingPositionJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"POSITION\", function() { return POSITION; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parsePosition\", function() { return parsePosition; });\n\n\nvar POSITION = {\n  STATIC: 0,\n  RELATIVE: 1,\n  ABSOLUTE: 2,\n  FIXED: 3,\n  STICKY: 4\n};\nvar parsePosition = function parsePosition(position) {\n  switch (position) {\n    case 'relative':\n      return POSITION.RELATIVE;\n\n    case 'absolute':\n      return POSITION.ABSOLUTE;\n\n    case 'fixed':\n      return POSITION.FIXED;\n\n    case 'sticky':\n      return POSITION.STICKY;\n  }\n\n  return POSITION.STATIC;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/position.js?");
      },
      "./src/parsing/textDecoration.js": function srcParsingTextDecorationJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TEXT_DECORATION_STYLE\", function() { return TEXT_DECORATION_STYLE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TEXT_DECORATION\", function() { return TEXT_DECORATION; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TEXT_DECORATION_LINE\", function() { return TEXT_DECORATION_LINE; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseTextDecoration\", function() { return parseTextDecoration; });\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Color */ \"./src/Color.js\");\n\n\n\nvar TEXT_DECORATION_STYLE = {\n  SOLID: 0,\n  DOUBLE: 1,\n  DOTTED: 2,\n  DASHED: 3,\n  WAVY: 4\n};\nvar TEXT_DECORATION = {\n  NONE: null\n};\nvar TEXT_DECORATION_LINE = {\n  UNDERLINE: 1,\n  OVERLINE: 2,\n  LINE_THROUGH: 3,\n  BLINK: 4\n};\n\nvar parseLine = function parseLine(line) {\n  switch (line) {\n    case 'underline':\n      return TEXT_DECORATION_LINE.UNDERLINE;\n\n    case 'overline':\n      return TEXT_DECORATION_LINE.OVERLINE;\n\n    case 'line-through':\n      return TEXT_DECORATION_LINE.LINE_THROUGH;\n  }\n\n  return TEXT_DECORATION_LINE.BLINK;\n};\n\nvar parseTextDecorationLine = function parseTextDecorationLine(line) {\n  if (line === 'none') {\n    return null;\n  }\n\n  return line.split(' ').map(parseLine);\n};\n\nvar parseTextDecorationStyle = function parseTextDecorationStyle(style) {\n  switch (style) {\n    case 'double':\n      return TEXT_DECORATION_STYLE.DOUBLE;\n\n    case 'dotted':\n      return TEXT_DECORATION_STYLE.DOTTED;\n\n    case 'dashed':\n      return TEXT_DECORATION_STYLE.DASHED;\n\n    case 'wavy':\n      return TEXT_DECORATION_STYLE.WAVY;\n  }\n\n  return TEXT_DECORATION_STYLE.SOLID;\n};\n\nvar parseTextDecoration = function parseTextDecoration(style) {\n  var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);\n\n  if (textDecorationLine === null) {\n    return TEXT_DECORATION.NONE;\n  }\n\n  var textDecorationColor = style.textDecorationColor ? new _Color__WEBPACK_IMPORTED_MODULE_0__[\"default\"](style.textDecorationColor) : null;\n  var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);\n  return {\n    textDecorationLine: textDecorationLine,\n    textDecorationColor: textDecorationColor,\n    textDecorationStyle: textDecorationStyle\n  };\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/textDecoration.js?");
      },
      "./src/parsing/textShadow.js": function srcParsingTextShadowJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseTextShadow\", function() { return parseTextShadow; });\n/* harmony import */ var _Color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Color */ \"./src/Color.js\");\n\n\n\nvar NUMBER = /^([+-]|\\d|\\.)$/i;\nvar parseTextShadow = function parseTextShadow(textShadow) {\n  if (textShadow === 'none' || typeof textShadow !== 'string') {\n    return null;\n  }\n\n  var currentValue = '';\n  var isLength = false;\n  var values = [];\n  var shadows = [];\n  var numParens = 0;\n  var color = null;\n\n  var appendValue = function appendValue() {\n    if (currentValue.length) {\n      if (isLength) {\n        values.push(parseFloat(currentValue));\n      } else {\n        color = new _Color__WEBPACK_IMPORTED_MODULE_0__[\"default\"](currentValue);\n      }\n    }\n\n    isLength = false;\n    currentValue = '';\n  };\n\n  var appendShadow = function appendShadow() {\n    if (values.length && color !== null) {\n      shadows.push({\n        color: color,\n        offsetX: values[0] || 0,\n        offsetY: values[1] || 0,\n        blur: values[2] || 0\n      });\n    }\n\n    values.splice(0, values.length);\n    color = null;\n  };\n\n  for (var i = 0; i < textShadow.length; i++) {\n    var c = textShadow[i];\n\n    switch (c) {\n      case '(':\n        currentValue += c;\n        numParens++;\n        break;\n\n      case ')':\n        currentValue += c;\n        numParens--;\n        break;\n\n      case ',':\n        if (numParens === 0) {\n          appendValue();\n          appendShadow();\n        } else {\n          currentValue += c;\n        }\n\n        break;\n\n      case ' ':\n        if (numParens === 0) {\n          appendValue();\n        } else {\n          currentValue += c;\n        }\n\n        break;\n\n      default:\n        if (currentValue.length === 0 && NUMBER.test(c)) {\n          isLength = true;\n        }\n\n        currentValue += c;\n    }\n  }\n\n  appendValue();\n  appendShadow();\n\n  if (shadows.length === 0) {\n    return null;\n  }\n\n  return shadows;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/textShadow.js?");
      },
      "./src/parsing/textTransform.js": function srcParsingTextTransformJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TEXT_TRANSFORM\", function() { return TEXT_TRANSFORM; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseTextTransform\", function() { return parseTextTransform; });\n\n\nvar TEXT_TRANSFORM = {\n  NONE: 0,\n  LOWERCASE: 1,\n  UPPERCASE: 2,\n  CAPITALIZE: 3\n};\nvar parseTextTransform = function parseTextTransform(textTransform) {\n  switch (textTransform) {\n    case 'uppercase':\n      return TEXT_TRANSFORM.UPPERCASE;\n\n    case 'lowercase':\n      return TEXT_TRANSFORM.LOWERCASE;\n\n    case 'capitalize':\n      return TEXT_TRANSFORM.CAPITALIZE;\n  }\n\n  return TEXT_TRANSFORM.NONE;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/textTransform.js?");
      },
      "./src/parsing/transform.js": function srcParsingTransformJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseTransform\", function() { return parseTransform; });\n/* harmony import */ var _Length__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Length */ \"./src/Length.js\");\n\n\n\n\nvar toFloat = function toFloat(s) {\n  return parseFloat(s.trim());\n};\n\nvar MATRIX = /(matrix|matrix3d)\\((.+)\\)/;\nvar parseTransform = function parseTransform(style) {\n  var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform || // $FlowFixMe\n  style.msTransform || // $FlowFixMe\n  style.oTransform);\n\n  if (transform === null) {\n    return null;\n  }\n\n  return {\n    transform: transform,\n    transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin || // $FlowFixMe\n    style.msTransformOrigin || // $FlowFixMe\n    style.oTransformOrigin)\n  };\n}; // $FlowFixMe\n\nvar parseTransformOrigin = function parseTransformOrigin(origin) {\n  if (typeof origin !== 'string') {\n    var v = new _Length__WEBPACK_IMPORTED_MODULE_0__[\"default\"]('0');\n    return [v, v];\n  }\n\n  var values = origin.split(' ').map(_Length__WEBPACK_IMPORTED_MODULE_0__[\"default\"].create);\n  return [values[0], values[1]];\n}; // $FlowFixMe\n\n\nvar parseTransformMatrix = function parseTransformMatrix(transform) {\n  if (transform === 'none' || typeof transform !== 'string') {\n    return null;\n  }\n\n  var match = transform.match(MATRIX);\n\n  if (match) {\n    if (match[1] === 'matrix') {\n      var matrix = match[2].split(',').map(toFloat);\n      return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];\n    } else {\n      var matrix3d = match[2].split(',').map(toFloat);\n      return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];\n    }\n  }\n\n  return null;\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/transform.js?");
      },
      "./src/parsing/visibility.js": function srcParsingVisibilityJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"VISIBILITY\", function() { return VISIBILITY; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseVisibility\", function() { return parseVisibility; });\n\n\nvar VISIBILITY = {\n  VISIBLE: 0,\n  HIDDEN: 1,\n  COLLAPSE: 2\n};\nvar parseVisibility = function parseVisibility(visibility) {\n  switch (visibility) {\n    case 'hidden':\n      return VISIBILITY.HIDDEN;\n\n    case 'collapse':\n      return VISIBILITY.COLLAPSE;\n\n    case 'visible':\n    default:\n      return VISIBILITY.VISIBLE;\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/visibility.js?");
      },
      "./src/parsing/word-break.js": function srcParsingWordBreakJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"WORD_BREAK\", function() { return WORD_BREAK; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseWordBreak\", function() { return parseWordBreak; });\n\n\nvar WORD_BREAK = {\n  NORMAL: 'normal',\n  BREAK_ALL: 'break-all',\n  KEEP_ALL: 'keep-all'\n};\nvar parseWordBreak = function parseWordBreak(wordBreak) {\n  switch (wordBreak) {\n    case 'break-all':\n      return WORD_BREAK.BREAK_ALL;\n\n    case 'keep-all':\n      return WORD_BREAK.KEEP_ALL;\n\n    case 'normal':\n    default:\n      return WORD_BREAK.NORMAL;\n  }\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/word-break.js?");
      },
      "./src/parsing/zIndex.js": function srcParsingZIndexJs(module, __webpack_exports__, __webpack_require__) {
        eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"parseZIndex\", function() { return parseZIndex; });\n\n\nvar parseZIndex = function parseZIndex(zIndex) {\n  var auto = zIndex === 'auto';\n  return {\n    auto: auto,\n    order: auto ? 0 : parseInt(zIndex, 10)\n  };\n};\n\n//# sourceURL=webpack://html2canvas/./src/parsing/zIndex.js?");
      },
      "./src/renderer/CanvasRenderer.js": function srcRendererCanvasRendererJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CanvasRenderer; });\n/* harmony import */ var _drawing_Path__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../drawing/Path */ "./src/drawing/Path.js");\n/* harmony import */ var _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../parsing/textDecoration */ "./src/parsing/textDecoration.js");\n\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n\n\n\nvar addColorStops = function addColorStops(gradient, canvasGradient) {\n  var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {\n    return colorStop.stop;\n  }));\n  var f = 1 / Math.max(1, maxStop);\n  gradient.colorStops.forEach(function (colorStop) {\n    canvasGradient.addColorStop(Math.floor(Math.max(0, f * colorStop.stop)), colorStop.color.toString());\n  });\n};\n\nvar CanvasRenderer =\n/*#__PURE__*/\nfunction () {\n  function CanvasRenderer(canvas) {\n    _classCallCheck(this, CanvasRenderer);\n\n    this.canvas = canvas ? canvas : document.createElement(\'canvas\');\n  }\n\n  _createClass(CanvasRenderer, [{\n    key: "render",\n    value: function render(options) {\n      this.ctx = this.canvas.getContext(\'2d\');\n      this.options = options;\n      this.canvas.width = Math.floor(options.width * options.scale);\n      this.canvas.height = Math.floor(options.height * options.scale);\n      this.canvas.style.width = "".concat(options.width, "px");\n      this.canvas.style.height = "".concat(options.height, "px");\n      this.ctx.scale(this.options.scale, this.options.scale);\n      this.ctx.translate(-options.x, -options.y);\n      this.ctx.textBaseline = \'bottom\';\n      options.logger.log("Canvas renderer initialized (".concat(options.width, "x").concat(options.height, " at ").concat(options.x, ",").concat(options.y, ") with scale ").concat(this.options.scale));\n    }\n  }, {\n    key: "clip",\n    value: function clip(clipPaths, callback) {\n      var _this = this;\n\n      if (clipPaths.length) {\n        this.ctx.save();\n        clipPaths.forEach(function (path) {\n          _this.path(path);\n\n          _this.ctx.clip();\n        });\n      }\n\n      callback();\n\n      if (clipPaths.length) {\n        this.ctx.restore();\n      }\n    }\n  }, {\n    key: "drawImage",\n    value: function drawImage(image, source, destination) {\n      this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);\n    }\n  }, {\n    key: "drawShape",\n    value: function drawShape(path, color) {\n      this.path(path);\n      this.ctx.fillStyle = color.toString();\n      this.ctx.fill();\n    }\n  }, {\n    key: "fill",\n    value: function fill(color) {\n      this.ctx.fillStyle = color.toString();\n      this.ctx.fill();\n    }\n  }, {\n    key: "getTarget",\n    value: function getTarget() {\n      this.canvas.getContext(\'2d\').setTransform(1, 0, 0, 1, 0, 0);\n      return Promise.resolve(this.canvas);\n    }\n  }, {\n    key: "path",\n    value: function path(_path) {\n      var _this2 = this;\n\n      this.ctx.beginPath();\n\n      if (Array.isArray(_path)) {\n        _path.forEach(function (point, index) {\n          var start = point.type === _drawing_Path__WEBPACK_IMPORTED_MODULE_0__["PATH"].VECTOR ? point : point.start;\n\n          if (index === 0) {\n            _this2.ctx.moveTo(start.x, start.y);\n          } else {\n            _this2.ctx.lineTo(start.x, start.y);\n          }\n\n          if (point.type === _drawing_Path__WEBPACK_IMPORTED_MODULE_0__["PATH"].BEZIER_CURVE) {\n            _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);\n          }\n        });\n      } else {\n        this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);\n      }\n\n      this.ctx.closePath();\n    }\n  }, {\n    key: "rectangle",\n    value: function rectangle(x, y, width, height, color) {\n      this.ctx.fillStyle = color.toString();\n      this.ctx.fillRect(x, y, width, height);\n    }\n  }, {\n    key: "renderLinearGradient",\n    value: function renderLinearGradient(bounds, gradient) {\n      var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);\n      addColorStops(gradient, linearGradient);\n      this.ctx.fillStyle = linearGradient;\n      this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);\n    }\n  }, {\n    key: "renderRadialGradient",\n    value: function renderRadialGradient(bounds, gradient) {\n      var _this3 = this;\n\n      var x = bounds.left + gradient.center.x;\n      var y = bounds.top + gradient.center.y;\n      var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);\n\n      if (!radialGradient) {\n        return;\n      }\n\n      addColorStops(gradient, radialGradient);\n      this.ctx.fillStyle = radialGradient;\n\n      if (gradient.radius.x !== gradient.radius.y) {\n        // transforms for elliptical radial gradient\n        var midX = bounds.left + 0.5 * bounds.width;\n        var midY = bounds.top + 0.5 * bounds.height;\n        var f = gradient.radius.y / gradient.radius.x;\n        var invF = 1 / f;\n        this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {\n          return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);\n        });\n      } else {\n        this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);\n      }\n    }\n  }, {\n    key: "renderRepeat",\n    value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {\n      this.path(path);\n      this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), \'repeat\');\n      this.ctx.translate(offsetX, offsetY);\n      this.ctx.fill();\n      this.ctx.translate(-offsetX, -offsetY);\n    }\n  }, {\n    key: "renderTextNode",\n    value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {\n      var _this4 = this;\n\n      this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(\' \');\n      textBounds.forEach(function (text) {\n        _this4.ctx.fillStyle = color.toString();\n\n        if (textShadows && text.text.trim().length) {\n          textShadows.slice(0).reverse().forEach(function (textShadow) {\n            _this4.ctx.shadowColor = textShadow.color.toString();\n            _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;\n            _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;\n            _this4.ctx.shadowBlur = textShadow.blur;\n\n            _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);\n          });\n          _this4.ctx.shadowColor = \'\';\n          _this4.ctx.shadowOffsetX = 0;\n          _this4.ctx.shadowOffsetY = 0;\n          _this4.ctx.shadowBlur = 0;\n        } else {\n          _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);\n        }\n\n        if (textDecoration !== null) {\n          var textDecorationColor = textDecoration.textDecorationColor || color;\n          textDecoration.textDecorationLine.forEach(function (textDecorationLine) {\n            switch (textDecorationLine) {\n              case _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_1__["TEXT_DECORATION_LINE"].UNDERLINE:\n                // Draws a line at the baseline of the font\n                // TODO As some browsers display the line as more than 1px if the font-size is big,\n                // need to take that into account both in position and size\n                var _this4$options$fontMe = _this4.options.fontMetrics.getMetrics(font),\n                    baseline = _this4$options$fontMe.baseline;\n\n                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);\n\n                break;\n\n              case _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_1__["TEXT_DECORATION_LINE"].OVERLINE:\n                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);\n\n                break;\n\n              case _parsing_textDecoration__WEBPACK_IMPORTED_MODULE_1__["TEXT_DECORATION_LINE"].LINE_THROUGH:\n                // TODO try and find exact position for line-through\n                var _this4$options$fontMe2 = _this4.options.fontMetrics.getMetrics(font),\n                    middle = _this4$options$fontMe2.middle;\n\n                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);\n\n                break;\n            }\n          });\n        }\n      });\n    }\n  }, {\n    key: "resizeImage",\n    value: function resizeImage(image, size) {\n      if (image.width === size.width && image.height === size.height) {\n        return image;\n      }\n\n      var canvas = this.canvas.ownerDocument.createElement(\'canvas\');\n      canvas.width = size.width;\n      canvas.height = size.height;\n      var ctx = canvas.getContext(\'2d\');\n      ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);\n      return canvas;\n    }\n  }, {\n    key: "setOpacity",\n    value: function setOpacity(opacity) {\n      this.ctx.globalAlpha = opacity;\n    }\n  }, {\n    key: "transform",\n    value: function transform(offsetX, offsetY, matrix, callback) {\n      this.ctx.save();\n      this.ctx.translate(offsetX, offsetY);\n      this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);\n      this.ctx.translate(-offsetX, -offsetY);\n      callback();\n      this.ctx.restore();\n    }\n  }]);\n\n  return CanvasRenderer;\n}();\n\n\n\n//# sourceURL=webpack://html2canvas/./src/renderer/CanvasRenderer.js?');
      },
      "./src/renderer/ForeignObjectRenderer.js": function srcRendererForeignObjectRendererJs(module, __webpack_exports__, __webpack_require__) {
        eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ForeignObjectRenderer; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createForeignObjectSVG", function() { return createForeignObjectSVG; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSerializedSVG", function() { return loadSerializedSVG; });\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nvar ForeignObjectRenderer =\n/*#__PURE__*/\nfunction () {\n  function ForeignObjectRenderer(element) {\n    _classCallCheck(this, ForeignObjectRenderer);\n\n    this.element = element;\n  }\n\n  _createClass(ForeignObjectRenderer, [{\n    key: "render",\n    value: function render(options) {\n      var _this = this;\n\n      this.options = options;\n      this.canvas = document.createElement(\'canvas\');\n      this.ctx = this.canvas.getContext(\'2d\');\n      this.canvas.width = Math.floor(options.width) * options.scale;\n      this.canvas.height = Math.floor(options.height) * options.scale;\n      this.canvas.style.width = "".concat(options.width, "px");\n      this.canvas.style.height = "".concat(options.height, "px");\n      this.ctx.scale(options.scale, options.scale);\n      options.logger.log("ForeignObject renderer initialized (".concat(options.width, "x").concat(options.height, " at ").concat(options.x, ",").concat(options.y, ") with scale ").concat(options.scale));\n      var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);\n      return loadSerializedSVG(svg).then(function (img) {\n        if (options.backgroundColor) {\n          _this.ctx.fillStyle = options.backgroundColor.toString();\n\n          _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);\n        }\n\n        _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);\n\n        return _this.canvas;\n      });\n    }\n  }]);\n\n  return ForeignObjectRenderer;\n}();\n\n\nvar createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {\n  var xmlns = \'http://www.w3.org/2000/svg\';\n  var svg = document.createElementNS(xmlns, \'svg\');\n  var foreignObject = document.createElementNS(xmlns, \'foreignObject\');\n  svg.setAttributeNS(null, \'width\', width);\n  svg.setAttributeNS(null, \'height\', height);\n  foreignObject.setAttributeNS(null, \'width\', \'100%\');\n  foreignObject.setAttributeNS(null, \'height\', \'100%\');\n  foreignObject.setAttributeNS(null, \'x\', x);\n  foreignObject.setAttributeNS(null, \'y\', y);\n  foreignObject.setAttributeNS(null, \'externalResourcesRequired\', \'true\');\n  svg.appendChild(foreignObject);\n  foreignObject.appendChild(node);\n  return svg;\n};\nvar loadSerializedSVG = function loadSerializedSVG(svg) {\n  return new Promise(function (resolve, reject) {\n    var img = new Image();\n\n    img.onload = function () {\n      return resolve(img);\n    };\n\n    img.onerror = reject;\n    img.src = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(new XMLSerializer().serializeToString(svg)));\n  });\n};\n\n//# sourceURL=webpack://html2canvas/./src/renderer/ForeignObjectRenderer.js?');
      }
    }, P = {}, Q.m = O, Q.c = P, Q.d = function (e, n, r) {
      Q.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, Q.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, Q.t = function (n, e) {
      if (1 & e && (n = Q(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (Q.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var t in n) {
        Q.d(r, t, function (e) {
          return n[e];
        }.bind(null, t));
      }
      return r;
    }, Q.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return Q.d(n, "a", n), n;
    }, Q.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, Q.p = "", Q(Q.s = "./src/index.js")).default;

    function Q(e) {
      if (P[e]) return P[e].exports;
      var n = P[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return O[e].call(n.exports, n, n.exports, Q), n.l = !0, n.exports;
    }

    var O, P;
  }, module.exports = N();
}),
    html2canvas$1 = unwrapExports(html2canvas),
    _extendStatics = function extendStatics(e, n) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, n) {
    e.__proto__ = n;
  } || function (e, n) {
    for (var r in n) {
      n.hasOwnProperty(r) && (e[r] = n[r]);
    }
  })(e, n);
};

function __extends(e, n) {
  function r() {
    this.constructor = e;
  }

  _extendStatics(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
}

var _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var n, r = 1, t = arguments.length; r < t; r++) {
      for (var a in n = arguments[r]) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function __rest(e, n) {
  var r = {};

  for (var t in e) {
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (r[t] = e[t]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (t = Object.getOwnPropertySymbols(e); a < t.length; a++) {
      n.indexOf(t[a]) < 0 && (r[t[a]] = e[t[a]]);
    }
  }

  return r;
}

var _assign$ = function __assign$1() {
  return (_assign$ = Object.assign || function (e) {
    for (var n, r = 1, t = arguments.length; r < t; r++) {
      for (var a in n = arguments[r]) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    clamp = function clamp(n, r) {
  return function (e) {
    return Math.max(Math.min(e, r), n);
  };
},
    sanitize = function sanitize(e) {
  return e % 1 ? Number(e.toFixed(5)) : e;
},
    floatRegex = /(-)?(\d[\d\.]*)/g,
    colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
    singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))$/i,
    number = {
  test: function test(e) {
    return "number" == typeof e;
  },
  parse: parseFloat,
  transform: function transform(e) {
    return e;
  }
},
    alpha = _assign$({}, number, {
  transform: clamp(0, 1)
}),
    scale = _assign$({}, number, {
  default: 1
}),
    createUnitType = function createUnitType(n) {
  return {
    test: function test(e) {
      return "string" == typeof e && e.endsWith(n) && 1 === e.split(" ").length;
    },
    parse: parseFloat,
    transform: function transform(e) {
      return "" + e + n;
    }
  };
},
    degrees = createUnitType("deg"),
    percent = createUnitType("%"),
    px = createUnitType("px"),
    vh = createUnitType("vh"),
    vw = createUnitType("vw"),
    progressPercentage = _assign$({}, percent, {
  parse: function parse(e) {
    return percent.parse(e) / 100;
  },
  transform: function transform(e) {
    return percent.transform(100 * e);
  }
}),
    getValueFromFunctionString = function getValueFromFunctionString(e) {
  return e.substring(e.indexOf("(") + 1, e.lastIndexOf(")"));
},
    clampRgbUnit = clamp(0, 255),
    isRgba = function isRgba(e) {
  return void 0 !== e.red;
},
    isHsla = function isHsla(e) {
  return void 0 !== e.hue;
},
    splitColorValues = function splitColorValues(a) {
  return function (e) {
    if ("string" != typeof e) return e;

    for (var n = {}, r = getValueFromFunctionString(e).split(/,\s*/), t = 0; t < 4; t++) {
      n[a[t]] = void 0 !== r[t] ? parseFloat(r[t]) : 1;
    }

    return n;
  };
},
    rgbaTemplate = function rgbaTemplate(e) {
  var n = e.red,
      r = e.green,
      t = e.blue,
      a = e.alpha;
  return "rgba(" + n + ", " + r + ", " + t + ", " + (void 0 === a ? 1 : a) + ")";
},
    hslaTemplate = function hslaTemplate(e) {
  var n = e.hue,
      r = e.saturation,
      t = e.lightness,
      a = e.alpha;
  return "hsla(" + n + ", " + r + ", " + t + ", " + (void 0 === a ? 1 : a) + ")";
},
    rgbUnit = _assign$({}, number, {
  transform: function transform(e) {
    return Math.round(clampRgbUnit(e));
  }
});

function isColorString(e, n) {
  return e.startsWith(n) && singleColorRegex.test(e);
}

var rgba = {
  test: function test(e) {
    return "string" == typeof e ? isColorString(e, "rgb") : isRgba(e);
  },
  parse: splitColorValues(["red", "green", "blue", "alpha"]),
  transform: function transform(e) {
    var n = e.red,
        r = e.green,
        t = e.blue,
        a = e.alpha;
    return rgbaTemplate({
      red: rgbUnit.transform(n),
      green: rgbUnit.transform(r),
      blue: rgbUnit.transform(t),
      alpha: sanitize(a)
    });
  }
},
    hsla = {
  test: function test(e) {
    return "string" == typeof e ? isColorString(e, "hsl") : isHsla(e);
  },
  parse: splitColorValues(["hue", "saturation", "lightness", "alpha"]),
  transform: function transform(e) {
    var n = e.hue,
        r = e.saturation,
        t = e.lightness,
        a = e.alpha;
    return hslaTemplate({
      hue: Math.round(n),
      saturation: percent.transform(sanitize(r)),
      lightness: percent.transform(sanitize(t)),
      alpha: sanitize(a)
    });
  }
},
    hex = _assign$({}, rgba, {
  test: function test(e) {
    return "string" == typeof e && isColorString(e, "#");
  },
  parse: function parse(e) {
    var n = "",
        r = "",
        t = "";
    return 4 < e.length ? (n = e.substr(1, 2), r = e.substr(3, 2), t = e.substr(5, 2)) : (n = e.substr(1, 1), r = e.substr(2, 1), t = e.substr(3, 1), n += n, r += r, t += t), {
      red: parseInt(n, 16),
      green: parseInt(r, 16),
      blue: parseInt(t, 16),
      alpha: 1
    };
  }
}),
    color = {
  test: function test(e) {
    return "string" == typeof e && singleColorRegex.test(e) || isRgba(e) || isHsla(e);
  },
  parse: function parse(e) {
    return rgba.test(e) ? rgba.parse(e) : hsla.test(e) ? hsla.parse(e) : hex.test(e) ? hex.parse(e) : e;
  },
  transform: function transform(e) {
    return isRgba(e) ? rgba.transform(e) : isHsla(e) ? hsla.transform(e) : e;
  }
},
    COLOR_TOKEN = "${c}",
    NUMBER_TOKEN = "${n}",
    convertNumbersToZero = function convertNumbersToZero(e) {
  return "number" == typeof e ? 0 : e;
},
    complex = {
  test: function test(e) {
    if ("string" != typeof e || !isNaN(e)) return !1;
    var n = 0,
        r = e.match(floatRegex),
        t = e.match(colorRegex);
    return r && (n += r.length), t && (n += t.length), 0 < n;
  },
  parse: function parse(e) {
    var n = e,
        r = [],
        t = n.match(colorRegex);
    t && (n = n.replace(colorRegex, COLOR_TOKEN), r.push.apply(r, t.map(color.parse)));
    var a = n.match(floatRegex);
    return a && r.push.apply(r, a.map(number.parse)), r;
  },
  createTransformer: function createTransformer(e) {
    var t = e,
        a = 0,
        n = e.match(colorRegex),
        i = n ? n.length : 0;
    if (n) for (var r = 0; r < i; r++) {
      t = t.replace(n[r], COLOR_TOKEN), a++;
    }
    var A = t.match(floatRegex),
        o = A ? A.length : 0;
    if (A) for (r = 0; r < o; r++) {
      t = t.replace(A[r], NUMBER_TOKEN), a++;
    }
    return function (e) {
      for (var n = t, r = 0; r < a; r++) {
        n = n.replace(r < i ? COLOR_TOKEN : NUMBER_TOKEN, r < i ? color.transform(e[r]) : sanitize(e[r]));
      }

      return n;
    };
  },
  getAnimatableNone: function getAnimatableNone(e) {
    var n = complex.parse(e);
    return complex.createTransformer(e)(n.map(convertNumbersToZero));
  }
},
    warning = function warning() {},
    invariant = function invariant() {};

"production" !== process.env.NODE_ENV && (warning = function warning(e, n) {
  e || "undefined" == typeof console || console.warn(n);
}, invariant = function invariant(e, n) {
  if (!e) throw new Error(n);
});

var prevTime = 0,
    onNextFrame = "undefined" != typeof window && void 0 !== window.requestAnimationFrame ? function (e) {
  return window.requestAnimationFrame(e);
} : function (e) {
  var n = Date.now(),
      r = Math.max(0, 16.7 - (n - prevTime));
  prevTime = n + r, setTimeout(function () {
    return e(prevTime);
  }, r);
},
    createStep = function createStep(t) {
  var i = [],
      A = [],
      o = 0,
      s = !1,
      a = 0,
      c = new WeakSet(),
      l = new WeakSet(),
      u = {
    cancel: function cancel(e) {
      var n = A.indexOf(e);
      c.add(e), -1 !== n && A.splice(n, 1);
    },
    process: function process(e) {
      var n, r;
      if (s = !0, i = (n = [A, i])[0], (A = n[1]).length = 0, o = i.length) for (a = 0; a < o; a++) {
        (r = i[a])(e), !0 !== l.has(r) || c.has(r) || (u.schedule(r), t(!0));
      }
      s = !1;
    },
    schedule: function schedule(e, n, r) {
      void 0 === n && (n = !1), void 0 === r && (r = !1), invariant("function" == typeof e, "Argument must be a function");
      var t = r && s,
          a = t ? i : A;
      c.delete(e), n && l.add(e), -1 === a.indexOf(e) && (a.push(e), t && (o = i.length));
    }
  };
  return u;
},
    StepId;

!function (e) {
  e.Read = "read", e.Update = "update", e.Render = "render", e.PostRender = "postRender", e.FixedUpdate = "fixedUpdate";
}(StepId || (StepId = {}));

var maxElapsed = 40,
    defaultElapsed = 1 / 60 * 1e3,
    useDefaultElapsed = !0,
    willRunNextFrame = !1,
    isProcessing = !1,
    frame = {
  delta: 0,
  timestamp: 0
},
    stepsOrder = [StepId.Read, StepId.Update, StepId.Render, StepId.PostRender],
    setWillRunNextFrame = function setWillRunNextFrame(e) {
  return willRunNextFrame = e;
},
    _a = stepsOrder.reduce(function (e, n) {
  var t = createStep(setWillRunNextFrame);
  return e.sync[n] = function (e, n, r) {
    return void 0 === n && (n = !1), void 0 === r && (r = !1), willRunNextFrame || startLoop(), t.schedule(e, n, r), e;
  }, e.cancelSync[n] = function (e) {
    return t.cancel(e);
  }, e.steps[n] = t, e;
}, {
  steps: {},
  sync: {},
  cancelSync: {}
}),
    steps = _a.steps,
    sync = _a.sync,
    cancelSync = _a.cancelSync,
    processStep = function processStep(e) {
  return steps[e].process(frame);
},
    processFrame = function processFrame(e) {
  willRunNextFrame = !1, frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(e - frame.timestamp, maxElapsed), 1), useDefaultElapsed || (defaultElapsed = frame.delta), frame.timestamp = e, isProcessing = !0, stepsOrder.forEach(processStep), isProcessing = !1, willRunNextFrame && (useDefaultElapsed = !1, onNextFrame(processFrame));
},
    startLoop = function startLoop() {
  useDefaultElapsed = willRunNextFrame = !0, isProcessing || onNextFrame(processFrame);
},
    getFrameData = function getFrameData() {
  return frame;
},
    DEFAULT_OVERSHOOT_STRENGTH = 1.525,
    reversed = function reversed(n) {
  return function (e) {
    return 1 - n(1 - e);
  };
},
    mirrored = function mirrored(n) {
  return function (e) {
    return e <= .5 ? n(2 * e) / 2 : (2 - n(2 * (1 - e))) / 2;
  };
},
    createExpoIn = function createExpoIn(n) {
  return function (e) {
    return Math.pow(e, n);
  };
},
    createBackIn = function createBackIn(n) {
  return function (e) {
    return e * e * ((n + 1) * e - n);
  };
},
    createAnticipateEasing = function createAnticipateEasing(e) {
  var n = createBackIn(e);
  return function (e) {
    return (e *= 2) < 1 ? .5 * n(e) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
  };
},
    linear = function linear(e) {
  return e;
},
    easeIn = createExpoIn(2),
    easeOut = reversed(easeIn),
    easeInOut = mirrored(easeIn),
    circIn = function circIn(e) {
  return 1 - Math.sin(Math.acos(e));
},
    circOut = reversed(circIn),
    circInOut = mirrored(circOut),
    backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH),
    backOut = reversed(backIn),
    backInOut = mirrored(backIn),
    anticipate = createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH),
    NEWTON_ITERATIONS = 8,
    NEWTON_MIN_SLOPE = .001,
    SUBDIVISION_PRECISION = 1e-7,
    SUBDIVISION_MAX_ITERATIONS = 10,
    K_SPLINE_TABLE_SIZE = 11,
    K_SAMPLE_STEP_SIZE = 1 / (K_SPLINE_TABLE_SIZE - 1),
    FLOAT_32_SUPPORTED = "undefined" != typeof Float32Array,
    a = function a(e, n) {
  return 1 - 3 * n + 3 * e;
},
    b = function b(e, n) {
  return 3 * n - 6 * e;
},
    c = function c(e) {
  return 3 * e;
},
    getSlope = function getSlope(e, n, r) {
  return 3 * a(n, r) * e * e + 2 * b(n, r) * e + c(n);
},
    calcBezier = function calcBezier(e, n, r) {
  return ((a(n, r) * e + b(n, r)) * e + c(n)) * e;
};

function cubicBezier(o, n, s, r) {
  function t(e) {
    for (var n, r, t, a = 0, i = 1, A = K_SPLINE_TABLE_SIZE - 1; i !== A && c[i] <= e; ++i) {
      a += K_SAMPLE_STEP_SIZE;
    }

    return n = (e - c[--i]) / (c[i + 1] - c[i]), t = getSlope(r = a + n * K_SAMPLE_STEP_SIZE, o, s), NEWTON_MIN_SLOPE <= t ? function (e, n) {
      for (var r = 0, t = 0; r < NEWTON_ITERATIONS; ++r) {
        if (0 === (t = getSlope(n, o, s))) return n;
        n -= (calcBezier(n, o, s) - e) / t;
      }

      return n;
    }(e, r) : 0 === t ? r : function (e, n, r) {
      for (var t, a, i = 0; 0 < (t = calcBezier(a = n + (r - n) / 2, o, s) - e) ? r = a : n = a, Math.abs(t) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS;) {
        ;
      }

      return a;
    }(e, a, a + K_SAMPLE_STEP_SIZE);
  }

  var c = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
  !function () {
    for (var e = 0; e < K_SPLINE_TABLE_SIZE; ++e) {
      c[e] = calcBezier(e * K_SAMPLE_STEP_SIZE, o, s);
    }
  }();
  return function (e) {
    return o === n && s === r ? e : 0 === e ? 0 : 1 === e ? 1 : calcBezier(t(e), n, r);
  };
}

var zeroPoint = {
  x: 0,
  y: 0,
  z: 0
},
    isNum = function isNum(e) {
  return "number" == typeof e;
},
    radiansToDegrees = function radiansToDegrees(e) {
  return 180 * e / Math.PI;
},
    angle = function angle(e, n) {
  return void 0 === n && (n = zeroPoint), radiansToDegrees(Math.atan2(n.y - e.y, n.x - e.x));
},
    applyOffset = function applyOffset(n, r) {
  var t = !0;
  return void 0 === r && (r = n, t = !1), function (e) {
    return t ? e - n + r : (n = e, t = !0, r);
  };
},
    curryRange = function curryRange(t) {
  return function (n, r, e) {
    return void 0 !== e ? t(n, r, e) : function (e) {
      return t(n, r, e);
    };
  };
},
    clamp$1 = function clamp$1(e, n, r) {
  return Math.min(Math.max(r, e), n);
},
    clamp$1$1 = curryRange(clamp$1),
    conditional = function conditional(n, r) {
  return function (e) {
    return n(e) ? r(e) : e;
  };
},
    isPoint = function isPoint(e) {
  return e.hasOwnProperty("x") && e.hasOwnProperty("y");
},
    isPoint3D = function isPoint3D(e) {
  return isPoint(e) && e.hasOwnProperty("z");
},
    distance1D = function distance1D(e, n) {
  return Math.abs(e - n);
},
    distance = function distance(e, n) {
  if (void 0 === n && (n = zeroPoint), isNum(e) && isNum(n)) return distance1D(e, n);

  if (isPoint(e) && isPoint(n)) {
    var r = distance1D(e.x, n.x),
        t = distance1D(e.y, n.y),
        a = isPoint3D(e) && isPoint3D(n) ? distance1D(e.z, n.z) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(t, 2) + Math.pow(a, 2));
  }

  return 0;
},
    progress = function progress(e, n, r) {
  var t = n - e;
  return 0 == t ? 1 : (r - e) / t;
},
    mix = function mix(e, n, r) {
  return -r * e + r * n + e;
},
    _assign$2 = function __assign$2() {
  return (_assign$2 = Object.assign || function (e) {
    for (var n, r = 1, t = arguments.length; r < t; r++) {
      for (var a in n = arguments[r]) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    mixLinearColor = function mixLinearColor(e, n, r) {
  var t = e * e,
      a = n * n;
  return Math.sqrt(Math.max(0, r * (a - t) + t));
},
    colorTypes = [hex, rgba, hsla],
    getColorType = function getColorType(n) {
  return colorTypes.find(function (e) {
    return e.test(n);
  });
},
    notAnimatable = function notAnimatable(e) {
  return "'" + e + "' is not an animatable color. Use the equivalent color code instead.";
},
    mixColor = function mixColor(e, n) {
  var r = getColorType(e),
      t = getColorType(n);
  invariant(!!r, notAnimatable(e)), invariant(!!t, notAnimatable(n)), invariant(r.transform === t.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");

  var a = r.parse(e),
      i = t.parse(n),
      A = _assign$2({}, a),
      o = r === hsla ? mix : mixLinearColor;

  return function (e) {
    for (var n in A) {
      "alpha" !== n && (A[n] = o(a[n], i[n], e));
    }

    return A.alpha = mix(a.alpha, i.alpha, e), r.transform(A);
  };
},
    combineFunctions = function combineFunctions(n, r) {
  return function (e) {
    return r(n(e));
  };
},
    pipe = function pipe() {
  for (var e = [], n = 0; n < arguments.length; n++) {
    e[n] = arguments[n];
  }

  return e.reduce(combineFunctions);
};

function getMixer(n, r) {
  return isNum(n) ? function (e) {
    return mix(n, r, e);
  } : color.test(n) ? mixColor(n, r) : mixComplex(n, r);
}

var mixArray = function mixArray(e, r) {
  var t = e.slice(),
      a = t.length,
      i = e.map(function (e, n) {
    return getMixer(e, r[n]);
  });
  return function (e) {
    for (var n = 0; n < a; n++) {
      t[n] = i[n](e);
    }

    return t;
  };
},
    mixObject = function mixObject(e, n) {
  var r = _assign$2({}, e, n),
      t = {};

  for (var a in r) {
    void 0 !== e[a] && void 0 !== n[a] && (t[a] = getMixer(e[a], n[a]));
  }

  return function (e) {
    for (var n in t) {
      r[n] = t[n](e);
    }

    return r;
  };
};

function analyse(e) {
  for (var n = complex.parse(e), r = n.length, t = 0, a = 0, i = 0, A = 0; A < r; A++) {
    t || "number" == typeof n[A] ? t++ : void 0 !== n[A].hue ? i++ : a++;
  }

  return {
    parsed: n,
    numNumbers: t,
    numRGB: a,
    numHSL: i
  };
}

var mixComplex = function mixComplex(e, n) {
  var r = complex.createTransformer(n),
      t = analyse(e),
      a = analyse(n);
  return invariant(t.numHSL === a.numHSL && t.numRGB === a.numRGB && t.numNumbers >= a.numNumbers, "Complex values '" + e + "' and '" + n + "' too different to mix. Ensure all colors are of the same type."), pipe(mixArray(t.parsed, a.parsed), r);
},
    mixNumber = function mixNumber(n, r) {
  return function (e) {
    return mix(n, r, e);
  };
};

function detectMixerFactory(e) {
  return "number" == typeof e ? mixNumber : "string" == typeof e ? color.test(e) ? mixColor : mixComplex : Array.isArray(e) ? mixArray : "object" == typeof e ? mixObject : void 0;
}

function createMixers(e, n, r) {
  for (var t = [], a = r || detectMixerFactory(e[0]), i = e.length - 1, A = 0; A < i; A++) {
    var o = a(e[A], e[A + 1]);

    if (n) {
      var s = Array.isArray(n) ? n[A] : n;
      o = pipe(s, o);
    }

    t.push(o);
  }

  return t;
}

function fastInterpolate(e, n) {
  var r = e[0],
      t = e[1],
      a = n[0];
  return function (e) {
    return a(progress(r, t, e));
  };
}

function slowInterpolate(i, A) {
  var o = i.length,
      s = o - 1;
  return function (e) {
    var n = 0,
        r = !1;

    if (e <= i[0] ? r = !0 : e >= i[s] && (n = s - 1, r = !0), !r) {
      for (var t = 1; t < o && !(i[t] > e || t === s); t++) {
        ;
      }

      n = t - 1;
    }

    var a = progress(i[n], i[n + 1], e);
    return A[n](a);
  };
}

function interpolate$$1(e, n, r) {
  var t = void 0 === r ? {} : r,
      a = t.clamp,
      i = void 0 === a || a,
      A = t.ease,
      o = t.mixer,
      s = e.length;
  invariant(s === n.length, "Both input and output ranges must be the same length"), invariant(!A || !Array.isArray(A) || A.length === s - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[s - 1] && (e = [].concat(e), n = [].concat(n), e.reverse(), n.reverse());
  var c = createMixers(n, A, o),
      l = 2 === s ? fastInterpolate(e, c) : slowInterpolate(e, c);
  return i ? pipe(clamp$1$1(e[0], e[s - 1]), l) : l;
}

var toDecimal = function toDecimal(e, n) {
  return void 0 === n && (n = 2), n = Math.pow(10, n), Math.round(e * n) / n;
},
    smoothFrame = function smoothFrame(e, n, r, t) {
  return void 0 === t && (t = 0), toDecimal(e + r * (n - e) / Math.max(t, r));
},
    smooth = function smooth(a) {
  void 0 === a && (a = 50);
  var i = 0,
      A = 0;
  return function (e) {
    var n = getFrameData().timestamp,
        r = n !== A ? n - A : 0,
        t = r ? smoothFrame(i, e, r, a) : i;
    return A = n, i = t;
  };
},
    snap = function snap(a) {
  if ("number" == typeof a) return function (e) {
    return Math.round(e / a) * a;
  };
  var i = 0,
      A = a.length;
  return function (e) {
    var n = Math.abs(a[0] - e);

    for (i = 1; i < A; i++) {
      var r = a[i],
          t = Math.abs(r - e);
      if (0 === t) return r;
      if (n < t) return a[i - 1];
      if (i === A - 1) return r;
      n = t;
    }
  };
},
    identity = function identity(e) {
  return e;
},
    springForce = function springForce(i) {
  return void 0 === i && (i = identity), curryRange(function (e, n, r) {
    var t = n - r,
        a = -(0 - e + 1) * (0 - i(Math.abs(t)));
    return t <= 0 ? n + a : n - a;
  });
},
    springForceLinear = springForce(),
    springForceExpo = springForce(Math.sqrt),
    velocityPerFrame = function velocityPerFrame(e, n) {
  return isNum(e) ? e / (1e3 / n) : 0;
},
    velocityPerSecond = function velocityPerSecond(e, n) {
  return n ? e * (1e3 / n) : 0;
},
    wrap = function wrap(e, n, r) {
  var t = n - e;
  return ((r - e) % t + t) % t + e;
},
    wrap$1 = curryRange(wrap),
    clampProgress = clamp$1$1(0, 1),
    _assign$3 = function __assign$3() {
  return (_assign$3 = Object.assign || function (e) {
    for (var n, r = 1, t = arguments.length; r < t; r++) {
      for (var a in n = arguments[r]) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function __rest$1(e, n) {
  var r = {};

  for (var t in e) {
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (r[t] = e[t]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (t = Object.getOwnPropertySymbols(e); a < t.length; a++) {
      n.indexOf(t[a]) < 0 && (r[t[a]] = e[t[a]]);
    }
  }

  return r;
}

var createStyler = function createStyler(e) {
  var r = e.onRead,
      n = e.onRender,
      t = e.uncachedValues,
      c = void 0 === t ? new Set() : t,
      a = e.useCache,
      l = void 0 === a || a;
  return function (e) {
    void 0 === e && (e = {});

    var t = __rest$1(e, []),
        a = {},
        i = [],
        A = !1;

    function o(e, n) {
      e.startsWith("--") && (t.hasCSSVariable = !0);
      var r = a[e];
      a[e] = n, a[e] !== r && (-1 === i.indexOf(e) && i.push(e), A || (A = !0, sync.render(s.render)));
    }

    var s = {
      get: function get(e, n) {
        return void 0 === n && (n = !1), !n && l && !c.has(e) && void 0 !== a[e] ? a[e] : r(e, t);
      },
      set: function set(e, n) {
        if ("string" == typeof e) o(e, n);else for (var r in e) {
          o(r, e[r]);
        }
        return this;
      },
      render: function render(e) {
        return void 0 === e && (e = !1), !A && !0 !== e || (n(a, t, i), A = !1, i.length = 0), this;
      }
    };
    return s;
  };
},
    CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g,
    REPLACE_TEMPLATE = "$1-$2",
    camelToDash = function camelToDash(e) {
  return e.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
},
    setDomAttrs = function setDomAttrs(e, n) {
  for (var r in n) {
    n.hasOwnProperty(r) && e.setAttribute(r, n[r]);
  }
},
    camelCache = new Map(),
    dashCache = new Map(),
    prefixes = ["Webkit", "Moz", "O", "ms", ""],
    numPrefixes = prefixes.length,
    isBrowser = "undefined" != typeof document,
    testElement,
    setDashPrefix = function setDashPrefix(e, n) {
  return dashCache.set(e, camelToDash(n));
},
    testPrefix = function testPrefix(e) {
  testElement = testElement || document.createElement("div");

  for (var n = 0; n < numPrefixes; n++) {
    var r = prefixes[n],
        t = "" === r,
        a = t ? e : r + e.charAt(0).toUpperCase() + e.slice(1);
    (a in testElement.style || t) && (camelCache.set(e, a), setDashPrefix(e, (t ? "" : "-") + camelToDash(a)));
  }
},
    setServerProperty = function setServerProperty(e) {
  return setDashPrefix(e, e);
},
    prefixer = function prefixer(e, n) {
  void 0 === n && (n = !1);
  var r = n ? dashCache : camelCache;
  return r.has(e) || (isBrowser ? testPrefix(e) : setServerProperty(e)), r.get(e) || e;
},
    axes = ["", "X", "Y", "Z"],
    order = ["scale", "rotate", "skew", "transformPerspective"],
    transformProps = order.reduce(function (e, r) {
  return axes.reduce(function (e, n) {
    return e.push(r + n), e;
  }, e);
}, ["x", "y", "z"]),
    transformPropDictionary = transformProps.reduce(function (e, n) {
  return e[n] = !0, e;
}, {});

function isTransformProp(e) {
  return !0 === transformPropDictionary[e];
}

function sortTransformProps(e, n) {
  return transformProps.indexOf(e) - transformProps.indexOf(n);
}

var transformOriginProps = new Set(["originX", "originY", "originZ"]);

function isTransformOriginProp(e) {
  return transformOriginProps.has(e);
}

var rounded = _assign$3({}, number, {
  transform: Math.round
}),
    valueTypes = {
  color: color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale: scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  zIndex: rounded
},
    getValueType = function getValueType(e) {
  return valueTypes[e];
},
    getValueAsType = function getValueAsType(e, n) {
  return n && "number" == typeof e ? n.transform(e) : e;
},
    SCROLL_LEFT = "scrollLeft",
    SCROLL_TOP = "scrollTop",
    scrollKeys = new Set([SCROLL_LEFT, SCROLL_TOP]),
    blacklist = new Set([SCROLL_LEFT, SCROLL_TOP, "transform"]),
    translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
};

function isCustomTemplate(e) {
  return "function" == typeof e;
}

function buildTransform(e, n, r, t, a) {
  var i = "",
      A = !1;
  r.sort(sortTransformProps);

  for (var o = r.length, s = 0; s < o; s++) {
    var c = r[s];
    i += (translateAlias[c] || c) + "(" + n[c] + ") ", A = "z" === c || A;
  }

  return !A && a ? i += "translateZ(0)" : i = i.trim(), isCustomTemplate(e.transform) ? i = e.transform(n, i) : t && (i = "none"), i;
}

function buildStyleProperty(e, n, r, t, a, i, A) {
  void 0 === n && (n = !0), void 0 === r && (r = {}), void 0 === t && (t = {}), void 0 === a && (a = {}), void 0 === i && (i = []), void 0 === A && (A = !1);
  var o = !0,
      s = !1,
      c = !1;

  for (var l in e) {
    var u = e[l],
        _ = getValueType(l),
        d = getValueAsType(u, _);

    isTransformProp(l) ? (s = !0, t[l] = d, i.push(l), o && (_.default && u !== _.default || !_.default && 0 !== u) && (o = !1)) : isTransformOriginProp(l) ? (a[l] = d, c = !0) : blacklist.has(l) && isCustomTemplate(d) || (r[prefixer(l, A)] = d);
  }

  return !s && "function" != typeof e.transform || (r.transform = buildTransform(e, t, i, o, n)), c && (r.transformOrigin = (a.originX || 0) + " " + (a.originY || 0) + " " + (a.originZ || 0)), r;
}

function createStyleBuilder(n) {
  void 0 === n && (n = !0);
  var r = {},
      t = {},
      a = {},
      i = [];
  return function (e) {
    return i.length = 0, buildStyleProperty(e, n, r, t, a, i, !0), r;
  };
}

function onRead(e, n) {
  var r = n.element,
      t = n.preparseOutput,
      a = getValueType(e);
  if (isTransformProp(e)) return a && a.default || 0;
  if (scrollKeys.has(e)) return r[e];
  var i = window.getComputedStyle(r, null).getPropertyValue(prefixer(e, !0)) || 0;
  return t && a && a.test(i) && a.parse ? a.parse(i) : i;
}

function onRender(e, n, r) {
  var t = n.element,
      a = n.buildStyles,
      i = n.hasCSSVariable;
  if (Object.assign(t.style, a(e)), i) for (var A = r.length, o = 0; o < A; o++) {
    var s = r[o];
    s.startsWith("--") && t.style.setProperty(s, e[s]);
  }
  -1 !== r.indexOf(SCROLL_LEFT) && (t[SCROLL_LEFT] = e[SCROLL_LEFT]), -1 !== r.indexOf(SCROLL_TOP) && (t[SCROLL_TOP] = e[SCROLL_TOP]);
}

var cssStyler = createStyler({
  onRead: onRead,
  onRender: onRender,
  uncachedValues: scrollKeys
});

function createCssStyler(e, n) {
  void 0 === n && (n = {});

  var r = n.enableHardwareAcceleration,
      t = __rest$1(n, ["enableHardwareAcceleration"]);

  return cssStyler(_assign$3({
    element: e,
    buildStyles: createStyleBuilder(r),
    preparseOutput: !0
  }, t));
}

var camelCaseAttributes = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues"]),
    ZERO_NOT_ZERO = 1e-7,
    progressToPixels = function progressToPixels(e, n) {
  return e * n + "px";
},
    build = function build(e, n, r, t) {
  var a = !1,
      i = !1,
      A = {},
      o = r ? {
    pathLength: "0",
    pathSpacing: "" + t
  } : void 0,
      s = void 0 !== e.scale ? e.scale || ZERO_NOT_ZERO : e.scaleX || 1,
      c = void 0 !== e.scaleY ? e.scaleY || ZERO_NOT_ZERO : s || 1,
      l = n.width * (e.originX || 50) + n.x,
      u = n.height * (e.originY || 50) + n.y,
      _ = 1 * s * -l,
      d = 1 * c * -u,
      p = l / s,
      m = u / c,
      g = {
    translate: "translate(" + e.x + ", " + e.y + ") ",
    scale: "translate(" + _ + ", " + d + ") scale(" + s + ", " + c + ") translate(" + p + ", " + m + ") ",
    rotate: "rotate(" + e.rotate + ", " + l + ", " + u + ") ",
    skewX: "skewX(" + e.skewX + ") ",
    skewY: "skewY(" + e.skewY + ") "
  };

  for (var h in e) {
    if (e.hasOwnProperty(h)) {
      var B = e[h];
      if (isTransformProp(h)) a = !0;else if (!r || "pathLength" !== h && "pathSpacing" !== h || "number" != typeof B) {
        if (r && "pathOffset" === h) A["stroke-dashoffset"] = progressToPixels(-B, t);else {
          A[camelCaseAttributes.has(h) ? h : camelToDash(h)] = B;
        }
      } else i = !0, o[h] = progressToPixels(B, t);
    }
  }

  if (i && (A["stroke-dasharray"] = o.pathLength + " " + o.pathSpacing), a) for (var h in A.transform = "", g) {
    if (g.hasOwnProperty(h)) {
      var f = "scale" === h ? "1" : "0";
      A.transform += g[h].replace(/undefined/g, f);
    }
  }
  return A;
},
    int = _assign$3({}, number, {
  transform: Math.round
}),
    valueTypes$1 = {
  fill: color,
  stroke: color,
  scale: scale,
  scaleX: scale,
  scaleY: scale,
  opacity: alpha,
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
},
    getValueType$1 = function getValueType$1(e) {
  return valueTypes$1[e];
},
    getDimensions = function getDimensions(e) {
  return "function" == typeof e.getBBox ? e.getBBox() : e.getBoundingClientRect();
},
    getSVGElementDimensions = function getSVGElementDimensions(e) {
  try {
    return getDimensions(e);
  } catch (e) {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
},
    svgStyler = createStyler({
  onRead: function onRead(e, n) {
    var r = n.element;

    if (isTransformProp(e)) {
      var t = getValueType$1(e);
      return t ? t.default : 0;
    }

    return r.getAttribute(e);
  },
  onRender: function onRender(e, n) {
    var r = n.dimensions,
        t = n.element,
        a = n.isPath,
        i = n.pathLength;
    setDomAttrs(t, build(e, r, a, i));
  }
}),
    svg = function svg(e) {
  var n = {
    element: e,
    dimensions: getSVGElementDimensions(e),
    isPath: !1
  };
  return "path" === e.tagName && (n.isPath = !0, n.pathLength = e.getTotalLength()), svgStyler(n);
},
    viewport = createStyler({
  useCache: !1,
  onRead: function onRead(e) {
    return "scrollTop" === e ? window.pageYOffset : window.pageXOffset;
  },
  onRender: function onRender(e) {
    var n = e.scrollTop,
        r = void 0 === n ? 0 : n,
        t = e.scrollLeft,
        a = void 0 === t ? 0 : t;
    return window.scrollTo(a, r);
  }
}),
    cache = new WeakMap(),
    createDOMStyler = function createDOMStyler(e, n) {
  var r;
  return e instanceof HTMLElement ? r = createCssStyler(e, n) : e instanceof SVGElement ? r = svg(e) : e === window && (r = viewport(e)), invariant(void 0 !== r, "No valid node provided. Node must be HTMLElement, SVGElement or window."), cache.set(e, r), r;
},
    getStyler = function getStyler(e, n) {
  return cache.has(e) ? cache.get(e) : createDOMStyler(e, n);
};

function index(e, n) {
  var r = "string" == typeof e ? document.querySelector(e) : e;
  return getStyler(r, n);
}

var Chainable = function () {
  function e(e) {
    void 0 === e && (e = {}), this.props = e;
  }

  return e.prototype.applyMiddleware = function (e) {
    return this.create(_assign({}, this.props, {
      middleware: this.props.middleware ? [e].concat(this.props.middleware) : [e]
    }));
  }, e.prototype.pipe = function () {
    for (var e = [], n = 0; n < arguments.length; n++) {
      e[n] = arguments[n];
    }

    var r = 1 === e.length ? e[0] : pipe.apply(void 0, e);
    return this.applyMiddleware(function (n) {
      return function (e) {
        return n(r(e));
      };
    });
  }, e.prototype.while = function (t) {
    return this.applyMiddleware(function (n, r) {
      return function (e) {
        return t(e) ? n(e) : r();
      };
    });
  }, e.prototype.filter = function (r) {
    return this.applyMiddleware(function (n) {
      return function (e) {
        return r(e) && n(e);
      };
    });
  }, e;
}(),
    Observer = function () {
  return function (e, n) {
    var r = e.middleware,
        t = e.onComplete,
        a = this;
    this.isActive = !0, this.update = function (e) {
      a.observer.update && a.updateObserver(e);
    }, this.complete = function () {
      a.observer.complete && a.isActive && a.observer.complete(), a.onComplete && a.onComplete(), a.isActive = !1;
    }, this.error = function (e) {
      a.observer.error && a.isActive && a.observer.error(e), a.isActive = !1;
    }, this.observer = n, this.updateObserver = function (e) {
      return n.update(e);
    }, this.onComplete = t, n.update && r && r.length && r.forEach(function (e) {
      return a.updateObserver = e(a.updateObserver, a.complete);
    });
  };
}(),
    createObserver = function createObserver(e, n, r) {
  var t = n.middleware;
  return new Observer({
    middleware: t,
    onComplete: r
  }, "function" == typeof e ? {
    update: e
  } : e);
},
    Action = function (e) {
  function n() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(n, e), n.prototype.create = function (e) {
    return new n(e);
  }, n.prototype.start = function (e) {
    void 0 === e && (e = {});

    var n = !1,
        r = {
      stop: function stop() {}
    },
        t = this.props,
        a = t.init,
        i = __rest(t, ["init"]),
        A = a(createObserver(e, i, function () {
      n = !0, r.stop();
    }));

    return r = A ? _assign({}, r, A) : r, e.registerParent && e.registerParent(r), n && r.stop(), r;
  }, n;
}(Chainable),
    action = function action(e) {
  return new Action({
    init: e
  });
},
    BaseMulticast = function (n) {
  function e() {
    var e = null !== n && n.apply(this, arguments) || this;
    return e.subscribers = [], e;
  }

  return __extends(e, n), e.prototype.complete = function () {
    this.subscribers.forEach(function (e) {
      return e.complete();
    });
  }, e.prototype.error = function (n) {
    this.subscribers.forEach(function (e) {
      return e.error(n);
    });
  }, e.prototype.update = function (e) {
    for (var n = 0; n < this.subscribers.length; n++) {
      this.subscribers[n].update(e);
    }
  }, e.prototype.subscribe = function (e) {
    var n = this,
        r = createObserver(e, this.props);
    return this.subscribers.push(r), {
      unsubscribe: function unsubscribe() {
        var e = n.subscribers.indexOf(r);
        -1 !== e && n.subscribers.splice(e, 1);
      }
    };
  }, e.prototype.stop = function () {
    this.parent && this.parent.stop();
  }, e.prototype.registerParent = function (e) {
    this.stop(), this.parent = e;
  }, e;
}(Chainable),
    stepProgress = function stepProgress(e, n) {
  var r = 1 / (e - 1),
      t = 1 / (2 * (e - 1)),
      a = Math.min(n, 1) / t;
  return Math.floor((1 + a) / 2) * r;
},
    isValueList = function isValueList(e) {
  return Array.isArray(e);
},
    isSingleValue = function isSingleValue(e) {
  var n = typeof e;
  return "string" == n || "number" == n;
},
    ValueReaction = function (a) {
  function n(e) {
    var r = a.call(this, e) || this;
    return r.scheduleVelocityCheck = function () {
      return sync.postRender(r.velocityCheck);
    }, r.velocityCheck = function (e) {
      e.timestamp !== r.lastUpdated && (r.prev = r.current);
    }, r.prev = r.current = e.value || 0, isSingleValue(r.current) ? (r.updateCurrent = function (e) {
      return r.current = e;
    }, r.getVelocityOfCurrent = function () {
      return r.getSingleVelocity(r.current, r.prev);
    }) : isValueList(r.current) ? (r.updateCurrent = function (e) {
      return r.current = e.slice();
    }, r.getVelocityOfCurrent = function () {
      return r.getListVelocity();
    }) : (r.updateCurrent = function (e) {
      for (var n in r.current = {}, e) {
        e.hasOwnProperty(n) && (r.current[n] = e[n]);
      }
    }, r.getVelocityOfCurrent = function () {
      return r.getMapVelocity();
    }), e.initialSubscription && r.subscribe(e.initialSubscription), r;
  }

  return __extends(n, a), n.prototype.create = function (e) {
    return new n(e);
  }, n.prototype.get = function () {
    return this.current;
  }, n.prototype.getVelocity = function () {
    return this.getVelocityOfCurrent();
  }, n.prototype.update = function (e) {
    a.prototype.update.call(this, e), this.prev = this.current, this.updateCurrent(e);
    var n = getFrameData(),
        r = n.delta,
        t = n.timestamp;
    this.timeDelta = r, this.lastUpdated = t, sync.postRender(this.scheduleVelocityCheck);
  }, n.prototype.subscribe = function (e) {
    var n = a.prototype.subscribe.call(this, e);
    return this.subscribers[this.subscribers.length - 1].update(this.current), n;
  }, n.prototype.getSingleVelocity = function (e, n) {
    return "number" == typeof e && "number" == typeof n ? velocityPerSecond(e - n, this.timeDelta) : velocityPerSecond(parseFloat(e) - parseFloat(n), this.timeDelta) || 0;
  }, n.prototype.getListVelocity = function () {
    var r = this;
    return this.current.map(function (e, n) {
      return r.getSingleVelocity(e, r.prev[n]);
    });
  }, n.prototype.getMapVelocity = function () {
    var e = {};

    for (var n in this.current) {
      this.current.hasOwnProperty(n) && (e[n] = this.getSingleVelocity(this.current[n], this.prev[n]));
    }

    return e;
  }, n;
}(BaseMulticast),
    value = function value(e, n) {
  return new ValueReaction({
    value: e,
    initialSubscription: n
  });
},
    multi = function multi(e) {
  var l = e.getCount,
      u = e.getFirst,
      _ = e.getOutput,
      d = e.mapApi,
      p = e.setProp,
      m = e.startActions;
  return function (c) {
    return action(function (e) {
      function t() {
        return n(o);
      }

      var n = e.update,
          a = e.complete,
          i = e.error,
          A = l(c),
          o = _(),
          s = 0,
          r = m(c, function (e, n) {
        var r = !1;
        return e.start({
          complete: function complete() {
            r || (r = !0, ++s === A && sync.update(a));
          },
          error: i,
          update: function update(e) {
            p(o, n, e), sync.update(t, !1, !0);
          }
        });
      });

      return Object.keys(u(r)).reduce(function (e, n) {
        return e[n] = d(r, n), e;
      }, {});
    });
  };
},
    composite = multi({
  getOutput: function getOutput() {
    return {};
  },
  getCount: function getCount(e) {
    return Object.keys(e).length;
  },
  getFirst: function getFirst(e) {
    return e[Object.keys(e)[0]];
  },
  mapApi: function mapApi(a, i) {
    return function () {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      return Object.keys(a).reduce(function (e, n) {
        var r;
        return a[n][i] && (t[0] && void 0 !== t[0][n] ? e[n] = a[n][i](t[0][n]) : e[n] = (r = a[n])[i].apply(r, t)), e;
      }, {});
    };
  },
  setProp: function setProp(e, n, r) {
    return e[n] = r;
  },
  startActions: function startActions(r, t) {
    return Object.keys(r).reduce(function (e, n) {
      return e[n] = t(r[n], n), e;
    }, {});
  }
}),
    parallel = multi({
  getOutput: function getOutput() {
    return [];
  },
  getCount: function getCount(e) {
    return e.length;
  },
  getFirst: function getFirst(e) {
    return e[0];
  },
  mapApi: function mapApi(n, t) {
    return function () {
      for (var r = [], e = 0; e < arguments.length; e++) {
        r[e] = arguments[e];
      }

      return n.map(function (e, n) {
        if (e[t]) return Array.isArray(r[0]) ? e[t](r[0][n]) : e[t].apply(e, r);
      });
    };
  },
  setProp: function setProp(e, n, r) {
    return e[n] = r;
  },
  startActions: function startActions(e, r) {
    return e.map(function (e, n) {
      return r(e, n);
    });
  }
}),
    parallel$1 = function parallel$1() {
  for (var e = [], n = 0; n < arguments.length; n++) {
    e[n] = arguments[n];
  }

  return parallel(e);
},
    createVectorTests = function createVectorTests(r) {
  function t(e, n) {
    return void 0 !== e && !r[n](e);
  }

  var e = Object.keys(r);
  return {
    getVectorKeys: function getVectorKeys(r) {
      return e.reduce(function (e, n) {
        return t(r[n], n) && e.push(n), e;
      }, []);
    },
    testVectorProps: function testVectorProps(n) {
      return n && e.some(function (e) {
        return t(n[e], e);
      });
    }
  };
},
    unitTypes = [px, percent, degrees, vh, vw],
    findUnitType = function findUnitType(n) {
  return unitTypes.find(function (e) {
    return e.test(n);
  });
},
    isUnitProp = function isUnitProp(e) {
  return Boolean(findUnitType(e));
},
    createAction = function createAction(e, n) {
  return e(n);
},
    reduceArrayValue = function reduceArrayValue(r) {
  return function (e, n) {
    return e[n] = e[n][r], e;
  };
},
    createArrayAction = function createArrayAction(t, a, i) {
  var e = i[0],
      n = a[e].map(function (e, n) {
    var r = i.reduce(reduceArrayValue(n), _assign({}, a));
    return getActionCreator(e)(t, r);
  });
  return parallel$1.apply(void 0, n);
},
    reduceObjectValue = function reduceObjectValue(r) {
  return function (e, n) {
    return e[n] = e[n][r], e;
  };
},
    createObjectAction = function createObjectAction(t, a, i) {
  var A = i[0],
      e = Object.keys(a[A]).reduce(function (e, n) {
    var r = i.reduce(reduceObjectValue(n), _assign({}, a));
    return e[n] = getActionCreator(a[A][n])(t, r), e;
  }, {});
  return composite(e);
},
    createUnitAction = function createUnitAction(e, n) {
  var r = n.from,
      t = n.to,
      a = __rest(n, ["from", "to"]),
      i = findUnitType(r) || findUnitType(t),
      A = i.transform,
      o = i.parse;

  return e(_assign({}, a, {
    from: "string" == typeof r ? o(r) : r,
    to: "string" == typeof t ? o(t) : t
  })).pipe(A);
},
    createMixerAction = function createMixerAction(i) {
  return function (e, n) {
    var r = n.from,
        t = n.to,
        a = __rest(n, ["from", "to"]);

    return e(_assign({}, a, {
      from: 0,
      to: 1
    })).pipe(i(r, t));
  };
},
    createColorAction = createMixerAction(mixColor),
    createComplexAction = createMixerAction(mixComplex),
    createVectorAction = function createVectorAction(t, e) {
  var n = createVectorTests(e),
      a = n.testVectorProps,
      i = n.getVectorKeys;
  return function (e) {
    if (!a(e)) return t(e);
    var n = i(e),
        r = e[n[0]];
    return getActionCreator(r)(t, e, n);
  };
},
    getActionCreator = function getActionCreator(e) {
  return "number" == typeof e ? createAction : Array.isArray(e) ? createArrayAction : isUnitProp(e) ? createUnitAction : color.test(e) ? createColorAction : complex.test(e) ? createComplexAction : "object" == typeof e ? createObjectAction : createAction;
},
    decay = function decay(f) {
  return void 0 === f && (f = {}), action(function (e) {
    var a = e.complete,
        i = e.update,
        n = f.velocity,
        r = void 0 === n ? 0 : n,
        t = f.from,
        A = void 0 === t ? 0 : t,
        o = f.power,
        s = void 0 === o ? .8 : o,
        c = f.timeConstant,
        l = void 0 === c ? 350 : c,
        u = f.restDelta,
        _ = void 0 === u ? .5 : u,
        d = f.modifyTarget,
        p = 0,
        m = s * r,
        g = Math.round(A + m),
        h = void 0 === d ? g : d(g),
        B = sync.update(function (e) {
      var n = e.delta;
      p += n;
      var r = -m * Math.exp(-p / l),
          t = _ < r || r < -_;
      i(t ? h + r : h), t || (cancelSync.update(B), a());
    }, !0);

    return {
      stop: function stop() {
        return cancelSync.update(B);
      }
    };
  });
},
    vectorDecay = createVectorAction(decay, {
  from: number.test,
  modifyTarget: function modifyTarget(e) {
    return "function" == typeof e;
  },
  velocity: number.test
}),
    spring = function spring(y) {
  return void 0 === y && (y = {}), action(function (e) {
    var s = e.update,
        c = e.complete,
        n = y.velocity,
        l = void 0 === n ? 0 : n,
        r = y.from,
        t = void 0 === r ? 0 : r,
        a = y.to,
        u = void 0 === a ? 0 : a,
        i = y.stiffness,
        _ = void 0 === i ? 100 : i,
        A = y.damping,
        d = void 0 === A ? 10 : A,
        o = y.mass,
        p = void 0 === o ? 1 : o,
        m = y.restSpeed,
        g = void 0 === m ? .01 : m,
        h = y.restDelta,
        B = void 0 === h ? .01 : h,
        f = l ? -l / 1e3 : 0,
        C = 0,
        b = u - t,
        E = t,
        w = E,
        v = sync.update(function (e) {
      var n = e.delta;
      C += n;
      var r = d / (2 * Math.sqrt(_ * p)),
          t = Math.sqrt(_ / p) / 1e3;

      if (w = E, r < 1) {
        var a = Math.exp(-r * t * C),
            i = t * Math.sqrt(1 - r * r);
        E = u - a * ((f + r * t * b) / i * Math.sin(i * C) + b * Math.cos(i * C));
      } else {
        a = Math.exp(-t * C);
        E = u - a * (b + (f + t * b) * C);
      }

      l = velocityPerSecond(E - w, n);
      var A = Math.abs(l) <= g,
          o = Math.abs(u - E) <= B;
      A && o ? (s(E = u), cancelSync.update(v), c()) : s(E);
    }, !0);

    return {
      stop: function stop() {
        return cancelSync.update(v);
      }
    };
  });
},
    vectorSpring = createVectorAction(spring, {
  from: number.test,
  to: number.test,
  stiffness: number.test,
  damping: number.test,
  mass: number.test,
  velocity: number.test
}),
    scrubber = function scrubber(e) {
  var n = e.from,
      r = void 0 === n ? 0 : n,
      t = e.to,
      a = void 0 === t ? 1 : t,
      i = e.ease,
      A = void 0 === i ? linear : i;
  return action(function (e) {
    var n = e.update;
    return {
      seek: function seek(e) {
        return n(e);
      }
    };
  }).pipe(A, function (e) {
    return mix(r, a, e);
  });
},
    vectorScrubber = createVectorAction(scrubber, {
  ease: function ease(e) {
    return "function" == typeof e;
  },
  from: number.test,
  to: number.test
}),
    clampProgress$1 = clamp$1$1(0, 1),
    tween = function tween(L) {
  return void 0 === L && (L = {}), action(function (e) {
    function t() {
      if (c < w) w -= 2 * (w - c);else if (w < 0) {
        w += 2 * (-1 * w);
      }
      y *= -1;
    }

    function r() {
      D = clampProgress$1(progress(0, c, w)), M.seek(D);
    }

    function n() {
      O = !0, i = sync.update(function (e) {
        var n = e.delta;
        w += n * y, r(), function () {
          var e,
              n = 1 === y ? O && c <= w : O && w <= 0;
          if (!n) return !1;
          if (n && !m && !d && !h) return !0;
          var r = !1;
          return m && F < m ? (w = c - w, F++, r = !0) : d && U < d ? (w = c - w, M = vectorScrubber({
            from: f = (e = [b, f])[0],
            to: b = e[1],
            ease: u
          }).start(A), U++, r = !0) : h && P < h && (t(), P++, r = !0), !r;
        }() && o && (cancelSync.update(i), sync.update(o, !1, !0));
      }, !0);
    }

    function a() {
      O = !1, i && cancelSync.update(i);
    }

    var i,
        A = e.update,
        o = e.complete,
        s = L.duration,
        c = void 0 === s ? 300 : s,
        l = L.ease,
        u = void 0 === l ? easeOut : l,
        _ = L.flip,
        d = void 0 === _ ? 0 : _,
        p = L.loop,
        m = void 0 === p ? 0 : p,
        g = L.yoyo,
        h = void 0 === g ? 0 : g,
        B = L.from,
        f = void 0 === B ? 0 : B,
        C = L.to,
        b = void 0 === C ? 1 : C,
        E = L.elapsed,
        w = void 0 === E ? 0 : E,
        v = L.playDirection,
        y = void 0 === v ? 1 : v,
        T = L.flipCount,
        U = void 0 === T ? 0 : T,
        I = L.yoyoCount,
        P = void 0 === I ? 0 : I,
        S = L.loopCount,
        F = void 0 === S ? 0 : S,
        M = vectorScrubber({
      from: f,
      to: b,
      ease: u
    }).start(A),
        D = 0,
        O = !1;
    return n(), {
      isActive: function isActive() {
        return O;
      },
      getElapsed: function getElapsed() {
        return clamp$1$1(0, c, w);
      },
      getProgress: function getProgress() {
        return D;
      },
      stop: function stop() {
        a();
      },
      pause: function pause() {
        return a(), this;
      },
      resume: function resume() {
        return O || n(), this;
      },
      seek: function seek(e) {
        return w = mix(0, c, e), sync.update(r, !1, !0), this;
      },
      reverse: function reverse() {
        return t(), this;
      }
    };
  });
},
    clampProgress$1$1 = clamp$1$1(0, 1),
    defaultEasings = function defaultEasings(e, n) {
  return e.map(function () {
    return n || easeOut;
  }).splice(0, e.length - 1);
},
    defaultTimings = function defaultTimings(e) {
  var r = e.length;
  return e.map(function (e, n) {
    return 0 !== n ? n / (r - 1) : 0;
  });
},
    interpolateScrubbers = function interpolateScrubbers(t, e, n) {
  var a = t.length,
      i = a - 1,
      A = i - 1,
      o = e.map(function (e) {
    return e.start(n);
  });
  return function (e) {
    e <= t[0] && o[0].seek(0), e >= t[i] && o[A].seek(1);

    for (var n = 1; n < a && !(t[n] > e || n === i); n++) {
      ;
    }

    var r = progress(t[n - 1], t[n], e);
    o[n - 1].seek(clampProgress$1$1(r));
  };
},
    keyframes = function keyframes(e) {
  var n = e.easings,
      r = e.ease,
      t = void 0 === r ? linear : r,
      a = e.times,
      i = e.values,
      A = __rest(e, ["easings", "ease", "times", "values"]);

  n = Array.isArray(n) ? n : defaultEasings(i, n), a = a || defaultTimings(i);
  var o = n.map(function (e, n) {
    return vectorScrubber({
      from: i[n],
      to: i[n + 1],
      ease: e
    });
  });
  return tween(_assign({}, A, {
    ease: t
  })).applyMiddleware(function (e) {
    return interpolateScrubbers(a, o, e);
  });
},
    physics = function physics(g) {
  return void 0 === g && (g = {}), action(function (e) {
    var t = e.complete,
        a = e.update,
        n = g.acceleration,
        i = void 0 === n ? 0 : n,
        r = g.friction,
        A = void 0 === r ? 0 : r,
        o = g.velocity,
        s = void 0 === o ? 0 : o,
        c = g.springStrength,
        l = g.to,
        u = g.restSpeed,
        _ = void 0 === u ? .001 : u,
        d = g.from,
        p = void 0 === d ? 0 : d,
        m = sync.update(function (e) {
      var n = e.delta,
          r = Math.max(n, 16);
      i && (s += velocityPerFrame(i, r)), A && (s *= Math.pow(1 - A, r / 100)), void 0 !== c && void 0 !== l && (s += (l - p) * velocityPerFrame(c, r));
      p += velocityPerFrame(s, r), a(p), !1 !== _ && (!s || Math.abs(s) <= _) && (cancelSync.update(m), t());
    }, !0);

    return {
      set: function set(e) {
        return p = e, this;
      },
      setAcceleration: function setAcceleration(e) {
        return i = e, this;
      },
      setFriction: function setFriction(e) {
        return A = e, this;
      },
      setSpringStrength: function setSpringStrength(e) {
        return c = e, this;
      },
      setSpringTarget: function setSpringTarget(e) {
        return l = e, this;
      },
      setVelocity: function setVelocity(e) {
        return s = e, this;
      },
      stop: function stop() {
        return cancelSync.update(m);
      }
    };
  });
},
    vectorPhysics = createVectorAction(physics, {
  acceleration: number.test,
  friction: number.test,
  velocity: number.test,
  from: number.test,
  to: number.test,
  springStrength: number.test
}),
    listen = function listen(t, a, i) {
  return action(function (e) {
    var n = e.update,
        r = a.split(" ").map(function (e) {
      return t.addEventListener(e, n, i), e;
    });
    return {
      stop: function stop() {
        return r.forEach(function (e) {
          return t.removeEventListener(e, n, i);
        });
      }
    };
  });
},
    defaultPointerPos = function defaultPointerPos() {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
  };
},
    eventToPoint = function eventToPoint(e, n) {
  return void 0 === n && (n = defaultPointerPos()), n.clientX = n.x = e.clientX, n.clientY = n.y = e.clientY, n.pageX = e.pageX, n.pageY = e.pageY, n;
},
    points = [defaultPointerPos()],
    isTouchDevice = !1;

if ("undefined" != typeof document) {
  var updatePointsLocation = function updatePointsLocation(e) {
    var n = e.touches;
    isTouchDevice = !0;

    for (var r = n.length, t = points.length = 0; t < r; t++) {
      var a = n[t];
      points.push(eventToPoint(a));
    }
  };

  listen(document, "touchstart touchmove", {
    passive: !0,
    capture: !0
  }).start(updatePointsLocation);
}

var multitouch = function multitouch(e) {
  var n = void 0 === e ? {} : e,
      r = n.preventDefault,
      l = void 0 === r || r,
      t = n.scale,
      u = void 0 === t ? 1 : t,
      a = n.rotate,
      _ = void 0 === a ? 0 : a;

  return action(function (e) {
    var a = e.update,
        i = {
      touches: points,
      scale: u,
      rotate: _
    },
        A = 0,
        o = 0,
        s = 1 < points.length;

    if (s) {
      var n = points[0],
          r = points[1];
      A = distance(n, r), o = angle(n, r);
    }

    function t() {
      if (s) {
        var e = points[0],
            n = points[1],
            r = distance(e, n),
            t = angle(e, n);
        i.scale = u * (r / A), i.rotate = _ + (t - o);
      }

      a(i);
    }

    var c = listen(document, "touchmove", {
      passive: !l
    }).start(function (e) {
      (l || 1 < e.touches.length) && e.preventDefault(), sync.update(t);
    });
    return isTouchDevice && sync.update(t), {
      stop: function stop() {
        cancelSync.update(t), c.stop();
      }
    };
  });
},
    getIsTouchDevice = function getIsTouchDevice() {
  return isTouchDevice;
},
    point = defaultPointerPos(),
    isMouseDevice = !1;

if ("undefined" != typeof document) {
  var updatePointLocation = function updatePointLocation(e) {
    isMouseDevice = !0, eventToPoint(e, point);
  };

  listen(document, "mousedown mousemove", !0).start(updatePointLocation);
}

var mouse = function mouse(e) {
  var n = (void 0 === e ? {} : e).preventDefault,
      a = void 0 === n || n;
  return action(function (e) {
    function n() {
      return r(point);
    }

    var r = e.update,
        t = listen(document, "mousemove").start(function (e) {
      a && e.preventDefault(), sync.update(n);
    });
    return isMouseDevice && sync.update(n), {
      stop: function stop() {
        cancelSync.update(n), t.stop();
      }
    };
  });
},
    getFirstTouch = function getFirstTouch(e) {
  return e[0];
},
    pointer = function pointer(e) {
  return void 0 === e && (e = {}), getIsTouchDevice() ? multitouch(e).pipe(function (e) {
    return e.touches;
  }, getFirstTouch) : mouse(e);
},
    index$1 = function index$1(e) {
  void 0 === e && (e = {});

  var n = e.x,
      r = e.y,
      t = __rest(e, ["x", "y"]);

  if (void 0 === n && void 0 === r) return pointer(t);
  var a = applyOffset(n || 0),
      i = applyOffset(r || 0),
      A = {
    x: 0,
    y: 0
  };
  return pointer(t).pipe(function (e) {
    return A.x = a(e.x), A.y = i(e.y), A;
  });
},
    chain = function chain() {
  for (var A = [], e = 0; e < arguments.length; e++) {
    A[e] = arguments[e];
  }

  return action(function (e) {
    var n,
        r = e.update,
        t = e.complete,
        a = 0,
        i = function i() {
      n = A[a].start({
        complete: function complete() {
          ++a >= A.length ? t() : i();
        },
        update: r
      });
    };

    return i(), {
      stop: function stop() {
        return n && n.stop();
      }
    };
  });
},
    delay = function delay(t) {
  return action(function (e) {
    var n = e.complete,
        r = setTimeout(n, t);
    return {
      stop: function stop() {
        return clearTimeout(r);
      }
    };
  });
},
    appendUnit = function appendUnit(n) {
  return function (e) {
    return "" + e + n;
  };
},
    steps$1 = function steps$1(r, t, a) {
  return void 0 === t && (t = 0), void 0 === a && (a = 1), function (e) {
    var n = progress(t, a, e);
    return mix(t, a, stepProgress(r, n));
  };
},
    transformMap = function transformMap(a) {
  return function (e) {
    var n = _assign({}, e);

    for (var r in a) {
      if (a.hasOwnProperty(r)) {
        var t = a[r];
        n[r] = t(e[r]);
      }
    }

    return n;
  };
},
    transformers = Object.freeze({
  applyOffset: applyOffset,
  clamp: clamp$1$1,
  conditional: conditional,
  interpolate: interpolate$$1,
  blendArray: mixArray,
  blendColor: mixColor,
  pipe: pipe,
  smooth: smooth,
  snap: snap,
  generateStaticSpring: springForce,
  nonlinearSpring: springForceExpo,
  linearSpring: springForceLinear,
  wrap: wrap$1,
  appendUnit: appendUnit,
  steps: steps$1,
  transformMap: transformMap
}),
    getPoseValues = function getPoseValues(e) {
  e.transition, e.flip, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.afterChildren, e.beforeChildren, e.preTransition, e.applyAtStart, e.applyAtEnd;
  return __rest(e, ["transition", "flip", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition", "applyAtStart", "applyAtEnd"]);
},
    selectPoses = function selectPoses(e) {
  e.label, e.props, e.values, e.parentValues, e.ancestorValues, e.onChange, e.passive, e.initialPose;
  return __rest(e, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);
},
    selectAllValues = function selectAllValues(e, r) {
  var t = {};
  return e.forEach(function (e, n) {
    return t[n] = r(e);
  }), t;
},
    resolveProp = function resolveProp(e, n) {
  return "function" == typeof e ? e(n) : e;
},
    poseDefault = function poseDefault(e, n, r, t) {
  return e && void 0 !== e[n] ? resolveProp(e[n], t) : r;
},
    startChildAnimations = function startChildAnimations(e, r, n, t) {
  var a = [],
      i = poseDefault(n, "delayChildren", 0, t),
      A = poseDefault(n, "staggerChildren", 0, t),
      o = poseDefault(n, "staggerDirection", 1, t),
      s = (e.size - 1) * A,
      c = 1 === o ? function (e) {
    return e * A;
  } : function (e) {
    return s - e * A;
  };
  return Array.from(e).forEach(function (e, n) {
    a.push(e.set(r, {
      delay: i + c(n)
    }));
  }), a;
},
    resolveTransition = function resolveTransition(e, n, r, t, a, i) {
  var A;

  if ("function" == typeof e) {
    var o = e(t);
    A = resolveTransition(o, n, r, t, a, i);
  } else if (e[n] || e.default) {
    var s = e[n] || e.default;
    A = "function" == typeof s ? s(t) : s;
  } else A = e;

  return !1 === A ? i(r, t) : a(r, A, t);
},
    findInsertionIndex = function findInsertionIndex(e, n, r) {
  for (var t = 0, a = r - 1; 0 <= a; a--) {
    var i = e.indexOf(n[a]);

    if (-1 !== i) {
      t = i + 1;
      break;
    }
  }

  return t;
},
    applyValues = function applyValues(r, t, a, i, A) {
  return invariant("object" == typeof r, "applyAtStart and applyAtEnd must be of type object"), Object.keys(r).forEach(function (e) {
    var n = resolveProp(r[e], a);
    t.has(e) ? i(t.get(e), n) : A(e, n, a);
  });
},
    createPoseSetter = function createPoseSetter(e) {
  var m = e.state,
      g = e.poses,
      h = e.startAction,
      B = e.stopAction,
      f = e.getInstantTransition,
      C = e.addActionDelay,
      b = e.getTransitionProps,
      E = e.resolveTarget,
      w = e.transformPose,
      v = e.posePriority,
      y = e.convertTransitionDefinition,
      T = e.setValue,
      U = e.setValueNative,
      I = e.forceRender;
  return function (a, e, n) {
    void 0 === e && (e = {}), void 0 === n && (n = !0);

    function r() {
      return s && n ? startChildAnimations(i, a, p, d) : [];
    }

    function t() {
      if (!p) return [];
      var e = p.applyAtStart;
      e && (applyValues(e, c, d, T, U), I && I(d)), w && (p = w(p, a, m));
      var n = p.preTransition,
          s = p.transition,
          r = p.applyAtEnd;
      n && n(d);
      var t = Object.keys(getPoseValues(p)).map(function (o) {
        var e = (u.has(o) || u.set(o, []), u.get(o)),
            n = e.indexOf(a);
        -1 !== n && e.splice(n, 1);
        var r = v ? v.indexOf(a) : 0,
            t = r <= 0 ? 0 : findInsertionIndex(e, v, r);
        return e.splice(t, 0, a), 0 === t ? new Promise(function (e) {
          var n = c.get(o),
              r = _assign({}, d, {
            key: o,
            value: n
          }),
              t = E(n, resolveProp(p[o], r));

          l.has(o) && B(l.get(o));

          var a = _assign({
            to: t
          }, r, b(n, t, r)),
              i = resolveTransition(s, o, n, a, y, f),
              A = _ || resolveProp(p.delay, r);

          A && (i = C(A, i)), l.set(o, h(n, i, e));
        }) : Promise.resolve();
      });
      return r ? [Promise.all(t).then(function () {
        applyValues(r, c, d, T, U);
      })] : t;
    }

    var i = m.children,
        c = m.values,
        A = m.props,
        l = m.activeActions,
        u = m.activePoses,
        o = e.delay,
        _ = void 0 === o ? 0 : o,
        s = i.size,
        d = _assign({}, A, e),
        p = g[a];

    if (p && s) {
      if (resolveProp(p.beforeChildren, d)) return Promise.all(t()).then(function () {
        return Promise.all(r());
      });
      if (resolveProp(p.afterChildren, d)) return Promise.all(r()).then(function () {
        return Promise.all(t());
      });
    }

    return Promise.all(t().concat(r()));
  };
},
    DEFAULT_INITIAL_POSE = "init",
    isScale = function isScale(e) {
  return e.includes("scale");
},
    defaultReadValueFromSource = function defaultReadValueFromSource(e) {
  return isScale(e) ? 1 : 0;
},
    readValueFromPose = function readValueFromPose(e, n, r) {
  var t = e.applyAtEnd && void 0 !== e.applyAtEnd[n] ? e.applyAtEnd[n] : void 0 !== e[n] ? e[n] : e.applyAtStart && void 0 !== e.applyAtStart[n] ? e.applyAtStart[n] : 0;
  return resolveProp(t, r);
},
    getPosesToSearch = function getPosesToSearch(e) {
  var n = Array.isArray(e) ? e : [e];
  return n.push(DEFAULT_INITIAL_POSE), n;
},
    getInitialValue = function getInitialValue(r, t, e, n, a, i) {
  void 0 === a && (a = defaultReadValueFromSource);
  var A = getPosesToSearch(e).filter(Boolean).find(function (e) {
    var n = r[e];
    return n && (void 0 !== n[t] || n.applyAtStart && void 0 !== n.applyAtStart[t] || n.applyAtEnd && void 0 !== n.applyAtEnd[t]);
  });
  return i.set(t, [A || DEFAULT_INITIAL_POSE]), A ? readValueFromPose(r[A], t, n) : a(t, n);
},
    createValues = function createValues(t, e) {
  var a = e.userSetValues,
      i = e.createValue,
      A = e.convertValue,
      o = e.readValueFromSource,
      s = e.initialPose,
      c = e.poses,
      l = e.activePoses,
      u = e.props;
  return function (e) {
    if (!t.has(e)) {
      var n;
      if (a && void 0 !== a[e]) n = A(a[e], e, u);else {
        var r = getInitialValue(c, e, s, u, o, l);
        n = i(r, e, u);
      }
      t.set(e, n);
    }
  };
},
    scrapeValuesFromPose = function scrapeValuesFromPose(r, t) {
  return function (e) {
    var n = t.poses[e];
    Object.keys(getPoseValues(n)).forEach(createValues(r, t));
  };
},
    getAncestorValue = function getAncestorValue(e, n, r) {
  if (!0 === n) return r[0] && r[0].values.get(e);
  var t = r.find(function (e) {
    return e.label === n;
  });
  return t && t.values.get(e);
},
    bindPassiveValues = function bindPassiveValues(o, e) {
  var s = e.passive,
      c = e.ancestorValues,
      l = e.createValue,
      u = e.readValue,
      _ = e.props;
  return function (e) {
    var n = s[e],
        r = n[0],
        t = n[1],
        a = n[2],
        i = a && c.length ? getAncestorValue(r, a, c) : !!o.has(r) && o.get(r);

    if (i) {
      var A = l(u(i), e, _, {
        passiveParentKey: r,
        passiveParent: i,
        passiveProps: t
      });
      o.set(e, A);
    }
  };
},
    setNativeValues = function setNativeValues(e) {
  function r(e, n) {
    if (e[n]) for (var r in e[n]) {
      A.has(r) || (A.add(r), t(r, resolveProp(e[n][r], a), a));
    }
  }

  var t = e.setValueNative,
      n = e.initialPose,
      a = e.props,
      i = e.poses,
      A = new Set();
  getPosesToSearch(n).forEach(function (e) {
    var n = i[e];
    n && (r(n, "applyAtEnd"), r(n, "applyAtStart"));
  });
},
    createValueMap = function createValueMap(e) {
  var n = e.poses,
      r = e.passive,
      t = new Map();
  return Object.keys(n).forEach(scrapeValuesFromPose(t, e)), setNativeValues(e), r && Object.keys(r).forEach(bindPassiveValues(t, e)), t;
},
    applyDefaultTransition = function applyDefaultTransition(e, n, r) {
  return _assign({}, e, {
    transition: r.has(n) ? r.get(n) : r.get("default")
  });
},
    generateTransitions = function generateTransitions(r, t) {
  return Object.keys(r).forEach(function (e) {
    var n = r[e];
    invariant("object" == typeof n, "Pose '" + e + "' is of invalid type. All poses should be objects."), r[e] = void 0 !== n.transition ? n : applyDefaultTransition(n, e, t);
  }), r;
},
    sortByReversePriority = function sortByReversePriority(a) {
  return function (e, n) {
    var r = a.indexOf(e),
        t = a.indexOf(n);
    return -1 === r && -1 !== t ? -1 : -1 !== r && -1 === t ? 1 : r - t;
  };
},
    poseFactory = function poseFactory(e) {
  var B = e.getDefaultProps,
      f = e.defaultTransitions,
      C = e.bindOnChange,
      b = e.startAction,
      E = e.stopAction,
      w = e.readValue,
      v = e.readValueFromSource,
      y = e.resolveTarget,
      T = e.setValue,
      U = e.setValueNative,
      I = e.createValue,
      P = e.convertValue,
      S = e.getInstantTransition,
      F = e.getTransitionProps,
      M = e.addActionDelay,
      D = e.selectValueToRead,
      O = e.convertTransitionDefinition,
      L = e.transformPose,
      Q = e.posePriority,
      R = e.forceRender,
      k = e.extendAPI;
  return function (t) {
    var e = t.parentValues,
        n = t.ancestorValues,
        a = void 0 === n ? [] : n;
    e && a.unshift({
      values: e
    });
    var r = new Map(),
        A = new Map(),
        o = new Set(),
        i = generateTransitions(selectPoses(t), f),
        s = t.props,
        c = void 0 === s ? {} : s;
    B && (c = _assign({}, B(t), c));
    var l = t.passive,
        u = t.values,
        _ = t.initialPose,
        d = void 0 === _ ? DEFAULT_INITIAL_POSE : _,
        p = createValueMap({
      poses: i,
      passive: l,
      ancestorValues: a,
      readValue: w,
      setValueNative: U,
      createValue: I,
      convertValue: P,
      readValueFromSource: v,
      userSetValues: u,
      initialPose: d,
      activePoses: A,
      props: c
    }),
        m = {
      activeActions: r,
      activePoses: A,
      children: o,
      props: c,
      values: p
    },
        g = t.onChange;
    g && Object.keys(g).forEach(C(p, g));
    var h = createPoseSetter({
      state: m,
      poses: i,
      getInstantTransition: S,
      getTransitionProps: F,
      convertTransitionDefinition: O,
      setValue: T,
      setValueNative: U,
      startAction: b,
      stopAction: E,
      resolveTarget: y,
      addActionDelay: M,
      transformPose: L,
      posePriority: Q,
      forceRender: R
    });
    return k({
      set: h,
      unset: function unset(a, n) {
        var i = [];
        A.forEach(function (e) {
          var n = e.indexOf(a);

          if (-1 !== n) {
            var r = e[0];
            e.splice(n, 1);
            var t = e[0];
            t !== r && -1 === i.indexOf(t) && i.push(t);
          }
        });
        var r = i.sort(sortByReversePriority(Q)).map(function (e) {
          return h(e, n, !1);
        });
        return o.forEach(function (e) {
          return r.push(e.unset(a));
        }), Promise.all(r);
      },
      get: function get(e) {
        return e ? D(p.get(e)) : selectAllValues(p, D);
      },
      has: function has(e) {
        return !!i[e];
      },
      setProps: function setProps(e) {
        return m.props = _assign({}, m.props, e);
      },
      _addChild: function _addChild(e, n) {
        var r = n(_assign({
          initialPose: d
        }, e, {
          ancestorValues: [{
            label: t.label,
            values: p
          }].concat(a)
        }));
        return o.add(r), r;
      },
      removeChild: function removeChild(e) {
        return o.delete(e);
      },
      clearChildren: function clearChildren() {
        o.forEach(function (e) {
          return e.destroy();
        }), o.clear();
      },
      destroy: function destroy() {
        r.forEach(E), o.forEach(function (e) {
          return e.destroy();
        });
      }
    }, m, t);
  };
},
    _assign$4 = function __assign$4() {
  return (_assign$4 = Object.assign || function (e) {
    for (var n, r = 1, t = arguments.length; r < t; r++) {
      for (var a in n = arguments[r]) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    BoundingBoxDimension;

function __rest$2(e, n) {
  var r = {};

  for (var t in e) {
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (r[t] = e[t]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (t = Object.getOwnPropertySymbols(e); a < t.length; a++) {
      n.indexOf(t[a]) < 0 && (r[t[a]] = e[t[a]]);
    }
  }

  return r;
}

!function (e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
}(BoundingBoxDimension || (BoundingBoxDimension = {}));

var measureWithoutTransform = function measureWithoutTransform(e) {
  var n = e.style.transform;
  e.style.transform = "";
  var r = e.getBoundingClientRect();
  return e.style.transform = n, r;
},
    resolveProp$1 = function resolveProp$1(e, n) {
  return "function" == typeof e ? e(n) : e;
},
    interpolate = transformers.interpolate,
    singleAxisPointer = function singleAxisPointer(r) {
  return function (e) {
    var n;
    return index$1(((n = {})[r] = "string" == typeof e ? parseFloat(e) : e, n)).pipe(function (e) {
      return e[r];
    });
  };
},
    pointerX = singleAxisPointer("x"),
    pointerY = singleAxisPointer("y"),
    createPointer = function createPointer(s, c, l, u) {
  return function (e) {
    var n = e.from,
        r = e.type,
        t = e.dimensions,
        a = e.dragBounds,
        i = s(t.measurementAsPixels(u, n, r)),
        A = [];

    if (a) {
      var o = resolveProp$1(a, e);
      void 0 !== o[c] && A.push(function (e) {
        return Math.max(e, t.measurementAsPixels(u, o[c], r));
      }), void 0 !== o[l] && A.push(function (e) {
        return Math.min(e, t.measurementAsPixels(u, o[l], r));
      });
    }

    return r === percent && A.push(interpolate([0, t.get(u)], [0, 100], {
      clamp: !1
    }), function (e) {
      return e + "%";
    }), A.length ? i.pipe.apply(i, A) : i;
  };
},
    just = function just(t) {
  return action(function (e) {
    var n = e.update,
        r = e.complete;
    n(t), r();
  });
},
    underDampedSpring = function underDampedSpring(e) {
  var n = e.from,
      r = e.velocity,
      t = e.to;
  return vectorSpring({
    from: n,
    to: t,
    velocity: r,
    stiffness: 500,
    damping: 25,
    restDelta: .5,
    restSpeed: 10
  });
},
    overDampedSpring = function overDampedSpring(e) {
  var n = e.from,
      r = e.velocity,
      t = e.to;
  return vectorSpring({
    from: n,
    to: t,
    velocity: r,
    stiffness: 700,
    damping: 0 === t ? 100 : 35
  });
},
    linearTween = function linearTween(e) {
  var n = e.from,
      r = e.to;
  return tween({
    from: n,
    to: r,
    ease: linear
  });
},
    intelligentTransition = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: overDampedSpring,
  scaleY: overDampedSpring,
  scale: overDampedSpring,
  opacity: linearTween,
  default: tween
},
    dragAction = _assign$4({}, intelligentTransition, {
  x: createPointer(pointerX, "left", "right", BoundingBoxDimension.width),
  y: createPointer(pointerY, "top", "bottom", BoundingBoxDimension.height)
}),
    justAxis = function justAxis(e) {
  var n = e.from;
  return just(n);
},
    intelligentDragEnd = _assign$4({}, intelligentTransition, {
  x: justAxis,
  y: justAxis
}),
    defaultTransitions = new Map([["default", intelligentTransition], ["drag", dragAction], ["dragEnd", intelligentDragEnd]]),
    animationLookup = {
  tween: tween,
  spring: vectorSpring,
  decay: vectorDecay,
  keyframes: keyframes,
  physics: vectorPhysics
},
    easingLookup = {
  linear: linear,
  easeIn: easeIn,
  easeOut: easeOut,
  easeInOut: easeInOut,
  circIn: circIn,
  circOut: circOut,
  circInOut: circInOut,
  backIn: backIn,
  backOut: backOut,
  backInOut: backInOut,
  anticipate: anticipate
},
    auto = {
  test: function test(e) {
    return "auto" === e;
  },
  parse: function parse(e) {
    return e;
  }
},
    valueTypeTests = [number, degrees, percent, px, vw, vh, auto],
    testValueType = function testValueType(n) {
  return function (e) {
    return e.test(n);
  };
},
    getValueType$2 = function getValueType$2(e) {
  return valueTypeTests.find(testValueType(e));
},
    createPassiveValue = function createPassiveValue(e, n, r) {
  var t = value(r(e));
  return n.raw.subscribe(function (e) {
    return t.update(r(e));
  }), {
    raw: t
  };
},
    _createValue = function createValue(e) {
  var n = getValueType$2(e);
  return {
    raw: value(e),
    type: n
  };
},
    addActionDelay = function addActionDelay(e, n) {
  return void 0 === e && (e = 0), chain(delay(e), n);
},
    isCubicBezierArgs = function isCubicBezierArgs(e) {
  return "number" == typeof e[0];
},
    getAction = function getAction(e, n, r) {
  var t,
      a = r.from,
      i = r.to,
      A = r.velocity,
      o = n.type,
      s = void 0 === o ? "tween" : o,
      c = n.ease,
      l = __rest$2(n, ["type", "ease"]);

  if (invariant(void 0 !== animationLookup[s], "Invalid transition type '" + s + "'. Valid transition types are: tween, spring, decay, physics and keyframes."), "tween" === s && "function" != typeof c) if ("string" == typeof c) invariant(void 0 !== easingLookup[c], "Invalid easing type '" + c + "'. popmotion.io/pose/api/config"), t = easingLookup[c];else if (Array.isArray(c) && isCubicBezierArgs(c)) {
    invariant(4 === c.length, "Cubic bezier arrays must contain four numerical values."), t = cubicBezier(c[0], c[1], c[2], c[3]);
  }
  t = t || c;
  var u = "keyframes" !== s ? {
    from: a,
    to: i,
    velocity: A,
    ease: t
  } : {
    ease: t
  };
  return animationLookup[s](_assign$4({}, u, l));
},
    isAction = function isAction(e) {
  return void 0 !== e.start;
},
    pose = function pose(e) {
  var n = e.transformPose,
      c = e.addListenerToValue,
      r = e.extendAPI,
      t = e.readValueFromSource,
      a = e.posePriority,
      i = e.setValueNative;
  return poseFactory({
    bindOnChange: function bindOnChange(n, r) {
      return function (e) {
        n.has(e) && n.get(e).raw.subscribe(r[e]);
      };
    },
    readValue: function readValue(e) {
      return e.raw.get();
    },
    setValue: function setValue(e, n) {
      return e.raw.update(n);
    },
    createValue: function createValue(e, n, r, t) {
      var a = r.elementStyler,
          i = void 0 === t ? {} : t,
          A = i.passiveParent,
          o = i.passiveProps,
          s = A ? createPassiveValue(e, A, o) : _createValue(e);
      return s.raw.subscribe(c(n, a)), s;
    },
    convertValue: function convertValue(e, n, r) {
      var t = r.elementStyler;
      return e.subscribe(c(n, t)), {
        raw: e,
        type: getValueType$2(e.get())
      };
    },
    getTransitionProps: function getTransitionProps(e, n) {
      var r = e.raw,
          t = e.type;
      return {
        from: r.get(),
        velocity: r.getVelocity(),
        to: n,
        type: t
      };
    },
    resolveTarget: function resolveTarget(e, n) {
      return n;
    },
    selectValueToRead: function selectValueToRead(e) {
      return e.raw;
    },
    startAction: function startAction(e, n, r) {
      var t = e.raw,
          a = {
        update: function update(e) {
          return t.update(e);
        },
        complete: r
      };
      return n.start(a);
    },
    stopAction: function stopAction(e) {
      return e.stop();
    },
    getInstantTransition: function getInstantTransition(e, n) {
      var r = n.to;
      return just(r);
    },
    convertTransitionDefinition: function convertTransitionDefinition(e, n, r) {
      if (isAction(n)) return n;

      var t = n.delay,
          a = n.min,
          i = n.max,
          A = n.round,
          o = __rest$2(n, ["delay", "min", "max", "round"]),
          s = getAction(e, o, r),
          c = [];

      return t && (s = addActionDelay(t, s)), void 0 !== a && c.push(function (e) {
        return Math.max(e, a);
      }), void 0 !== i && c.push(function (e) {
        return Math.min(e, i);
      }), A && c.push(Math.round), c.length ? s.pipe.apply(s, c) : s;
    },
    setValueNative: i,
    addActionDelay: addActionDelay,
    defaultTransitions: defaultTransitions,
    transformPose: n,
    readValueFromSource: t,
    posePriority: a,
    extendAPI: r
  });
},
    createDimensions = function createDimensions(e) {
  var n = !1,
      t = {
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };
  return {
    get: function get(e) {
      return e ? t[e] : t;
    },
    measure: function measure() {
      return t = e.getBoundingClientRect(), n = !0, t;
    },
    measurementAsPixels: function measurementAsPixels(e, n, r) {
      return r === percent ? ("string" == typeof n ? parseFloat(n) : n) / 100 * t[e] : n;
    },
    has: function has() {
      return n;
    }
  };
},
    makeUIEventApplicator = function makeUIEventApplicator(e) {
  var c = e.startEvents,
      l = e.endEvents,
      u = e.startPose,
      _ = e.endPose,
      d = e.startCallback,
      p = e.endCallback,
      m = e.useDocumentToEnd,
      g = e.preventScroll;
  return function (r, t, a, i) {
    var e = u + "Start",
        A = u + "End",
        n = u + "Move";

    if (g) {
      var o = listen(r, "touchmove", {
        passive: !1
      }).start(function (e) {
        e.preventDefault();
      });
      t.set(n, o);
    }

    var s = listen(r, c).start(function (e) {
      a.unset(_), a.set(u), d && i[d] && i[d](e);
      var n = listen(m ? document.documentElement : r, l + (m ? " mouseenter" : "")).start(function (e) {
        m && "mouseenter" === e.type && 1 === e.buttons || (t.get(A).stop(), a.unset(u), a.set(_), p && i[p] && i[p](e));
      });
      t.set(A, n);
    });
    t.set(e, s);
  };
},
    events = {
  draggable: makeUIEventApplicator({
    startEvents: "mousedown touchstart",
    endEvents: "mouseup touchend",
    startPose: "drag",
    endPose: "dragEnd",
    startCallback: "onDragStart",
    endCallback: "onDragEnd",
    useDocumentToEnd: !0,
    preventScroll: !0
  }),
  hoverable: makeUIEventApplicator({
    startEvents: "mouseenter",
    endEvents: "mouseleave",
    startPose: "hover",
    endPose: "hoverEnd"
  }),
  focusable: makeUIEventApplicator({
    startEvents: "focus",
    endEvents: "blur",
    startPose: "focus",
    endPose: "blur"
  }),
  pressable: makeUIEventApplicator({
    startEvents: "mousedown touchstart",
    endEvents: "mouseup touchend",
    startPose: "press",
    endPose: "pressEnd",
    startCallback: "onPressStart",
    endCallback: "onPressEnd",
    useDocumentToEnd: !0
  })
},
    eventKeys = Object.keys(events),
    appendEventListeners = function appendEventListeners(n, r, t, e) {
  var a = e.props;
  return eventKeys.forEach(function (e) {
    a[e] && events[e](n, r, t, a);
  });
},
    ORIGIN_START = 0,
    ORIGIN_CENTER = "50%",
    ORIGIN_END = "100%",
    findCenter = function findCenter(e) {
  var n = e.top,
      r = e.right,
      t = e.bottom;
  return {
    x: (e.left + r) / 2,
    y: (n + t) / 2
  };
},
    positionalProps = ["width", "height", "top", "left", "bottom", "right"],
    positionalPropsDict = new Set(positionalProps),
    checkPositionalProp = function checkPositionalProp(e) {
  return positionalPropsDict.has(e);
},
    hasPositionalProps = function hasPositionalProps(e) {
  return Object.keys(e).some(checkPositionalProp);
},
    isFlipPose = function isFlipPose(e, n, r) {
  return r.props.element instanceof HTMLElement && (!0 === e || "flip" === n);
},
    setValue = function setValue(e, n, r) {
  var t = e.values,
      a = e.props;

  if (t.has(n)) {
    var i = t.get(n).raw;
    i.update(r), i.update(r);
  } else t.set(n, {
    raw: value(r, function (e) {
      return a.elementStyler.set(n, e);
    })
  });
},
    explicitlyFlipPose = function explicitlyFlipPose(r, t) {
  var e = r.props,
      n = e.dimensions,
      a = e.elementStyler;
  n.measure();
  t.width, t.height, t.top, t.left, t.bottom, t.right, t.position;

  var i = __rest$2(t, ["width", "height", "top", "left", "bottom", "right", "position"]),
      A = positionalProps.concat("position").reduce(function (e, n) {
    return void 0 !== t[n] && (e[n] = resolveProp$1(t[n], r.props)), e;
  }, {});

  return a.set(A).render(), implicitlyFlipPose(r, i);
},
    implicitlyFlipPose = function implicitlyFlipPose(e, n) {
  var r = e.props,
      t = r.dimensions,
      a = r.element,
      i = r.elementStyler;
  if (!t.has()) return {};
  var A = t.get(),
      o = measureWithoutTransform(a),
      s = A.left === o.left ? ORIGIN_START : A.right === o.right ? ORIGIN_END : ORIGIN_CENTER,
      c = A.top === o.top ? ORIGIN_START : A.bottom === o.bottom ? ORIGIN_END : ORIGIN_CENTER;
  i.set({
    originX: s,
    originY: c
  }), A.width !== o.width && (setValue(e, "scaleX", A.width / o.width), n.scaleX = 1), A.height !== o.height && (setValue(e, "scaleY", A.height / o.height), n.scaleY = 1);
  var l = findCenter(A),
      u = findCenter(o);
  return s === ORIGIN_CENTER && (setValue(e, "x", l.x - u.x), n.x = 0), c === ORIGIN_CENTER && (setValue(e, "y", l.y - u.y), n.y = 0), i.render(), n;
},
    flipPose = function flipPose(e, n) {
  return hasPositionalProps(n) ? explicitlyFlipPose(e, n) : implicitlyFlipPose(e, n);
},
    getPosFromMatrix = function getPosFromMatrix(e, n) {
  return parseFloat(e.split(", ")[n]);
},
    getTranslateFromMatrix = function getTranslateFromMatrix(i, A) {
  return function (e, n, r) {
    var t = r.transform;
    if ("none" === t) return 0;
    var a = t.match(/^matrix3d\((.+)\)$/);
    return a ? getPosFromMatrix(a[1], A) : getPosFromMatrix(t.match(/^matrix\((.+)\)$/)[1], i);
  };
},
    positionalValues = {
  width: function width(e, n) {
    return n.width;
  },
  height: function height(e, n) {
    return n.height;
  },
  top: function top(e, n, r) {
    var t = r.top;
    return parseFloat(t);
  },
  left: function left(e, n, r) {
    var t = r.left;
    return parseFloat(t);
  },
  bottom: function bottom(e, n, r) {
    var t = n.height,
        a = r.top;
    return parseFloat(a) + t;
  },
  right: function right(e, n, r) {
    var t = n.width,
        a = r.left;
    return parseFloat(a) + t;
  },
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
},
    isPositionalKey = function isPositionalKey(e) {
  return void 0 !== positionalValues[e];
},
    isPositional = function isPositional(e) {
  return Object.keys(e).some(isPositionalKey);
},
    convertPositionalUnits = function convertPositionalUnits(a, i) {
  var A = a.values,
      o = a.props,
      n = o.element,
      e = o.elementStyler,
      r = Object.keys(i).filter(isPositionalKey),
      s = [],
      t = getComputedStyle(n),
      c = !1;
  if (r.forEach(function (e) {
    var n = A.get(e),
        r = getValueType$2(n.raw.get()),
        t = resolveProp$1(i[e], o);
    r !== getValueType$2(t) && (s.push(e), c || (c = !0, i.applyAtEnd = i.applyAtEnd ? _assign$4({}, i.applyAtEnd) : {}), i.applyAtEnd[e] = i.applyAtEnd[e] || i[e], setValue(a, e, t));
  }), !s.length) return i;
  var l = n.getBoundingClientRect(),
      u = {
    top: t.top,
    left: t.left,
    bottom: t.bottom,
    right: t.right,
    transform: t.transform
  };
  e.render();

  var _ = n.getBoundingClientRect();

  return s.forEach(function (e) {
    setValue(a, e, positionalValues[e](n, l, u)), i[e] = positionalValues[e](n, _, t);
  }), e.render(), i;
},
    getCurrent = function getCurrent(n) {
  return function (e) {
    return e.elementStyler.get(n);
  };
},
    dragPoses = function dragPoses(e) {
  var n = {
    preTransition: function preTransition(e) {
      return e.dimensions.measure();
    }
  },
      r = {};
  return !0 !== e && "x" !== e || (n.x = r.x = getCurrent("x")), !0 !== e && "y" !== e || (n.y = r.y = getCurrent("y")), {
    drag: n,
    dragEnd: r
  };
},
    createPoseConfig = function createPoseConfig(e, n) {
  var r = n.onDragStart,
      t = n.onDragEnd,
      a = n.onPressStart,
      i = n.onPressEnd,
      A = n.draggable,
      o = n.hoverable,
      s = n.focusable,
      c = n.pressable,
      l = n.dragBounds,
      u = __rest$2(n, ["onDragStart", "onDragEnd", "onPressStart", "onPressEnd", "draggable", "hoverable", "focusable", "pressable", "dragBounds"]),
      _ = _assign$4({
    flip: {}
  }, u, {
    props: _assign$4({}, u.props, {
      onDragStart: r,
      onDragEnd: t,
      onPressStart: a,
      onPressEnd: i,
      dragBounds: l,
      draggable: A,
      hoverable: o,
      focusable: s,
      pressable: c,
      element: e,
      elementStyler: index(e, {
        preparseOutput: !1
      }),
      dimensions: createDimensions(e)
    })
  });

  if (A) {
    var d = dragPoses(A),
        p = d.drag,
        m = d.dragEnd;
    _.drag = _assign$4({}, p, _.drag), _.dragEnd = _assign$4({}, m, _.dragEnd);
  }

  return _;
},
    domPose = pose({
  posePriority: ["drag", "press", "focus", "hover"],
  transformPose: function transformPose(e, n, r) {
    var t = e.flip,
        a = __rest$2(e, ["flip"]);

    return isFlipPose(t, n, r) ? flipPose(r, a) : isPositional(a) ? convertPositionalUnits(r, a) : a;
  },
  forceRender: function forceRender(e) {
    e.elementStyler.render();
  },
  addListenerToValue: function addListenerToValue(n, r) {
    return function (e) {
      return r.set(n, e);
    };
  },
  readValueFromSource: function readValueFromSource(e, n) {
    var r = n.elementStyler,
        t = n.dragBounds,
        a = r.get(e);

    if (t && ("x" === e || "y" === e)) {
      var i = "x" === e ? t.left || t.right : t.top || t.bottom;
      if (i) a = getValueType$2(i).transform(a);
    }

    return isNaN(a) ? a : parseFloat(a);
  },
  setValueNative: function setValueNative(e, n, r) {
    return r.elementStyler.set(e, n);
  },
  extendAPI: function extendAPI(r, e, n) {
    var t = e.props,
        a = e.activeActions,
        i = t.dimensions.measure,
        A = _assign$4({}, r, {
      addChild: function addChild(e, n) {
        return r._addChild(createPoseConfig(e, n), domPose);
      },
      measure: i,
      flip: function flip(e) {
        return e && (i(), e()), r.set("flip");
      }
    });

    return t.elementStyler.render(), appendEventListeners(t.element, a, A, n), A;
  }
}),
    domPose$1 = function domPose$1(e, n) {
  return domPose(createPoseConfig(e, n));
};

function memoize(n) {
  var r = {};
  return function (e) {
    return void 0 === r[e] && (r[e] = n(e)), r[e];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    index$2 = memoize(function (e) {
  return reactPropsRegex.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
}),
    hasChanged = function hasChanged(e, n) {
  if (e === n) return !1;
  var r = Array.isArray(e),
      t = Array.isArray(n);
  if (r !== t || !r && !t) return !0;

  if (r && t) {
    var a = e.length;
    if (a !== n.length) return !0;

    for (var i = 0; i < a; i++) {
      if (e[i] !== n[i]) return !0;
    }
  }

  return !1;
},
    pickAssign = function pickAssign(t, e) {
  return e.reduce(function (e, n) {
    for (var r in n) {
      t(r) && (e[r] = n[r]);
    }

    return e;
  }, {});
},
    _a$1 = React.createContext({}),
    PoseParentConsumer = _a$1.Consumer,
    PoseParentProvider = _a$1.Provider,
    calcPopFromFlowStyle = function calcPopFromFlowStyle(e) {
  return {
    position: "absolute",
    top: e.offsetTop,
    left: e.offsetLeft,
    width: e.offsetWidth,
    height: e.offsetHeight
  };
},
    hasPose = function hasPose(e, n) {
  return Array.isArray(e) ? -1 !== e.indexOf(n) : e === n;
},
    objectToMap = function objectToMap(r) {
  return Object.keys(r).reduce(function (e, n) {
    return e.set(n, {
      raw: r[n]
    }), e;
  }, new Map());
},
    testAlwaysTrue = function testAlwaysTrue() {
  return !0;
},
    filterProps = function filterProps(e) {
  e.elementType, e.poseConfig, e.onValueChange, e.innerRef, e._pose, e.pose, e.initialPose, e.poseKey, e.onPoseComplete, e.getParentPoseConfig, e.registerChild, e.onUnmount, e.getInitialPoseFromParent, e.popFromFlow, e.values, e.parentValues, e.onDragStart, e.onDragEnd, e.onPressStart, e.onPressEnd;
  return __rest(e, ["elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd", "onPressStart", "onPressEnd"]);
},
    PoseElement = function (t) {
  function e(e) {
    var r = t.call(this, e) || this;
    r.children = new Set(), r.childrenHandlers = {
      registerChild: function registerChild(e) {
        r.children.add(e), r.poser && r.flushChildren();
      },
      onUnmount: function onUnmount(e) {
        return r.poser.removeChild(e);
      },
      getParentPoseConfig: function getParentPoseConfig() {
        return r.poseConfig;
      },
      getInitialPoseFromParent: function getInitialPoseFromParent() {
        return r.getInitialPose();
      }
    }, r.setRef = function (e) {
      warning(null === e || e instanceof Element && void 0 === r.ref, "ref must be provided to the same DOM component for the entire lifecycle of a posed component."), r.ref = e;
      var n = r.props.innerRef;
      n && ("function" == typeof n ? n(e) : n.current = e);
    }, r.shouldForwardProp = "string" == typeof r.props.elementType ? index$2 : testAlwaysTrue;
    var n = r.props.poseConfig;
    return r.poseConfig = "function" == typeof n ? n(filterProps(e)) : n, r;
  }

  return __extends(e, t), e.prototype.getInitialPose = function () {
    var e = this.props,
        n = e.getInitialPoseFromParent,
        r = e.pose,
        t = e._pose,
        a = e.initialPose;
    if (a) return a;
    var i = n && n(),
        A = (Array.isArray(i) ? i : [i]).concat(r, t).filter(Boolean);
    return 0 < A.length ? A : void 0;
  }, e.prototype.getFirstPose = function () {
    var e = this.props,
        n = e.initialPose,
        r = e.pose,
        t = e._pose;

    if (n) {
      var a = (Array.isArray(r) ? r : [r]).concat(t).filter(Boolean);
      return 1 === a.length ? a[0] : a;
    }
  }, e.prototype.getSetProps = function () {
    var e = filterProps(this.props);
    return this.props.popFromFlow && this.ref && this.ref instanceof HTMLElement ? this.popStyle ? e.style = this.popStyle : (e.style = _assign({}, e.style, calcPopFromFlowStyle(this.ref)), this.popStyle = e.style) : this.popStyle = null, e;
  }, e.prototype.componentDidMount = function () {
    var n = this;
    invariant(this.ref instanceof Element, "No valid DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the ref to the host DOM node via the React.forwardRef function.");

    var e = this.props,
        r = e.onValueChange,
        t = e.registerChild,
        a = e.values,
        i = e.parentValues,
        A = e.onDragStart,
        o = e.onDragEnd,
        s = e.onPressStart,
        c = e.onPressEnd,
        l = _assign({}, this.poseConfig, {
      initialPose: this.getInitialPose(),
      values: a || this.poseConfig.values,
      parentValues: i ? objectToMap(i) : void 0,
      props: this.getSetProps(),
      onDragStart: A,
      onDragEnd: o,
      onPressStart: s,
      onPressEnd: c,
      onChange: r
    });

    t ? t({
      element: this.ref,
      poseConfig: l,
      onRegistered: function onRegistered(e) {
        return n.initPoser(e);
      }
    }) : this.initPoser(domPose$1(this.ref, l));
  }, e.prototype.getSnapshotBeforeUpdate = function () {
    var e = this.props,
        n = e.pose,
        r = e._pose;
    return (hasPose(n, "flip") || hasPose(r, "flip")) && this.poser.measure(), null;
  }, e.prototype.componentDidUpdate = function (e) {
    var n = this.props,
        r = n.pose,
        t = n._pose,
        a = n.poseKey;
    this.poser.setProps(this.getSetProps()), a === e.poseKey && !hasChanged(e.pose, r) && "flip" !== r || this.setPose(r), t === e._pose && "flip" !== t || this.setPose(t);
  }, e.prototype.componentWillUnmount = function () {
    if (this.poser) {
      var e = this.props.onUnmount;
      e && e(this.poser), this.poser.destroy();
    }
  }, e.prototype.initPoser = function (e) {
    this.poser = e, this.flushChildren();
    var n = this.getFirstPose();
    n && this.setPose(n);
  }, e.prototype.setPose = function (e) {
    var n = this,
        r = this.props.onPoseComplete,
        t = Array.isArray(e) ? e : [e];
    Promise.all(t.map(function (e) {
      return e && n.poser.set(e);
    })).then(function () {
      return r && r(e);
    });
  }, e.prototype.flushChildren = function () {
    var t = this;
    this.children.forEach(function (e) {
      var n = e.element,
          r = e.poseConfig;
      return (0, e.onRegistered)(t.poser.addChild(n, r));
    }), this.children.clear();
  }, e.prototype.render = function () {
    var e = this.props.elementType;
    return React__default.createElement(PoseParentProvider, {
      value: this.childrenHandlers
    }, React.createElement(e, pickAssign(this.shouldForwardProp, [this.getSetProps(), {
      ref: this.setRef
    }])));
  }, e;
}(React.PureComponent),
    supportedElements = ["a", "article", "aside", "audio", "b", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dialog", "div", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "i", "iframe", "img", "input", "label", "legend", "li", "nav", "object", "ol", "option", "p", "param", "picture", "pre", "progress", "q", "section", "select", "span", "strong", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "ul", "video", "circle", "clipPath", "defs", "ellipse", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"],
    componentCache = new Map(),
    createComponentFactory = function createComponentFactory(A) {
  function e(i) {
    return void 0 === i && (i = {}), React.forwardRef(function (e, n) {
      var r = e.withParent,
          t = void 0 === r || r,
          a = __rest(e, ["withParent"]);

      return warning(void 0 === a.innerRef, "innerRef is deprecated. Please use ref instead."), !t || a.parentValues ? React__default.createElement(PoseElement, _assign({
        poseConfig: i,
        innerRef: n,
        elementType: A
      }, a)) : React__default.createElement(PoseParentConsumer, null, function (e) {
        return React__default.createElement(PoseElement, _assign({
          poseConfig: i,
          elementType: A,
          innerRef: n
        }, a, e));
      });
    });
  }

  return componentCache.set(A, e), e;
},
    getComponentFactory = function getComponentFactory(e) {
  return componentCache.has(e) ? componentCache.get(e) : createComponentFactory(e);
},
    posed = function posed(e) {
  return getComponentFactory(e);
};

supportedElements.reduce(function (e, n) {
  return e[n] = createComponentFactory(n), e;
}, posed);

var getKey = function getKey(e) {
  return invariant(e && null !== e.key, "Every child of Transition must be given a unique key"), ("number" == typeof e.key ? e.key.toString() : e.key).replace(".$", "");
},
    prependProps = function prependProps(e, n) {
  return React.createElement(e.type, _assign({
    key: e.key,
    ref: e.ref
  }, n, e.props));
},
    handleTransition = function handleTransition(e, n) {
  var r = n.displayedChildren,
      t = n.finishedLeaving,
      a = n.hasInitialized,
      i = n.indexedChildren,
      A = n.scheduleChildRemoval,
      o = e.children,
      s = e.preEnterPose,
      c = e.enterPose,
      l = e.exitPose,
      u = e.animateOnMount,
      _ = (e.enterAfterExit, e.flipMove),
      d = (e.onRest, __rest(e, ["children", "preEnterPose", "enterPose", "exitPose", "animateOnMount", "enterAfterExit", "flipMove", "onRest"])),
      p = makeChildList(o),
      m = {
    displayedChildren: []
  };

  "production" !== process.env.NODE_ENV && warning(!d.onPoseComplete, "<Transition/> (or <PoseGroup/>) doesn't accept onPoseComplete prop.");
  var g = r.map(getKey),
      h = p.map(getKey),
      B = 0 !== Object.keys(d).length,
      f = new Set(h.filter(function (e) {
    return t.hasOwnProperty(e) || -1 === g.indexOf(e);
  }));
  f.forEach(function (e) {
    return delete t[e];
  });
  var C = [],
      b = {};
  g.forEach(function (e) {
    if (!f.has(e)) {
      var n = t.hasOwnProperty(e);
      !n && -1 !== h.indexOf(e) || (C.push(e), n || (t[e] = !1, b[e] = !0));
    }
  });
  var E = new Set(g.filter(function (e) {
    return !f.has(e) || -1 === C.indexOf(e);
  }));
  return p.forEach(function (e) {
    var n = {};
    f.has(e.key) ? ((a || u) && (n.initialPose = s), n._pose = c) : E.has(e.key) && _ ? n._pose = [c, "flip"] : n._pose = c;
    var r = React.cloneElement(e, n);
    i[e.key] = r, m.displayedChildren.push(B ? prependProps(r, d) : r);
  }), C.forEach(function (r) {
    var t = i[r],
        e = b[r] ? React.cloneElement(t, {
      _pose: l,
      onPoseComplete: function onPoseComplete(e) {
        e === l && A(r);
        var n = t.props.onPoseComplete;
        n && n(e);
      },
      popFromFlow: _
    }) : t,
        n = g.indexOf(r);
    i[t.key] = e, m.displayedChildren.splice(n, 0, B ? prependProps(e, d) : e);
  }), m;
},
    handleChildrenTransitions = function handleChildrenTransitions(e, n) {
  var r = handleTransition(e, n);
  return r.hasInitialized = !0, r;
},
    makeChildList = function makeChildList(e) {
  var n = [];
  return React.Children.forEach(e, function (e) {
    return e && n.push(e);
  }), n;
},
    Transition = function (e) {
  function n() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.state = {
      displayedChildren: [],
      finishedLeaving: {},
      hasInitialized: !1,
      indexedChildren: {},
      scheduleChildRemoval: function scheduleChildRemoval(e) {
        return n.removeChild(e);
      }
    }, n;
  }

  return __extends(n, e), n.prototype.removeChild = function (e) {
    var n = this.state,
        r = n.displayedChildren,
        t = n.finishedLeaving,
        a = this.props,
        i = a.enterAfterExit,
        A = a.onRest;

    if (t.hasOwnProperty(e) && (t[e] = !0, Object.keys(t).every(function (e) {
      return t[e];
    }))) {
      var o = r.filter(function (e) {
        return !t.hasOwnProperty(e.key);
      }),
          s = i ? _assign({
        finishedLeaving: {}
      }, handleChildrenTransitions(_assign({}, this.props, {
        enterAfterExit: !1
      }), _assign({}, this.state, {
        displayedChildren: o
      }))) : {
        finishedLeaving: {},
        displayedChildren: o
      };
      this.setState(s, A);
    }
  }, n.prototype.shouldComponentUpdate = function (e, n) {
    return this.state !== n;
  }, n.prototype.render = function () {
    return this.state.displayedChildren;
  }, n.defaultProps = {
    flipMove: !1,
    enterAfterExit: !1,
    preEnterPose: "exit",
    enterPose: "enter",
    exitPose: "exit"
  }, n.getDerivedStateFromProps = handleChildrenTransitions, n;
}(React.Component),
    PoseGroup = function (e) {
  function n() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(n, e), n.prototype.render = function () {
    return React.createElement(Transition, _assign({}, this.props));
  }, n.defaultProps = {
    flipMove: !0
  }, n;
}(React.Component),
    chance_1 = createCommonjsModule(function (B, f) {
  !function () {
    var i = 9007199254740992,
        a = "0123456789",
        A = "abcdefghijklmnopqrstuvwxyz",
        o = A.toUpperCase(),
        r = a + "abcdef";

    function t(e) {
      this.name = "UnsupportedError", this.message = e || "This feature is not supported on this platform";
    }

    (t.prototype = new Error()).constructor = t;
    var l = Array.prototype.slice;

    function s(e) {
      if (!(this instanceof s)) return e || (e = null), null === e ? new s() : new s(e);
      if ("function" == typeof e) return this.random = e, this;
      arguments.length && (this.seed = 0);

      for (var n = 0; n < arguments.length; n++) {
        var r = 0;
        if ("[object String]" === Object.prototype.toString.call(arguments[n])) for (var t = 0; t < arguments[n].length; t++) {
          for (var a = 0, i = 0; i < arguments[n].length; i++) {
            a = arguments[n].charCodeAt(i) + (a << 6) + (a << 16) - a;
          }

          r += a;
        } else r = arguments[n];
        this.seed += (arguments.length - n) * r;
      }

      return this.mt = this.mersenne_twister(this.seed), this.bimd5 = this.blueimp_md5(), this.random = function () {
        return this.mt.random(this.seed);
      }, this;
    }

    function g(e, n) {
      if (e = e || {}, n) for (var r in n) {
        void 0 === e[r] && (e[r] = n[r]);
      }
      return e;
    }

    function u(e, n) {
      if (e) throw new RangeError(n);
    }

    s.prototype.VERSION = "1.0.18";

    var e = function e() {
      throw new Error("No Base64 encoder available.");
    };

    function n(e) {
      return function () {
        return this.natural(e);
      };
    }

    "function" == typeof btoa ? e = btoa : "function" == typeof Buffer && (e = function e(_e) {
      return new Buffer(_e).toString("base64");
    }), s.prototype.bool = function (e) {
      return u((e = g(e, {
        likelihood: 50
      })).likelihood < 0 || 100 < e.likelihood, "Chance: Likelihood accepts values from 0 to 100."), 100 * this.random() < e.likelihood;
    }, s.prototype.animal = function (e) {
      return void 0 !== (e = g(e)).type ? (u(!this.get("animals")[e.type.toLowerCase()], "Please pick from desert, ocean, grassland, forest, zoo, pets, farm."), this.pick(this.get("animals")[e.type.toLowerCase()])) : (animalTypeArray = ["desert", "forest", "ocean", "zoo", "farm", "pet", "grassland"], this.pick(this.get("animals")[this.pick(animalTypeArray)]));
    }, s.prototype.character = function (e) {
      var n,
          r,
          t = "!@#$%^&*()[]";
      return n = "lower" === (e = g(e)).casing ? A : "upper" === e.casing ? o : A + o, e.pool ? r = e.pool : (r = "", e.alpha && (r += n), e.numeric && (r += a), e.symbols && (r += t), r || (r = n + a + t)), r.charAt(this.natural({
        max: r.length - 1
      }));
    }, s.prototype.floating = function (e) {
      u((e = g(e, {
        fixed: 4
      })).fixed && e.precision, "Chance: Cannot specify both fixed and precision.");
      var n = Math.pow(10, e.fixed),
          r = i / n,
          t = -r;
      u(e.min && e.fixed && e.min < t, "Chance: Min specified is out of range with fixed. Min should be, at least, " + t), u(e.max && e.fixed && e.max > r, "Chance: Max specified is out of range with fixed. Max should be, at most, " + r), e = g(e, {
        min: t,
        max: r
      });
      var a = (this.integer({
        min: e.min * n,
        max: e.max * n
      }) / n).toFixed(e.fixed);
      return parseFloat(a);
    }, s.prototype.integer = function (e) {
      return u((e = g(e, {
        min: -9007199254740992,
        max: i
      })).min > e.max, "Chance: Min cannot be greater than Max."), Math.floor(this.random() * (e.max - e.min + 1) + e.min);
    }, s.prototype.natural = function (e) {
      return "number" == typeof (e = g(e, {
        min: 0,
        max: i
      })).numerals && (u(e.numerals < 1, "Chance: Numerals cannot be less than one."), e.min = Math.pow(10, e.numerals - 1), e.max = Math.pow(10, e.numerals) - 1), u(e.min < 0, "Chance: Min cannot be less than zero."), this.integer(e);
    }, s.prototype.prime = function (n) {
      u((n = g(n, {
        min: 0,
        max: 1e4
      })).min < 0, "Chance: Min cannot be less than zero."), u(n.min > n.max, "Chance: Min cannot be greater than Max.");
      var e = c.primes[c.primes.length - 1];
      if (n.max > e) for (var r = e + 2; r <= n.max; ++r) {
        this.is_prime(r) && c.primes.push(r);
      }
      var t = c.primes.filter(function (e) {
        return e >= n.min && e <= n.max;
      });
      return this.pick(t);
    }, s.prototype.is_prime = function (e) {
      if (e % 1 || e < 2) return !1;
      if (e % 2 == 0) return 2 === e;
      if (e % 3 == 0) return 3 === e;

      for (var n = Math.sqrt(e), r = 5; r <= n; r += 6) {
        if (e % r == 0 || e % (r + 2) == 0) return !1;
      }

      return !0;
    }, s.prototype.hex = function (e) {
      u((e = g(e, {
        min: 0,
        max: i,
        casing: "lower"
      })).min < 0, "Chance: Min cannot be less than zero.");
      var n = this.natural({
        min: e.min,
        max: e.max
      });
      return "upper" === e.casing ? n.toString(16).toUpperCase() : n.toString(16);
    }, s.prototype.letter = function (e) {
      e = g(e, {
        casing: "lower"
      });
      var n = this.character({
        pool: "abcdefghijklmnopqrstuvwxyz"
      });
      return "upper" === e.casing && (n = n.toUpperCase()), n;
    }, s.prototype.string = function (e) {
      u((e = g(e, {
        length: this.natural({
          min: 5,
          max: 20
        })
      })).length < 0, "Chance: Length cannot be less than zero.");
      var n = e.length;
      return this.n(this.character, n, e).join("");
    }, s.prototype.buffer = function (e) {
      if ("undefined" == typeof Buffer) throw new t("Sorry, the buffer() function is not supported on your platform");
      u((e = g(e, {
        length: this.natural({
          min: 5,
          max: 20
        })
      })).length < 0, "Chance: Length cannot be less than zero.");
      var n = e.length,
          r = this.n(this.character, n, e);
      return Buffer.from(r);
    }, s.prototype.capitalize = function (e) {
      return e.charAt(0).toUpperCase() + e.substr(1);
    }, s.prototype.mixin = function (e) {
      for (var n in e) {
        s.prototype[n] = e[n];
      }

      return this;
    }, s.prototype.unique = function (e, n, r) {
      u("function" != typeof e, "Chance: The first argument must be a function.");

      var t = function t(e, n) {
        return -1 !== e.indexOf(n);
      };

      r && (t = r.comparator || t);

      for (var a, i = [], A = 0, o = 50 * n, s = l.call(arguments, 2); i.length < n;) {
        var c = JSON.parse(JSON.stringify(s));
        if (t(i, a = e.apply(this, c)) || (i.push(a), A = 0), ++A > o) throw new RangeError("Chance: num is likely too large for sample set");
      }

      return i;
    }, s.prototype.n = function (e, n) {
      u("function" != typeof e, "Chance: The first argument must be a function."), void 0 === n && (n = 1);
      var r = n,
          t = [],
          a = l.call(arguments, 2);

      for (r = Math.max(0, r); r--;) {
        t.push(e.apply(this, a));
      }

      return t;
    }, s.prototype.pad = function (e, n, r) {
      return r = r || "0", (e += "").length >= n ? e : new Array(n - e.length + 1).join(r) + e;
    }, s.prototype.pick = function (e, n) {
      if (0 === e.length) throw new RangeError("Chance: Cannot pick() from an empty array");
      return n && 1 !== n ? this.shuffle(e).slice(0, n) : e[this.natural({
        max: e.length - 1
      })];
    }, s.prototype.pickone = function (e) {
      if (0 === e.length) throw new RangeError("Chance: Cannot pickone() from an empty array");
      return e[this.natural({
        max: e.length - 1
      })];
    }, s.prototype.pickset = function (e, n) {
      if (0 === n) return [];
      if (0 === e.length) throw new RangeError("Chance: Cannot pickset() from an empty array");
      if (n < 0) throw new RangeError("Chance: Count must be a positive number");

      if (n && 1 !== n) {
        var r = e.slice(0),
            t = r.length;
        return this.n(function () {
          var e = this.natural({
            max: --t
          }),
              n = r[e];
          return r[e] = r[t], n;
        }, Math.min(t, n));
      }

      return [this.pickone(e)];
    }, s.prototype.shuffle = function (e) {
      for (var n, r = [], t = 0, a = Number(e.length), i = function (e) {
        return Array.apply(null, Array(e)).map(function (e, n) {
          return n;
        });
      }(a), A = a - 1, o = 0; o < a; o++) {
        t = i[n = this.natural({
          max: A
        })], r[o] = e[t], i[n] = i[A], A -= 1;
      }

      return r;
    }, s.prototype.weighted = function (e, n, r) {
      if (e.length !== n.length) throw new RangeError("Chance: Length of array and weights must match");

      for (var t, a = 0, i = 0; i < n.length; ++i) {
        if (t = n[i], isNaN(t)) throw new RangeError("Chance: All weights must be numbers");
        0 < t && (a += t);
      }

      if (0 === a) throw new RangeError("Chance: No valid entries in array weights");
      var A,
          o = this.random() * a,
          s = 0,
          c = -1;

      for (i = 0; i < n.length; ++i) {
        if (s += t = n[i], 0 < t) {
          if (o <= s) {
            A = i;
            break;
          }

          c = i;
        }

        i === n.length - 1 && (A = c);
      }

      var l = e[A];
      return (r = void 0 !== r && r) && (e.splice(A, 1), n.splice(A, 1)), l;
    }, s.prototype.paragraph = function (e) {
      var n = (e = g(e)).sentences || this.natural({
        min: 3,
        max: 7
      });
      return this.n(this.sentence, n).join(" ");
    }, s.prototype.sentence = function (e) {
      var n,
          r = (e = g(e)).words || this.natural({
        min: 12,
        max: 18
      }),
          t = e.punctuation;
      return n = this.n(this.word, r).join(" "), n = this.capitalize(n), !1 === t || /^[\.\?;!:]$/.test(t) || (t = "."), t && (n += t), n;
    }, s.prototype.syllable = function (e) {
      for (var n, r = (e = g(e)).length || this.natural({
        min: 2,
        max: 3
      }), t = "bcdfghjklmnprstvwz", a = "", i = 0; i < r; i++) {
        a += n = 0 === i ? this.character({
          pool: "bcdfghjklmnprstvwzaeiou"
        }) : -1 === t.indexOf(n) ? this.character({
          pool: t
        }) : this.character({
          pool: "aeiou"
        });
      }

      return e.capitalize && (a = this.capitalize(a)), a;
    }, s.prototype.word = function (e) {
      u((e = g(e)).syllables && e.length, "Chance: Cannot specify both syllables AND length.");
      var n = e.syllables || this.natural({
        min: 1,
        max: 3
      }),
          r = "";

      if (e.length) {
        for (; (r += this.syllable()).length < e.length;) {
          ;
        }

        r = r.substring(0, e.length);
      } else for (var t = 0; t < n; t++) {
        r += this.syllable();
      }

      return e.capitalize && (r = this.capitalize(r)), r;
    }, s.prototype.age = function (e) {
      var n;

      switch ((e = g(e)).type) {
        case "child":
          n = {
            min: 0,
            max: 12
          };
          break;

        case "teen":
          n = {
            min: 13,
            max: 19
          };
          break;

        case "adult":
          n = {
            min: 18,
            max: 65
          };
          break;

        case "senior":
          n = {
            min: 65,
            max: 100
          };
          break;

        case "all":
          n = {
            min: 0,
            max: 100
          };
          break;

        default:
          n = {
            min: 18,
            max: 65
          };
      }

      return this.natural(n);
    }, s.prototype.birthday = function (e) {
      var n = this.age(e),
          r = new Date().getFullYear();

      if (e && e.type) {
        var t = new Date(),
            a = new Date();
        t.setFullYear(r - n - 1), a.setFullYear(r - n), e = g(e, {
          min: t,
          max: a
        });
      } else e = g(e, {
        year: r - n
      });

      return this.date(e);
    }, s.prototype.cpf = function (e) {
      e = g(e, {
        formatted: !0
      });
      var n = this.n(this.natural, 9, {
        max: 9
      }),
          r = 2 * n[8] + 3 * n[7] + 4 * n[6] + 5 * n[5] + 6 * n[4] + 7 * n[3] + 8 * n[2] + 9 * n[1] + 10 * n[0];
      10 <= (r = 11 - r % 11) && (r = 0);
      var t = 2 * r + 3 * n[8] + 4 * n[7] + 5 * n[6] + 6 * n[5] + 7 * n[4] + 8 * n[3] + 9 * n[2] + 10 * n[1] + 11 * n[0];
      10 <= (t = 11 - t % 11) && (t = 0);
      var a = "" + n[0] + n[1] + n[2] + "." + n[3] + n[4] + n[5] + "." + n[6] + n[7] + n[8] + "-" + r + t;
      return e.formatted ? a : a.replace(/\D/g, "");
    }, s.prototype.cnpj = function (e) {
      e = g(e, {
        formatted: !0
      });
      var n = this.n(this.natural, 12, {
        max: 12
      }),
          r = 2 * n[11] + 3 * n[10] + 4 * n[9] + 5 * n[8] + 6 * n[7] + 7 * n[6] + 8 * n[5] + 9 * n[4] + 2 * n[3] + 3 * n[2] + 4 * n[1] + 5 * n[0];
      (r = 11 - r % 11) < 2 && (r = 0);
      var t = 2 * r + 3 * n[11] + 4 * n[10] + 5 * n[9] + 6 * n[8] + 7 * n[7] + 8 * n[6] + 9 * n[5] + 2 * n[4] + 3 * n[3] + 4 * n[2] + 5 * n[1] + 6 * n[0];
      (t = 11 - t % 11) < 2 && (t = 0);
      var a = "" + n[0] + n[1] + "." + n[2] + n[3] + n[4] + "." + n[5] + n[6] + n[7] + "/" + n[8] + n[9] + n[10] + n[11] + "-" + r + t;
      return e.formatted ? a : a.replace(/\D/g, "");
    }, s.prototype.first = function (e) {
      return e = g(e, {
        gender: this.gender(),
        nationality: "en"
      }), this.pick(this.get("firstNames")[e.gender.toLowerCase()][e.nationality.toLowerCase()]);
    }, s.prototype.profession = function (e) {
      return (e = g(e)).rank ? this.pick(["Apprentice ", "Junior ", "Senior ", "Lead "]) + this.pick(this.get("profession")) : this.pick(this.get("profession"));
    }, s.prototype.company = function () {
      return this.pick(this.get("company"));
    }, s.prototype.gender = function (e) {
      return e = g(e, {
        extraGenders: []
      }), this.pick(["Male", "Female"].concat(e.extraGenders));
    }, s.prototype.last = function (e) {
      if ("*" !== (e = g(e, {
        nationality: "*"
      })).nationality) return this.pick(this.get("lastNames")[e.nationality.toLowerCase()]);
      var n = [],
          r = this.get("lastNames");
      return Object.keys(r).forEach(function (e) {
        n = n.concat(r[e]);
      }), this.pick(n);
    }, s.prototype.israelId = function () {
      for (var e = this.string({
        pool: "0123456789",
        length: 8
      }), n = 0, r = 0; r < e.length; r++) {
        var t = e[r] * (r / 2 === parseInt(r / 2) ? 1 : 2);
        t = this.pad(t, 2).toString(), n += t = parseInt(t[0]) + parseInt(t[1]);
      }

      return e += (10 - parseInt(n.toString().slice(-1))).toString().slice(-1);
    }, s.prototype.mrz = function (e) {
      function n(e) {
        var t = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(""),
            a = [7, 3, 1],
            i = 0;
        return "string" != typeof e && (e = e.toString()), e.split("").forEach(function (e, n) {
          var r = t.indexOf(e);
          e = -1 !== r ? 0 === r ? 0 : r + 9 : parseInt(e, 10), i += e *= a[n % a.length];
        }), i % 10;
      }

      var r,
          t,
          a,
          i,
          A = this;
      return e = g(e, {
        first: this.first(),
        last: this.last(),
        passportNumber: this.integer({
          min: 1e8,
          max: 999999999
        }),
        dob: (t = A.birthday({
          type: "adult"
        }), [t.getFullYear().toString().substr(2), A.pad(t.getMonth() + 1, 2), A.pad(t.getDate(), 2)].join("")),
        expiry: (r = new Date(), [(r.getFullYear() + 5).toString().substr(2), A.pad(r.getMonth() + 1, 2), A.pad(r.getDate(), 2)].join("")),
        gender: "Female" === this.gender() ? "F" : "M",
        issuer: "GBR",
        nationality: "GBR"
      }), (i = ["P<", (a = e).issuer, a.last.toUpperCase(), "<<", a.first.toUpperCase(), o(39 - (a.last.length + a.first.length + 2)), a.passportNumber, n(a.passportNumber), a.nationality, a.dob, n(a.dob), a.gender, a.expiry, n(a.expiry), o(14), n(o(14))].join("")) + n(i.substr(44, 10) + i.substr(57, 7) + i.substr(65, 7));

      function o(e) {
        return new Array(e + 1).join("<");
      }
    }, s.prototype.name = function (e) {
      e = g(e);
      var n,
          r = this.first(e),
          t = this.last(e);
      return n = e.middle ? r + " " + this.first(e) + " " + t : e.middle_initial ? r + " " + this.character({
        alpha: !0,
        casing: "upper"
      }) + ". " + t : r + " " + t, e.prefix && (n = this.prefix(e) + " " + n), e.suffix && (n = n + " " + this.suffix(e)), n;
    }, s.prototype.name_prefixes = function (e) {
      var n = [{
        name: "Doctor",
        abbreviation: "Dr."
      }];
      return "male" !== (e = (e = e || "all").toLowerCase()) && "all" !== e || n.push({
        name: "Mister",
        abbreviation: "Mr."
      }), "female" !== e && "all" !== e || (n.push({
        name: "Miss",
        abbreviation: "Miss"
      }), n.push({
        name: "Misses",
        abbreviation: "Mrs."
      })), n;
    }, s.prototype.prefix = function (e) {
      return this.name_prefix(e);
    }, s.prototype.name_prefix = function (e) {
      return (e = g(e, {
        gender: "all"
      })).full ? this.pick(this.name_prefixes(e.gender)).name : this.pick(this.name_prefixes(e.gender)).abbreviation;
    }, s.prototype.HIDN = function () {
      var e = "";
      return e += this.string({
        pool: "0123456789",
        length: 6
      }), e += this.string({
        pool: "ABCDEFGHIJKLMNOPQRSTUVWXYXZ",
        length: 2
      });
    }, s.prototype.ssn = function (e) {
      var n = "1234567890",
          r = (e = g(e, {
        ssnFour: !1,
        dashes: !0
      })).dashes ? "-" : "";
      return e.ssnFour ? this.string({
        pool: n,
        length: 4
      }) : this.string({
        pool: n,
        length: 3
      }) + r + this.string({
        pool: n,
        length: 2
      }) + r + this.string({
        pool: n,
        length: 4
      });
    }, s.prototype.aadhar = function (e) {
      var n = "1234567890",
          r = (e = g(e, {
        onlyLastFour: !1,
        separatedByWhiteSpace: !0
      })).separatedByWhiteSpace ? " " : "";
      return e.onlyLastFour ? this.string({
        pool: n,
        length: 4
      }) : this.string({
        pool: n,
        length: 4
      }) + r + this.string({
        pool: n,
        length: 4
      }) + r + this.string({
        pool: n,
        length: 4
      });
    }, s.prototype.name_suffixes = function () {
      return [{
        name: "Doctor of Osteopathic Medicine",
        abbreviation: "D.O."
      }, {
        name: "Doctor of Philosophy",
        abbreviation: "Ph.D."
      }, {
        name: "Esquire",
        abbreviation: "Esq."
      }, {
        name: "Junior",
        abbreviation: "Jr."
      }, {
        name: "Juris Doctor",
        abbreviation: "J.D."
      }, {
        name: "Master of Arts",
        abbreviation: "M.A."
      }, {
        name: "Master of Business Administration",
        abbreviation: "M.B.A."
      }, {
        name: "Master of Science",
        abbreviation: "M.S."
      }, {
        name: "Medical Doctor",
        abbreviation: "M.D."
      }, {
        name: "Senior",
        abbreviation: "Sr."
      }, {
        name: "The Third",
        abbreviation: "III"
      }, {
        name: "The Fourth",
        abbreviation: "IV"
      }, {
        name: "Bachelor of Engineering",
        abbreviation: "B.E"
      }, {
        name: "Bachelor of Technology",
        abbreviation: "B.TECH"
      }];
    }, s.prototype.suffix = function (e) {
      return this.name_suffix(e);
    }, s.prototype.name_suffix = function (e) {
      return (e = g(e)).full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
    }, s.prototype.nationalities = function () {
      return this.get("nationalities");
    }, s.prototype.nationality = function () {
      return this.pick(this.nationalities()).name;
    }, s.prototype.android_id = function () {
      return "APA91" + this.string({
        pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_",
        length: 178
      });
    }, s.prototype.apple_token = function () {
      return this.string({
        pool: "abcdef1234567890",
        length: 64
      });
    }, s.prototype.wp8_anid2 = function () {
      return e(this.hash({
        length: 32
      }));
    }, s.prototype.wp7_anid = function () {
      return "A=" + this.guid().replace(/-/g, "").toUpperCase() + "&E=" + this.hash({
        length: 3
      }) + "&W=" + this.integer({
        min: 0,
        max: 9
      });
    }, s.prototype.bb_pin = function () {
      return this.hash({
        length: 8
      });
    }, s.prototype.avatar = function (e) {
      var n = {
        protocol: null,
        email: null,
        fileExtension: null,
        size: null,
        fallback: null,
        rating: null
      };
      if (e) {
        if ("string" == typeof e) n.email = e, e = {};else {
          if ("object" != typeof e) return null;
          if ("Array" === e.constructor) return null;
        }
      } else n.email = this.email(), e = {};
      return (n = g(e, n)).email || (n.email = this.email()), n.protocol = {
        http: "http",
        https: "https"
      }[n.protocol] ? n.protocol + ":" : "", n.size = parseInt(n.size, 0) ? n.size : "", n.rating = {
        g: "g",
        pg: "pg",
        r: "r",
        x: "x"
      }[n.rating] ? n.rating : "", n.fallback = {
        404: "404",
        mm: "mm",
        identicon: "identicon",
        monsterid: "monsterid",
        wavatar: "wavatar",
        retro: "retro",
        blank: "blank"
      }[n.fallback] ? n.fallback : "", n.fileExtension = {
        bmp: "bmp",
        gif: "gif",
        jpg: "jpg",
        png: "png"
      }[n.fileExtension] ? n.fileExtension : "", n.protocol + "//www.gravatar.com/avatar/" + this.bimd5.md5(n.email) + (n.fileExtension ? "." + n.fileExtension : "") + (n.size || n.rating || n.fallback ? "?" : "") + (n.size ? "&s=" + n.size.toString() : "") + (n.rating ? "&r=" + n.rating : "") + (n.fallback ? "&d=" + n.fallback : "");
    }, s.prototype.color = function (i) {
      function A(e, n) {
        return [e, e, e].join(n || "");
      }

      function e(e) {
        var n = e ? "rgba" : "rgb",
            r = e ? "," + this.floating({
          min: t,
          max: a
        }) : "";
        return n + "(" + (o ? A(this.natural({
          min: s,
          max: c
        }), ",") : this.natural({
          min: _,
          max: d
        }) + "," + this.natural({
          min: p,
          max: m
        }) + "," + this.natural({
          max: 255
        })) + r + ")";
      }

      function n(e, n, r) {
        var t = r ? "#" : "",
            a = "";
        return o ? (a = A(this.pad(this.hex({
          min: s,
          max: c
        }), 2)), "shorthex" === i.format && (a = A(this.hex({
          min: 0,
          max: 15
        })))) : a = "shorthex" === i.format ? this.pad(this.hex({
          min: Math.floor(l / 16),
          max: Math.floor(u / 16)
        }), 1) + this.pad(this.hex({
          min: Math.floor(_ / 16),
          max: Math.floor(d / 16)
        }), 1) + this.pad(this.hex({
          min: Math.floor(p / 16),
          max: Math.floor(m / 16)
        }), 1) : void 0 !== l || void 0 !== u || void 0 !== _ || void 0 !== d || void 0 !== p || void 0 !== m ? this.pad(this.hex({
          min: l,
          max: u
        }), 2) + this.pad(this.hex({
          min: _,
          max: d
        }), 2) + this.pad(this.hex({
          min: p,
          max: m
        }), 2) : this.pad(this.hex({
          min: s,
          max: c
        }), 2) + this.pad(this.hex({
          min: s,
          max: c
        }), 2) + this.pad(this.hex({
          min: s,
          max: c
        }), 2), t + a;
      }

      var r,
          o = (i = g(i, {
        format: this.pick(["hex", "shorthex", "rgb", "rgba", "0x", "name"]),
        grayscale: !1,
        casing: "lower",
        min: 0,
        max: 255,
        min_red: void 0,
        max_red: void 0,
        min_green: void 0,
        max_green: void 0,
        min_blue: void 0,
        max_blue: void 0,
        min_alpha: 0,
        max_alpha: 1
      })).grayscale,
          s = i.min,
          c = i.max,
          l = i.min_red,
          u = i.max_red,
          _ = i.min_green,
          d = i.max_green,
          p = i.min_blue,
          m = i.max_blue,
          t = i.min_alpha,
          a = i.max_alpha;
      if (void 0 === i.min_red && (l = s), void 0 === i.max_red && (u = c), void 0 === i.min_green && (_ = s), void 0 === i.max_green && (d = c), void 0 === i.min_blue && (p = s), void 0 === i.max_blue && (m = c), void 0 === i.min_alpha && (t = 0), void 0 === i.max_alpha && (a = 1), o && 0 === s && 255 === c && void 0 !== l && void 0 !== u && (s = (l + _ + p) / 3, c = (u + d + m) / 3), "hex" === i.format) r = n.call(this, 2, 6, !0);else if ("shorthex" === i.format) r = n.call(this, 1, 3, !0);else if ("rgb" === i.format) r = e.call(this, !1);else if ("rgba" === i.format) r = e.call(this, !0);else {
        if ("0x" !== i.format) {
          if ("name" === i.format) return this.pick(this.get("colorNames"));
          throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        }

        r = "0x" + n.call(this, 2, 6);
      }
      return "upper" === i.casing && (r = r.toUpperCase()), r;
    }, s.prototype.domain = function (e) {
      return e = g(e), this.word() + "." + (e.tld || this.tld());
    }, s.prototype.email = function (e) {
      return e = g(e), this.word({
        length: e.length
      }) + "@" + (e.domain || this.domain());
    }, s.prototype.fbid = function () {
      return "10000" + this.string({
        pool: "1234567890",
        length: 11
      });
    }, s.prototype.google_analytics = function () {
      return "UA-" + this.pad(this.natural({
        max: 999999
      }), 6) + "-" + this.pad(this.natural({
        max: 99
      }), 2);
    }, s.prototype.hashtag = function () {
      return "#" + this.word();
    }, s.prototype.ip = function () {
      return this.natural({
        min: 1,
        max: 254
      }) + "." + this.natural({
        max: 255
      }) + "." + this.natural({
        max: 255
      }) + "." + this.natural({
        min: 1,
        max: 254
      });
    }, s.prototype.ipv6 = function () {
      return this.n(this.hash, 8, {
        length: 4
      }).join(":");
    }, s.prototype.klout = function () {
      return this.natural({
        min: 1,
        max: 99
      });
    }, s.prototype.semver = function (e) {
      e = g(e, {
        include_prerelease: !0
      });
      var n = this.pickone(["^", "~", "<", ">", "<=", ">=", "="]);
      e.range && (n = e.range);
      var r = "";
      return e.include_prerelease && (r = this.weighted(["", "-dev", "-beta", "-alpha"], [50, 10, 5, 1])), n + this.rpg("3d10").join(".") + r;
    }, s.prototype.tlds = function () {
      return ["com", "org", "edu", "gov", "co.uk", "net", "io", "ac", "ad", "ae", "af", "ag", "ai", "al", "am", "an", "ao", "aq", "ar", "as", "at", "au", "aw", "ax", "az", "ba", "bb", "bd", "be", "bf", "bg", "bh", "bi", "bj", "bm", "bn", "bo", "bq", "br", "bs", "bt", "bv", "bw", "by", "bz", "ca", "cc", "cd", "cf", "cg", "ch", "ci", "ck", "cl", "cm", "cn", "co", "cr", "cu", "cv", "cw", "cx", "cy", "cz", "de", "dj", "dk", "dm", "do", "dz", "ec", "ee", "eg", "eh", "er", "es", "et", "eu", "fi", "fj", "fk", "fm", "fo", "fr", "ga", "gb", "gd", "ge", "gf", "gg", "gh", "gi", "gl", "gm", "gn", "gp", "gq", "gr", "gs", "gt", "gu", "gw", "gy", "hk", "hm", "hn", "hr", "ht", "hu", "id", "ie", "il", "im", "in", "io", "iq", "ir", "is", "it", "je", "jm", "jo", "jp", "ke", "kg", "kh", "ki", "km", "kn", "kp", "kr", "kw", "ky", "kz", "la", "lb", "lc", "li", "lk", "lr", "ls", "lt", "lu", "lv", "ly", "ma", "mc", "md", "me", "mg", "mh", "mk", "ml", "mm", "mn", "mo", "mp", "mq", "mr", "ms", "mt", "mu", "mv", "mw", "mx", "my", "mz", "na", "nc", "ne", "nf", "ng", "ni", "nl", "no", "np", "nr", "nu", "nz", "om", "pa", "pe", "pf", "pg", "ph", "pk", "pl", "pm", "pn", "pr", "ps", "pt", "pw", "py", "qa", "re", "ro", "rs", "ru", "rw", "sa", "sb", "sc", "sd", "se", "sg", "sh", "si", "sj", "sk", "sl", "sm", "sn", "so", "sr", "ss", "st", "su", "sv", "sx", "sy", "sz", "tc", "td", "tf", "tg", "th", "tj", "tk", "tl", "tm", "tn", "to", "tp", "tr", "tt", "tv", "tw", "tz", "ua", "ug", "uk", "us", "uy", "uz", "va", "vc", "ve", "vg", "vi", "vn", "vu", "wf", "ws", "ye", "yt", "za", "zm", "zw"];
    }, s.prototype.tld = function () {
      return this.pick(this.tlds());
    }, s.prototype.twitter = function () {
      return "@" + this.word();
    }, s.prototype.url = function (e) {
      var n = 0 < (e = g(e, {
        protocol: "http",
        domain: this.domain(e),
        domain_prefix: "",
        path: this.word(),
        extensions: []
      })).extensions.length ? "." + this.pick(e.extensions) : "",
          r = e.domain_prefix ? e.domain_prefix + "." + e.domain : e.domain;
      return e.protocol + "://" + r + "/" + e.path + n;
    }, s.prototype.port = function () {
      return this.integer({
        min: 0,
        max: 65535
      });
    }, s.prototype.locale = function (e) {
      return (e = g(e)).region ? this.pick(this.get("locale_regions")) : this.pick(this.get("locale_languages"));
    }, s.prototype.locales = function (e) {
      return (e = g(e)).region ? this.get("locale_regions") : this.get("locale_languages");
    }, s.prototype.loremPicsum = function (e) {
      var n = (e = g(e, {
        width: 500,
        height: 500,
        greyscale: !1,
        blurred: !1
      })).greyscale ? "g/" : "",
          r = e.blurred ? "/?blur" : "/?random";
      return "https://picsum.photos/" + n + e.width + "/" + e.height + r;
    }, s.prototype.address = function (e) {
      return e = g(e), this.natural({
        min: 5,
        max: 2e3
      }) + " " + this.street(e);
    }, s.prototype.altitude = function (e) {
      return e = g(e, {
        fixed: 5,
        min: 0,
        max: 8848
      }), this.floating({
        min: e.min,
        max: e.max,
        fixed: e.fixed
      });
    }, s.prototype.areacode = function (e) {
      e = g(e, {
        parens: !0
      });
      var n = this.natural({
        min: 2,
        max: 9
      }).toString() + this.natural({
        min: 0,
        max: 8
      }).toString() + this.natural({
        min: 0,
        max: 9
      }).toString();
      return e.parens ? "(" + n + ")" : n;
    }, s.prototype.city = function () {
      return this.capitalize(this.word({
        syllables: 3
      }));
    }, s.prototype.coordinates = function (e) {
      return this.latitude(e) + ", " + this.longitude(e);
    }, s.prototype.countries = function () {
      return this.get("countries");
    }, s.prototype.country = function (e) {
      e = g(e);
      var n = this.pick(this.countries());
      return e.raw ? n : e.full ? n.name : n.abbreviation;
    }, s.prototype.depth = function (e) {
      return e = g(e, {
        fixed: 5,
        min: -10994,
        max: 0
      }), this.floating({
        min: e.min,
        max: e.max,
        fixed: e.fixed
      });
    }, s.prototype.geohash = function (e) {
      return e = g(e, {
        length: 7
      }), this.string({
        length: e.length,
        pool: "0123456789bcdefghjkmnpqrstuvwxyz"
      });
    }, s.prototype.geojson = function (e) {
      return this.latitude(e) + ", " + this.longitude(e) + ", " + this.altitude(e);
    }, s.prototype.latitude = function (e) {
      return e = g(e, {
        fixed: 5,
        min: -90,
        max: 90
      }), this.floating({
        min: e.min,
        max: e.max,
        fixed: e.fixed
      });
    }, s.prototype.longitude = function (e) {
      return e = g(e, {
        fixed: 5,
        min: -180,
        max: 180
      }), this.floating({
        min: e.min,
        max: e.max,
        fixed: e.fixed
      });
    }, s.prototype.phone = function (e) {
      function n(e) {
        var n = [];
        return e.sections.forEach(function (e) {
          n.push(a.string({
            pool: "0123456789",
            length: e
          }));
        }), e.area + n.join(" ");
      }

      var r,
          t,
          a = this;

      switch ((e = g(e, {
        formatted: !0,
        country: "us",
        mobile: !1
      })).formatted || (e.parens = !1), e.country) {
        case "fr":
          t = (r = e.mobile ? this.pick(["06", "07"]) + a.string({
            pool: "0123456789",
            length: 8
          }) : this.pick(["01" + this.pick(["30", "34", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "53", "55", "56", "58", "60", "64", "69", "70", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "02" + this.pick(["14", "18", "22", "23", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "40", "41", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "56", "57", "61", "62", "69", "72", "76", "77", "78", "85", "90", "96", "97", "98", "99"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "03" + this.pick(["10", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "39", "44", "45", "51", "52", "54", "55", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "04" + this.pick(["11", "13", "15", "20", "22", "26", "27", "30", "32", "34", "37", "42", "43", "44", "50", "56", "57", "63", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "88", "89", "90", "91", "92", "93", "94", "95", "97", "98"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "05" + this.pick(["08", "16", "17", "19", "24", "31", "32", "33", "34", "35", "40", "45", "46", "47", "49", "53", "55", "56", "57", "58", "59", "61", "62", "63", "64", "65", "67", "79", "81", "82", "86", "87", "90", "94"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "09" + a.string({
            pool: "0123456789",
            length: 8
          })]), e.formatted ? r.match(/../g).join(" ") : r);
          break;

        case "uk":
          t = e.mobile ? (r = this.pick([{
            area: "07" + this.pick(["4", "5", "7", "8", "9"]),
            sections: [2, 6]
          }, {
            area: "07624 ",
            sections: [6]
          }]), e.formatted ? n(r) : n(r).replace(" ", "")) : (r = this.pick([{
            area: "01" + this.character({
              pool: "234569"
            }) + "1 ",
            sections: [3, 4]
          }, {
            area: "020 " + this.character({
              pool: "378"
            }),
            sections: [3, 4]
          }, {
            area: "023 " + this.character({
              pool: "89"
            }),
            sections: [3, 4]
          }, {
            area: "024 7",
            sections: [3, 4]
          }, {
            area: "028 " + this.pick(["25", "28", "37", "71", "82", "90", "92", "95"]),
            sections: [2, 4]
          }, {
            area: "012" + this.pick(["04", "08", "54", "76", "97", "98"]) + " ",
            sections: [6]
          }, {
            area: "013" + this.pick(["63", "64", "84", "86"]) + " ",
            sections: [6]
          }, {
            area: "014" + this.pick(["04", "20", "60", "61", "80", "88"]) + " ",
            sections: [6]
          }, {
            area: "015" + this.pick(["24", "27", "62", "66"]) + " ",
            sections: [6]
          }, {
            area: "016" + this.pick(["06", "29", "35", "47", "59", "95"]) + " ",
            sections: [6]
          }, {
            area: "017" + this.pick(["26", "44", "50", "68"]) + " ",
            sections: [6]
          }, {
            area: "018" + this.pick(["27", "37", "84", "97"]) + " ",
            sections: [6]
          }, {
            area: "019" + this.pick(["00", "05", "35", "46", "49", "63", "95"]) + " ",
            sections: [6]
          }]), e.formatted ? n(r) : n(r).replace(" ", "", "g"));
          break;

        case "za":
          t = (r = e.mobile ? this.pick(["060" + this.pick(["3", "4", "5", "6", "7", "8", "9"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "061" + this.pick(["0", "1", "2", "3", "4", "5", "8"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "06" + a.string({
            pool: "0123456789",
            length: 7
          }), "071" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]) + a.string({
            pool: "0123456789",
            length: 6
          }), "07" + this.pick(["2", "3", "4", "6", "7", "8", "9"]) + a.string({
            pool: "0123456789",
            length: 7
          }), "08" + this.pick(["0", "1", "2", "3", "4", "5"]) + a.string({
            pool: "0123456789",
            length: 7
          })]) : this.pick(["01" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8"]) + a.string({
            pool: "0123456789",
            length: 7
          }), "02" + this.pick(["1", "2", "3", "4", "7", "8"]) + a.string({
            pool: "0123456789",
            length: 7
          }), "03" + this.pick(["1", "2", "3", "5", "6", "9"]) + a.string({
            pool: "0123456789",
            length: 7
          }), "04" + this.pick(["1", "2", "3", "4", "5", "6", "7", "8", "9"]) + a.string({
            pool: "0123456789",
            length: 7
          }), "05" + this.pick(["1", "3", "4", "6", "7", "8"]) + a.string({
            pool: "0123456789",
            length: 7
          })]), e.formatted || r);
          break;

        case "us":
          var i = this.areacode(e).toString(),
              A = this.natural({
            min: 2,
            max: 9
          }).toString() + this.natural({
            min: 0,
            max: 9
          }).toString() + this.natural({
            min: 0,
            max: 9
          }).toString(),
              o = this.natural({
            min: 1e3,
            max: 9999
          }).toString();
          t = e.formatted ? i + " " + A + "-" + o : i + A + o;
          break;

        case "br":
          var s,
              c = this.pick(["11", "12", "13", "14", "15", "16", "17", "18", "19", "21", "22", "24", "27", "28", "31", "32", "33", "34", "35", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48", "49", "51", "53", "54", "55", "61", "62", "63", "64", "65", "66", "67", "68", "69", "71", "73", "74", "75", "77", "79", "81", "82", "83", "84", "85", "86", "87", "88", "89", "91", "92", "93", "94", "95", "96", "97", "98", "99"]);
          s = e.mobile ? "9" + a.string({
            pool: "0123456789",
            length: 4
          }) : this.natural({
            min: 2e3,
            max: 5999
          }).toString();
          var l = a.string({
            pool: "0123456789",
            length: 4
          });
          t = e.formatted ? "(" + c + ") " + s + "-" + l : c + s + l;
      }

      return t;
    }, s.prototype.postal = function () {
      return this.character({
        pool: "XVTSRPNKLMHJGECBA"
      }) + this.natural({
        max: 9
      }) + this.character({
        alpha: !0,
        casing: "upper"
      }) + " " + (this.natural({
        max: 9
      }) + this.character({
        alpha: !0,
        casing: "upper"
      }) + this.natural({
        max: 9
      }));
    }, s.prototype.postcode = function () {
      return this.pick(this.get("postcodeAreas")).code + this.natural({
        max: 9
      }) + (this.bool() ? this.character({
        alpha: !0,
        casing: "upper"
      }) : "") + " " + (this.natural({
        max: 9
      }) + (this.character({
        alpha: !0,
        casing: "upper"
      }) + this.character({
        alpha: !0,
        casing: "upper"
      })));
    }, s.prototype.counties = function (e) {
      return e = g(e, {
        country: "uk"
      }), this.get("counties")[e.country.toLowerCase()];
    }, s.prototype.county = function (e) {
      return this.pick(this.counties(e)).name;
    }, s.prototype.provinces = function (e) {
      return e = g(e, {
        country: "ca"
      }), this.get("provinces")[e.country.toLowerCase()];
    }, s.prototype.province = function (e) {
      return e && e.full ? this.pick(this.provinces(e)).name : this.pick(this.provinces(e)).abbreviation;
    }, s.prototype.state = function (e) {
      return e && e.full ? this.pick(this.states(e)).name : this.pick(this.states(e)).abbreviation;
    }, s.prototype.states = function (e) {
      var n;

      switch ((e = g(e, {
        country: "us",
        us_states_and_dc: !0
      })).country.toLowerCase()) {
        case "us":
          var r = this.get("us_states_and_dc"),
              t = this.get("territories"),
              a = this.get("armed_forces");
          n = [], e.us_states_and_dc && (n = n.concat(r)), e.territories && (n = n.concat(t)), e.armed_forces && (n = n.concat(a));
          break;

        case "it":
          n = this.get("country_regions")[e.country.toLowerCase()];
          break;

        case "uk":
          n = this.get("counties")[e.country.toLowerCase()];
      }

      return n;
    }, s.prototype.street = function (e) {
      var n;

      switch ((e = g(e, {
        country: "us",
        syllables: 2
      })).country.toLowerCase()) {
        case "us":
          n = this.word({
            syllables: e.syllables
          }), n = this.capitalize(n), n += " ", n += e.short_suffix ? this.street_suffix(e).abbreviation : this.street_suffix(e).name;
          break;

        case "it":
          n = this.word({
            syllables: e.syllables
          }), n = this.capitalize(n), n = (e.short_suffix ? this.street_suffix(e).abbreviation : this.street_suffix(e).name) + " " + n;
      }

      return n;
    }, s.prototype.street_suffix = function (e) {
      return e = g(e, {
        country: "us"
      }), this.pick(this.street_suffixes(e));
    }, s.prototype.street_suffixes = function (e) {
      return e = g(e, {
        country: "us"
      }), this.get("street_suffixes")[e.country.toLowerCase()];
    }, s.prototype.zip = function (e) {
      var n = this.n(this.natural, 5, {
        max: 9
      });
      return e && !0 === e.plusfour && (n.push("-"), n = n.concat(this.n(this.natural, 4, {
        max: 9
      }))), n.join("");
    }, s.prototype.ampm = function () {
      return this.bool() ? "am" : "pm";
    }, s.prototype.date = function (e) {
      var n, r;

      if (e && (e.min || e.max)) {
        var t = void 0 !== (e = g(e, {
          american: !0,
          string: !1
        })).min ? e.min.getTime() : 1,
            a = void 0 !== e.max ? e.max.getTime() : 864e13;
        r = new Date(this.integer({
          min: t,
          max: a
        }));
      } else {
        var i = this.month({
          raw: !0
        }),
            A = i.days;
        e && e.month && (A = this.get("months")[(e.month % 12 + 12) % 12].days), e = g(e, {
          year: parseInt(this.year(), 10),
          month: i.numeric - 1,
          day: this.natural({
            min: 1,
            max: A
          }),
          hour: this.hour({
            twentyfour: !0
          }),
          minute: this.minute(),
          second: this.second(),
          millisecond: this.millisecond(),
          american: !0,
          string: !1
        }), r = new Date(e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
      }

      return n = e.american ? r.getMonth() + 1 + "/" + r.getDate() + "/" + r.getFullYear() : r.getDate() + "/" + (r.getMonth() + 1) + "/" + r.getFullYear(), e.string ? n : r;
    }, s.prototype.hammertime = function (e) {
      return this.date(e).getTime();
    }, s.prototype.hour = function (e) {
      return u((e = g(e, {
        min: e && e.twentyfour ? 0 : 1,
        max: e && e.twentyfour ? 23 : 12
      })).min < 0, "Chance: Min cannot be less than 0."), u(e.twentyfour && 23 < e.max, "Chance: Max cannot be greater than 23 for twentyfour option."), u(!e.twentyfour && 12 < e.max, "Chance: Max cannot be greater than 12."), u(e.min > e.max, "Chance: Min cannot be greater than Max."), this.natural({
        min: e.min,
        max: e.max
      });
    }, s.prototype.millisecond = function () {
      return this.natural({
        max: 999
      });
    }, s.prototype.minute = s.prototype.second = function (e) {
      return u((e = g(e, {
        min: 0,
        max: 59
      })).min < 0, "Chance: Min cannot be less than 0."), u(59 < e.max, "Chance: Max cannot be greater than 59."), u(e.min > e.max, "Chance: Min cannot be greater than Max."), this.natural({
        min: e.min,
        max: e.max
      });
    }, s.prototype.month = function (e) {
      u((e = g(e, {
        min: 1,
        max: 12
      })).min < 1, "Chance: Min cannot be less than 1."), u(12 < e.max, "Chance: Max cannot be greater than 12."), u(e.min > e.max, "Chance: Min cannot be greater than Max.");
      var n = this.pick(this.months().slice(e.min - 1, e.max));
      return e.raw ? n : n.name;
    }, s.prototype.months = function () {
      return this.get("months");
    }, s.prototype.second = function () {
      return this.natural({
        max: 59
      });
    }, s.prototype.timestamp = function () {
      return this.natural({
        min: 1,
        max: parseInt(new Date().getTime() / 1e3, 10)
      });
    }, s.prototype.weekday = function (e) {
      var n = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
      return (e = g(e, {
        weekday_only: !1
      })).weekday_only || (n.push("Saturday"), n.push("Sunday")), this.pickone(n);
    }, s.prototype.year = function (e) {
      return (e = g(e, {
        min: new Date().getFullYear()
      })).max = void 0 !== e.max ? e.max : e.min + 100, this.natural(e).toString();
    }, s.prototype.cc = function (e) {
      var n, r, t;
      return r = (n = (e = g(e)).type ? this.cc_type({
        name: e.type,
        raw: !0
      }) : this.cc_type({
        raw: !0
      })).prefix.split(""), t = n.length - n.prefix.length - 1, (r = r.concat(this.n(this.integer, t, {
        min: 0,
        max: 9
      }))).push(this.luhn_calculate(r.join(""))), r.join("");
    }, s.prototype.cc_types = function () {
      return this.get("cc_types");
    }, s.prototype.cc_type = function (e) {
      e = g(e);
      var n = this.cc_types(),
          r = null;

      if (e.name) {
        for (var t = 0; t < n.length; t++) {
          if (n[t].name === e.name || n[t].short_name === e.name) {
            r = n[t];
            break;
          }
        }

        if (null === r) throw new RangeError("Chance: Credit card type '" + e.name + "' is not supported");
      } else r = this.pick(n);

      return e.raw ? r : r.name;
    }, s.prototype.currency_types = function () {
      return this.get("currency_types");
    }, s.prototype.currency = function () {
      return this.pick(this.currency_types());
    }, s.prototype.timezones = function () {
      return this.get("timezones");
    }, s.prototype.timezone = function () {
      return this.pick(this.timezones());
    }, s.prototype.currency_pair = function (e) {
      var n = this.unique(this.currency, 2, {
        comparator: function comparator(e, r) {
          return e.reduce(function (e, n) {
            return e || n.code === r.code;
          }, !1);
        }
      });
      return e ? n[0].code + "/" + n[1].code : n;
    }, s.prototype.dollar = function (e) {
      e = g(e, {
        max: 1e4,
        min: 0
      });
      var n = this.floating({
        min: e.min,
        max: e.max,
        fixed: 2
      }).toString(),
          r = n.split(".")[1];
      return void 0 === r ? n += ".00" : r.length < 2 && (n += "0"), n < 0 ? "-$" + n.replace("-", "") : "$" + n;
    }, s.prototype.euro = function (e) {
      return Number(this.dollar(e).replace("$", "")).toLocaleString() + "€";
    }, s.prototype.exp = function (e) {
      e = g(e);
      var n = {};
      return n.year = this.exp_year(), n.year === new Date().getFullYear().toString() ? n.month = this.exp_month({
        future: !0
      }) : n.month = this.exp_month(), e.raw ? n : n.month + "/" + n.year;
    }, s.prototype.exp_month = function (e) {
      e = g(e);
      var n,
          r = new Date().getMonth() + 1;
      if (e.future && 12 !== r) for (; n = this.month({
        raw: !0
      }).numeric, parseInt(n, 10) <= r;) {
        ;
      } else n = this.month({
        raw: !0
      }).numeric;
      return n;
    }, s.prototype.exp_year = function () {
      var e = new Date().getMonth() + 1,
          n = new Date().getFullYear();
      return this.year({
        min: 12 === e ? n + 1 : n,
        max: n + 10
      });
    }, s.prototype.vat = function (e) {
      switch ((e = g(e, {
        country: "it"
      })).country.toLowerCase()) {
        case "it":
          return this.it_vat();
      }
    }, s.prototype.iban = function () {
      var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      return this.string({
        length: 2,
        pool: e
      }) + this.pad(this.integer({
        min: 0,
        max: 99
      }), 2) + this.string({
        length: 4,
        pool: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
      }) + this.pad(this.natural(), this.natural({
        min: 6,
        max: 26
      }));
    }, s.prototype.it_vat = function () {
      var e = this.natural({
        min: 1,
        max: 18e5
      });
      return (e = this.pad(e, 7) + this.pad(this.pick(this.provinces({
        country: "it"
      })).code, 3)) + this.luhn_calculate(e);
    }, s.prototype.cf = function (e) {
      function n(e, n) {
        var r,
            t = [];
        return e.length < 3 ? t = e.split("").concat("XXX".split("")).splice(0, 3) : (3 < (r = e.toUpperCase().split("").map(function (e) {
          return -1 !== "BCDFGHJKLMNPRSTVWZ".indexOf(e) ? e : void 0;
        }).join("")).length && (r = n ? r.substr(0, 3) : r[0] + r.substr(2, 2)), r.length < 3 && (t = r, r = e.toUpperCase().split("").map(function (e) {
          return -1 !== "AEIOU".indexOf(e) ? e : void 0;
        }).join("").substr(0, 3 - t.length)), t += r), t;
      }

      var r,
          t,
          a,
          i = (e = e || {}).gender ? e.gender : this.gender(),
          A = e.first ? e.first : this.first({
        gender: i,
        nationality: "it"
      }),
          o = e.last ? e.last : this.last({
        nationality: "it"
      }),
          s = e.birthday ? e.birthday : this.birthday(),
          c = e.city ? e.city : this.pickone(["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M", "Z"]) + this.pad(this.natural({
        max: 999
      }), 3),
          l = [];
      return l = l.concat(n(o, !0), n(A), (t = i, a = this, (r = s).getFullYear().toString().substr(2) + ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"][r.getMonth()] + a.pad(r.getDate() + ("female" === t.toLowerCase() ? 40 : 0), 2)), c.toUpperCase().split("")).join(""), (l += function (e) {
        for (var n = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", r = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", t = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", a = 0, i = 0; i < 15; i++) {
          a += i % 2 != 0 ? t.indexOf(r[n.indexOf(e[i])]) : "BAKPLCQDREVOSFTGUHMINJWZYX".indexOf(r[n.indexOf(e[i])]);
        }

        return t[a % 26];
      }(l.toUpperCase())).toUpperCase();
    }, s.prototype.pl_pesel = function () {
      for (var e = this.natural({
        min: 1,
        max: 9999999999
      }), n = this.pad(e, 10).split(""), r = 0; r < n.length; r++) {
        n[r] = parseInt(n[r]);
      }

      var t = (1 * n[0] + 3 * n[1] + 7 * n[2] + 9 * n[3] + 1 * n[4] + 3 * n[5] + 7 * n[6] + 9 * n[7] + 1 * n[8] + 3 * n[9]) % 10;
      return 0 !== t && (t = 10 - t), n.join("") + t;
    }, s.prototype.pl_nip = function () {
      for (var e = this.natural({
        min: 1,
        max: 999999999
      }), n = this.pad(e, 9).split(""), r = 0; r < n.length; r++) {
        n[r] = parseInt(n[r]);
      }

      var t = (6 * n[0] + 5 * n[1] + 7 * n[2] + 2 * n[3] + 3 * n[4] + 4 * n[5] + 5 * n[6] + 6 * n[7] + 7 * n[8]) % 11;
      return 10 == t ? this.pl_nip() : n.join("") + t;
    }, s.prototype.pl_regon = function () {
      for (var e = this.natural({
        min: 1,
        max: 99999999
      }), n = this.pad(e, 8).split(""), r = 0; r < n.length; r++) {
        n[r] = parseInt(n[r]);
      }

      var t = (8 * n[0] + 9 * n[1] + 2 * n[2] + 3 * n[3] + 4 * n[4] + 5 * n[5] + 6 * n[6] + 7 * n[7]) % 11;
      return 10 === t && (t = 0), n.join("") + t;
    }, s.prototype.note = function (e) {
      e = g(e, {
        notes: "flatKey"
      });
      var n = {
        naturals: ["C", "D", "E", "F", "G", "A", "B"],
        flats: ["D♭", "E♭", "G♭", "A♭", "B♭"],
        sharps: ["C♯", "D♯", "F♯", "G♯", "A♯"]
      };
      return n.all = n.naturals.concat(n.flats.concat(n.sharps)), n.flatKey = n.naturals.concat(n.flats), n.sharpKey = n.naturals.concat(n.sharps), this.pickone(n[e.notes]);
    }, s.prototype.midi_note = function (e) {
      return e = g(e, {
        min: 0,
        max: 127
      }), this.integer({
        min: e.min,
        max: e.max
      });
    }, s.prototype.chord_quality = function (e) {
      var n = ["maj", "min", "aug", "dim"];
      return (e = g(e, {
        jazz: !0
      })).jazz && (n = ["maj7", "min7", "7", "sus", "dim", "ø"]), this.pickone(n);
    }, s.prototype.chord = function (e) {
      return e = g(e), this.note(e) + this.chord_quality(e);
    }, s.prototype.tempo = function (e) {
      return e = g(e, {
        min: 40,
        max: 320
      }), this.integer({
        min: e.min,
        max: e.max
      });
    }, s.prototype.coin = function () {
      return this.bool() ? "heads" : "tails";
    }, s.prototype.d4 = n({
      min: 1,
      max: 4
    }), s.prototype.d6 = n({
      min: 1,
      max: 6
    }), s.prototype.d8 = n({
      min: 1,
      max: 8
    }), s.prototype.d10 = n({
      min: 1,
      max: 10
    }), s.prototype.d12 = n({
      min: 1,
      max: 12
    }), s.prototype.d20 = n({
      min: 1,
      max: 20
    }), s.prototype.d30 = n({
      min: 1,
      max: 30
    }), s.prototype.d100 = n({
      min: 1,
      max: 100
    }), s.prototype.rpg = function (e, n) {
      if (n = g(n), e) {
        var r = e.toLowerCase().split("d"),
            t = [];
        if (2 !== r.length || !parseInt(r[0], 10) || !parseInt(r[1], 10)) throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");

        for (var a = r[0]; 0 < a; a--) {
          t[a - 1] = this.natural({
            min: 1,
            max: r[1]
          });
        }

        return void 0 !== n.sum && n.sum ? t.reduce(function (e, n) {
          return e + n;
        }) : t;
      }

      throw new RangeError("Chance: A type of die roll must be included");
    }, s.prototype.guid = function (e) {
      e = g(e, {
        version: 5
      });
      var n = "abcdef1234567890";
      return this.string({
        pool: n,
        length: 8
      }) + "-" + this.string({
        pool: n,
        length: 4
      }) + "-" + e.version + this.string({
        pool: n,
        length: 3
      }) + "-" + this.string({
        pool: "ab89",
        length: 1
      }) + this.string({
        pool: n,
        length: 3
      }) + "-" + this.string({
        pool: n,
        length: 12
      });
    }, s.prototype.hash = function (e) {
      var n = "upper" === (e = g(e, {
        length: 40,
        casing: "lower"
      })).casing ? r.toUpperCase() : r;
      return this.string({
        pool: n,
        length: e.length
      });
    }, s.prototype.luhn_check = function (e) {
      var n = e.toString();
      return +n.substring(n.length - 1) === this.luhn_calculate(+n.substring(0, n.length - 1));
    }, s.prototype.luhn_calculate = function (e) {
      for (var n, r = e.toString().split("").reverse(), t = 0, a = 0, i = r.length; a < i; ++a) {
        n = +r[a], a % 2 == 0 && 9 < (n *= 2) && (n -= 9), t += n;
      }

      return 9 * t % 10;
    }, s.prototype.md5 = function (e) {
      var n = {
        str: "",
        key: null,
        raw: !1
      };
      if (e) {
        if ("string" == typeof e) n.str = e, e = {};else {
          if ("object" != typeof e) return null;
          if ("Array" === e.constructor) return null;
        }
      } else n.str = this.string(), e = {};
      if (!(n = g(e, n)).str) throw new Error("A parameter is required to return an md5 hash.");
      return this.bimd5.md5(n.str, n.key, n.raw);
    };

    var c = {
      firstNames: {
        male: {
          en: ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas", "Christopher", "Daniel", "Matthew", "George", "Donald", "Anthony", "Paul", "Mark", "Edward", "Steven", "Kenneth", "Andrew", "Brian", "Joshua", "Kevin", "Ronald", "Timothy", "Jason", "Jeffrey", "Frank", "Gary", "Ryan", "Nicholas", "Eric", "Stephen", "Jacob", "Larry", "Jonathan", "Scott", "Raymond", "Justin", "Brandon", "Gregory", "Samuel", "Benjamin", "Patrick", "Jack", "Henry", "Walter", "Dennis", "Jerry", "Alexander", "Peter", "Tyler", "Douglas", "Harold", "Aaron", "Jose", "Adam", "Arthur", "Zachary", "Carl", "Nathan", "Albert", "Kyle", "Lawrence", "Joe", "Willie", "Gerald", "Roger", "Keith", "Jeremy", "Terry", "Harry", "Ralph", "Sean", "Jesse", "Roy", "Louis", "Billy", "Austin", "Bruce", "Eugene", "Christian", "Bryan", "Wayne", "Russell", "Howard", "Fred", "Ethan", "Jordan", "Philip", "Alan", "Juan", "Randy", "Vincent", "Bobby", "Dylan", "Johnny", "Phillip", "Victor", "Clarence", "Ernest", "Martin", "Craig", "Stanley", "Shawn", "Travis", "Bradley", "Leonard", "Earl", "Gabriel", "Jimmy", "Francis", "Todd", "Noah", "Danny", "Dale", "Cody", "Carlos", "Allen", "Frederick", "Logan", "Curtis", "Alex", "Joel", "Luis", "Norman", "Marvin", "Glenn", "Tony", "Nathaniel", "Rodney", "Melvin", "Alfred", "Steve", "Cameron", "Chad", "Edwin", "Caleb", "Evan", "Antonio", "Lee", "Herbert", "Jeffery", "Isaac", "Derek", "Ricky", "Marcus", "Theodore", "Elijah", "Luke", "Jesus", "Eddie", "Troy", "Mike", "Dustin", "Ray", "Adrian", "Bernard", "Leroy", "Angel", "Randall", "Wesley", "Ian", "Jared", "Mason", "Hunter", "Calvin", "Oscar", "Clifford", "Jay", "Shane", "Ronnie", "Barry", "Lucas", "Corey", "Manuel", "Leo", "Tommy", "Warren", "Jackson", "Isaiah", "Connor", "Don", "Dean", "Jon", "Julian", "Miguel", "Bill", "Lloyd", "Charlie", "Mitchell", "Leon", "Jerome", "Darrell", "Jeremiah", "Alvin", "Brett", "Seth", "Floyd", "Jim", "Blake", "Micheal", "Gordon", "Trevor", "Lewis", "Erik", "Edgar", "Vernon", "Devin", "Gavin", "Jayden", "Chris", "Clyde", "Tom", "Derrick", "Mario", "Brent", "Marc", "Herman", "Chase", "Dominic", "Ricardo", "Franklin", "Maurice", "Max", "Aiden", "Owen", "Lester", "Gilbert", "Elmer", "Gene", "Francisco", "Glen", "Cory", "Garrett", "Clayton", "Sam", "Jorge", "Chester", "Alejandro", "Jeff", "Harvey", "Milton", "Cole", "Ivan", "Andre", "Duane", "Landon"],
          it: ["Adolfo", "Alberto", "Aldo", "Alessandro", "Alessio", "Alfredo", "Alvaro", "Andrea", "Angelo", "Angiolo", "Antonino", "Antonio", "Attilio", "Benito", "Bernardo", "Bruno", "Carlo", "Cesare", "Christian", "Claudio", "Corrado", "Cosimo", "Cristian", "Cristiano", "Daniele", "Dario", "David", "Davide", "Diego", "Dino", "Domenico", "Duccio", "Edoardo", "Elia", "Elio", "Emanuele", "Emiliano", "Emilio", "Enrico", "Enzo", "Ettore", "Fabio", "Fabrizio", "Federico", "Ferdinando", "Fernando", "Filippo", "Francesco", "Franco", "Gabriele", "Giacomo", "Giampaolo", "Giampiero", "Giancarlo", "Gianfranco", "Gianluca", "Gianmarco", "Gianni", "Gino", "Giorgio", "Giovanni", "Giuliano", "Giulio", "Giuseppe", "Graziano", "Gregorio", "Guido", "Iacopo", "Jacopo", "Lapo", "Leonardo", "Lorenzo", "Luca", "Luciano", "Luigi", "Manuel", "Marcello", "Marco", "Marino", "Mario", "Massimiliano", "Massimo", "Matteo", "Mattia", "Maurizio", "Mauro", "Michele", "Mirko", "Mohamed", "Nello", "Neri", "Niccolò", "Nicola", "Osvaldo", "Otello", "Paolo", "Pier Luigi", "Piero", "Pietro", "Raffaele", "Remo", "Renato", "Renzo", "Riccardo", "Roberto", "Rolando", "Romano", "Salvatore", "Samuele", "Sandro", "Sergio", "Silvano", "Simone", "Stefano", "Thomas", "Tommaso", "Ubaldo", "Ugo", "Umberto", "Valerio", "Valter", "Vasco", "Vincenzo", "Vittorio"],
          nl: ["Aaron", "Abel", "Adam", "Adriaan", "Albert", "Alexander", "Ali", "Arjen", "Arno", "Bart", "Bas", "Bastiaan", "Benjamin", "Bob", "Boris", "Bram", "Brent", "Cas", "Casper", "Chris", "Christiaan", "Cornelis", "Daan", "Daley", "Damian", "Dani", "Daniel", "Daniël", "David", "Dean", "Dirk", "Dylan", "Egbert", "Elijah", "Erik", "Erwin", "Evert", "Ezra", "Fabian", "Fedde", "Finn", "Florian", "Floris", "Frank", "Frans", "Frederik", "Freek", "Geert", "Gerard", "Gerben", "Gerrit", "Gijs", "Guus", "Hans", "Hendrik", "Henk", "Herman", "Hidde", "Hugo", "Jaap", "Jan Jaap", "Jan-Willem", "Jack", "Jacob", "Jan", "Jason", "Jasper", "Jayden", "Jelle", "Jelte", "Jens", "Jeroen", "Jesse", "Jim", "Job", "Joep", "Johannes", "John", "Jonathan", "Joris", "Joshua", "Joël", "Julian", "Kees", "Kevin", "Koen", "Lars", "Laurens", "Leendert", "Lennard", "Lodewijk", "Luc", "Luca", "Lucas", "Lukas", "Luuk", "Maarten", "Marcus", "Martijn", "Martin", "Matthijs", "Maurits", "Max", "Mees", "Melle", "Mick", "Mika", "Milan", "Mohamed", "Mohammed", "Morris", "Muhammed", "Nathan", "Nick", "Nico", "Niek", "Niels", "Noah", "Noud", "Olivier", "Oscar", "Owen", "Paul", "Pepijn", "Peter", "Pieter", "Pim", "Quinten", "Reinier", "Rens", "Robin", "Ruben", "Sam", "Samuel", "Sander", "Sebastiaan", "Sem", "Sep", "Sepp", "Siem", "Simon", "Stan", "Stef", "Steven", "Stijn", "Sven", "Teun", "Thijmen", "Thijs", "Thomas", "Tijn", "Tim", "Timo", "Tobias", "Tom", "Victor", "Vince", "Willem", "Wim", "Wouter", "Yusuf"],
          fr: ["Aaron", "Abdon", "Abel", "Abélard", "Abelin", "Abondance", "Abraham", "Absalon", "Acace", "Achaire", "Achille", "Adalard", "Adalbald", "Adalbéron", "Adalbert", "Adalric", "Adam", "Adegrin", "Adel", "Adelin", "Andelin", "Adelphe", "Adam", "Adéodat", "Adhémar", "Adjutor", "Adolphe", "Adonis", "Adon", "Adrien", "Agapet", "Agathange", "Agathon", "Agilbert", "Agénor", "Agnan", "Aignan", "Agrippin", "Aimable", "Aimé", "Alain", "Alban", "Albin", "Aubin", "Albéric", "Albert", "Albertet", "Alcibiade", "Alcide", "Alcée", "Alcime", "Aldonce", "Aldric", "Aldéric", "Aleaume", "Alexandre", "Alexis", "Alix", "Alliaume", "Aleaume", "Almine", "Almire", "Aloïs", "Alphée", "Alphonse", "Alpinien", "Alverède", "Amalric", "Amaury", "Amandin", "Amant", "Ambroise", "Amédée", "Amélien", "Amiel", "Amour", "Anaël", "Anastase", "Anatole", "Ancelin", "Andéol", "Andoche", "André", "Andoche", "Ange", "Angelin", "Angilbe", "Anglebert", "Angoustan", "Anicet", "Anne", "Annibal", "Ansbert", "Anselme", "Anthelme", "Antheaume", "Anthime", "Antide", "Antoine", "Antonius", "Antonin", "Apollinaire", "Apollon", "Aquilin", "Arcade", "Archambaud", "Archambeau", "Archange", "Archibald", "Arian", "Ariel", "Ariste", "Aristide", "Armand", "Armel", "Armin", "Arnould", "Arnaud", "Arolde", "Arsène", "Arsinoé", "Arthaud", "Arthème", "Arthur", "Ascelin", "Athanase", "Aubry", "Audebert", "Audouin", "Audran", "Audric", "Auguste", "Augustin", "Aurèle", "Aurélien", "Aurian", "Auxence", "Axel", "Aymard", "Aymeric", "Aymon", "Aymond", "Balthazar", "Baptiste", "Barnabé", "Barthélemy", "Bartimée", "Basile", "Bastien", "Baudouin", "Bénigne", "Benjamin", "Benoît", "Bérenger", "Bérard", "Bernard", "Bertrand", "Blaise", "Bon", "Boniface", "Bouchard", "Brice", "Brieuc", "Bruno", "Brunon", "Calixte", "Calliste", "Camélien", "Camille", "Camillien", "Candide", "Caribert", "Carloman", "Cassandre", "Cassien", "Cédric", "Céleste", "Célestin", "Célien", "Césaire", "César", "Charles", "Charlemagne", "Childebert", "Chilpéric", "Chrétien", "Christian", "Christodule", "Christophe", "Chrysostome", "Clarence", "Claude", "Claudien", "Cléandre", "Clément", "Clotaire", "Côme", "Constance", "Constant", "Constantin", "Corentin", "Cyprien", "Cyriaque", "Cyrille", "Cyril", "Damien", "Daniel", "David", "Delphin", "Denis", "Désiré", "Didier", "Dieudonné", "Dimitri", "Dominique", "Dorian", "Dorothée", "Edgard", "Edmond", "Édouard", "Éleuthère", "Élie", "Élisée", "Émeric", "Émile", "Émilien", "Emmanuel", "Enguerrand", "Épiphane", "Éric", "Esprit", "Ernest", "Étienne", "Eubert", "Eudes", "Eudoxe", "Eugène", "Eusèbe", "Eustache", "Évariste", "Évrard", "Fabien", "Fabrice", "Falba", "Félicité", "Félix", "Ferdinand", "Fiacre", "Fidèle", "Firmin", "Flavien", "Flodoard", "Florent", "Florentin", "Florestan", "Florian", "Fortuné", "Foulques", "Francisque", "François", "Français", "Franciscus", "Francs", "Frédéric", "Fulbert", "Fulcran", "Fulgence", "Gabin", "Gabriel", "Gaël", "Garnier", "Gaston", "Gaspard", "Gatien", "Gaud", "Gautier", "Gédéon", "Geoffroy", "Georges", "Géraud", "Gérard", "Gerbert", "Germain", "Gervais", "Ghislain", "Gilbert", "Gilles", "Girart", "Gislebert", "Gondebaud", "Gonthier", "Gontran", "Gonzague", "Grégoire", "Guérin", "Gui", "Guillaume", "Gustave", "Guy", "Guyot", "Hardouin", "Hector", "Hédelin", "Hélier", "Henri", "Herbert", "Herluin", "Hervé", "Hilaire", "Hildebert", "Hincmar", "Hippolyte", "Honoré", "Hubert", "Hugues", "Innocent", "Isabeau", "Isidore", "Jacques", "Japhet", "Jason", "Jean", "Jeannel", "Jeannot", "Jérémie", "Jérôme", "Joachim", "Joanny", "Job", "Jocelyn", "Joël", "Johan", "Jonas", "Jonathan", "Joseph", "Josse", "Josselin", "Jourdain", "Jude", "Judicaël", "Jules", "Julien", "Juste", "Justin", "Lambert", "Landry", "Laurent", "Lazare", "Léandre", "Léon", "Léonard", "Léopold", "Leu", "Loup", "Leufroy", "Libère", "Liétald", "Lionel", "Loïc", "Longin", "Lorrain", "Lorraine", "Lothaire", "Louis", "Loup", "Luc", "Lucas", "Lucien", "Ludolphe", "Ludovic", "Macaire", "Malo", "Mamert", "Manassé", "Marc", "Marceau", "Marcel", "Marcelin", "Marius", "Marseille", "Martial", "Martin", "Mathurin", "Matthias", "Mathias", "Matthieu", "Maugis", "Maurice", "Mauricet", "Maxence", "Maxime", "Maximilien", "Mayeul", "Médéric", "Melchior", "Mence", "Merlin", "Mérovée", "Michaël", "Michel", "Moïse", "Morgan", "Nathan", "Nathanaël", "Narcisse", "Néhémie", "Nestor", "Nestor", "Nicéphore", "Nicolas", "Noé", "Noël", "Norbert", "Normand", "Normands", "Octave", "Odilon", "Odon", "Oger", "Olivier", "Oury", "Pacôme", "Palémon", "Parfait", "Pascal", "Paterne", "Patrice", "Paul", "Pépin", "Perceval", "Philémon", "Philibert", "Philippe", "Philothée", "Pie", "Pierre", "Pierrick", "Prosper", "Quentin", "Raoul", "Raphaël", "Raymond", "Régis", "Réjean", "Rémi", "Renaud", "René", "Reybaud", "Richard", "Robert", "Roch", "Rodolphe", "Rodrigue", "Roger", "Roland", "Romain", "Romuald", "Roméo", "Rome", "Ronan", "Roselin", "Salomon", "Samuel", "Savin", "Savinien", "Scholastique", "Sébastien", "Séraphin", "Serge", "Séverin", "Sidoine", "Sigebert", "Sigismond", "Silvère", "Simon", "Siméon", "Sixte", "Stanislas", "Stéphane", "Stephan", "Sylvain", "Sylvestre", "Tancrède", "Tanguy", "Taurin", "Théodore", "Théodose", "Théophile", "Théophraste", "Thibault", "Thibert", "Thierry", "Thomas", "Timoléon", "Timothée", "Titien", "Tonnin", "Toussaint", "Trajan", "Tristan", "Turold", "Tim", "Ulysse", "Urbain", "Valentin", "Valère", "Valéry", "Venance", "Venant", "Venceslas", "Vianney", "Victor", "Victorien", "Victorin", "Vigile", "Vincent", "Vital", "Vitalien", "Vivien", "Waleran", "Wandrille", "Xavier", "Xénophon", "Yves", "Zacharie", "Zaché", "Zéphirin"]
        },
        female: {
          en: ["Mary", "Emma", "Elizabeth", "Minnie", "Margaret", "Ida", "Alice", "Bertha", "Sarah", "Annie", "Clara", "Ella", "Florence", "Cora", "Martha", "Laura", "Nellie", "Grace", "Carrie", "Maude", "Mabel", "Bessie", "Jennie", "Gertrude", "Julia", "Hattie", "Edith", "Mattie", "Rose", "Catherine", "Lillian", "Ada", "Lillie", "Helen", "Jessie", "Louise", "Ethel", "Lula", "Myrtle", "Eva", "Frances", "Lena", "Lucy", "Edna", "Maggie", "Pearl", "Daisy", "Fannie", "Josephine", "Dora", "Rosa", "Katherine", "Agnes", "Marie", "Nora", "May", "Mamie", "Blanche", "Stella", "Ellen", "Nancy", "Effie", "Sallie", "Nettie", "Della", "Lizzie", "Flora", "Susie", "Maud", "Mae", "Etta", "Harriet", "Sadie", "Caroline", "Katie", "Lydia", "Elsie", "Kate", "Susan", "Mollie", "Alma", "Addie", "Georgia", "Eliza", "Lulu", "Nannie", "Lottie", "Amanda", "Belle", "Charlotte", "Rebecca", "Ruth", "Viola", "Olive", "Amelia", "Hannah", "Jane", "Virginia", "Emily", "Matilda", "Irene", "Kathryn", "Esther", "Willie", "Henrietta", "Ollie", "Amy", "Rachel", "Sara", "Estella", "Theresa", "Augusta", "Ora", "Pauline", "Josie", "Lola", "Sophia", "Leona", "Anne", "Mildred", "Ann", "Beulah", "Callie", "Lou", "Delia", "Eleanor", "Barbara", "Iva", "Louisa", "Maria", "Mayme", "Evelyn", "Estelle", "Nina", "Betty", "Marion", "Bettie", "Dorothy", "Luella", "Inez", "Lela", "Rosie", "Allie", "Millie", "Janie", "Cornelia", "Victoria", "Ruby", "Winifred", "Alta", "Celia", "Christine", "Beatrice", "Birdie", "Harriett", "Mable", "Myra", "Sophie", "Tillie", "Isabel", "Sylvia", "Carolyn", "Isabelle", "Leila", "Sally", "Ina", "Essie", "Bertie", "Nell", "Alberta", "Katharine", "Lora", "Rena", "Mina", "Rhoda", "Mathilda", "Abbie", "Eula", "Dollie", "Hettie", "Eunice", "Fanny", "Ola", "Lenora", "Adelaide", "Christina", "Lelia", "Nelle", "Sue", "Johanna", "Lilly", "Lucinda", "Minerva", "Lettie", "Roxie", "Cynthia", "Helena", "Hilda", "Hulda", "Bernice", "Genevieve", "Jean", "Cordelia", "Marian", "Francis", "Jeanette", "Adeline", "Gussie", "Leah", "Lois", "Lura", "Mittie", "Hallie", "Isabella", "Olga", "Phoebe", "Teresa", "Hester", "Lida", "Lina", "Winnie", "Claudia", "Marguerite", "Vera", "Cecelia", "Bess", "Emilie", "Rosetta", "Verna", "Myrtie", "Cecilia", "Elva", "Olivia", "Ophelia", "Georgie", "Elnora", "Violet", "Adele", "Lily", "Linnie", "Loretta", "Madge", "Polly", "Virgie", "Eugenia", "Lucile", "Lucille", "Mabelle", "Rosalie"],
          it: ["Ada", "Adriana", "Alessandra", "Alessia", "Alice", "Angela", "Anna", "Anna Maria", "Annalisa", "Annita", "Annunziata", "Antonella", "Arianna", "Asia", "Assunta", "Aurora", "Barbara", "Beatrice", "Benedetta", "Bianca", "Bruna", "Camilla", "Carla", "Carlotta", "Carmela", "Carolina", "Caterina", "Catia", "Cecilia", "Chiara", "Cinzia", "Clara", "Claudia", "Costanza", "Cristina", "Daniela", "Debora", "Diletta", "Dina", "Donatella", "Elena", "Eleonora", "Elisa", "Elisabetta", "Emanuela", "Emma", "Eva", "Federica", "Fernanda", "Fiorella", "Fiorenza", "Flora", "Franca", "Francesca", "Gabriella", "Gaia", "Gemma", "Giada", "Gianna", "Gina", "Ginevra", "Giorgia", "Giovanna", "Giulia", "Giuliana", "Giuseppa", "Giuseppina", "Grazia", "Graziella", "Greta", "Ida", "Ilaria", "Ines", "Iolanda", "Irene", "Irma", "Isabella", "Jessica", "Laura", "Lea", "Letizia", "Licia", "Lidia", "Liliana", "Lina", "Linda", "Lisa", "Livia", "Loretta", "Luana", "Lucia", "Luciana", "Lucrezia", "Luisa", "Manuela", "Mara", "Marcella", "Margherita", "Maria", "Maria Cristina", "Maria Grazia", "Maria Luisa", "Maria Pia", "Maria Teresa", "Marina", "Marisa", "Marta", "Martina", "Marzia", "Matilde", "Melissa", "Michela", "Milena", "Mirella", "Monica", "Natalina", "Nella", "Nicoletta", "Noemi", "Olga", "Paola", "Patrizia", "Piera", "Pierina", "Raffaella", "Rebecca", "Renata", "Rina", "Rita", "Roberta", "Rosa", "Rosanna", "Rossana", "Rossella", "Sabrina", "Sandra", "Sara", "Serena", "Silvana", "Silvia", "Simona", "Simonetta", "Sofia", "Sonia", "Stefania", "Susanna", "Teresa", "Tina", "Tiziana", "Tosca", "Valentina", "Valeria", "Vanda", "Vanessa", "Vanna", "Vera", "Veronica", "Vilma", "Viola", "Virginia", "Vittoria"],
          nl: ["Ada", "Arianne", "Afke", "Amanda", "Amber", "Amy", "Aniek", "Anita", "Anja", "Anna", "Anne", "Annelies", "Annemarie", "Annette", "Anouk", "Astrid", "Aukje", "Barbara", "Bianca", "Carla", "Carlijn", "Carolien", "Chantal", "Charlotte", "Claudia", "Daniëlle", "Debora", "Diane", "Dora", "Eline", "Elise", "Ella", "Ellen", "Emma", "Esmee", "Evelien", "Esther", "Erica", "Eva", "Femke", "Fleur", "Floor", "Froukje", "Gea", "Gerda", "Hanna", "Hanneke", "Heleen", "Hilde", "Ilona", "Ina", "Inge", "Ingrid", "Iris", "Isabel", "Isabelle", "Janneke", "Jasmijn", "Jeanine", "Jennifer", "Jessica", "Johanna", "Joke", "Julia", "Julie", "Karen", "Karin", "Katja", "Kim", "Lara", "Laura", "Lena", "Lianne", "Lieke", "Lilian", "Linda", "Lisa", "Lisanne", "Lotte", "Louise", "Maaike", "Manon", "Marga", "Maria", "Marissa", "Marit", "Marjolein", "Martine", "Marleen", "Melissa", "Merel", "Miranda", "Michelle", "Mirjam", "Mirthe", "Naomi", "Natalie", "Nienke", "Nina", "Noortje", "Olivia", "Patricia", "Paula", "Paulien", "Ramona", "Ria", "Rianne", "Roos", "Rosanne", "Ruth", "Sabrina", "Sandra", "Sanne", "Sara", "Saskia", "Silvia", "Sofia", "Sophie", "Sonja", "Suzanne", "Tamara", "Tess", "Tessa", "Tineke", "Valerie", "Vanessa", "Veerle", "Vera", "Victoria", "Wendy", "Willeke", "Yvonne", "Zoë"],
          fr: ["Abdon", "Abel", "Abigaëlle", "Abigaïl", "Acacius", "Acanthe", "Adalbert", "Adalsinde", "Adegrine", "Adélaïde", "Adèle", "Adélie", "Adeline", "Adeltrude", "Adolphe", "Adonis", "Adrastée", "Adrehilde", "Adrienne", "Agathe", "Agilbert", "Aglaé", "Aignan", "Agneflète", "Agnès", "Agrippine", "Aimé", "Alaine", "Alaïs", "Albane", "Albérade", "Alberte", "Alcide", "Alcine", "Alcyone", "Aldegonde", "Aleth", "Alexandrine", "Alexine", "Alice", "Aliénor", "Aliette", "Aline", "Alix", "Alizé", "Aloïse", "Aloyse", "Alphonsine", "Althée", "Amaliane", "Amalthée", "Amande", "Amandine", "Amant", "Amarande", "Amaranthe", "Amaryllis", "Ambre", "Ambroisie", "Amélie", "Améthyste", "Aminte", "Anaël", "Anaïs", "Anastasie", "Anatole", "Ancelin", "Andrée", "Anémone", "Angadrême", "Angèle", "Angeline", "Angélique", "Angilbert", "Anicet", "Annabelle", "Anne", "Annette", "Annick", "Annie", "Annonciade", "Ansbert", "Anstrudie", "Anthelme", "Antigone", "Antoinette", "Antonine", "Aphélie", "Apolline", "Apollonie", "Aquiline", "Arabelle", "Arcadie", "Archange", "Argine", "Ariane", "Aricie", "Ariel", "Arielle", "Arlette", "Armance", "Armande", "Armandine", "Armelle", "Armide", "Armelle", "Armin", "Arnaud", "Arsène", "Arsinoé", "Artémis", "Arthur", "Ascelin", "Ascension", "Assomption", "Astarté", "Astérie", "Astrée", "Astrid", "Athalie", "Athanasie", "Athina", "Aube", "Albert", "Aude", "Audrey", "Augustine", "Aure", "Aurélie", "Aurélien", "Aurèle", "Aurore", "Auxence", "Aveline", "Abigaëlle", "Avoye", "Axelle", "Aymard", "Azalée", "Adèle", "Adeline", "Barbe", "Basilisse", "Bathilde", "Béatrice", "Béatrix", "Bénédicte", "Bérengère", "Bernadette", "Berthe", "Bertille", "Beuve", "Blanche", "Blanc", "Blandine", "Brigitte", "Brune", "Brunehilde", "Callista", "Camille", "Capucine", "Carine", "Caroline", "Cassandre", "Catherine", "Cécile", "Céleste", "Célestine", "Céline", "Chantal", "Charlène", "Charline", "Charlotte", "Chloé", "Christelle", "Christiane", "Christine", "Claire", "Clara", "Claude", "Claudine", "Clarisse", "Clémence", "Clémentine", "Cléo", "Clio", "Clotilde", "Coline", "Conception", "Constance", "Coralie", "Coraline", "Corentine", "Corinne", "Cyrielle", "Daniel", "Daniel", "Daphné", "Débora", "Delphine", "Denise", "Diane", "Dieudonné", "Dominique", "Doriane", "Dorothée", "Douce", "Édith", "Edmée", "Éléonore", "Éliane", "Élia", "Éliette", "Élisabeth", "Élise", "Ella", "Élodie", "Éloïse", "Elsa", "Émeline", "Émérance", "Émérentienne", "Émérencie", "Émilie", "Emma", "Emmanuelle", "Emmelie", "Ernestine", "Esther", "Estelle", "Eudoxie", "Eugénie", "Eulalie", "Euphrasie", "Eusébie", "Évangéline", "Eva", "Ève", "Évelyne", "Fanny", "Fantine", "Faustine", "Félicie", "Fernande", "Flavie", "Fleur", "Flore", "Florence", "Florie", "Fortuné", "France", "Francia", "Françoise", "Francine", "Gabrielle", "Gaëlle", "Garance", "Geneviève", "Georgette", "Gerberge", "Germaine", "Gertrude", "Gisèle", "Guenièvre", "Guilhemine", "Guillemette", "Gustave", "Gwenael", "Hélène", "Héloïse", "Henriette", "Hermine", "Hermione", "Hippolyte", "Honorine", "Hortense", "Huguette", "Ines", "Irène", "Irina", "Iris", "Isabeau", "Isabelle", "Iseult", "Isolde", "Ismérie", "Jacinthe", "Jacqueline", "Jade", "Janine", "Jeanne", "Jocelyne", "Joëlle", "Joséphine", "Judith", "Julia", "Julie", "Jules", "Juliette", "Justine", "Katy", "Kathy", "Katie", "Laura", "Laure", "Laureline", "Laurence", "Laurene", "Lauriane", "Laurianne", "Laurine", "Léa", "Léna", "Léonie", "Léon", "Léontine", "Lorraine", "Lucie", "Lucienne", "Lucille", "Ludivine", "Lydie", "Lydie", "Megane", "Madeleine", "Magali", "Maguelone", "Mallaury", "Manon", "Marceline", "Margot", "Marguerite", "Marianne", "Marie", "Myriam", "Marie", "Marine", "Marion", "Marlène", "Marthe", "Martine", "Mathilde", "Maud", "Maureen", "Mauricette", "Maxime", "Mélanie", "Melissa", "Mélissandre", "Mélisande", "Mélodie", "Michel", "Micheline", "Mireille", "Miriam", "Moïse", "Monique", "Morgane", "Muriel", "Mylène", "Nadège", "Nadine", "Nathalie", "Nicole", "Nicolette", "Nine", "Noël", "Noémie", "Océane", "Odette", "Odile", "Olive", "Olivia", "Olympe", "Ombline", "Ombeline", "Ophélie", "Oriande", "Oriane", "Ozanne", "Pascale", "Pascaline", "Paule", "Paulette", "Pauline", "Priscille", "Prisca", "Prisque", "Pécine", "Pélagie", "Pénélope", "Perrine", "Pétronille", "Philippine", "Philomène", "Philothée", "Primerose", "Prudence", "Pulchérie", "Quentine", "Quiéta", "Quintia", "Quintilla", "Rachel", "Raphaëlle", "Raymonde", "Rebecca", "Régine", "Réjeanne", "René", "Rita", "Rita", "Rolande", "Romane", "Rosalie", "Rose", "Roseline", "Sabine", "Salomé", "Sandra", "Sandrine", "Sarah", "Ségolène", "Séverine", "Sibylle", "Simone", "Sixt", "Solange", "Soline", "Solène", "Sophie", "Stéphanie", "Suzanne", "Sylvain", "Sylvie", "Tatiana", "Thaïs", "Théodora", "Thérèse", "Tiphaine", "Ursule", "Valentine", "Valérie", "Véronique", "Victoire", "Victorine", "Vinciane", "Violette", "Virginie", "Viviane", "Xavière", "Yolande", "Ysaline", "Yvette", "Yvonne", "Zélie", "Zita", "Zoé"]
        }
      },
      lastNames: {
        en: ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "Hernandez", "King", "Wright", "Lopez", "Hill", "Scott", "Green", "Adams", "Baker", "Gonzalez", "Nelson", "Carter", "Mitchell", "Perez", "Roberts", "Turner", "Phillips", "Campbell", "Parker", "Evans", "Edwards", "Collins", "Stewart", "Sanchez", "Morris", "Rogers", "Reed", "Cook", "Morgan", "Bell", "Murphy", "Bailey", "Rivera", "Cooper", "Richardson", "Cox", "Howard", "Ward", "Torres", "Peterson", "Gray", "Ramirez", "James", "Watson", "Brooks", "Kelly", "Sanders", "Price", "Bennett", "Wood", "Barnes", "Ross", "Henderson", "Coleman", "Jenkins", "Perry", "Powell", "Long", "Patterson", "Hughes", "Flores", "Washington", "Butler", "Simmons", "Foster", "Gonzales", "Bryant", "Alexander", "Russell", "Griffin", "Diaz", "Hayes", "Myers", "Ford", "Hamilton", "Graham", "Sullivan", "Wallace", "Woods", "Cole", "West", "Jordan", "Owens", "Reynolds", "Fisher", "Ellis", "Harrison", "Gibson", "McDonald", "Cruz", "Marshall", "Ortiz", "Gomez", "Murray", "Freeman", "Wells", "Webb", "Simpson", "Stevens", "Tucker", "Porter", "Hunter", "Hicks", "Crawford", "Henry", "Boyd", "Mason", "Morales", "Kennedy", "Warren", "Dixon", "Ramos", "Reyes", "Burns", "Gordon", "Shaw", "Holmes", "Rice", "Robertson", "Hunt", "Black", "Daniels", "Palmer", "Mills", "Nichols", "Grant", "Knight", "Ferguson", "Rose", "Stone", "Hawkins", "Dunn", "Perkins", "Hudson", "Spencer", "Gardner", "Stephens", "Payne", "Pierce", "Berry", "Matthews", "Arnold", "Wagner", "Willis", "Ray", "Watkins", "Olson", "Carroll", "Duncan", "Snyder", "Hart", "Cunningham", "Bradley", "Lane", "Andrews", "Ruiz", "Harper", "Fox", "Riley", "Armstrong", "Carpenter", "Weaver", "Greene", "Lawrence", "Elliott", "Chavez", "Sims", "Austin", "Peters", "Kelley", "Franklin", "Lawson", "Fields", "Gutierrez", "Ryan", "Schmidt", "Carr", "Vasquez", "Castillo", "Wheeler", "Chapman", "Oliver", "Montgomery", "Richards", "Williamson", "Johnston", "Banks", "Meyer", "Bishop", "McCoy", "Howell", "Alvarez", "Morrison", "Hansen", "Fernandez", "Garza", "Harvey", "Little", "Burton", "Stanley", "Nguyen", "George", "Jacobs", "Reid", "Kim", "Fuller", "Lynch", "Dean", "Gilbert", "Garrett", "Romero", "Welch", "Larson", "Frazier", "Burke", "Hanson", "Day", "Mendoza", "Moreno", "Bowman", "Medina", "Fowler", "Brewer", "Hoffman", "Carlson", "Silva", "Pearson", "Holland", "Douglas", "Fleming", "Jensen", "Vargas", "Byrd", "Davidson", "Hopkins", "May", "Terry", "Herrera", "Wade", "Soto", "Walters", "Curtis", "Neal", "Caldwell", "Lowe", "Jennings", "Barnett", "Graves", "Jimenez", "Horton", "Shelton", "Barrett", "Obrien", "Castro", "Sutton", "Gregory", "McKinney", "Lucas", "Miles", "Craig", "Rodriquez", "Chambers", "Holt", "Lambert", "Fletcher", "Watts", "Bates", "Hale", "Rhodes", "Pena", "Beck", "Newman", "Haynes", "McDaniel", "Mendez", "Bush", "Vaughn", "Parks", "Dawson", "Santiago", "Norris", "Hardy", "Love", "Steele", "Curry", "Powers", "Schultz", "Barker", "Guzman", "Page", "Munoz", "Ball", "Keller", "Chandler", "Weber", "Leonard", "Walsh", "Lyons", "Ramsey", "Wolfe", "Schneider", "Mullins", "Benson", "Sharp", "Bowen", "Daniel", "Barber", "Cummings", "Hines", "Baldwin", "Griffith", "Valdez", "Hubbard", "Salazar", "Reeves", "Warner", "Stevenson", "Burgess", "Santos", "Tate", "Cross", "Garner", "Mann", "Mack", "Moss", "Thornton", "Dennis", "McGee", "Farmer", "Delgado", "Aguilar", "Vega", "Glover", "Manning", "Cohen", "Harmon", "Rodgers", "Robbins", "Newton", "Todd", "Blair", "Higgins", "Ingram", "Reese", "Cannon", "Strickland", "Townsend", "Potter", "Goodwin", "Walton", "Rowe", "Hampton", "Ortega", "Patton", "Swanson", "Joseph", "Francis", "Goodman", "Maldonado", "Yates", "Becker", "Erickson", "Hodges", "Rios", "Conner", "Adkins", "Webster", "Norman", "Malone", "Hammond", "Flowers", "Cobb", "Moody", "Quinn", "Blake", "Maxwell", "Pope", "Floyd", "Osborne", "Paul", "McCarthy", "Guerrero", "Lindsey", "Estrada", "Sandoval", "Gibbs", "Tyler", "Gross", "Fitzgerald", "Stokes", "Doyle", "Sherman", "Saunders", "Wise", "Colon", "Gill", "Alvarado", "Greer", "Padilla", "Simon", "Waters", "Nunez", "Ballard", "Schwartz", "McBride", "Houston", "Christensen", "Klein", "Pratt", "Briggs", "Parsons", "McLaughlin", "Zimmerman", "French", "Buchanan", "Moran", "Copeland", "Roy", "Pittman", "Brady", "McCormick", "Holloway", "Brock", "Poole", "Frank", "Logan", "Owen", "Bass", "Marsh", "Drake", "Wong", "Jefferson", "Park", "Morton", "Abbott", "Sparks", "Patrick", "Norton", "Huff", "Clayton", "Massey", "Lloyd", "Figueroa", "Carson", "Bowers", "Roberson", "Barton", "Tran", "Lamb", "Harrington", "Casey", "Boone", "Cortez", "Clarke", "Mathis", "Singleton", "Wilkins", "Cain", "Bryan", "Underwood", "Hogan", "McKenzie", "Collier", "Luna", "Phelps", "McGuire", "Allison", "Bridges", "Wilkerson", "Nash", "Summers", "Atkins"],
        it: ["Acciai", "Aglietti", "Agostini", "Agresti", "Ahmed", "Aiazzi", "Albanese", "Alberti", "Alessi", "Alfani", "Alinari", "Alterini", "Amato", "Ammannati", "Ancillotti", "Andrei", "Andreini", "Andreoni", "Angeli", "Anichini", "Antonelli", "Antonini", "Arena", "Ariani", "Arnetoli", "Arrighi", "Baccani", "Baccetti", "Bacci", "Bacherini", "Badii", "Baggiani", "Baglioni", "Bagni", "Bagnoli", "Baldassini", "Baldi", "Baldini", "Ballerini", "Balli", "Ballini", "Balloni", "Bambi", "Banchi", "Bandinelli", "Bandini", "Bani", "Barbetti", "Barbieri", "Barchielli", "Bardazzi", "Bardelli", "Bardi", "Barducci", "Bargellini", "Bargiacchi", "Barni", "Baroncelli", "Baroncini", "Barone", "Baroni", "Baronti", "Bartalesi", "Bartoletti", "Bartoli", "Bartolini", "Bartoloni", "Bartolozzi", "Basagni", "Basile", "Bassi", "Batacchi", "Battaglia", "Battaglini", "Bausi", "Becagli", "Becattini", "Becchi", "Becucci", "Bellandi", "Bellesi", "Belli", "Bellini", "Bellucci", "Bencini", "Benedetti", "Benelli", "Beni", "Benini", "Bensi", "Benucci", "Benvenuti", "Berlincioni", "Bernacchioni", "Bernardi", "Bernardini", "Berni", "Bernini", "Bertelli", "Berti", "Bertini", "Bessi", "Betti", "Bettini", "Biagi", "Biagini", "Biagioni", "Biagiotti", "Biancalani", "Bianchi", "Bianchini", "Bianco", "Biffoli", "Bigazzi", "Bigi", "Biliotti", "Billi", "Binazzi", "Bindi", "Bini", "Biondi", "Bizzarri", "Bocci", "Bogani", "Bolognesi", "Bonaiuti", "Bonanni", "Bonciani", "Boncinelli", "Bondi", "Bonechi", "Bongini", "Boni", "Bonini", "Borchi", "Boretti", "Borghi", "Borghini", "Borgioli", "Borri", "Borselli", "Boschi", "Bottai", "Bracci", "Braccini", "Brandi", "Braschi", "Bravi", "Brazzini", "Breschi", "Brilli", "Brizzi", "Brogelli", "Brogi", "Brogioni", "Brunelli", "Brunetti", "Bruni", "Bruno", "Brunori", "Bruschi", "Bucci", "Bucciarelli", "Buccioni", "Bucelli", "Bulli", "Burberi", "Burchi", "Burgassi", "Burroni", "Bussotti", "Buti", "Caciolli", "Caiani", "Calabrese", "Calamai", "Calamandrei", "Caldini", "Calo'", "Calonaci", "Calosi", "Calvelli", "Cambi", "Camiciottoli", "Cammelli", "Cammilli", "Campolmi", "Cantini", "Capanni", "Capecchi", "Caponi", "Cappelletti", "Cappelli", "Cappellini", "Cappugi", "Capretti", "Caputo", "Carbone", "Carboni", "Cardini", "Carlesi", "Carletti", "Carli", "Caroti", "Carotti", "Carrai", "Carraresi", "Carta", "Caruso", "Casalini", "Casati", "Caselli", "Casini", "Castagnoli", "Castellani", "Castelli", "Castellucci", "Catalano", "Catarzi", "Catelani", "Cavaciocchi", "Cavallaro", "Cavallini", "Cavicchi", "Cavini", "Ceccarelli", "Ceccatelli", "Ceccherelli", "Ceccherini", "Cecchi", "Cecchini", "Cecconi", "Cei", "Cellai", "Celli", "Cellini", "Cencetti", "Ceni", "Cenni", "Cerbai", "Cesari", "Ceseri", "Checcacci", "Checchi", "Checcucci", "Cheli", "Chellini", "Chen", "Cheng", "Cherici", "Cherubini", "Chiaramonti", "Chiarantini", "Chiarelli", "Chiari", "Chiarini", "Chiarugi", "Chiavacci", "Chiesi", "Chimenti", "Chini", "Chirici", "Chiti", "Ciabatti", "Ciampi", "Cianchi", "Cianfanelli", "Cianferoni", "Ciani", "Ciapetti", "Ciappi", "Ciardi", "Ciatti", "Cicali", "Ciccone", "Cinelli", "Cini", "Ciobanu", "Ciolli", "Cioni", "Cipriani", "Cirillo", "Cirri", "Ciucchi", "Ciuffi", "Ciulli", "Ciullini", "Clemente", "Cocchi", "Cognome", "Coli", "Collini", "Colombo", "Colzi", "Comparini", "Conforti", "Consigli", "Conte", "Conti", "Contini", "Coppini", "Coppola", "Corsi", "Corsini", "Corti", "Cortini", "Cosi", "Costa", "Costantini", "Costantino", "Cozzi", "Cresci", "Crescioli", "Cresti", "Crini", "Curradi", "D'Agostino", "D'Alessandro", "D'Amico", "D'Angelo", "Daddi", "Dainelli", "Dallai", "Danti", "Davitti", "De Angelis", "De Luca", "De Marco", "De Rosa", "De Santis", "De Simone", "De Vita", "Degl'Innocenti", "Degli Innocenti", "Dei", "Del Lungo", "Del Re", "Di Marco", "Di Stefano", "Dini", "Diop", "Dobre", "Dolfi", "Donati", "Dondoli", "Dong", "Donnini", "Ducci", "Dumitru", "Ermini", "Esposito", "Evangelisti", "Fabbri", "Fabbrini", "Fabbrizzi", "Fabbroni", "Fabbrucci", "Fabiani", "Facchini", "Faggi", "Fagioli", "Failli", "Faini", "Falciani", "Falcini", "Falcone", "Fallani", "Falorni", "Falsini", "Falugiani", "Fancelli", "Fanelli", "Fanetti", "Fanfani", "Fani", "Fantappie'", "Fantechi", "Fanti", "Fantini", "Fantoni", "Farina", "Fattori", "Favilli", "Fedi", "Fei", "Ferrante", "Ferrara", "Ferrari", "Ferraro", "Ferretti", "Ferri", "Ferrini", "Ferroni", "Fiaschi", "Fibbi", "Fiesoli", "Filippi", "Filippini", "Fini", "Fioravanti", "Fiore", "Fiorentini", "Fiorini", "Fissi", "Focardi", "Foggi", "Fontana", "Fontanelli", "Fontani", "Forconi", "Formigli", "Forte", "Forti", "Fortini", "Fossati", "Fossi", "Francalanci", "Franceschi", "Franceschini", "Franchi", "Franchini", "Franci", "Francini", "Francioni", "Franco", "Frassineti", "Frati", "Fratini", "Frilli", "Frizzi", "Frosali", "Frosini", "Frullini", "Fusco", "Fusi", "Gabbrielli", "Gabellini", "Gagliardi", "Galanti", "Galardi", "Galeotti", "Galletti", "Galli", "Gallo", "Gallori", "Gambacciani", "Gargani", "Garofalo", "Garuglieri", "Gashi", "Gasperini", "Gatti", "Gelli", "Gensini", "Gentile", "Gentili", "Geri", "Gerini", "Gheri", "Ghini", "Giachetti", "Giachi", "Giacomelli", "Gianassi", "Giani", "Giannelli", "Giannetti", "Gianni", "Giannini", "Giannoni", "Giannotti", "Giannozzi", "Gigli", "Giordano", "Giorgetti", "Giorgi", "Giovacchini", "Giovannelli", "Giovannetti", "Giovannini", "Giovannoni", "Giuliani", "Giunti", "Giuntini", "Giusti", "Gonnelli", "Goretti", "Gori", "Gradi", "Gramigni", "Grassi", "Grasso", "Graziani", "Grazzini", "Greco", "Grifoni", "Grillo", "Grimaldi", "Grossi", "Gualtieri", "Guarducci", "Guarino", "Guarnieri", "Guasti", "Guerra", "Guerri", "Guerrini", "Guidi", "Guidotti", "He", "Hoxha", "Hu", "Huang", "Iandelli", "Ignesti", "Innocenti", "Jin", "La Rosa", "Lai", "Landi", "Landini", "Lanini", "Lapi", "Lapini", "Lari", "Lascialfari", "Lastrucci", "Latini", "Lazzeri", "Lazzerini", "Lelli", "Lenzi", "Leonardi", "Leoncini", "Leone", "Leoni", "Lepri", "Li", "Liao", "Lin", "Linari", "Lippi", "Lisi", "Livi", "Lombardi", "Lombardini", "Lombardo", "Longo", "Lopez", "Lorenzi", "Lorenzini", "Lorini", "Lotti", "Lu", "Lucchesi", "Lucherini", "Lunghi", "Lupi", "Madiai", "Maestrini", "Maffei", "Maggi", "Maggini", "Magherini", "Magini", "Magnani", "Magnelli", "Magni", "Magnolfi", "Magrini", "Malavolti", "Malevolti", "Manca", "Mancini", "Manetti", "Manfredi", "Mangani", "Mannelli", "Manni", "Mannini", "Mannucci", "Manuelli", "Manzini", "Marcelli", "Marchese", "Marchetti", "Marchi", "Marchiani", "Marchionni", "Marconi", "Marcucci", "Margheri", "Mari", "Mariani", "Marilli", "Marinai", "Marinari", "Marinelli", "Marini", "Marino", "Mariotti", "Marsili", "Martelli", "Martinelli", "Martini", "Martino", "Marzi", "Masi", "Masini", "Masoni", "Massai", "Materassi", "Mattei", "Matteini", "Matteucci", "Matteuzzi", "Mattioli", "Mattolini", "Matucci", "Mauro", "Mazzanti", "Mazzei", "Mazzetti", "Mazzi", "Mazzini", "Mazzocchi", "Mazzoli", "Mazzoni", "Mazzuoli", "Meacci", "Mecocci", "Meini", "Melani", "Mele", "Meli", "Mengoni", "Menichetti", "Meoni", "Merlini", "Messeri", "Messina", "Meucci", "Miccinesi", "Miceli", "Micheli", "Michelini", "Michelozzi", "Migliori", "Migliorini", "Milani", "Miniati", "Misuri", "Monaco", "Montagnani", "Montagni", "Montanari", "Montelatici", "Monti", "Montigiani", "Montini", "Morandi", "Morandini", "Morelli", "Moretti", "Morganti", "Mori", "Morini", "Moroni", "Morozzi", "Mugnai", "Mugnaini", "Mustafa", "Naldi", "Naldini", "Nannelli", "Nanni", "Nannini", "Nannucci", "Nardi", "Nardini", "Nardoni", "Natali", "Ndiaye", "Nencetti", "Nencini", "Nencioni", "Neri", "Nesi", "Nesti", "Niccolai", "Niccoli", "Niccolini", "Nigi", "Nistri", "Nocentini", "Noferini", "Novelli", "Nucci", "Nuti", "Nutini", "Oliva", "Olivieri", "Olmi", "Orlandi", "Orlandini", "Orlando", "Orsini", "Ortolani", "Ottanelli", "Pacciani", "Pace", "Paci", "Pacini", "Pagani", "Pagano", "Paggetti", "Pagliai", "Pagni", "Pagnini", "Paladini", "Palagi", "Palchetti", "Palloni", "Palmieri", "Palumbo", "Pampaloni", "Pancani", "Pandolfi", "Pandolfini", "Panerai", "Panichi", "Paoletti", "Paoli", "Paolini", "Papi", "Papini", "Papucci", "Parenti", "Parigi", "Parisi", "Parri", "Parrini", "Pasquini", "Passeri", "Pecchioli", "Pecorini", "Pellegrini", "Pepi", "Perini", "Perrone", "Peruzzi", "Pesci", "Pestelli", "Petri", "Petrini", "Petrucci", "Pettini", "Pezzati", "Pezzatini", "Piani", "Piazza", "Piazzesi", "Piazzini", "Piccardi", "Picchi", "Piccini", "Piccioli", "Pieraccini", "Pieraccioni", "Pieralli", "Pierattini", "Pieri", "Pierini", "Pieroni", "Pietrini", "Pini", "Pinna", "Pinto", "Pinzani", "Pinzauti", "Piras", "Pisani", "Pistolesi", "Poggesi", "Poggi", "Poggiali", "Poggiolini", "Poli", "Pollastri", "Porciani", "Pozzi", "Pratellesi", "Pratesi", "Prosperi", "Pruneti", "Pucci", "Puccini", "Puccioni", "Pugi", "Pugliese", "Puliti", "Querci", "Quercioli", "Raddi", "Radu", "Raffaelli", "Ragazzini", "Ranfagni", "Ranieri", "Rastrelli", "Raugei", "Raveggi", "Renai", "Renzi", "Rettori", "Ricci", "Ricciardi", "Ridi", "Ridolfi", "Rigacci", "Righi", "Righini", "Rinaldi", "Risaliti", "Ristori", "Rizzo", "Rocchi", "Rocchini", "Rogai", "Romagnoli", "Romanelli", "Romani", "Romano", "Romei", "Romeo", "Romiti", "Romoli", "Romolini", "Rontini", "Rosati", "Roselli", "Rosi", "Rossetti", "Rossi", "Rossini", "Rovai", "Ruggeri", "Ruggiero", "Russo", "Sabatini", "Saccardi", "Sacchetti", "Sacchi", "Sacco", "Salerno", "Salimbeni", "Salucci", "Salvadori", "Salvestrini", "Salvi", "Salvini", "Sanesi", "Sani", "Sanna", "Santi", "Santini", "Santoni", "Santoro", "Santucci", "Sardi", "Sarri", "Sarti", "Sassi", "Sbolci", "Scali", "Scarpelli", "Scarselli", "Scopetani", "Secci", "Selvi", "Senatori", "Senesi", "Serafini", "Sereni", "Serra", "Sestini", "Sguanci", "Sieni", "Signorini", "Silvestri", "Simoncini", "Simonetti", "Simoni", "Singh", "Sodi", "Soldi", "Somigli", "Sorbi", "Sorelli", "Sorrentino", "Sottili", "Spina", "Spinelli", "Staccioli", "Staderini", "Stefanelli", "Stefani", "Stefanini", "Stella", "Susini", "Tacchi", "Tacconi", "Taddei", "Tagliaferri", "Tamburini", "Tanganelli", "Tani", "Tanini", "Tapinassi", "Tarchi", "Tarchiani", "Targioni", "Tassi", "Tassini", "Tempesti", "Terzani", "Tesi", "Testa", "Testi", "Tilli", "Tinti", "Tirinnanzi", "Toccafondi", "Tofanari", "Tofani", "Tognaccini", "Tonelli", "Tonini", "Torelli", "Torrini", "Tosi", "Toti", "Tozzi", "Trambusti", "Trapani", "Tucci", "Turchi", "Ugolini", "Ulivi", "Valente", "Valenti", "Valentini", "Vangelisti", "Vanni", "Vannini", "Vannoni", "Vannozzi", "Vannucchi", "Vannucci", "Ventura", "Venturi", "Venturini", "Vestri", "Vettori", "Vichi", "Viciani", "Vieri", "Vigiani", "Vignoli", "Vignolini", "Vignozzi", "Villani", "Vinci", "Visani", "Vitale", "Vitali", "Viti", "Viviani", "Vivoli", "Volpe", "Volpi", "Wang", "Wu", "Xu", "Yang", "Ye", "Zagli", "Zani", "Zanieri", "Zanobini", "Zecchi", "Zetti", "Zhang", "Zheng", "Zhou", "Zhu", "Zingoni", "Zini", "Zoppi"],
        nl: ["Albers", "Alblas", "Appelman", "Baars", "Baas", "Bakker", "Blank", "Bleeker", "Blok", "Blom", "Boer", "Boers", "Boldewijn", "Boon", "Boot", "Bos", "Bosch", "Bosma", "Bosman", "Bouma", "Bouman", "Bouwman", "Brands", "Brouwer", "Burger", "Buijs", "Buitenhuis", "Ceder", "Cohen", "Dekker", "Dekkers", "Dijkman", "Dijkstra", "Driessen", "Drost", "Engel", "Evers", "Faber", "Franke", "Gerritsen", "Goedhart", "Goossens", "Groen", "Groenenberg", "Groot", "Haan", "Hart", "Heemskerk", "Hendriks", "Hermans", "Hoekstra", "Hofman", "Hopman", "Huisman", "Jacobs", "Jansen", "Janssen", "Jonker", "Jaspers", "Keijzer", "Klaassen", "Klein", "Koek", "Koenders", "Kok", "Kool", "Koopman", "Koopmans", "Koning", "Koster", "Kramer", "Kroon", "Kuijpers", "Kuiper", "Kuipers", "Kurt", "Koster", "Kwakman", "Los", "Lubbers", "Maas", "Markus", "Martens", "Meijer", "Mol", "Molenaar", "Mulder", "Nieuwenhuis", "Peeters", "Peters", "Pengel", "Pieters", "Pool", "Post", "Postma", "Prins", "Pronk", "Reijnders", "Rietveld", "Roest", "Roos", "Sanders", "Schaap", "Scheffer", "Schenk", "Schilder", "Schipper", "Schmidt", "Scholten", "Schouten", "Schut", "Schutte", "Schuurman", "Simons", "Smeets", "Smit", "Smits", "Snel", "Swinkels", "Tas", "Terpstra", "Timmermans", "Tol", "Tromp", "Troost", "Valk", "Veenstra", "Veldkamp", "Verbeek", "Verheul", "Verhoeven", "Vermeer", "Vermeulen", "Verweij", "Vink", "Visser", "Voorn", "Vos", "Wagenaar", "Wiersema", "Willems", "Willemsen", "Witteveen", "Wolff", "Wolters", "Zijlstra", "Zwart", "de Beer", "de Boer", "de Bruijn", "de Bruin", "de Graaf", "de Groot", "de Haan", "de Haas", "de Jager", "de Jong", "de Jonge", "de Koning", "de Lange", "de Leeuw", "de Ridder", "de Rooij", "de Ruiter", "de Vos", "de Vries", "de Waal", "de Wit", "de Zwart", "van Beek", "van Boven", "van Dam", "van Dijk", "van Dongen", "van Doorn", "van Egmond", "van Eijk", "van Es", "van Gelder", "van Gelderen", "van Houten", "van Hulst", "van Kempen", "van Kesteren", "van Leeuwen", "van Loon", "van Mill", "van Noord", "van Ommen", "van Ommeren", "van Oosten", "van Oostveen", "van Rijn", "van Schaik", "van Veen", "van Vliet", "van Wijk", "van Wijngaarden", "van den Poel", "van de Pol", "van den Ploeg", "van de Ven", "van den Berg", "van den Bosch", "van den Brink", "van den Broek", "van den Heuvel", "van der Heijden", "van der Horst", "van der Hulst", "van der Kroon", "van der Laan", "van der Linden", "van der Meer", "van der Meij", "van der Meulen", "van der Molen", "van der Sluis", "van der Spek", "van der Veen", "van der Velde", "van der Velden", "van der Vliet", "van der Wal"],
        uk: ["Smith", "Jones", "Williams", "Taylor", "Brown", "Davies", "Evans", "Wilson", "Thomas", "Johnson", "Roberts", "Robinson", "Thompson", "Wright", "Walker", "White", "Edwards", "Hughes", "Green", "Hall", "Lewis", "Harris", "Clarke", "Patel", "Jackson", "Wood", "Turner", "Martin", "Cooper", "Hill", "Ward", "Morris", "Moore", "Clark", "Lee", "King", "Baker", "Harrison", "Morgan", "Allen", "James", "Scott", "Phillips", "Watson", "Davis", "Parker", "Price", "Bennett", "Young", "Griffiths", "Mitchell", "Kelly", "Cook", "Carter", "Richardson", "Bailey", "Collins", "Bell", "Shaw", "Murphy", "Miller", "Cox", "Richards", "Khan", "Marshall", "Anderson", "Simpson", "Ellis", "Adams", "Singh", "Begum", "Wilkinson", "Foster", "Chapman", "Powell", "Webb", "Rogers", "Gray", "Mason", "Ali", "Hunt", "Hussain", "Campbell", "Matthews", "Owen", "Palmer", "Holmes", "Mills", "Barnes", "Knight", "Lloyd", "Butler", "Russell", "Barker", "Fisher", "Stevens", "Jenkins", "Murray", "Dixon", "Harvey", "Graham", "Pearson", "Ahmed", "Fletcher", "Walsh", "Kaur", "Gibson", "Howard", "Andrews", "Stewart", "Elliott", "Reynolds", "Saunders", "Payne", "Fox", "Ford", "Pearce", "Day", "Brooks", "West", "Lawrence", "Cole", "Atkinson", "Bradley", "Spencer", "Gill", "Dawson", "Ball", "Burton", "O'brien", "Watts", "Rose", "Booth", "Perry", "Ryan", "Grant", "Wells", "Armstrong", "Francis", "Rees", "Hayes", "Hart", "Hudson", "Newman", "Barrett", "Webster", "Hunter", "Gregory", "Carr", "Lowe", "Page", "Marsh", "Riley", "Dunn", "Woods", "Parsons", "Berry", "Stone", "Reid", "Holland", "Hawkins", "Harding", "Porter", "Robertson", "Newton", "Oliver", "Reed", "Kennedy", "Williamson", "Bird", "Gardner", "Shah", "Dean", "Lane", "Cooke", "Bates", "Henderson", "Parry", "Burgess", "Bishop", "Walton", "Burns", "Nicholson", "Shepherd", "Ross", "Cross", "Long", "Freeman", "Warren", "Nicholls", "Hamilton", "Byrne", "Sutton", "Mcdonald", "Yates", "Hodgson", "Robson", "Curtis", "Hopkins", "O'connor", "Harper", "Coleman", "Watkins", "Moss", "Mccarthy", "Chambers", "O'neill", "Griffin", "Sharp", "Hardy", "Wheeler", "Potter", "Osborne", "Johnston", "Gordon", "Doyle", "Wallace", "George", "Jordan", "Hutchinson", "Rowe", "Burke", "May", "Pritchard", "Gilbert", "Willis", "Higgins", "Read", "Miles", "Stevenson", "Stephenson", "Hammond", "Arnold", "Buckley", "Walters", "Hewitt", "Barber", "Nelson", "Slater", "Austin", "Sullivan", "Whitehead", "Mann", "Frost", "Lambert", "Stephens", "Blake", "Akhtar", "Lynch", "Goodwin", "Barton", "Woodward", "Thomson", "Cunningham", "Quinn", "Barnett", "Baxter", "Bibi", "Clayton", "Nash", "Greenwood", "Jennings", "Holt", "Kemp", "Poole", "Gallagher", "Bond", "Stokes", "Tucker", "Davidson", "Fowler", "Heath", "Norman", "Middleton", "Lawson", "Banks", "French", "Stanley", "Jarvis", "Gibbs", "Ferguson", "Hayward", "Carroll", "Douglas", "Dickinson", "Todd", "Barlow", "Peters", "Lucas", "Knowles", "Hartley", "Miah", "Simmons", "Morton", "Alexander", "Field", "Morrison", "Norris", "Townsend", "Preston", "Hancock", "Thornton", "Baldwin", "Burrows", "Briggs", "Parkinson", "Reeves", "Macdonald", "Lamb", "Black", "Abbott", "Sanders", "Thorpe", "Holden", "Tomlinson", "Perkins", "Ashton", "Rhodes", "Fuller", "Howe", "Bryant", "Vaughan", "Dale", "Davey", "Weston", "Bartlett", "Whittaker", "Davison", "Kent", "Skinner", "Birch", "Morley", "Daniels", "Glover", "Howell", "Cartwright", "Pugh", "Humphreys", "Goddard", "Brennan", "Wall", "Kirby", "Bowen", "Savage", "Bull", "Wong", "Dobson", "Smart", "Wilkins", "Kirk", "Fraser", "Duffy", "Hicks", "Patterson", "Bradshaw", "Little", "Archer", "Warner", "Waters", "O'sullivan", "Farrell", "Brookes", "Atkins", "Kay", "Dodd", "Bentley", "Flynn", "John", "Schofield", "Short", "Haynes", "Wade", "Butcher", "Henry", "Sanderson", "Crawford", "Sheppard", "Bolton", "Coates", "Giles", "Gould", "Houghton", "Gibbons", "Pratt", "Manning", "Law", "Hooper", "Noble", "Dyer", "Rahman", "Clements", "Moran", "Sykes", "Chan", "Doherty", "Connolly", "Joyce", "Franklin", "Hobbs", "Coles", "Herbert", "Steele", "Kerr", "Leach", "Winter", "Owens", "Duncan", "Naylor", "Fleming", "Horton", "Finch", "Fitzgerald", "Randall", "Carpenter", "Marsden", "Browne", "Garner", "Pickering", "Hale", "Dennis", "Vincent", "Chadwick", "Chandler", "Sharpe", "Nolan", "Lyons", "Hurst", "Collier", "Peacock", "Howarth", "Faulkner", "Rice", "Pollard", "Welch", "Norton", "Gough", "Sinclair", "Blackburn", "Bryan", "Conway", "Power", "Cameron", "Daly", "Allan", "Hanson", "Gardiner", "Boyle", "Myers", "Turnbull", "Wallis", "Mahmood", "Sims", "Swift", "Iqbal", "Pope", "Brady", "Chamberlain", "Rowley", "Tyler", "Farmer", "Metcalfe", "Hilton", "Godfrey", "Holloway", "Parkin", "Bray", "Talbot", "Donnelly", "Nixon", "Charlton", "Benson", "Whitehouse", "Barry", "Hope", "Lord", "North", "Storey", "Connor", "Potts", "Bevan", "Hargreaves", "Mclean", "Mistry", "Bruce", "Howells", "Hyde", "Parkes", "Wyatt", "Fry", "Lees", "O'donnell", "Craig", "Forster", "Mckenzie", "Humphries", "Mellor", "Carey", "Ingram", "Summers", "Leonard"],
        de: ["Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier", "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer", "Huber", "Kaiser", "Fuchs", "Peters", "Lang", "Scholz", "Möller", "Weiß", "Jung", "Hahn", "Schubert", "Vogel", "Friedrich", "Keller", "Günther", "Frank", "Berger", "Winkler", "Roth", "Beck", "Lorenz", "Baumann", "Franke", "Albrecht", "Schuster", "Simon", "Ludwig", "Böhm", "Winter", "Kraus", "Martin", "Schumacher", "Krämer", "Vogt", "Stein", "Jäger", "Otto", "Sommer", "Groß", "Seidel", "Heinrich", "Brandt", "Haas", "Schreiber", "Graf", "Schulte", "Dietrich", "Ziegler", "Kuhn", "Kühn", "Pohl", "Engel", "Horn", "Busch", "Bergmann", "Thomas", "Voigt", "Sauer", "Arnold", "Wolff", "Pfeiffer"],
        jp: ["Sato", "Suzuki", "Takahashi", "Tanaka", "Watanabe", "Ito", "Yamamoto", "Nakamura", "Kobayashi", "Kato", "Yoshida", "Yamada", "Sasaki", "Yamaguchi", "Saito", "Matsumoto", "Inoue", "Kimura", "Hayashi", "Shimizu", "Yamazaki", "Mori", "Abe", "Ikeda", "Hashimoto", "Yamashita", "Ishikawa", "Nakajima", "Maeda", "Fujita", "Ogawa", "Goto", "Okada", "Hasegawa", "Murakami", "Kondo", "Ishii", "Saito", "Sakamoto", "Endo", "Aoki", "Fujii", "Nishimura", "Fukuda", "Ota", "Miura", "Fujiwara", "Okamoto", "Matsuda", "Nakagawa", "Nakano", "Harada", "Ono", "Tamura", "Takeuchi", "Kaneko", "Wada", "Nakayama", "Ishida", "Ueda", "Morita", "Hara", "Shibata", "Sakai", "Kudo", "Yokoyama", "Miyazaki", "Miyamoto", "Uchida", "Takagi", "Ando", "Taniguchi", "Ohno", "Maruyama", "Imai", "Takada", "Fujimoto", "Takeda", "Murata", "Ueno", "Sugiyama", "Masuda", "Sugawara", "Hirano", "Kojima", "Otsuka", "Chiba", "Kubo", "Matsui", "Iwasaki", "Sakurai", "Kinoshita", "Noguchi", "Matsuo", "Nomura", "Kikuchi", "Sano", "Onishi", "Sugimoto", "Arai"],
        es: ["Garcia", "Fernandez", "Lopez", "Martinez", "Gonzalez", "Rodriguez", "Sanchez", "Perez", "Martin", "Gomez", "Ruiz", "Diaz", "Hernandez", "Alvarez", "Jimenez", "Moreno", "Munoz", "Alonso", "Romero", "Navarro", "Gutierrez", "Torres", "Dominguez", "Gil", "Vazquez", "Blanco", "Serrano", "Ramos", "Castro", "Suarez", "Sanz", "Rubio", "Ortega", "Molina", "Delgado", "Ortiz", "Morales", "Ramirez", "Marin", "Iglesias", "Santos", "Castillo", "Garrido", "Calvo", "Pena", "Cruz", "Cano", "Nunez", "Prieto", "Diez", "Lozano", "Vidal", "Pascual", "Ferrer", "Medina", "Vega", "Leon", "Herrero", "Vicente", "Mendez", "Guerrero", "Fuentes", "Campos", "Nieto", "Cortes", "Caballero", "Ibanez", "Lorenzo", "Pastor", "Gimenez", "Saez", "Soler", "Marquez", "Carrasco", "Herrera", "Montero", "Arias", "Crespo", "Flores", "Andres", "Aguilar", "Hidalgo", "Cabrera", "Mora", "Duran", "Velasco", "Rey", "Pardo", "Roman", "Vila", "Bravo", "Merino", "Moya", "Soto", "Izquierdo", "Reyes", "Redondo", "Marcos", "Carmona", "Menendez"],
        fr: ["Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand", "Dubois", "Moreau", "Laurent", "Simon", "Michel", "Lefèvre", "Leroy", "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard", "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent", "Müller", "Lefèvre", "Faure", "André", "Mercier", "Blanc", "Guérin", "Boyer", "Garnier", "Chevalier", "François", "Legrand", "Gauthier", "Garcia", "Perrin", "Robin", "Clément", "Morin", "Nicolas", "Henry", "Roussel", "Matthieu", "Gautier", "Masson", "Marchand", "Duval", "Denis", "Dumont", "Marie", "Lemaire", "Noël", "Meyer", "Dufour", "Meunier", "Brun", "Blanchard", "Giraud", "Joly", "Rivière", "Lucas", "Brunet", "Gaillard", "Barbier", "Arnaud", "Martínez", "Gérard", "Roche", "Renard", "Schmitt", "Roy", "Leroux", "Colin", "Vidal", "Caron", "Picard", "Roger", "Fabre", "Aubert", "Lemoine", "Renaud", "Dumas", "Lacroix", "Olivier", "Philippe", "Bourgeois", "Pierre", "Benoît", "Rey", "Leclerc", "Payet", "Rolland", "Leclercq", "Guillaume", "Lecomte", "López", "Jean", "Dupuy", "Guillot", "Hubert", "Berger", "Carpentier", "Sánchez", "Dupuis", "Moulin", "Louis", "Deschamps", "Huet", "Vasseur", "Perez", "Boucher", "Fleury", "Royer", "Klein", "Jacquet", "Adam", "Paris", "Poirier", "Marty", "Aubry", "Guyot", "Carré", "Charles", "Renault", "Charpentier", "Ménard", "Maillard", "Baron", "Bertin", "Bailly", "Hervé", "Schneider", "Fernández", "Le GallGall", "Collet", "Léger", "Bouvier", "Julien", "Prévost", "Millet", "Perrot", "Daniel", "Le RouxRoux", "Cousin", "Germain", "Breton", "Besson", "Langlois", "Rémi", "Le GoffGoff", "Pelletier", "Lévêque", "Perrier", "Leblanc", "Barré", "Lebrun", "Marchal", "Weber", "Mallet", "Hamon", "Boulanger", "Jacob", "Monnier", "Michaud", "Rodríguez", "Guichard", "Gillet", "Étienne", "Grondin", "Poulain", "Tessier", "Chevallier", "Collin", "Chauvin", "Da SilvaSilva", "Bouchet", "Gay", "Lemaître", "Bénard", "Maréchal", "Humbert", "Reynaud", "Antoine", "Hoarau", "Perret", "Barthélemy", "Cordier", "Pichon", "Lejeune", "Gilbert", "Lamy", "Delaunay", "Pasquier", "Carlier", "LaporteLaporte"]
      },
      postcodeAreas: [{
        code: "AB"
      }, {
        code: "AL"
      }, {
        code: "B"
      }, {
        code: "BA"
      }, {
        code: "BB"
      }, {
        code: "BD"
      }, {
        code: "BH"
      }, {
        code: "BL"
      }, {
        code: "BN"
      }, {
        code: "BR"
      }, {
        code: "BS"
      }, {
        code: "BT"
      }, {
        code: "CA"
      }, {
        code: "CB"
      }, {
        code: "CF"
      }, {
        code: "CH"
      }, {
        code: "CM"
      }, {
        code: "CO"
      }, {
        code: "CR"
      }, {
        code: "CT"
      }, {
        code: "CV"
      }, {
        code: "CW"
      }, {
        code: "DA"
      }, {
        code: "DD"
      }, {
        code: "DE"
      }, {
        code: "DG"
      }, {
        code: "DH"
      }, {
        code: "DL"
      }, {
        code: "DN"
      }, {
        code: "DT"
      }, {
        code: "DY"
      }, {
        code: "E"
      }, {
        code: "EC"
      }, {
        code: "EH"
      }, {
        code: "EN"
      }, {
        code: "EX"
      }, {
        code: "FK"
      }, {
        code: "FY"
      }, {
        code: "G"
      }, {
        code: "GL"
      }, {
        code: "GU"
      }, {
        code: "GY"
      }, {
        code: "HA"
      }, {
        code: "HD"
      }, {
        code: "HG"
      }, {
        code: "HP"
      }, {
        code: "HR"
      }, {
        code: "HS"
      }, {
        code: "HU"
      }, {
        code: "HX"
      }, {
        code: "IG"
      }, {
        code: "IM"
      }, {
        code: "IP"
      }, {
        code: "IV"
      }, {
        code: "JE"
      }, {
        code: "KA"
      }, {
        code: "KT"
      }, {
        code: "KW"
      }, {
        code: "KY"
      }, {
        code: "L"
      }, {
        code: "LA"
      }, {
        code: "LD"
      }, {
        code: "LE"
      }, {
        code: "LL"
      }, {
        code: "LN"
      }, {
        code: "LS"
      }, {
        code: "LU"
      }, {
        code: "M"
      }, {
        code: "ME"
      }, {
        code: "MK"
      }, {
        code: "ML"
      }, {
        code: "N"
      }, {
        code: "NE"
      }, {
        code: "NG"
      }, {
        code: "NN"
      }, {
        code: "NP"
      }, {
        code: "NR"
      }, {
        code: "NW"
      }, {
        code: "OL"
      }, {
        code: "OX"
      }, {
        code: "PA"
      }, {
        code: "PE"
      }, {
        code: "PH"
      }, {
        code: "PL"
      }, {
        code: "PO"
      }, {
        code: "PR"
      }, {
        code: "RG"
      }, {
        code: "RH"
      }, {
        code: "RM"
      }, {
        code: "S"
      }, {
        code: "SA"
      }, {
        code: "SE"
      }, {
        code: "SG"
      }, {
        code: "SK"
      }, {
        code: "SL"
      }, {
        code: "SM"
      }, {
        code: "SN"
      }, {
        code: "SO"
      }, {
        code: "SP"
      }, {
        code: "SR"
      }, {
        code: "SS"
      }, {
        code: "ST"
      }, {
        code: "SW"
      }, {
        code: "SY"
      }, {
        code: "TA"
      }, {
        code: "TD"
      }, {
        code: "TF"
      }, {
        code: "TN"
      }, {
        code: "TQ"
      }, {
        code: "TR"
      }, {
        code: "TS"
      }, {
        code: "TW"
      }, {
        code: "UB"
      }, {
        code: "W"
      }, {
        code: "WA"
      }, {
        code: "WC"
      }, {
        code: "WD"
      }, {
        code: "WF"
      }, {
        code: "WN"
      }, {
        code: "WR"
      }, {
        code: "WS"
      }, {
        code: "WV"
      }, {
        code: "YO"
      }, {
        code: "ZE"
      }],
      countries: [{
        name: "Afghanistan",
        abbreviation: "AF"
      }, {
        name: "Åland Islands",
        abbreviation: "AX"
      }, {
        name: "Albania",
        abbreviation: "AL"
      }, {
        name: "Algeria",
        abbreviation: "DZ"
      }, {
        name: "American Samoa",
        abbreviation: "AS"
      }, {
        name: "Andorra",
        abbreviation: "AD"
      }, {
        name: "Angola",
        abbreviation: "AO"
      }, {
        name: "Anguilla",
        abbreviation: "AI"
      }, {
        name: "Antarctica",
        abbreviation: "AQ"
      }, {
        name: "Antigua & Barbuda",
        abbreviation: "AG"
      }, {
        name: "Argentina",
        abbreviation: "AR"
      }, {
        name: "Armenia",
        abbreviation: "AM"
      }, {
        name: "Aruba",
        abbreviation: "AW"
      }, {
        name: "Ascension Island",
        abbreviation: "AC"
      }, {
        name: "Australia",
        abbreviation: "AU"
      }, {
        name: "Austria",
        abbreviation: "AT"
      }, {
        name: "Azerbaijan",
        abbreviation: "AZ"
      }, {
        name: "Bahamas",
        abbreviation: "BS"
      }, {
        name: "Bahrain",
        abbreviation: "BH"
      }, {
        name: "Bangladesh",
        abbreviation: "BD"
      }, {
        name: "Barbados",
        abbreviation: "BB"
      }, {
        name: "Belarus",
        abbreviation: "BY"
      }, {
        name: "Belgium",
        abbreviation: "BE"
      }, {
        name: "Belize",
        abbreviation: "BZ"
      }, {
        name: "Benin",
        abbreviation: "BJ"
      }, {
        name: "Bermuda",
        abbreviation: "BM"
      }, {
        name: "Bhutan",
        abbreviation: "BT"
      }, {
        name: "Bolivia",
        abbreviation: "BO"
      }, {
        name: "Bosnia & Herzegovina",
        abbreviation: "BA"
      }, {
        name: "Botswana",
        abbreviation: "BW"
      }, {
        name: "Brazil",
        abbreviation: "BR"
      }, {
        name: "British Indian Ocean Territory",
        abbreviation: "IO"
      }, {
        name: "British Virgin Islands",
        abbreviation: "VG"
      }, {
        name: "Brunei",
        abbreviation: "BN"
      }, {
        name: "Bulgaria",
        abbreviation: "BG"
      }, {
        name: "Burkina Faso",
        abbreviation: "BF"
      }, {
        name: "Burundi",
        abbreviation: "BI"
      }, {
        name: "Cambodia",
        abbreviation: "KH"
      }, {
        name: "Cameroon",
        abbreviation: "CM"
      }, {
        name: "Canada",
        abbreviation: "CA"
      }, {
        name: "Canary Islands",
        abbreviation: "IC"
      }, {
        name: "Cape Verde",
        abbreviation: "CV"
      }, {
        name: "Caribbean Netherlands",
        abbreviation: "BQ"
      }, {
        name: "Cayman Islands",
        abbreviation: "KY"
      }, {
        name: "Central African Republic",
        abbreviation: "CF"
      }, {
        name: "Ceuta & Melilla",
        abbreviation: "EA"
      }, {
        name: "Chad",
        abbreviation: "TD"
      }, {
        name: "Chile",
        abbreviation: "CL"
      }, {
        name: "China",
        abbreviation: "CN"
      }, {
        name: "Christmas Island",
        abbreviation: "CX"
      }, {
        name: "Cocos (Keeling) Islands",
        abbreviation: "CC"
      }, {
        name: "Colombia",
        abbreviation: "CO"
      }, {
        name: "Comoros",
        abbreviation: "KM"
      }, {
        name: "Congo - Brazzaville",
        abbreviation: "CG"
      }, {
        name: "Congo - Kinshasa",
        abbreviation: "CD"
      }, {
        name: "Cook Islands",
        abbreviation: "CK"
      }, {
        name: "Costa Rica",
        abbreviation: "CR"
      }, {
        name: "Côte d'Ivoire",
        abbreviation: "CI"
      }, {
        name: "Croatia",
        abbreviation: "HR"
      }, {
        name: "Cuba",
        abbreviation: "CU"
      }, {
        name: "Curaçao",
        abbreviation: "CW"
      }, {
        name: "Cyprus",
        abbreviation: "CY"
      }, {
        name: "Czech Republic",
        abbreviation: "CZ"
      }, {
        name: "Denmark",
        abbreviation: "DK"
      }, {
        name: "Diego Garcia",
        abbreviation: "DG"
      }, {
        name: "Djibouti",
        abbreviation: "DJ"
      }, {
        name: "Dominica",
        abbreviation: "DM"
      }, {
        name: "Dominican Republic",
        abbreviation: "DO"
      }, {
        name: "Ecuador",
        abbreviation: "EC"
      }, {
        name: "Egypt",
        abbreviation: "EG"
      }, {
        name: "El Salvador",
        abbreviation: "SV"
      }, {
        name: "Equatorial Guinea",
        abbreviation: "GQ"
      }, {
        name: "Eritrea",
        abbreviation: "ER"
      }, {
        name: "Estonia",
        abbreviation: "EE"
      }, {
        name: "Ethiopia",
        abbreviation: "ET"
      }, {
        name: "Falkland Islands",
        abbreviation: "FK"
      }, {
        name: "Faroe Islands",
        abbreviation: "FO"
      }, {
        name: "Fiji",
        abbreviation: "FJ"
      }, {
        name: "Finland",
        abbreviation: "FI"
      }, {
        name: "France",
        abbreviation: "FR"
      }, {
        name: "French Guiana",
        abbreviation: "GF"
      }, {
        name: "French Polynesia",
        abbreviation: "PF"
      }, {
        name: "French Southern Territories",
        abbreviation: "TF"
      }, {
        name: "Gabon",
        abbreviation: "GA"
      }, {
        name: "Gambia",
        abbreviation: "GM"
      }, {
        name: "Georgia",
        abbreviation: "GE"
      }, {
        name: "Germany",
        abbreviation: "DE"
      }, {
        name: "Ghana",
        abbreviation: "GH"
      }, {
        name: "Gibraltar",
        abbreviation: "GI"
      }, {
        name: "Greece",
        abbreviation: "GR"
      }, {
        name: "Greenland",
        abbreviation: "GL"
      }, {
        name: "Grenada",
        abbreviation: "GD"
      }, {
        name: "Guadeloupe",
        abbreviation: "GP"
      }, {
        name: "Guam",
        abbreviation: "GU"
      }, {
        name: "Guatemala",
        abbreviation: "GT"
      }, {
        name: "Guernsey",
        abbreviation: "GG"
      }, {
        name: "Guinea",
        abbreviation: "GN"
      }, {
        name: "Guinea-Bissau",
        abbreviation: "GW"
      }, {
        name: "Guyana",
        abbreviation: "GY"
      }, {
        name: "Haiti",
        abbreviation: "HT"
      }, {
        name: "Honduras",
        abbreviation: "HN"
      }, {
        name: "Hong Kong SAR China",
        abbreviation: "HK"
      }, {
        name: "Hungary",
        abbreviation: "HU"
      }, {
        name: "Iceland",
        abbreviation: "IS"
      }, {
        name: "India",
        abbreviation: "IN"
      }, {
        name: "Indonesia",
        abbreviation: "ID"
      }, {
        name: "Iran",
        abbreviation: "IR"
      }, {
        name: "Iraq",
        abbreviation: "IQ"
      }, {
        name: "Ireland",
        abbreviation: "IE"
      }, {
        name: "Isle of Man",
        abbreviation: "IM"
      }, {
        name: "Israel",
        abbreviation: "IL"
      }, {
        name: "Italy",
        abbreviation: "IT"
      }, {
        name: "Jamaica",
        abbreviation: "JM"
      }, {
        name: "Japan",
        abbreviation: "JP"
      }, {
        name: "Jersey",
        abbreviation: "JE"
      }, {
        name: "Jordan",
        abbreviation: "JO"
      }, {
        name: "Kazakhstan",
        abbreviation: "KZ"
      }, {
        name: "Kenya",
        abbreviation: "KE"
      }, {
        name: "Kiribati",
        abbreviation: "KI"
      }, {
        name: "Kosovo",
        abbreviation: "XK"
      }, {
        name: "Kuwait",
        abbreviation: "KW"
      }, {
        name: "Kyrgyzstan",
        abbreviation: "KG"
      }, {
        name: "Laos",
        abbreviation: "LA"
      }, {
        name: "Latvia",
        abbreviation: "LV"
      }, {
        name: "Lebanon",
        abbreviation: "LB"
      }, {
        name: "Lesotho",
        abbreviation: "LS"
      }, {
        name: "Liberia",
        abbreviation: "LR"
      }, {
        name: "Libya",
        abbreviation: "LY"
      }, {
        name: "Liechtenstein",
        abbreviation: "LI"
      }, {
        name: "Lithuania",
        abbreviation: "LT"
      }, {
        name: "Luxembourg",
        abbreviation: "LU"
      }, {
        name: "Macau SAR China",
        abbreviation: "MO"
      }, {
        name: "Macedonia",
        abbreviation: "MK"
      }, {
        name: "Madagascar",
        abbreviation: "MG"
      }, {
        name: "Malawi",
        abbreviation: "MW"
      }, {
        name: "Malaysia",
        abbreviation: "MY"
      }, {
        name: "Maldives",
        abbreviation: "MV"
      }, {
        name: "Mali",
        abbreviation: "ML"
      }, {
        name: "Malta",
        abbreviation: "MT"
      }, {
        name: "Marshall Islands",
        abbreviation: "MH"
      }, {
        name: "Martinique",
        abbreviation: "MQ"
      }, {
        name: "Mauritania",
        abbreviation: "MR"
      }, {
        name: "Mauritius",
        abbreviation: "MU"
      }, {
        name: "Mayotte",
        abbreviation: "YT"
      }, {
        name: "Mexico",
        abbreviation: "MX"
      }, {
        name: "Micronesia",
        abbreviation: "FM"
      }, {
        name: "Moldova",
        abbreviation: "MD"
      }, {
        name: "Monaco",
        abbreviation: "MC"
      }, {
        name: "Mongolia",
        abbreviation: "MN"
      }, {
        name: "Montenegro",
        abbreviation: "ME"
      }, {
        name: "Montserrat",
        abbreviation: "MS"
      }, {
        name: "Morocco",
        abbreviation: "MA"
      }, {
        name: "Mozambique",
        abbreviation: "MZ"
      }, {
        name: "Myanmar (Burma)",
        abbreviation: "MM"
      }, {
        name: "Namibia",
        abbreviation: "NA"
      }, {
        name: "Nauru",
        abbreviation: "NR"
      }, {
        name: "Nepal",
        abbreviation: "NP"
      }, {
        name: "Netherlands",
        abbreviation: "NL"
      }, {
        name: "New Caledonia",
        abbreviation: "NC"
      }, {
        name: "New Zealand",
        abbreviation: "NZ"
      }, {
        name: "Nicaragua",
        abbreviation: "NI"
      }, {
        name: "Niger",
        abbreviation: "NE"
      }, {
        name: "Nigeria",
        abbreviation: "NG"
      }, {
        name: "Niue",
        abbreviation: "NU"
      }, {
        name: "Norfolk Island",
        abbreviation: "NF"
      }, {
        name: "North Korea",
        abbreviation: "KP"
      }, {
        name: "Northern Mariana Islands",
        abbreviation: "MP"
      }, {
        name: "Norway",
        abbreviation: "NO"
      }, {
        name: "Oman",
        abbreviation: "OM"
      }, {
        name: "Pakistan",
        abbreviation: "PK"
      }, {
        name: "Palau",
        abbreviation: "PW"
      }, {
        name: "Palestinian Territories",
        abbreviation: "PS"
      }, {
        name: "Panama",
        abbreviation: "PA"
      }, {
        name: "Papua New Guinea",
        abbreviation: "PG"
      }, {
        name: "Paraguay",
        abbreviation: "PY"
      }, {
        name: "Peru",
        abbreviation: "PE"
      }, {
        name: "Philippines",
        abbreviation: "PH"
      }, {
        name: "Pitcairn Islands",
        abbreviation: "PN"
      }, {
        name: "Poland",
        abbreviation: "PL"
      }, {
        name: "Portugal",
        abbreviation: "PT"
      }, {
        name: "Puerto Rico",
        abbreviation: "PR"
      }, {
        name: "Qatar",
        abbreviation: "QA"
      }, {
        name: "Réunion",
        abbreviation: "RE"
      }, {
        name: "Romania",
        abbreviation: "RO"
      }, {
        name: "Russia",
        abbreviation: "RU"
      }, {
        name: "Rwanda",
        abbreviation: "RW"
      }, {
        name: "Samoa",
        abbreviation: "WS"
      }, {
        name: "San Marino",
        abbreviation: "SM"
      }, {
        name: "São Tomé and Príncipe",
        abbreviation: "ST"
      }, {
        name: "Saudi Arabia",
        abbreviation: "SA"
      }, {
        name: "Senegal",
        abbreviation: "SN"
      }, {
        name: "Serbia",
        abbreviation: "RS"
      }, {
        name: "Seychelles",
        abbreviation: "SC"
      }, {
        name: "Sierra Leone",
        abbreviation: "SL"
      }, {
        name: "Singapore",
        abbreviation: "SG"
      }, {
        name: "Sint Maarten",
        abbreviation: "SX"
      }, {
        name: "Slovakia",
        abbreviation: "SK"
      }, {
        name: "Slovenia",
        abbreviation: "SI"
      }, {
        name: "Solomon Islands",
        abbreviation: "SB"
      }, {
        name: "Somalia",
        abbreviation: "SO"
      }, {
        name: "South Africa",
        abbreviation: "ZA"
      }, {
        name: "South Georgia & South Sandwich Islands",
        abbreviation: "GS"
      }, {
        name: "South Korea",
        abbreviation: "KR"
      }, {
        name: "South Sudan",
        abbreviation: "SS"
      }, {
        name: "Spain",
        abbreviation: "ES"
      }, {
        name: "Sri Lanka",
        abbreviation: "LK"
      }, {
        name: "St. Barthélemy",
        abbreviation: "BL"
      }, {
        name: "St. Helena",
        abbreviation: "SH"
      }, {
        name: "St. Kitts & Nevis",
        abbreviation: "KN"
      }, {
        name: "St. Lucia",
        abbreviation: "LC"
      }, {
        name: "St. Martin",
        abbreviation: "MF"
      }, {
        name: "St. Pierre & Miquelon",
        abbreviation: "PM"
      }, {
        name: "St. Vincent & Grenadines",
        abbreviation: "VC"
      }, {
        name: "Sudan",
        abbreviation: "SD"
      }, {
        name: "Suriname",
        abbreviation: "SR"
      }, {
        name: "Svalbard & Jan Mayen",
        abbreviation: "SJ"
      }, {
        name: "Swaziland",
        abbreviation: "SZ"
      }, {
        name: "Sweden",
        abbreviation: "SE"
      }, {
        name: "Switzerland",
        abbreviation: "CH"
      }, {
        name: "Syria",
        abbreviation: "SY"
      }, {
        name: "Taiwan",
        abbreviation: "TW"
      }, {
        name: "Tajikistan",
        abbreviation: "TJ"
      }, {
        name: "Tanzania",
        abbreviation: "TZ"
      }, {
        name: "Thailand",
        abbreviation: "TH"
      }, {
        name: "Timor-Leste",
        abbreviation: "TL"
      }, {
        name: "Togo",
        abbreviation: "TG"
      }, {
        name: "Tokelau",
        abbreviation: "TK"
      }, {
        name: "Tonga",
        abbreviation: "TO"
      }, {
        name: "Trinidad & Tobago",
        abbreviation: "TT"
      }, {
        name: "Tristan da Cunha",
        abbreviation: "TA"
      }, {
        name: "Tunisia",
        abbreviation: "TN"
      }, {
        name: "Turkey",
        abbreviation: "TR"
      }, {
        name: "Turkmenistan",
        abbreviation: "TM"
      }, {
        name: "Turks & Caicos Islands",
        abbreviation: "TC"
      }, {
        name: "Tuvalu",
        abbreviation: "TV"
      }, {
        name: "U.S. Outlying Islands",
        abbreviation: "UM"
      }, {
        name: "U.S. Virgin Islands",
        abbreviation: "VI"
      }, {
        name: "Uganda",
        abbreviation: "UG"
      }, {
        name: "Ukraine",
        abbreviation: "UA"
      }, {
        name: "United Arab Emirates",
        abbreviation: "AE"
      }, {
        name: "United Kingdom",
        abbreviation: "GB"
      }, {
        name: "United States",
        abbreviation: "US"
      }, {
        name: "Uruguay",
        abbreviation: "UY"
      }, {
        name: "Uzbekistan",
        abbreviation: "UZ"
      }, {
        name: "Vanuatu",
        abbreviation: "VU"
      }, {
        name: "Vatican City",
        abbreviation: "VA"
      }, {
        name: "Venezuela",
        abbreviation: "VE"
      }, {
        name: "Vietnam",
        abbreviation: "VN"
      }, {
        name: "Wallis & Futuna",
        abbreviation: "WF"
      }, {
        name: "Western Sahara",
        abbreviation: "EH"
      }, {
        name: "Yemen",
        abbreviation: "YE"
      }, {
        name: "Zambia",
        abbreviation: "ZM"
      }, {
        name: "Zimbabwe",
        abbreviation: "ZW"
      }],
      counties: {
        uk: [{
          name: "Bath and North East Somerset"
        }, {
          name: "Aberdeenshire"
        }, {
          name: "Anglesey"
        }, {
          name: "Angus"
        }, {
          name: "Bedford"
        }, {
          name: "Blackburn with Darwen"
        }, {
          name: "Blackpool"
        }, {
          name: "Bournemouth"
        }, {
          name: "Bracknell Forest"
        }, {
          name: "Brighton & Hove"
        }, {
          name: "Bristol"
        }, {
          name: "Buckinghamshire"
        }, {
          name: "Cambridgeshire"
        }, {
          name: "Carmarthenshire"
        }, {
          name: "Central Bedfordshire"
        }, {
          name: "Ceredigion"
        }, {
          name: "Cheshire East"
        }, {
          name: "Cheshire West and Chester"
        }, {
          name: "Clackmannanshire"
        }, {
          name: "Conwy"
        }, {
          name: "Cornwall"
        }, {
          name: "County Antrim"
        }, {
          name: "County Armagh"
        }, {
          name: "County Down"
        }, {
          name: "County Durham"
        }, {
          name: "County Fermanagh"
        }, {
          name: "County Londonderry"
        }, {
          name: "County Tyrone"
        }, {
          name: "Cumbria"
        }, {
          name: "Darlington"
        }, {
          name: "Denbighshire"
        }, {
          name: "Derby"
        }, {
          name: "Derbyshire"
        }, {
          name: "Devon"
        }, {
          name: "Dorset"
        }, {
          name: "Dumfries and Galloway"
        }, {
          name: "Dundee"
        }, {
          name: "East Lothian"
        }, {
          name: "East Riding of Yorkshire"
        }, {
          name: "East Sussex"
        }, {
          name: "Edinburgh?"
        }, {
          name: "Essex"
        }, {
          name: "Falkirk"
        }, {
          name: "Fife"
        }, {
          name: "Flintshire"
        }, {
          name: "Gloucestershire"
        }, {
          name: "Greater London"
        }, {
          name: "Greater Manchester"
        }, {
          name: "Gwent"
        }, {
          name: "Gwynedd"
        }, {
          name: "Halton"
        }, {
          name: "Hampshire"
        }, {
          name: "Hartlepool"
        }, {
          name: "Herefordshire"
        }, {
          name: "Hertfordshire"
        }, {
          name: "Highlands"
        }, {
          name: "Hull"
        }, {
          name: "Isle of Wight"
        }, {
          name: "Isles of Scilly"
        }, {
          name: "Kent"
        }, {
          name: "Lancashire"
        }, {
          name: "Leicester"
        }, {
          name: "Leicestershire"
        }, {
          name: "Lincolnshire"
        }, {
          name: "Lothian"
        }, {
          name: "Luton"
        }, {
          name: "Medway"
        }, {
          name: "Merseyside"
        }, {
          name: "Mid Glamorgan"
        }, {
          name: "Middlesbrough"
        }, {
          name: "Milton Keynes"
        }, {
          name: "Monmouthshire"
        }, {
          name: "Moray"
        }, {
          name: "Norfolk"
        }, {
          name: "North East Lincolnshire"
        }, {
          name: "North Lincolnshire"
        }, {
          name: "North Somerset"
        }, {
          name: "North Yorkshire"
        }, {
          name: "Northamptonshire"
        }, {
          name: "Northumberland"
        }, {
          name: "Nottingham"
        }, {
          name: "Nottinghamshire"
        }, {
          name: "Oxfordshire"
        }, {
          name: "Pembrokeshire"
        }, {
          name: "Perth and Kinross"
        }, {
          name: "Peterborough"
        }, {
          name: "Plymouth"
        }, {
          name: "Poole"
        }, {
          name: "Portsmouth"
        }, {
          name: "Powys"
        }, {
          name: "Reading"
        }, {
          name: "Redcar and Cleveland"
        }, {
          name: "Rutland"
        }, {
          name: "Scottish Borders"
        }, {
          name: "Shropshire"
        }, {
          name: "Slough"
        }, {
          name: "Somerset"
        }, {
          name: "South Glamorgan"
        }, {
          name: "South Gloucestershire"
        }, {
          name: "South Yorkshire"
        }, {
          name: "Southampton"
        }, {
          name: "Southend-on-Sea"
        }, {
          name: "Staffordshire"
        }, {
          name: "Stirlingshire"
        }, {
          name: "Stockton-on-Tees"
        }, {
          name: "Stoke-on-Trent"
        }, {
          name: "Strathclyde"
        }, {
          name: "Suffolk"
        }, {
          name: "Surrey"
        }, {
          name: "Swindon"
        }, {
          name: "Telford and Wrekin"
        }, {
          name: "Thurrock"
        }, {
          name: "Torbay"
        }, {
          name: "Tyne and Wear"
        }, {
          name: "Warrington"
        }, {
          name: "Warwickshire"
        }, {
          name: "West Berkshire"
        }, {
          name: "West Glamorgan"
        }, {
          name: "West Lothian"
        }, {
          name: "West Midlands"
        }, {
          name: "West Sussex"
        }, {
          name: "West Yorkshire"
        }, {
          name: "Western Isles"
        }, {
          name: "Wiltshire"
        }, {
          name: "Windsor and Maidenhead"
        }, {
          name: "Wokingham"
        }, {
          name: "Worcestershire"
        }, {
          name: "Wrexham"
        }, {
          name: "York"
        }]
      },
      provinces: {
        ca: [{
          name: "Alberta",
          abbreviation: "AB"
        }, {
          name: "British Columbia",
          abbreviation: "BC"
        }, {
          name: "Manitoba",
          abbreviation: "MB"
        }, {
          name: "New Brunswick",
          abbreviation: "NB"
        }, {
          name: "Newfoundland and Labrador",
          abbreviation: "NL"
        }, {
          name: "Nova Scotia",
          abbreviation: "NS"
        }, {
          name: "Ontario",
          abbreviation: "ON"
        }, {
          name: "Prince Edward Island",
          abbreviation: "PE"
        }, {
          name: "Quebec",
          abbreviation: "QC"
        }, {
          name: "Saskatchewan",
          abbreviation: "SK"
        }, {
          name: "Northwest Territories",
          abbreviation: "NT"
        }, {
          name: "Nunavut",
          abbreviation: "NU"
        }, {
          name: "Yukon",
          abbreviation: "YT"
        }],
        it: [{
          name: "Agrigento",
          abbreviation: "AG",
          code: 84
        }, {
          name: "Alessandria",
          abbreviation: "AL",
          code: 6
        }, {
          name: "Ancona",
          abbreviation: "AN",
          code: 42
        }, {
          name: "Aosta",
          abbreviation: "AO",
          code: 7
        }, {
          name: "L'Aquila",
          abbreviation: "AQ",
          code: 66
        }, {
          name: "Arezzo",
          abbreviation: "AR",
          code: 51
        }, {
          name: "Ascoli-Piceno",
          abbreviation: "AP",
          code: 44
        }, {
          name: "Asti",
          abbreviation: "AT",
          code: 5
        }, {
          name: "Avellino",
          abbreviation: "AV",
          code: 64
        }, {
          name: "Bari",
          abbreviation: "BA",
          code: 72
        }, {
          name: "Barletta-Andria-Trani",
          abbreviation: "BT",
          code: 72
        }, {
          name: "Belluno",
          abbreviation: "BL",
          code: 25
        }, {
          name: "Benevento",
          abbreviation: "BN",
          code: 62
        }, {
          name: "Bergamo",
          abbreviation: "BG",
          code: 16
        }, {
          name: "Biella",
          abbreviation: "BI",
          code: 96
        }, {
          name: "Bologna",
          abbreviation: "BO",
          code: 37
        }, {
          name: "Bolzano",
          abbreviation: "BZ",
          code: 21
        }, {
          name: "Brescia",
          abbreviation: "BS",
          code: 17
        }, {
          name: "Brindisi",
          abbreviation: "BR",
          code: 74
        }, {
          name: "Cagliari",
          abbreviation: "CA",
          code: 92
        }, {
          name: "Caltanissetta",
          abbreviation: "CL",
          code: 85
        }, {
          name: "Campobasso",
          abbreviation: "CB",
          code: 70
        }, {
          name: "Carbonia Iglesias",
          abbreviation: "CI",
          code: 70
        }, {
          name: "Caserta",
          abbreviation: "CE",
          code: 61
        }, {
          name: "Catania",
          abbreviation: "CT",
          code: 87
        }, {
          name: "Catanzaro",
          abbreviation: "CZ",
          code: 79
        }, {
          name: "Chieti",
          abbreviation: "CH",
          code: 69
        }, {
          name: "Como",
          abbreviation: "CO",
          code: 13
        }, {
          name: "Cosenza",
          abbreviation: "CS",
          code: 78
        }, {
          name: "Cremona",
          abbreviation: "CR",
          code: 19
        }, {
          name: "Crotone",
          abbreviation: "KR",
          code: 101
        }, {
          name: "Cuneo",
          abbreviation: "CN",
          code: 4
        }, {
          name: "Enna",
          abbreviation: "EN",
          code: 86
        }, {
          name: "Fermo",
          abbreviation: "FM",
          code: 86
        }, {
          name: "Ferrara",
          abbreviation: "FE",
          code: 38
        }, {
          name: "Firenze",
          abbreviation: "FI",
          code: 48
        }, {
          name: "Foggia",
          abbreviation: "FG",
          code: 71
        }, {
          name: "Forli-Cesena",
          abbreviation: "FC",
          code: 71
        }, {
          name: "Frosinone",
          abbreviation: "FR",
          code: 60
        }, {
          name: "Genova",
          abbreviation: "GE",
          code: 10
        }, {
          name: "Gorizia",
          abbreviation: "GO",
          code: 31
        }, {
          name: "Grosseto",
          abbreviation: "GR",
          code: 53
        }, {
          name: "Imperia",
          abbreviation: "IM",
          code: 8
        }, {
          name: "Isernia",
          abbreviation: "IS",
          code: 94
        }, {
          name: "La-Spezia",
          abbreviation: "SP",
          code: 66
        }, {
          name: "Latina",
          abbreviation: "LT",
          code: 59
        }, {
          name: "Lecce",
          abbreviation: "LE",
          code: 75
        }, {
          name: "Lecco",
          abbreviation: "LC",
          code: 97
        }, {
          name: "Livorno",
          abbreviation: "LI",
          code: 49
        }, {
          name: "Lodi",
          abbreviation: "LO",
          code: 98
        }, {
          name: "Lucca",
          abbreviation: "LU",
          code: 46
        }, {
          name: "Macerata",
          abbreviation: "MC",
          code: 43
        }, {
          name: "Mantova",
          abbreviation: "MN",
          code: 20
        }, {
          name: "Massa-Carrara",
          abbreviation: "MS",
          code: 45
        }, {
          name: "Matera",
          abbreviation: "MT",
          code: 77
        }, {
          name: "Medio Campidano",
          abbreviation: "VS",
          code: 77
        }, {
          name: "Messina",
          abbreviation: "ME",
          code: 83
        }, {
          name: "Milano",
          abbreviation: "MI",
          code: 15
        }, {
          name: "Modena",
          abbreviation: "MO",
          code: 36
        }, {
          name: "Monza-Brianza",
          abbreviation: "MB",
          code: 36
        }, {
          name: "Napoli",
          abbreviation: "NA",
          code: 63
        }, {
          name: "Novara",
          abbreviation: "NO",
          code: 3
        }, {
          name: "Nuoro",
          abbreviation: "NU",
          code: 91
        }, {
          name: "Ogliastra",
          abbreviation: "OG",
          code: 91
        }, {
          name: "Olbia Tempio",
          abbreviation: "OT",
          code: 91
        }, {
          name: "Oristano",
          abbreviation: "OR",
          code: 95
        }, {
          name: "Padova",
          abbreviation: "PD",
          code: 28
        }, {
          name: "Palermo",
          abbreviation: "PA",
          code: 82
        }, {
          name: "Parma",
          abbreviation: "PR",
          code: 34
        }, {
          name: "Pavia",
          abbreviation: "PV",
          code: 18
        }, {
          name: "Perugia",
          abbreviation: "PG",
          code: 54
        }, {
          name: "Pesaro-Urbino",
          abbreviation: "PU",
          code: 41
        }, {
          name: "Pescara",
          abbreviation: "PE",
          code: 68
        }, {
          name: "Piacenza",
          abbreviation: "PC",
          code: 33
        }, {
          name: "Pisa",
          abbreviation: "PI",
          code: 50
        }, {
          name: "Pistoia",
          abbreviation: "PT",
          code: 47
        }, {
          name: "Pordenone",
          abbreviation: "PN",
          code: 93
        }, {
          name: "Potenza",
          abbreviation: "PZ",
          code: 76
        }, {
          name: "Prato",
          abbreviation: "PO",
          code: 100
        }, {
          name: "Ragusa",
          abbreviation: "RG",
          code: 88
        }, {
          name: "Ravenna",
          abbreviation: "RA",
          code: 39
        }, {
          name: "Reggio-Calabria",
          abbreviation: "RC",
          code: 35
        }, {
          name: "Reggio-Emilia",
          abbreviation: "RE",
          code: 35
        }, {
          name: "Rieti",
          abbreviation: "RI",
          code: 57
        }, {
          name: "Rimini",
          abbreviation: "RN",
          code: 99
        }, {
          name: "Roma",
          abbreviation: "Roma",
          code: 58
        }, {
          name: "Rovigo",
          abbreviation: "RO",
          code: 29
        }, {
          name: "Salerno",
          abbreviation: "SA",
          code: 65
        }, {
          name: "Sassari",
          abbreviation: "SS",
          code: 90
        }, {
          name: "Savona",
          abbreviation: "SV",
          code: 9
        }, {
          name: "Siena",
          abbreviation: "SI",
          code: 52
        }, {
          name: "Siracusa",
          abbreviation: "SR",
          code: 89
        }, {
          name: "Sondrio",
          abbreviation: "SO",
          code: 14
        }, {
          name: "Taranto",
          abbreviation: "TA",
          code: 73
        }, {
          name: "Teramo",
          abbreviation: "TE",
          code: 67
        }, {
          name: "Terni",
          abbreviation: "TR",
          code: 55
        }, {
          name: "Torino",
          abbreviation: "TO",
          code: 1
        }, {
          name: "Trapani",
          abbreviation: "TP",
          code: 81
        }, {
          name: "Trento",
          abbreviation: "TN",
          code: 22
        }, {
          name: "Treviso",
          abbreviation: "TV",
          code: 26
        }, {
          name: "Trieste",
          abbreviation: "TS",
          code: 32
        }, {
          name: "Udine",
          abbreviation: "UD",
          code: 30
        }, {
          name: "Varese",
          abbreviation: "VA",
          code: 12
        }, {
          name: "Venezia",
          abbreviation: "VE",
          code: 27
        }, {
          name: "Verbania",
          abbreviation: "VB",
          code: 27
        }, {
          name: "Vercelli",
          abbreviation: "VC",
          code: 2
        }, {
          name: "Verona",
          abbreviation: "VR",
          code: 23
        }, {
          name: "Vibo-Valentia",
          abbreviation: "VV",
          code: 102
        }, {
          name: "Vicenza",
          abbreviation: "VI",
          code: 24
        }, {
          name: "Viterbo",
          abbreviation: "VT",
          code: 56
        }]
      },
      nationalities: [{
        name: "Afghan"
      }, {
        name: "Albanian"
      }, {
        name: "Algerian"
      }, {
        name: "American"
      }, {
        name: "Andorran"
      }, {
        name: "Angolan"
      }, {
        name: "Antiguans"
      }, {
        name: "Argentinean"
      }, {
        name: "Armenian"
      }, {
        name: "Australian"
      }, {
        name: "Austrian"
      }, {
        name: "Azerbaijani"
      }, {
        name: "Bahami"
      }, {
        name: "Bahraini"
      }, {
        name: "Bangladeshi"
      }, {
        name: "Barbadian"
      }, {
        name: "Barbudans"
      }, {
        name: "Batswana"
      }, {
        name: "Belarusian"
      }, {
        name: "Belgian"
      }, {
        name: "Belizean"
      }, {
        name: "Beninese"
      }, {
        name: "Bhutanese"
      }, {
        name: "Bolivian"
      }, {
        name: "Bosnian"
      }, {
        name: "Brazilian"
      }, {
        name: "British"
      }, {
        name: "Bruneian"
      }, {
        name: "Bulgarian"
      }, {
        name: "Burkinabe"
      }, {
        name: "Burmese"
      }, {
        name: "Burundian"
      }, {
        name: "Cambodian"
      }, {
        name: "Cameroonian"
      }, {
        name: "Canadian"
      }, {
        name: "Cape Verdean"
      }, {
        name: "Central African"
      }, {
        name: "Chadian"
      }, {
        name: "Chilean"
      }, {
        name: "Chinese"
      }, {
        name: "Colombian"
      }, {
        name: "Comoran"
      }, {
        name: "Congolese"
      }, {
        name: "Costa Rican"
      }, {
        name: "Croatian"
      }, {
        name: "Cuban"
      }, {
        name: "Cypriot"
      }, {
        name: "Czech"
      }, {
        name: "Danish"
      }, {
        name: "Djibouti"
      }, {
        name: "Dominican"
      }, {
        name: "Dutch"
      }, {
        name: "East Timorese"
      }, {
        name: "Ecuadorean"
      }, {
        name: "Egyptian"
      }, {
        name: "Emirian"
      }, {
        name: "Equatorial Guinean"
      }, {
        name: "Eritrean"
      }, {
        name: "Estonian"
      }, {
        name: "Ethiopian"
      }, {
        name: "Fijian"
      }, {
        name: "Filipino"
      }, {
        name: "Finnish"
      }, {
        name: "French"
      }, {
        name: "Gabonese"
      }, {
        name: "Gambian"
      }, {
        name: "Georgian"
      }, {
        name: "German"
      }, {
        name: "Ghanaian"
      }, {
        name: "Greek"
      }, {
        name: "Grenadian"
      }, {
        name: "Guatemalan"
      }, {
        name: "Guinea-Bissauan"
      }, {
        name: "Guinean"
      }, {
        name: "Guyanese"
      }, {
        name: "Haitian"
      }, {
        name: "Herzegovinian"
      }, {
        name: "Honduran"
      }, {
        name: "Hungarian"
      }, {
        name: "I-Kiribati"
      }, {
        name: "Icelander"
      }, {
        name: "Indian"
      }, {
        name: "Indonesian"
      }, {
        name: "Iranian"
      }, {
        name: "Iraqi"
      }, {
        name: "Irish"
      }, {
        name: "Israeli"
      }, {
        name: "Italian"
      }, {
        name: "Ivorian"
      }, {
        name: "Jamaican"
      }, {
        name: "Japanese"
      }, {
        name: "Jordanian"
      }, {
        name: "Kazakhstani"
      }, {
        name: "Kenyan"
      }, {
        name: "Kittian and Nevisian"
      }, {
        name: "Kuwaiti"
      }, {
        name: "Kyrgyz"
      }, {
        name: "Laotian"
      }, {
        name: "Latvian"
      }, {
        name: "Lebanese"
      }, {
        name: "Liberian"
      }, {
        name: "Libyan"
      }, {
        name: "Liechtensteiner"
      }, {
        name: "Lithuanian"
      }, {
        name: "Luxembourger"
      }, {
        name: "Macedonian"
      }, {
        name: "Malagasy"
      }, {
        name: "Malawian"
      }, {
        name: "Malaysian"
      }, {
        name: "Maldivan"
      }, {
        name: "Malian"
      }, {
        name: "Maltese"
      }, {
        name: "Marshallese"
      }, {
        name: "Mauritanian"
      }, {
        name: "Mauritian"
      }, {
        name: "Mexican"
      }, {
        name: "Micronesian"
      }, {
        name: "Moldovan"
      }, {
        name: "Monacan"
      }, {
        name: "Mongolian"
      }, {
        name: "Moroccan"
      }, {
        name: "Mosotho"
      }, {
        name: "Motswana"
      }, {
        name: "Mozambican"
      }, {
        name: "Namibian"
      }, {
        name: "Nauruan"
      }, {
        name: "Nepalese"
      }, {
        name: "New Zealander"
      }, {
        name: "Nicaraguan"
      }, {
        name: "Nigerian"
      }, {
        name: "Nigerien"
      }, {
        name: "North Korean"
      }, {
        name: "Northern Irish"
      }, {
        name: "Norwegian"
      }, {
        name: "Omani"
      }, {
        name: "Pakistani"
      }, {
        name: "Palauan"
      }, {
        name: "Panamanian"
      }, {
        name: "Papua New Guinean"
      }, {
        name: "Paraguayan"
      }, {
        name: "Peruvian"
      }, {
        name: "Polish"
      }, {
        name: "Portuguese"
      }, {
        name: "Qatari"
      }, {
        name: "Romani"
      }, {
        name: "Russian"
      }, {
        name: "Rwandan"
      }, {
        name: "Saint Lucian"
      }, {
        name: "Salvadoran"
      }, {
        name: "Samoan"
      }, {
        name: "San Marinese"
      }, {
        name: "Sao Tomean"
      }, {
        name: "Saudi"
      }, {
        name: "Scottish"
      }, {
        name: "Senegalese"
      }, {
        name: "Serbian"
      }, {
        name: "Seychellois"
      }, {
        name: "Sierra Leonean"
      }, {
        name: "Singaporean"
      }, {
        name: "Slovakian"
      }, {
        name: "Slovenian"
      }, {
        name: "Solomon Islander"
      }, {
        name: "Somali"
      }, {
        name: "South African"
      }, {
        name: "South Korean"
      }, {
        name: "Spanish"
      }, {
        name: "Sri Lankan"
      }, {
        name: "Sudanese"
      }, {
        name: "Surinamer"
      }, {
        name: "Swazi"
      }, {
        name: "Swedish"
      }, {
        name: "Swiss"
      }, {
        name: "Syrian"
      }, {
        name: "Taiwanese"
      }, {
        name: "Tajik"
      }, {
        name: "Tanzanian"
      }, {
        name: "Thai"
      }, {
        name: "Togolese"
      }, {
        name: "Tongan"
      }, {
        name: "Trinidadian or Tobagonian"
      }, {
        name: "Tunisian"
      }, {
        name: "Turkish"
      }, {
        name: "Tuvaluan"
      }, {
        name: "Ugandan"
      }, {
        name: "Ukrainian"
      }, {
        name: "Uruguaya"
      }, {
        name: "Uzbekistani"
      }, {
        name: "Venezuela"
      }, {
        name: "Vietnamese"
      }, {
        name: "Wels"
      }, {
        name: "Yemenit"
      }, {
        name: "Zambia"
      }, {
        name: "Zimbabwe"
      }],
      locale_languages: ["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"],
      locale_regions: ["agq-CM", "asa-TZ", "ast-ES", "bas-CM", "bem-ZM", "bez-TZ", "brx-IN", "cgg-UG", "chr-US", "dav-KE", "dje-NE", "dsb-DE", "dua-CM", "dyo-SN", "ebu-KE", "ewo-CM", "fil-PH", "fur-IT", "gsw-CH", "gsw-FR", "gsw-LI", "guz-KE", "haw-US", "hsb-DE", "jgo-CM", "jmc-TZ", "kab-DZ", "kam-KE", "kde-TZ", "kea-CV", "khq-ML", "kkj-CM", "kln-KE", "kok-IN", "ksb-TZ", "ksf-CM", "ksh-DE", "lag-TZ", "lkt-US", "luo-KE", "luy-KE", "mas-KE", "mas-TZ", "mer-KE", "mfe-MU", "mgh-MZ", "mgo-CM", "mua-CM", "naq-NA", "nmg-CM", "nnh-CM", "nus-SD", "nyn-UG", "rof-TZ", "rwk-TZ", "sah-RU", "saq-KE", "sbp-TZ", "seh-MZ", "ses-ML", "shi-Latn", "shi-Latn-MA", "shi-Tfng", "shi-Tfng-MA", "smn-FI", "teo-KE", "teo-UG", "twq-NE", "tzm-Latn", "tzm-Latn-MA", "vai-Latn", "vai-Latn-LR", "vai-Vaii", "vai-Vaii-LR", "vun-TZ", "wae-CH", "xog-UG", "yav-CM", "zgh-MA", "af-NA", "af-ZA", "ak-GH", "am-ET", "ar-001", "ar-AE", "ar-BH", "ar-DJ", "ar-DZ", "ar-EG", "ar-EH", "ar-ER", "ar-IL", "ar-IQ", "ar-JO", "ar-KM", "ar-KW", "ar-LB", "ar-LY", "ar-MA", "ar-MR", "ar-OM", "ar-PS", "ar-QA", "ar-SA", "ar-SD", "ar-SO", "ar-SS", "ar-SY", "ar-TD", "ar-TN", "ar-YE", "as-IN", "az-Cyrl", "az-Cyrl-AZ", "az-Latn", "az-Latn-AZ", "be-BY", "bg-BG", "bm-Latn", "bm-Latn-ML", "bn-BD", "bn-IN", "bo-CN", "bo-IN", "br-FR", "bs-Cyrl", "bs-Cyrl-BA", "bs-Latn", "bs-Latn-BA", "ca-AD", "ca-ES", "ca-ES-VALENCIA", "ca-FR", "ca-IT", "cs-CZ", "cy-GB", "da-DK", "da-GL", "de-AT", "de-BE", "de-CH", "de-DE", "de-LI", "de-LU", "dz-BT", "ee-GH", "ee-TG", "el-CY", "el-GR", "en-001", "en-150", "en-AG", "en-AI", "en-AS", "en-AU", "en-BB", "en-BE", "en-BM", "en-BS", "en-BW", "en-BZ", "en-CA", "en-CC", "en-CK", "en-CM", "en-CX", "en-DG", "en-DM", "en-ER", "en-FJ", "en-FK", "en-FM", "en-GB", "en-GD", "en-GG", "en-GH", "en-GI", "en-GM", "en-GU", "en-GY", "en-HK", "en-IE", "en-IM", "en-IN", "en-IO", "en-JE", "en-JM", "en-KE", "en-KI", "en-KN", "en-KY", "en-LC", "en-LR", "en-LS", "en-MG", "en-MH", "en-MO", "en-MP", "en-MS", "en-MT", "en-MU", "en-MW", "en-MY", "en-NA", "en-NF", "en-NG", "en-NR", "en-NU", "en-NZ", "en-PG", "en-PH", "en-PK", "en-PN", "en-PR", "en-PW", "en-RW", "en-SB", "en-SC", "en-SD", "en-SG", "en-SH", "en-SL", "en-SS", "en-SX", "en-SZ", "en-TC", "en-TK", "en-TO", "en-TT", "en-TV", "en-TZ", "en-UG", "en-UM", "en-US", "en-US-POSIX", "en-VC", "en-VG", "en-VI", "en-VU", "en-WS", "en-ZA", "en-ZM", "en-ZW", "eo-001", "es-419", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-CU", "es-DO", "es-EA", "es-EC", "es-ES", "es-GQ", "es-GT", "es-HN", "es-IC", "es-MX", "es-NI", "es-PA", "es-PE", "es-PH", "es-PR", "es-PY", "es-SV", "es-US", "es-UY", "es-VE", "et-EE", "eu-ES", "fa-AF", "fa-IR", "ff-CM", "ff-GN", "ff-MR", "ff-SN", "fi-FI", "fo-FO", "fr-BE", "fr-BF", "fr-BI", "fr-BJ", "fr-BL", "fr-CA", "fr-CD", "fr-CF", "fr-CG", "fr-CH", "fr-CI", "fr-CM", "fr-DJ", "fr-DZ", "fr-FR", "fr-GA", "fr-GF", "fr-GN", "fr-GP", "fr-GQ", "fr-HT", "fr-KM", "fr-LU", "fr-MA", "fr-MC", "fr-MF", "fr-MG", "fr-ML", "fr-MQ", "fr-MR", "fr-MU", "fr-NC", "fr-NE", "fr-PF", "fr-PM", "fr-RE", "fr-RW", "fr-SC", "fr-SN", "fr-SY", "fr-TD", "fr-TG", "fr-TN", "fr-VU", "fr-WF", "fr-YT", "fy-NL", "ga-IE", "gd-GB", "gl-ES", "gu-IN", "gv-IM", "ha-Latn", "ha-Latn-GH", "ha-Latn-NE", "ha-Latn-NG", "he-IL", "hi-IN", "hr-BA", "hr-HR", "hu-HU", "hy-AM", "id-ID", "ig-NG", "ii-CN", "is-IS", "it-CH", "it-IT", "it-SM", "ja-JP", "ka-GE", "ki-KE", "kk-Cyrl", "kk-Cyrl-KZ", "kl-GL", "km-KH", "kn-IN", "ko-KP", "ko-KR", "ks-Arab", "ks-Arab-IN", "kw-GB", "ky-Cyrl", "ky-Cyrl-KG", "lb-LU", "lg-UG", "ln-AO", "ln-CD", "ln-CF", "ln-CG", "lo-LA", "lt-LT", "lu-CD", "lv-LV", "mg-MG", "mk-MK", "ml-IN", "mn-Cyrl", "mn-Cyrl-MN", "mr-IN", "ms-Latn", "ms-Latn-BN", "ms-Latn-MY", "ms-Latn-SG", "mt-MT", "my-MM", "nb-NO", "nb-SJ", "nd-ZW", "ne-IN", "ne-NP", "nl-AW", "nl-BE", "nl-BQ", "nl-CW", "nl-NL", "nl-SR", "nl-SX", "nn-NO", "om-ET", "om-KE", "or-IN", "os-GE", "os-RU", "pa-Arab", "pa-Arab-PK", "pa-Guru", "pa-Guru-IN", "pl-PL", "ps-AF", "pt-AO", "pt-BR", "pt-CV", "pt-GW", "pt-MO", "pt-MZ", "pt-PT", "pt-ST", "pt-TL", "qu-BO", "qu-EC", "qu-PE", "rm-CH", "rn-BI", "ro-MD", "ro-RO", "ru-BY", "ru-KG", "ru-KZ", "ru-MD", "ru-RU", "ru-UA", "rw-RW", "se-FI", "se-NO", "se-SE", "sg-CF", "si-LK", "sk-SK", "sl-SI", "sn-ZW", "so-DJ", "so-ET", "so-KE", "so-SO", "sq-AL", "sq-MK", "sq-XK", "sr-Cyrl", "sr-Cyrl-BA", "sr-Cyrl-ME", "sr-Cyrl-RS", "sr-Cyrl-XK", "sr-Latn", "sr-Latn-BA", "sr-Latn-ME", "sr-Latn-RS", "sr-Latn-XK", "sv-AX", "sv-FI", "sv-SE", "sw-CD", "sw-KE", "sw-TZ", "sw-UG", "ta-IN", "ta-LK", "ta-MY", "ta-SG", "te-IN", "th-TH", "ti-ER", "ti-ET", "to-TO", "tr-CY", "tr-TR", "ug-Arab", "ug-Arab-CN", "uk-UA", "ur-IN", "ur-PK", "uz-Arab", "uz-Arab-AF", "uz-Cyrl", "uz-Cyrl-UZ", "uz-Latn", "uz-Latn-UZ", "vi-VN", "yi-001", "yo-BJ", "yo-NG", "zh-Hans", "zh-Hans-CN", "zh-Hans-HK", "zh-Hans-MO", "zh-Hans-SG", "zh-Hant", "zh-Hant-HK", "zh-Hant-MO", "zh-Hant-TW", "zu-ZA"],
      us_states_and_dc: [{
        name: "Alabama",
        abbreviation: "AL"
      }, {
        name: "Alaska",
        abbreviation: "AK"
      }, {
        name: "Arizona",
        abbreviation: "AZ"
      }, {
        name: "Arkansas",
        abbreviation: "AR"
      }, {
        name: "California",
        abbreviation: "CA"
      }, {
        name: "Colorado",
        abbreviation: "CO"
      }, {
        name: "Connecticut",
        abbreviation: "CT"
      }, {
        name: "Delaware",
        abbreviation: "DE"
      }, {
        name: "District of Columbia",
        abbreviation: "DC"
      }, {
        name: "Florida",
        abbreviation: "FL"
      }, {
        name: "Georgia",
        abbreviation: "GA"
      }, {
        name: "Hawaii",
        abbreviation: "HI"
      }, {
        name: "Idaho",
        abbreviation: "ID"
      }, {
        name: "Illinois",
        abbreviation: "IL"
      }, {
        name: "Indiana",
        abbreviation: "IN"
      }, {
        name: "Iowa",
        abbreviation: "IA"
      }, {
        name: "Kansas",
        abbreviation: "KS"
      }, {
        name: "Kentucky",
        abbreviation: "KY"
      }, {
        name: "Louisiana",
        abbreviation: "LA"
      }, {
        name: "Maine",
        abbreviation: "ME"
      }, {
        name: "Maryland",
        abbreviation: "MD"
      }, {
        name: "Massachusetts",
        abbreviation: "MA"
      }, {
        name: "Michigan",
        abbreviation: "MI"
      }, {
        name: "Minnesota",
        abbreviation: "MN"
      }, {
        name: "Mississippi",
        abbreviation: "MS"
      }, {
        name: "Missouri",
        abbreviation: "MO"
      }, {
        name: "Montana",
        abbreviation: "MT"
      }, {
        name: "Nebraska",
        abbreviation: "NE"
      }, {
        name: "Nevada",
        abbreviation: "NV"
      }, {
        name: "New Hampshire",
        abbreviation: "NH"
      }, {
        name: "New Jersey",
        abbreviation: "NJ"
      }, {
        name: "New Mexico",
        abbreviation: "NM"
      }, {
        name: "New York",
        abbreviation: "NY"
      }, {
        name: "North Carolina",
        abbreviation: "NC"
      }, {
        name: "North Dakota",
        abbreviation: "ND"
      }, {
        name: "Ohio",
        abbreviation: "OH"
      }, {
        name: "Oklahoma",
        abbreviation: "OK"
      }, {
        name: "Oregon",
        abbreviation: "OR"
      }, {
        name: "Pennsylvania",
        abbreviation: "PA"
      }, {
        name: "Rhode Island",
        abbreviation: "RI"
      }, {
        name: "South Carolina",
        abbreviation: "SC"
      }, {
        name: "South Dakota",
        abbreviation: "SD"
      }, {
        name: "Tennessee",
        abbreviation: "TN"
      }, {
        name: "Texas",
        abbreviation: "TX"
      }, {
        name: "Utah",
        abbreviation: "UT"
      }, {
        name: "Vermont",
        abbreviation: "VT"
      }, {
        name: "Virginia",
        abbreviation: "VA"
      }, {
        name: "Washington",
        abbreviation: "WA"
      }, {
        name: "West Virginia",
        abbreviation: "WV"
      }, {
        name: "Wisconsin",
        abbreviation: "WI"
      }, {
        name: "Wyoming",
        abbreviation: "WY"
      }],
      territories: [{
        name: "American Samoa",
        abbreviation: "AS"
      }, {
        name: "Federated States of Micronesia",
        abbreviation: "FM"
      }, {
        name: "Guam",
        abbreviation: "GU"
      }, {
        name: "Marshall Islands",
        abbreviation: "MH"
      }, {
        name: "Northern Mariana Islands",
        abbreviation: "MP"
      }, {
        name: "Puerto Rico",
        abbreviation: "PR"
      }, {
        name: "Virgin Islands, U.S.",
        abbreviation: "VI"
      }],
      armed_forces: [{
        name: "Armed Forces Europe",
        abbreviation: "AE"
      }, {
        name: "Armed Forces Pacific",
        abbreviation: "AP"
      }, {
        name: "Armed Forces the Americas",
        abbreviation: "AA"
      }],
      country_regions: {
        it: [{
          name: "Valle d'Aosta",
          abbreviation: "VDA"
        }, {
          name: "Piemonte",
          abbreviation: "PIE"
        }, {
          name: "Lombardia",
          abbreviation: "LOM"
        }, {
          name: "Veneto",
          abbreviation: "VEN"
        }, {
          name: "Trentino Alto Adige",
          abbreviation: "TAA"
        }, {
          name: "Friuli Venezia Giulia",
          abbreviation: "FVG"
        }, {
          name: "Liguria",
          abbreviation: "LIG"
        }, {
          name: "Emilia Romagna",
          abbreviation: "EMR"
        }, {
          name: "Toscana",
          abbreviation: "TOS"
        }, {
          name: "Umbria",
          abbreviation: "UMB"
        }, {
          name: "Marche",
          abbreviation: "MAR"
        }, {
          name: "Abruzzo",
          abbreviation: "ABR"
        }, {
          name: "Lazio",
          abbreviation: "LAZ"
        }, {
          name: "Campania",
          abbreviation: "CAM"
        }, {
          name: "Puglia",
          abbreviation: "PUG"
        }, {
          name: "Basilicata",
          abbreviation: "BAS"
        }, {
          name: "Molise",
          abbreviation: "MOL"
        }, {
          name: "Calabria",
          abbreviation: "CAL"
        }, {
          name: "Sicilia",
          abbreviation: "SIC"
        }, {
          name: "Sardegna",
          abbreviation: "SAR"
        }]
      },
      street_suffixes: {
        us: [{
          name: "Avenue",
          abbreviation: "Ave"
        }, {
          name: "Boulevard",
          abbreviation: "Blvd"
        }, {
          name: "Center",
          abbreviation: "Ctr"
        }, {
          name: "Circle",
          abbreviation: "Cir"
        }, {
          name: "Court",
          abbreviation: "Ct"
        }, {
          name: "Drive",
          abbreviation: "Dr"
        }, {
          name: "Extension",
          abbreviation: "Ext"
        }, {
          name: "Glen",
          abbreviation: "Gln"
        }, {
          name: "Grove",
          abbreviation: "Grv"
        }, {
          name: "Heights",
          abbreviation: "Hts"
        }, {
          name: "Highway",
          abbreviation: "Hwy"
        }, {
          name: "Junction",
          abbreviation: "Jct"
        }, {
          name: "Key",
          abbreviation: "Key"
        }, {
          name: "Lane",
          abbreviation: "Ln"
        }, {
          name: "Loop",
          abbreviation: "Loop"
        }, {
          name: "Manor",
          abbreviation: "Mnr"
        }, {
          name: "Mill",
          abbreviation: "Mill"
        }, {
          name: "Park",
          abbreviation: "Park"
        }, {
          name: "Parkway",
          abbreviation: "Pkwy"
        }, {
          name: "Pass",
          abbreviation: "Pass"
        }, {
          name: "Path",
          abbreviation: "Path"
        }, {
          name: "Pike",
          abbreviation: "Pike"
        }, {
          name: "Place",
          abbreviation: "Pl"
        }, {
          name: "Plaza",
          abbreviation: "Plz"
        }, {
          name: "Point",
          abbreviation: "Pt"
        }, {
          name: "Ridge",
          abbreviation: "Rdg"
        }, {
          name: "River",
          abbreviation: "Riv"
        }, {
          name: "Road",
          abbreviation: "Rd"
        }, {
          name: "Square",
          abbreviation: "Sq"
        }, {
          name: "Street",
          abbreviation: "St"
        }, {
          name: "Terrace",
          abbreviation: "Ter"
        }, {
          name: "Trail",
          abbreviation: "Trl"
        }, {
          name: "Turnpike",
          abbreviation: "Tpke"
        }, {
          name: "View",
          abbreviation: "Vw"
        }, {
          name: "Way",
          abbreviation: "Way"
        }],
        it: [{
          name: "Accesso",
          abbreviation: "Acc."
        }, {
          name: "Alzaia",
          abbreviation: "Alz."
        }, {
          name: "Arco",
          abbreviation: "Arco"
        }, {
          name: "Archivolto",
          abbreviation: "Acv."
        }, {
          name: "Arena",
          abbreviation: "Arena"
        }, {
          name: "Argine",
          abbreviation: "Argine"
        }, {
          name: "Bacino",
          abbreviation: "Bacino"
        }, {
          name: "Banchi",
          abbreviation: "Banchi"
        }, {
          name: "Banchina",
          abbreviation: "Ban."
        }, {
          name: "Bastioni",
          abbreviation: "Bas."
        }, {
          name: "Belvedere",
          abbreviation: "Belv."
        }, {
          name: "Borgata",
          abbreviation: "B.ta"
        }, {
          name: "Borgo",
          abbreviation: "B.go"
        }, {
          name: "Calata",
          abbreviation: "Cal."
        }, {
          name: "Calle",
          abbreviation: "Calle"
        }, {
          name: "Campiello",
          abbreviation: "Cam."
        }, {
          name: "Campo",
          abbreviation: "Cam."
        }, {
          name: "Canale",
          abbreviation: "Can."
        }, {
          name: "Carraia",
          abbreviation: "Carr."
        }, {
          name: "Cascina",
          abbreviation: "Cascina"
        }, {
          name: "Case sparse",
          abbreviation: "c.s."
        }, {
          name: "Cavalcavia",
          abbreviation: "Cv."
        }, {
          name: "Circonvallazione",
          abbreviation: "Cv."
        }, {
          name: "Complanare",
          abbreviation: "C.re"
        }, {
          name: "Contrada",
          abbreviation: "C.da"
        }, {
          name: "Corso",
          abbreviation: "C.so"
        }, {
          name: "Corte",
          abbreviation: "C.te"
        }, {
          name: "Cortile",
          abbreviation: "C.le"
        }, {
          name: "Diramazione",
          abbreviation: "Dir."
        }, {
          name: "Fondaco",
          abbreviation: "F.co"
        }, {
          name: "Fondamenta",
          abbreviation: "F.ta"
        }, {
          name: "Fondo",
          abbreviation: "F.do"
        }, {
          name: "Frazione",
          abbreviation: "Fr."
        }, {
          name: "Isola",
          abbreviation: "Is."
        }, {
          name: "Largo",
          abbreviation: "L.go"
        }, {
          name: "Litoranea",
          abbreviation: "Lit."
        }, {
          name: "Lungolago",
          abbreviation: "L.go lago"
        }, {
          name: "Lungo Po",
          abbreviation: "l.go Po"
        }, {
          name: "Molo",
          abbreviation: "Molo"
        }, {
          name: "Mura",
          abbreviation: "Mura"
        }, {
          name: "Passaggio privato",
          abbreviation: "pass. priv."
        }, {
          name: "Passeggiata",
          abbreviation: "Pass."
        }, {
          name: "Piazza",
          abbreviation: "P.zza"
        }, {
          name: "Piazzale",
          abbreviation: "P.le"
        }, {
          name: "Ponte",
          abbreviation: "P.te"
        }, {
          name: "Portico",
          abbreviation: "P.co"
        }, {
          name: "Rampa",
          abbreviation: "Rampa"
        }, {
          name: "Regione",
          abbreviation: "Reg."
        }, {
          name: "Rione",
          abbreviation: "R.ne"
        }, {
          name: "Rio",
          abbreviation: "Rio"
        }, {
          name: "Ripa",
          abbreviation: "Ripa"
        }, {
          name: "Riva",
          abbreviation: "Riva"
        }, {
          name: "Rondò",
          abbreviation: "Rondò"
        }, {
          name: "Rotonda",
          abbreviation: "Rot."
        }, {
          name: "Sagrato",
          abbreviation: "Sagr."
        }, {
          name: "Salita",
          abbreviation: "Sal."
        }, {
          name: "Scalinata",
          abbreviation: "Scal."
        }, {
          name: "Scalone",
          abbreviation: "Scal."
        }, {
          name: "Slargo",
          abbreviation: "Sl."
        }, {
          name: "Sottoportico",
          abbreviation: "Sott."
        }, {
          name: "Strada",
          abbreviation: "Str."
        }, {
          name: "Stradale",
          abbreviation: "Str.le"
        }, {
          name: "Strettoia",
          abbreviation: "Strett."
        }, {
          name: "Traversa",
          abbreviation: "Trav."
        }, {
          name: "Via",
          abbreviation: "V."
        }, {
          name: "Viale",
          abbreviation: "V.le"
        }, {
          name: "Vicinale",
          abbreviation: "Vic.le"
        }, {
          name: "Vicolo",
          abbreviation: "Vic."
        }],
        uk: [{
          name: "Avenue",
          abbreviation: "Ave"
        }, {
          name: "Close",
          abbreviation: "Cl"
        }, {
          name: "Court",
          abbreviation: "Ct"
        }, {
          name: "Crescent",
          abbreviation: "Cr"
        }, {
          name: "Drive",
          abbreviation: "Dr"
        }, {
          name: "Garden",
          abbreviation: "Gdn"
        }, {
          name: "Gardens",
          abbreviation: "Gdns"
        }, {
          name: "Green",
          abbreviation: "Gn"
        }, {
          name: "Grove",
          abbreviation: "Gr"
        }, {
          name: "Lane",
          abbreviation: "Ln"
        }, {
          name: "Mount",
          abbreviation: "Mt"
        }, {
          name: "Place",
          abbreviation: "Pl"
        }, {
          name: "Park",
          abbreviation: "Pk"
        }, {
          name: "Ridge",
          abbreviation: "Rdg"
        }, {
          name: "Road",
          abbreviation: "Rd"
        }, {
          name: "Square",
          abbreviation: "Sq"
        }, {
          name: "Street",
          abbreviation: "St"
        }, {
          name: "Terrace",
          abbreviation: "Ter"
        }, {
          name: "Valley",
          abbreviation: "Val"
        }]
      },
      months: [{
        name: "January",
        short_name: "Jan",
        numeric: "01",
        days: 31
      }, {
        name: "February",
        short_name: "Feb",
        numeric: "02",
        days: 28
      }, {
        name: "March",
        short_name: "Mar",
        numeric: "03",
        days: 31
      }, {
        name: "April",
        short_name: "Apr",
        numeric: "04",
        days: 30
      }, {
        name: "May",
        short_name: "May",
        numeric: "05",
        days: 31
      }, {
        name: "June",
        short_name: "Jun",
        numeric: "06",
        days: 30
      }, {
        name: "July",
        short_name: "Jul",
        numeric: "07",
        days: 31
      }, {
        name: "August",
        short_name: "Aug",
        numeric: "08",
        days: 31
      }, {
        name: "September",
        short_name: "Sep",
        numeric: "09",
        days: 30
      }, {
        name: "October",
        short_name: "Oct",
        numeric: "10",
        days: 31
      }, {
        name: "November",
        short_name: "Nov",
        numeric: "11",
        days: 30
      }, {
        name: "December",
        short_name: "Dec",
        numeric: "12",
        days: 31
      }],
      cc_types: [{
        name: "American Express",
        short_name: "amex",
        prefix: "34",
        length: 15
      }, {
        name: "Bankcard",
        short_name: "bankcard",
        prefix: "5610",
        length: 16
      }, {
        name: "China UnionPay",
        short_name: "chinaunion",
        prefix: "62",
        length: 16
      }, {
        name: "Diners Club Carte Blanche",
        short_name: "dccarte",
        prefix: "300",
        length: 14
      }, {
        name: "Diners Club enRoute",
        short_name: "dcenroute",
        prefix: "2014",
        length: 15
      }, {
        name: "Diners Club International",
        short_name: "dcintl",
        prefix: "36",
        length: 14
      }, {
        name: "Diners Club United States & Canada",
        short_name: "dcusc",
        prefix: "54",
        length: 16
      }, {
        name: "Discover Card",
        short_name: "discover",
        prefix: "6011",
        length: 16
      }, {
        name: "InstaPayment",
        short_name: "instapay",
        prefix: "637",
        length: 16
      }, {
        name: "JCB",
        short_name: "jcb",
        prefix: "3528",
        length: 16
      }, {
        name: "Laser",
        short_name: "laser",
        prefix: "6304",
        length: 16
      }, {
        name: "Maestro",
        short_name: "maestro",
        prefix: "5018",
        length: 16
      }, {
        name: "Mastercard",
        short_name: "mc",
        prefix: "51",
        length: 16
      }, {
        name: "Solo",
        short_name: "solo",
        prefix: "6334",
        length: 16
      }, {
        name: "Switch",
        short_name: "switch",
        prefix: "4903",
        length: 16
      }, {
        name: "Visa",
        short_name: "visa",
        prefix: "4",
        length: 16
      }, {
        name: "Visa Electron",
        short_name: "electron",
        prefix: "4026",
        length: 16
      }],
      currency_types: [{
        code: "AED",
        name: "United Arab Emirates Dirham"
      }, {
        code: "AFN",
        name: "Afghanistan Afghani"
      }, {
        code: "ALL",
        name: "Albania Lek"
      }, {
        code: "AMD",
        name: "Armenia Dram"
      }, {
        code: "ANG",
        name: "Netherlands Antilles Guilder"
      }, {
        code: "AOA",
        name: "Angola Kwanza"
      }, {
        code: "ARS",
        name: "Argentina Peso"
      }, {
        code: "AUD",
        name: "Australia Dollar"
      }, {
        code: "AWG",
        name: "Aruba Guilder"
      }, {
        code: "AZN",
        name: "Azerbaijan New Manat"
      }, {
        code: "BAM",
        name: "Bosnia and Herzegovina Convertible Marka"
      }, {
        code: "BBD",
        name: "Barbados Dollar"
      }, {
        code: "BDT",
        name: "Bangladesh Taka"
      }, {
        code: "BGN",
        name: "Bulgaria Lev"
      }, {
        code: "BHD",
        name: "Bahrain Dinar"
      }, {
        code: "BIF",
        name: "Burundi Franc"
      }, {
        code: "BMD",
        name: "Bermuda Dollar"
      }, {
        code: "BND",
        name: "Brunei Darussalam Dollar"
      }, {
        code: "BOB",
        name: "Bolivia Boliviano"
      }, {
        code: "BRL",
        name: "Brazil Real"
      }, {
        code: "BSD",
        name: "Bahamas Dollar"
      }, {
        code: "BTN",
        name: "Bhutan Ngultrum"
      }, {
        code: "BWP",
        name: "Botswana Pula"
      }, {
        code: "BYR",
        name: "Belarus Ruble"
      }, {
        code: "BZD",
        name: "Belize Dollar"
      }, {
        code: "CAD",
        name: "Canada Dollar"
      }, {
        code: "CDF",
        name: "Congo/Kinshasa Franc"
      }, {
        code: "CHF",
        name: "Switzerland Franc"
      }, {
        code: "CLP",
        name: "Chile Peso"
      }, {
        code: "CNY",
        name: "China Yuan Renminbi"
      }, {
        code: "COP",
        name: "Colombia Peso"
      }, {
        code: "CRC",
        name: "Costa Rica Colon"
      }, {
        code: "CUC",
        name: "Cuba Convertible Peso"
      }, {
        code: "CUP",
        name: "Cuba Peso"
      }, {
        code: "CVE",
        name: "Cape Verde Escudo"
      }, {
        code: "CZK",
        name: "Czech Republic Koruna"
      }, {
        code: "DJF",
        name: "Djibouti Franc"
      }, {
        code: "DKK",
        name: "Denmark Krone"
      }, {
        code: "DOP",
        name: "Dominican Republic Peso"
      }, {
        code: "DZD",
        name: "Algeria Dinar"
      }, {
        code: "EGP",
        name: "Egypt Pound"
      }, {
        code: "ERN",
        name: "Eritrea Nakfa"
      }, {
        code: "ETB",
        name: "Ethiopia Birr"
      }, {
        code: "EUR",
        name: "Euro Member Countries"
      }, {
        code: "FJD",
        name: "Fiji Dollar"
      }, {
        code: "FKP",
        name: "Falkland Islands (Malvinas) Pound"
      }, {
        code: "GBP",
        name: "United Kingdom Pound"
      }, {
        code: "GEL",
        name: "Georgia Lari"
      }, {
        code: "GGP",
        name: "Guernsey Pound"
      }, {
        code: "GHS",
        name: "Ghana Cedi"
      }, {
        code: "GIP",
        name: "Gibraltar Pound"
      }, {
        code: "GMD",
        name: "Gambia Dalasi"
      }, {
        code: "GNF",
        name: "Guinea Franc"
      }, {
        code: "GTQ",
        name: "Guatemala Quetzal"
      }, {
        code: "GYD",
        name: "Guyana Dollar"
      }, {
        code: "HKD",
        name: "Hong Kong Dollar"
      }, {
        code: "HNL",
        name: "Honduras Lempira"
      }, {
        code: "HRK",
        name: "Croatia Kuna"
      }, {
        code: "HTG",
        name: "Haiti Gourde"
      }, {
        code: "HUF",
        name: "Hungary Forint"
      }, {
        code: "IDR",
        name: "Indonesia Rupiah"
      }, {
        code: "ILS",
        name: "Israel Shekel"
      }, {
        code: "IMP",
        name: "Isle of Man Pound"
      }, {
        code: "INR",
        name: "India Rupee"
      }, {
        code: "IQD",
        name: "Iraq Dinar"
      }, {
        code: "IRR",
        name: "Iran Rial"
      }, {
        code: "ISK",
        name: "Iceland Krona"
      }, {
        code: "JEP",
        name: "Jersey Pound"
      }, {
        code: "JMD",
        name: "Jamaica Dollar"
      }, {
        code: "JOD",
        name: "Jordan Dinar"
      }, {
        code: "JPY",
        name: "Japan Yen"
      }, {
        code: "KES",
        name: "Kenya Shilling"
      }, {
        code: "KGS",
        name: "Kyrgyzstan Som"
      }, {
        code: "KHR",
        name: "Cambodia Riel"
      }, {
        code: "KMF",
        name: "Comoros Franc"
      }, {
        code: "KPW",
        name: "Korea (North) Won"
      }, {
        code: "KRW",
        name: "Korea (South) Won"
      }, {
        code: "KWD",
        name: "Kuwait Dinar"
      }, {
        code: "KYD",
        name: "Cayman Islands Dollar"
      }, {
        code: "KZT",
        name: "Kazakhstan Tenge"
      }, {
        code: "LAK",
        name: "Laos Kip"
      }, {
        code: "LBP",
        name: "Lebanon Pound"
      }, {
        code: "LKR",
        name: "Sri Lanka Rupee"
      }, {
        code: "LRD",
        name: "Liberia Dollar"
      }, {
        code: "LSL",
        name: "Lesotho Loti"
      }, {
        code: "LTL",
        name: "Lithuania Litas"
      }, {
        code: "LYD",
        name: "Libya Dinar"
      }, {
        code: "MAD",
        name: "Morocco Dirham"
      }, {
        code: "MDL",
        name: "Moldova Leu"
      }, {
        code: "MGA",
        name: "Madagascar Ariary"
      }, {
        code: "MKD",
        name: "Macedonia Denar"
      }, {
        code: "MMK",
        name: "Myanmar (Burma) Kyat"
      }, {
        code: "MNT",
        name: "Mongolia Tughrik"
      }, {
        code: "MOP",
        name: "Macau Pataca"
      }, {
        code: "MRO",
        name: "Mauritania Ouguiya"
      }, {
        code: "MUR",
        name: "Mauritius Rupee"
      }, {
        code: "MVR",
        name: "Maldives (Maldive Islands) Rufiyaa"
      }, {
        code: "MWK",
        name: "Malawi Kwacha"
      }, {
        code: "MXN",
        name: "Mexico Peso"
      }, {
        code: "MYR",
        name: "Malaysia Ringgit"
      }, {
        code: "MZN",
        name: "Mozambique Metical"
      }, {
        code: "NAD",
        name: "Namibia Dollar"
      }, {
        code: "NGN",
        name: "Nigeria Naira"
      }, {
        code: "NIO",
        name: "Nicaragua Cordoba"
      }, {
        code: "NOK",
        name: "Norway Krone"
      }, {
        code: "NPR",
        name: "Nepal Rupee"
      }, {
        code: "NZD",
        name: "New Zealand Dollar"
      }, {
        code: "OMR",
        name: "Oman Rial"
      }, {
        code: "PAB",
        name: "Panama Balboa"
      }, {
        code: "PEN",
        name: "Peru Nuevo Sol"
      }, {
        code: "PGK",
        name: "Papua New Guinea Kina"
      }, {
        code: "PHP",
        name: "Philippines Peso"
      }, {
        code: "PKR",
        name: "Pakistan Rupee"
      }, {
        code: "PLN",
        name: "Poland Zloty"
      }, {
        code: "PYG",
        name: "Paraguay Guarani"
      }, {
        code: "QAR",
        name: "Qatar Riyal"
      }, {
        code: "RON",
        name: "Romania New Leu"
      }, {
        code: "RSD",
        name: "Serbia Dinar"
      }, {
        code: "RUB",
        name: "Russia Ruble"
      }, {
        code: "RWF",
        name: "Rwanda Franc"
      }, {
        code: "SAR",
        name: "Saudi Arabia Riyal"
      }, {
        code: "SBD",
        name: "Solomon Islands Dollar"
      }, {
        code: "SCR",
        name: "Seychelles Rupee"
      }, {
        code: "SDG",
        name: "Sudan Pound"
      }, {
        code: "SEK",
        name: "Sweden Krona"
      }, {
        code: "SGD",
        name: "Singapore Dollar"
      }, {
        code: "SHP",
        name: "Saint Helena Pound"
      }, {
        code: "SLL",
        name: "Sierra Leone Leone"
      }, {
        code: "SOS",
        name: "Somalia Shilling"
      }, {
        code: "SPL",
        name: "Seborga Luigino"
      }, {
        code: "SRD",
        name: "Suriname Dollar"
      }, {
        code: "STD",
        name: "São Tomé and Príncipe Dobra"
      }, {
        code: "SVC",
        name: "El Salvador Colon"
      }, {
        code: "SYP",
        name: "Syria Pound"
      }, {
        code: "SZL",
        name: "Swaziland Lilangeni"
      }, {
        code: "THB",
        name: "Thailand Baht"
      }, {
        code: "TJS",
        name: "Tajikistan Somoni"
      }, {
        code: "TMT",
        name: "Turkmenistan Manat"
      }, {
        code: "TND",
        name: "Tunisia Dinar"
      }, {
        code: "TOP",
        name: "Tonga Pa'anga"
      }, {
        code: "TRY",
        name: "Turkey Lira"
      }, {
        code: "TTD",
        name: "Trinidad and Tobago Dollar"
      }, {
        code: "TVD",
        name: "Tuvalu Dollar"
      }, {
        code: "TWD",
        name: "Taiwan New Dollar"
      }, {
        code: "TZS",
        name: "Tanzania Shilling"
      }, {
        code: "UAH",
        name: "Ukraine Hryvnia"
      }, {
        code: "UGX",
        name: "Uganda Shilling"
      }, {
        code: "USD",
        name: "United States Dollar"
      }, {
        code: "UYU",
        name: "Uruguay Peso"
      }, {
        code: "UZS",
        name: "Uzbekistan Som"
      }, {
        code: "VEF",
        name: "Venezuela Bolivar"
      }, {
        code: "VND",
        name: "Viet Nam Dong"
      }, {
        code: "VUV",
        name: "Vanuatu Vatu"
      }, {
        code: "WST",
        name: "Samoa Tala"
      }, {
        code: "XAF",
        name: "Communauté Financière Africaine (BEAC) CFA Franc BEAC"
      }, {
        code: "XCD",
        name: "East Caribbean Dollar"
      }, {
        code: "XDR",
        name: "International Monetary Fund (IMF) Special Drawing Rights"
      }, {
        code: "XOF",
        name: "Communauté Financière Africaine (BCEAO) Franc"
      }, {
        code: "XPF",
        name: "Comptoirs Français du Pacifique (CFP) Franc"
      }, {
        code: "YER",
        name: "Yemen Rial"
      }, {
        code: "ZAR",
        name: "South Africa Rand"
      }, {
        code: "ZMW",
        name: "Zambia Kwacha"
      }, {
        code: "ZWD",
        name: "Zimbabwe Dollar"
      }],
      colorNames: ["AliceBlue", "Black", "Navy", "DarkBlue", "MediumBlue", "Blue", "DarkGreen", "Green", "Teal", "DarkCyan", "DeepSkyBlue", "DarkTurquoise", "MediumSpringGreen", "Lime", "SpringGreen", "Aqua", "Cyan", "MidnightBlue", "DodgerBlue", "LightSeaGreen", "ForestGreen", "SeaGreen", "DarkSlateGray", "LimeGreen", "MediumSeaGreen", "Turquoise", "RoyalBlue", "SteelBlue", "DarkSlateBlue", "MediumTurquoise", "Indigo", "DarkOliveGreen", "CadetBlue", "CornflowerBlue", "RebeccaPurple", "MediumAquaMarine", "DimGray", "SlateBlue", "OliveDrab", "SlateGray", "LightSlateGray", "MediumSlateBlue", "LawnGreen", "Chartreuse", "Aquamarine", "Maroon", "Purple", "Olive", "Gray", "SkyBlue", "LightSkyBlue", "BlueViolet", "DarkRed", "DarkMagenta", "SaddleBrown", "Ivory", "White", "DarkSeaGreen", "LightGreen", "MediumPurple", "DarkViolet", "PaleGreen", "DarkOrchid", "YellowGreen", "Sienna", "Brown", "DarkGray", "LightBlue", "GreenYellow", "PaleTurquoise", "LightSteelBlue", "PowderBlue", "FireBrick", "DarkGoldenRod", "MediumOrchid", "RosyBrown", "DarkKhaki", "Silver", "MediumVioletRed", "IndianRed", "Peru", "Chocolate", "Tan", "LightGray", "Thistle", "Orchid", "GoldenRod", "PaleVioletRed", "Crimson", "Gainsboro", "Plum", "BurlyWood", "LightCyan", "Lavender", "DarkSalmon", "Violet", "PaleGoldenRod", "LightCoral", "Khaki", "AliceBlue", "HoneyDew", "Azure", "SandyBrown", "Wheat", "Beige", "WhiteSmoke", "MintCream", "GhostWhite", "Salmon", "AntiqueWhite", "Linen", "LightGoldenRodYellow", "OldLace", "Red", "Fuchsia", "Magenta", "DeepPink", "OrangeRed", "Tomato", "HotPink", "Coral", "DarkOrange", "LightSalmon", "Orange", "LightPink", "Pink", "Gold", "PeachPuff", "NavajoWhite", "Moccasin", "Bisque", "MistyRose", "BlanchedAlmond", "PapayaWhip", "LavenderBlush", "SeaShell", "Cornsilk", "LemonChiffon", "FloralWhite", "Snow", "Yellow", "LightYellow"],
      company: ["3Com Corp", "3M Company", "A.G. Edwards Inc.", "Abbott Laboratories", "Abercrombie & Fitch Co.", "ABM Industries Incorporated", "Ace Hardware Corporation", "ACT Manufacturing Inc.", "Acterna Corp.", "Adams Resources & Energy, Inc.", "ADC Telecommunications, Inc.", "Adelphia Communications Corporation", "Administaff, Inc.", "Adobe Systems Incorporated", "Adolph Coors Company", "Advance Auto Parts, Inc.", "Advanced Micro Devices, Inc.", "AdvancePCS, Inc.", "Advantica Restaurant Group, Inc.", "The AES Corporation", "Aetna Inc.", "Affiliated Computer Services, Inc.", "AFLAC Incorporated", "AGCO Corporation", "Agilent Technologies, Inc.", "Agway Inc.", "Apartment Investment and Management Company", "Air Products and Chemicals, Inc.", "Airborne, Inc.", "Airgas, Inc.", "AK Steel Holding Corporation", "Alaska Air Group, Inc.", "Alberto-Culver Company", "Albertson's, Inc.", "Alcoa Inc.", "Alleghany Corporation", "Allegheny Energy, Inc.", "Allegheny Technologies Incorporated", "Allergan, Inc.", "ALLETE, Inc.", "Alliant Energy Corporation", "Allied Waste Industries, Inc.", "Allmerica Financial Corporation", "The Allstate Corporation", "ALLTEL Corporation", "The Alpine Group, Inc.", "Amazon.com, Inc.", "AMC Entertainment Inc.", "American Power Conversion Corporation", "Amerada Hess Corporation", "AMERCO", "Ameren Corporation", "America West Holdings Corporation", "American Axle & Manufacturing Holdings, Inc.", "American Eagle Outfitters, Inc.", "American Electric Power Company, Inc.", "American Express Company", "American Financial Group, Inc.", "American Greetings Corporation", "American International Group, Inc.", "American Standard Companies Inc.", "American Water Works Company, Inc.", "AmerisourceBergen Corporation", "Ames Department Stores, Inc.", "Amgen Inc.", "Amkor Technology, Inc.", "AMR Corporation", "AmSouth Bancorp.", "Amtran, Inc.", "Anadarko Petroleum Corporation", "Analog Devices, Inc.", "Anheuser-Busch Companies, Inc.", "Anixter International Inc.", "AnnTaylor Inc.", "Anthem, Inc.", "AOL Time Warner Inc.", "Aon Corporation", "Apache Corporation", "Apple Computer, Inc.", "Applera Corporation", "Applied Industrial Technologies, Inc.", "Applied Materials, Inc.", "Aquila, Inc.", "ARAMARK Corporation", "Arch Coal, Inc.", "Archer Daniels Midland Company", "Arkansas Best Corporation", "Armstrong Holdings, Inc.", "Arrow Electronics, Inc.", "ArvinMeritor, Inc.", "Ashland Inc.", "Astoria Financial Corporation", "AT&T Corp.", "Atmel Corporation", "Atmos Energy Corporation", "Audiovox Corporation", "Autoliv, Inc.", "Automatic Data Processing, Inc.", "AutoNation, Inc.", "AutoZone, Inc.", "Avaya Inc.", "Avery Dennison Corporation", "Avista Corporation", "Avnet, Inc.", "Avon Products, Inc.", "Baker Hughes Incorporated", "Ball Corporation", "Bank of America Corporation", "The Bank of New York Company, Inc.", "Bank One Corporation", "Banknorth Group, Inc.", "Banta Corporation", "Barnes & Noble, Inc.", "Bausch & Lomb Incorporated", "Baxter International Inc.", "BB&T Corporation", "The Bear Stearns Companies Inc.", "Beazer Homes USA, Inc.", "Beckman Coulter, Inc.", "Becton, Dickinson and Company", "Bed Bath & Beyond Inc.", "Belk, Inc.", "Bell Microproducts Inc.", "BellSouth Corporation", "Belo Corp.", "Bemis Company, Inc.", "Benchmark Electronics, Inc.", "Berkshire Hathaway Inc.", "Best Buy Co., Inc.", "Bethlehem Steel Corporation", "Beverly Enterprises, Inc.", "Big Lots, Inc.", "BJ Services Company", "BJ's Wholesale Club, Inc.", "The Black & Decker Corporation", "Black Hills Corporation", "BMC Software, Inc.", "The Boeing Company", "Boise Cascade Corporation", "Borders Group, Inc.", "BorgWarner Inc.", "Boston Scientific Corporation", "Bowater Incorporated", "Briggs & Stratton Corporation", "Brightpoint, Inc.", "Brinker International, Inc.", "Bristol-Myers Squibb Company", "Broadwing, Inc.", "Brown Shoe Company, Inc.", "Brown-Forman Corporation", "Brunswick Corporation", "Budget Group, Inc.", "Burlington Coat Factory Warehouse Corporation", "Burlington Industries, Inc.", "Burlington Northern Santa Fe Corporation", "Burlington Resources Inc.", "C. H. Robinson Worldwide Inc.", "Cablevision Systems Corp", "Cabot Corp", "Cadence Design Systems, Inc.", "Calpine Corp.", "Campbell Soup Co.", "Capital One Financial Corp.", "Cardinal Health Inc.", "Caremark Rx Inc.", "Carlisle Cos. Inc.", "Carpenter Technology Corp.", "Casey's General Stores Inc.", "Caterpillar Inc.", "CBRL Group Inc.", "CDI Corp.", "CDW Computer Centers Inc.", "CellStar Corp.", "Cendant Corp", "Cenex Harvest States Cooperatives", "Centex Corp.", "CenturyTel Inc.", "Ceridian Corp.", "CH2M Hill Cos. Ltd.", "Champion Enterprises Inc.", "Charles Schwab Corp.", "Charming Shoppes Inc.", "Charter Communications Inc.", "Charter One Financial Inc.", "ChevronTexaco Corp.", "Chiquita Brands International Inc.", "Chubb Corp", "Ciena Corp.", "Cigna Corp", "Cincinnati Financial Corp.", "Cinergy Corp.", "Cintas Corp.", "Circuit City Stores Inc.", "Cisco Systems Inc.", "Citigroup, Inc", "Citizens Communications Co.", "CKE Restaurants Inc.", "Clear Channel Communications Inc.", "The Clorox Co.", "CMGI Inc.", "CMS Energy Corp.", "CNF Inc.", "Coca-Cola Co.", "Coca-Cola Enterprises Inc.", "Colgate-Palmolive Co.", "Collins & Aikman Corp.", "Comcast Corp.", "Comdisco Inc.", "Comerica Inc.", "Comfort Systems USA Inc.", "Commercial Metals Co.", "Community Health Systems Inc.", "Compass Bancshares Inc", "Computer Associates International Inc.", "Computer Sciences Corp.", "Compuware Corp.", "Comverse Technology Inc.", "ConAgra Foods Inc.", "Concord EFS Inc.", "Conectiv, Inc", "Conoco Inc", "Conseco Inc.", "Consolidated Freightways Corp.", "Consolidated Edison Inc.", "Constellation Brands Inc.", "Constellation Emergy Group Inc.", "Continental Airlines Inc.", "Convergys Corp.", "Cooper Cameron Corp.", "Cooper Industries Ltd.", "Cooper Tire & Rubber Co.", "Corn Products International Inc.", "Corning Inc.", "Costco Wholesale Corp.", "Countrywide Credit Industries Inc.", "Coventry Health Care Inc.", "Cox Communications Inc.", "Crane Co.", "Crompton Corp.", "Crown Cork & Seal Co. Inc.", "CSK Auto Corp.", "CSX Corp.", "Cummins Inc.", "CVS Corp.", "Cytec Industries Inc.", "D&K Healthcare Resources, Inc.", "D.R. Horton Inc.", "Dana Corporation", "Danaher Corporation", "Darden Restaurants Inc.", "DaVita Inc.", "Dean Foods Company", "Deere & Company", "Del Monte Foods Co", "Dell Computer Corporation", "Delphi Corp.", "Delta Air Lines Inc.", "Deluxe Corporation", "Devon Energy Corporation", "Di Giorgio Corporation", "Dial Corporation", "Diebold Incorporated", "Dillard's Inc.", "DIMON Incorporated", "Dole Food Company, Inc.", "Dollar General Corporation", "Dollar Tree Stores, Inc.", "Dominion Resources, Inc.", "Domino's Pizza LLC", "Dover Corporation, Inc.", "Dow Chemical Company", "Dow Jones & Company, Inc.", "DPL Inc.", "DQE Inc.", "Dreyer's Grand Ice Cream, Inc.", "DST Systems, Inc.", "DTE Energy Co.", "E.I. Du Pont de Nemours and Company", "Duke Energy Corp", "Dun & Bradstreet Inc.", "DURA Automotive Systems Inc.", "DynCorp", "Dynegy Inc.", "E*Trade Group, Inc.", "E.W. Scripps Company", "Earthlink, Inc.", "Eastman Chemical Company", "Eastman Kodak Company", "Eaton Corporation", "Echostar Communications Corporation", "Ecolab Inc.", "Edison International", "EGL Inc.", "El Paso Corporation", "Electronic Arts Inc.", "Electronic Data Systems Corp.", "Eli Lilly and Company", "EMC Corporation", "Emcor Group Inc.", "Emerson Electric Co.", "Encompass Services Corporation", "Energizer Holdings Inc.", "Energy East Corporation", "Engelhard Corporation", "Enron Corp.", "Entergy Corporation", "Enterprise Products Partners L.P.", "EOG Resources, Inc.", "Equifax Inc.", "Equitable Resources Inc.", "Equity Office Properties Trust", "Equity Residential Properties Trust", "Estee Lauder Companies Inc.", "Exelon Corporation", "Exide Technologies", "Expeditors International of Washington Inc.", "Express Scripts Inc.", "ExxonMobil Corporation", "Fairchild Semiconductor International Inc.", "Family Dollar Stores Inc.", "Farmland Industries Inc.", "Federal Mogul Corp.", "Federated Department Stores Inc.", "Federal Express Corp.", "Felcor Lodging Trust Inc.", "Ferro Corp.", "Fidelity National Financial Inc.", "Fifth Third Bancorp", "First American Financial Corp.", "First Data Corp.", "First National of Nebraska Inc.", "First Tennessee National Corp.", "FirstEnergy Corp.", "Fiserv Inc.", "Fisher Scientific International Inc.", "FleetBoston Financial Co.", "Fleetwood Enterprises Inc.", "Fleming Companies Inc.", "Flowers Foods Inc.", "Flowserv Corp", "Fluor Corp", "FMC Corp", "Foamex International Inc", "Foot Locker Inc", "Footstar Inc.", "Ford Motor Co", "Forest Laboratories Inc.", "Fortune Brands Inc.", "Foster Wheeler Ltd.", "FPL Group Inc.", "Franklin Resources Inc.", "Freeport McMoran Copper & Gold Inc.", "Frontier Oil Corp", "Furniture Brands International Inc.", "Gannett Co., Inc.", "Gap Inc.", "Gateway Inc.", "GATX Corporation", "Gemstar-TV Guide International Inc.", "GenCorp Inc.", "General Cable Corporation", "General Dynamics Corporation", "General Electric Company", "General Mills Inc", "General Motors Corporation", "Genesis Health Ventures Inc.", "Gentek Inc.", "Gentiva Health Services Inc.", "Genuine Parts Company", "Genuity Inc.", "Genzyme Corporation", "Georgia Gulf Corporation", "Georgia-Pacific Corporation", "Gillette Company", "Gold Kist Inc.", "Golden State Bancorp Inc.", "Golden West Financial Corporation", "Goldman Sachs Group Inc.", "Goodrich Corporation", "The Goodyear Tire & Rubber Company", "Granite Construction Incorporated", "Graybar Electric Company Inc.", "Great Lakes Chemical Corporation", "Great Plains Energy Inc.", "GreenPoint Financial Corp.", "Greif Bros. Corporation", "Grey Global Group Inc.", "Group 1 Automotive Inc.", "Guidant Corporation", "H&R Block Inc.", "H.B. Fuller Company", "H.J. Heinz Company", "Halliburton Co.", "Harley-Davidson Inc.", "Harman International Industries Inc.", "Harrah's Entertainment Inc.", "Harris Corp.", "Harsco Corp.", "Hartford Financial Services Group Inc.", "Hasbro Inc.", "Hawaiian Electric Industries Inc.", "HCA Inc.", "Health Management Associates Inc.", "Health Net Inc.", "Healthsouth Corp", "Henry Schein Inc.", "Hercules Inc.", "Herman Miller Inc.", "Hershey Foods Corp.", "Hewlett-Packard Company", "Hibernia Corp.", "Hillenbrand Industries Inc.", "Hilton Hotels Corp.", "Hollywood Entertainment Corp.", "Home Depot Inc.", "Hon Industries Inc.", "Honeywell International Inc.", "Hormel Foods Corp.", "Host Marriott Corp.", "Household International Corp.", "Hovnanian Enterprises Inc.", "Hub Group Inc.", "Hubbell Inc.", "Hughes Supply Inc.", "Humana Inc.", "Huntington Bancshares Inc.", "Idacorp Inc.", "IDT Corporation", "IKON Office Solutions Inc.", "Illinois Tool Works Inc.", "IMC Global Inc.", "Imperial Sugar Company", "IMS Health Inc.", "Ingles Market Inc", "Ingram Micro Inc.", "Insight Enterprises Inc.", "Integrated Electrical Services Inc.", "Intel Corporation", "International Paper Co.", "Interpublic Group of Companies Inc.", "Interstate Bakeries Corporation", "International Business Machines Corp.", "International Flavors & Fragrances Inc.", "International Multifoods Corporation", "Intuit Inc.", "IT Group Inc.", "ITT Industries Inc.", "Ivax Corp.", "J.B. Hunt Transport Services Inc.", "J.C. Penny Co.", "J.P. Morgan Chase & Co.", "Jabil Circuit Inc.", "Jack In The Box Inc.", "Jacobs Engineering Group Inc.", "JDS Uniphase Corp.", "Jefferson-Pilot Co.", "John Hancock Financial Services Inc.", "Johnson & Johnson", "Johnson Controls Inc.", "Jones Apparel Group Inc.", "KB Home", "Kellogg Company", "Kellwood Company", "Kelly Services Inc.", "Kemet Corp.", "Kennametal Inc.", "Kerr-McGee Corporation", "KeyCorp", "KeySpan Corp.", "Kimball International Inc.", "Kimberly-Clark Corporation", "Kindred Healthcare Inc.", "KLA-Tencor Corporation", "K-Mart Corp.", "Knight-Ridder Inc.", "Kohl's Corp.", "KPMG Consulting Inc.", "Kroger Co.", "L-3 Communications Holdings Inc.", "Laboratory Corporation of America Holdings", "Lam Research Corporation", "LandAmerica Financial Group Inc.", "Lands' End Inc.", "Landstar System Inc.", "La-Z-Boy Inc.", "Lear Corporation", "Legg Mason Inc.", "Leggett & Platt Inc.", "Lehman Brothers Holdings Inc.", "Lennar Corporation", "Lennox International Inc.", "Level 3 Communications Inc.", "Levi Strauss & Co.", "Lexmark International Inc.", "Limited Inc.", "Lincoln National Corporation", "Linens 'n Things Inc.", "Lithia Motors Inc.", "Liz Claiborne Inc.", "Lockheed Martin Corporation", "Loews Corporation", "Longs Drug Stores Corporation", "Louisiana-Pacific Corporation", "Lowe's Companies Inc.", "LSI Logic Corporation", "The LTV Corporation", "The Lubrizol Corporation", "Lucent Technologies Inc.", "Lyondell Chemical Company", "M & T Bank Corporation", "Magellan Health Services Inc.", "Mail-Well Inc.", "Mandalay Resort Group", "Manor Care Inc.", "Manpower Inc.", "Marathon Oil Corporation", "Mariner Health Care Inc.", "Markel Corporation", "Marriott International Inc.", "Marsh & McLennan Companies Inc.", "Marsh Supermarkets Inc.", "Marshall & Ilsley Corporation", "Martin Marietta Materials Inc.", "Masco Corporation", "Massey Energy Company", "MasTec Inc.", "Mattel Inc.", "Maxim Integrated Products Inc.", "Maxtor Corporation", "Maxxam Inc.", "The May Department Stores Company", "Maytag Corporation", "MBNA Corporation", "McCormick & Company Incorporated", "McDonald's Corporation", "The McGraw-Hill Companies Inc.", "McKesson Corporation", "McLeodUSA Incorporated", "M.D.C. Holdings Inc.", "MDU Resources Group Inc.", "MeadWestvaco Corporation", "Medtronic Inc.", "Mellon Financial Corporation", "The Men's Wearhouse Inc.", "Merck & Co., Inc.", "Mercury General Corporation", "Merrill Lynch & Co. Inc.", "Metaldyne Corporation", "Metals USA Inc.", "MetLife Inc.", "Metris Companies Inc", "MGIC Investment Corporation", "MGM Mirage", "Michaels Stores Inc.", "Micron Technology Inc.", "Microsoft Corporation", "Milacron Inc.", "Millennium Chemicals Inc.", "Mirant Corporation", "Mohawk Industries Inc.", "Molex Incorporated", "The MONY Group Inc.", "Morgan Stanley Dean Witter & Co.", "Motorola Inc.", "MPS Group Inc.", "Murphy Oil Corporation", "Nabors Industries Inc", "Nacco Industries Inc", "Nash Finch Company", "National City Corp.", "National Commerce Financial Corporation", "National Fuel Gas Company", "National Oilwell Inc", "National Rural Utilities Cooperative Finance Corporation", "National Semiconductor Corporation", "National Service Industries Inc", "Navistar International Corporation", "NCR Corporation", "The Neiman Marcus Group Inc.", "New Jersey Resources Corporation", "New York Times Company", "Newell Rubbermaid Inc", "Newmont Mining Corporation", "Nextel Communications Inc", "Nicor Inc", "Nike Inc", "NiSource Inc", "Noble Energy Inc", "Nordstrom Inc", "Norfolk Southern Corporation", "Nortek Inc", "North Fork Bancorporation Inc", "Northeast Utilities System", "Northern Trust Corporation", "Northrop Grumman Corporation", "NorthWestern Corporation", "Novellus Systems Inc", "NSTAR", "NTL Incorporated", "Nucor Corp", "Nvidia Corp", "NVR Inc", "Northwest Airlines Corp", "Occidental Petroleum Corp", "Ocean Energy Inc", "Office Depot Inc.", "OfficeMax Inc", "OGE Energy Corp", "Oglethorpe Power Corp.", "Ohio Casualty Corp.", "Old Republic International Corp.", "Olin Corp.", "OM Group Inc", "Omnicare Inc", "Omnicom Group", "On Semiconductor Corp", "ONEOK Inc", "Oracle Corp", "Oshkosh Truck Corp", "Outback Steakhouse Inc.", "Owens & Minor Inc.", "Owens Corning", "Owens-Illinois Inc", "Oxford Health Plans Inc", "Paccar Inc", "PacifiCare Health Systems Inc", "Packaging Corp. of America", "Pactiv Corp", "Pall Corp", "Pantry Inc", "Park Place Entertainment Corp", "Parker Hannifin Corp.", "Pathmark Stores Inc.", "Paychex Inc", "Payless Shoesource Inc", "Penn Traffic Co.", "Pennzoil-Quaker State Company", "Pentair Inc", "Peoples Energy Corp.", "PeopleSoft Inc", "Pep Boys Manny, Moe & Jack", "Potomac Electric Power Co.", "Pepsi Bottling Group Inc.", "PepsiAmericas Inc.", "PepsiCo Inc.", "Performance Food Group Co.", "Perini Corp", "PerkinElmer Inc", "Perot Systems Corp", "Petco Animal Supplies Inc.", "Peter Kiewit Sons', Inc.", "PETsMART Inc", "Pfizer Inc", "Pacific Gas & Electric Corp.", "Pharmacia Corp", "Phar Mor Inc.", "Phelps Dodge Corp.", "Philip Morris Companies Inc.", "Phillips Petroleum Co", "Phillips Van Heusen Corp.", "Phoenix Companies Inc", "Pier 1 Imports Inc.", "Pilgrim's Pride Corporation", "Pinnacle West Capital Corp", "Pioneer-Standard Electronics Inc.", "Pitney Bowes Inc.", "Pittston Brinks Group", "Plains All American Pipeline LP", "PNC Financial Services Group Inc.", "PNM Resources Inc", "Polaris Industries Inc.", "Polo Ralph Lauren Corp", "PolyOne Corp", "Popular Inc", "Potlatch Corp", "PPG Industries Inc", "PPL Corp", "Praxair Inc", "Precision Castparts Corp", "Premcor Inc.", "Pride International Inc", "Primedia Inc", "Principal Financial Group Inc.", "Procter & Gamble Co.", "Pro-Fac Cooperative Inc.", "Progress Energy Inc", "Progressive Corporation", "Protective Life Corp", "Provident Financial Group", "Providian Financial Corp.", "Prudential Financial Inc.", "PSS World Medical Inc", "Public Service Enterprise Group Inc.", "Publix Super Markets Inc.", "Puget Energy Inc.", "Pulte Homes Inc", "Qualcomm Inc", "Quanta Services Inc.", "Quantum Corp", "Quest Diagnostics Inc.", "Questar Corp", "Quintiles Transnational", "Qwest Communications Intl Inc", "R.J. Reynolds Tobacco Company", "R.R. Donnelley & Sons Company", "Radio Shack Corporation", "Raymond James Financial Inc.", "Raytheon Company", "Reader's Digest Association Inc.", "Reebok International Ltd.", "Regions Financial Corp.", "Regis Corporation", "Reliance Steel & Aluminum Co.", "Reliant Energy Inc.", "Rent A Center Inc", "Republic Services Inc", "Revlon Inc", "RGS Energy Group Inc", "Rite Aid Corp", "Riverwood Holding Inc.", "RoadwayCorp", "Robert Half International Inc.", "Rock-Tenn Co", "Rockwell Automation Inc", "Rockwell Collins Inc", "Rohm & Haas Co.", "Ross Stores Inc", "RPM Inc.", "Ruddick Corp", "Ryder System Inc", "Ryerson Tull Inc", "Ryland Group Inc.", "Sabre Holdings Corp", "Safeco Corp", "Safeguard Scientifics Inc.", "Safeway Inc", "Saks Inc", "Sanmina-SCI Inc", "Sara Lee Corp", "SBC Communications Inc", "Scana Corp.", "Schering-Plough Corp", "Scholastic Corp", "SCI Systems Onc.", "Science Applications Intl. Inc.", "Scientific-Atlanta Inc", "Scotts Company", "Seaboard Corp", "Sealed Air Corp", "Sears Roebuck & Co", "Sempra Energy", "Sequa Corp", "Service Corp. International", "ServiceMaster Co", "Shaw Group Inc", "Sherwin-Williams Company", "Shopko Stores Inc", "Siebel Systems Inc", "Sierra Health Services Inc", "Sierra Pacific Resources", "Silgan Holdings Inc.", "Silicon Graphics Inc", "Simon Property Group Inc", "SLM Corporation", "Smith International Inc", "Smithfield Foods Inc", "Smurfit-Stone Container Corp", "Snap-On Inc", "Solectron Corp", "Solutia Inc", "Sonic Automotive Inc.", "Sonoco Products Co.", "Southern Company", "Southern Union Company", "SouthTrust Corp.", "Southwest Airlines Co", "Southwest Gas Corp", "Sovereign Bancorp Inc.", "Spartan Stores Inc", "Spherion Corp", "Sports Authority Inc", "Sprint Corp.", "SPX Corp", "St. Jude Medical Inc", "St. Paul Cos.", "Staff Leasing Inc.", "StanCorp Financial Group Inc", "Standard Pacific Corp.", "Stanley Works", "Staples Inc", "Starbucks Corp", "Starwood Hotels & Resorts Worldwide Inc", "State Street Corp.", "Stater Bros. Holdings Inc.", "Steelcase Inc", "Stein Mart Inc", "Stewart & Stevenson Services Inc", "Stewart Information Services Corp", "Stilwell Financial Inc", "Storage Technology Corporation", "Stryker Corp", "Sun Healthcare Group Inc.", "Sun Microsystems Inc.", "SunGard Data Systems Inc.", "Sunoco Inc.", "SunTrust Banks Inc", "Supervalu Inc", "Swift Transportation, Co., Inc", "Symbol Technologies Inc", "Synovus Financial Corp.", "Sysco Corp", "Systemax Inc.", "Target Corp.", "Tech Data Corporation", "TECO Energy Inc", "Tecumseh Products Company", "Tektronix Inc", "Teleflex Incorporated", "Telephone & Data Systems Inc", "Tellabs Inc.", "Temple-Inland Inc", "Tenet Healthcare Corporation", "Tenneco Automotive Inc.", "Teradyne Inc", "Terex Corp", "Tesoro Petroleum Corp.", "Texas Industries Inc.", "Texas Instruments Incorporated", "Textron Inc", "Thermo Electron Corporation", "Thomas & Betts Corporation", "Tiffany & Co", "Timken Company", "TJX Companies Inc", "TMP Worldwide Inc", "Toll Brothers Inc", "Torchmark Corporation", "Toro Company", "Tower Automotive Inc.", "Toys 'R' Us Inc", "Trans World Entertainment Corp.", "TransMontaigne Inc", "Transocean Inc", "TravelCenters of America Inc.", "Triad Hospitals Inc", "Tribune Company", "Trigon Healthcare Inc.", "Trinity Industries Inc", "Trump Hotels & Casino Resorts Inc.", "TruServ Corporation", "TRW Inc", "TXU Corp", "Tyson Foods Inc", "U.S. Bancorp", "U.S. Industries Inc.", "UAL Corporation", "UGI Corporation", "Unified Western Grocers Inc", "Union Pacific Corporation", "Union Planters Corp", "Unisource Energy Corp", "Unisys Corporation", "United Auto Group Inc", "United Defense Industries Inc.", "United Parcel Service Inc", "United Rentals Inc", "United Stationers Inc", "United Technologies Corporation", "UnitedHealth Group Incorporated", "Unitrin Inc", "Universal Corporation", "Universal Forest Products Inc", "Universal Health Services Inc", "Unocal Corporation", "Unova Inc", "UnumProvident Corporation", "URS Corporation", "US Airways Group Inc", "US Oncology Inc", "USA Interactive", "USFreighways Corporation", "USG Corporation", "UST Inc", "Valero Energy Corporation", "Valspar Corporation", "Value City Department Stores Inc", "Varco International Inc", "Vectren Corporation", "Veritas Software Corporation", "Verizon Communications Inc", "VF Corporation", "Viacom Inc", "Viad Corp", "Viasystems Group Inc", "Vishay Intertechnology Inc", "Visteon Corporation", "Volt Information Sciences Inc", "Vulcan Materials Company", "W.R. Berkley Corporation", "W.R. Grace & Co", "W.W. Grainger Inc", "Wachovia Corporation", "Wakenhut Corporation", "Walgreen Co", "Wallace Computer Services Inc", "Wal-Mart Stores Inc", "Walt Disney Co", "Walter Industries Inc", "Washington Mutual Inc", "Washington Post Co.", "Waste Management Inc", "Watsco Inc", "Weatherford International Inc", "Weis Markets Inc.", "Wellpoint Health Networks Inc", "Wells Fargo & Company", "Wendy's International Inc", "Werner Enterprises Inc", "WESCO International Inc", "Western Digital Inc", "Western Gas Resources Inc", "WestPoint Stevens Inc", "Weyerhauser Company", "WGL Holdings Inc", "Whirlpool Corporation", "Whole Foods Market Inc", "Willamette Industries Inc.", "Williams Companies Inc", "Williams Sonoma Inc", "Winn Dixie Stores Inc", "Wisconsin Energy Corporation", "Wm Wrigley Jr Company", "World Fuel Services Corporation", "WorldCom Inc", "Worthington Industries Inc", "WPS Resources Corporation", "Wyeth", "Wyndham International Inc", "Xcel Energy Inc", "Xerox Corp", "Xilinx Inc", "XO Communications Inc", "Yellow Corporation", "York International Corp", "Yum Brands Inc.", "Zale Corporation", "Zions Bancorporation"],
      fileExtension: {
        raster: ["bmp", "gif", "gpl", "ico", "jpeg", "psd", "png", "psp", "raw", "tiff"],
        vector: ["3dv", "amf", "awg", "ai", "cgm", "cdr", "cmx", "dxf", "e2d", "egt", "eps", "fs", "odg", "svg", "xar"],
        "3d": ["3dmf", "3dm", "3mf", "3ds", "an8", "aoi", "blend", "cal3d", "cob", "ctm", "iob", "jas", "max", "mb", "mdx", "obj", "x", "x3d"],
        document: ["doc", "docx", "dot", "html", "xml", "odt", "odm", "ott", "csv", "rtf", "tex", "xhtml", "xps"]
      },
      timezones: [{
        name: "Dateline Standard Time",
        abbr: "DST",
        offset: -12,
        isdst: !(s.prototype.file = function (e) {
          var n,
              r = e || {},
              t = "fileExtension",
              a = Object.keys(this.get("fileExtension"));
          if (n = this.word({
            length: r.length
          }), r.extension) return n + "." + r.extension;

          if (r.extensions) {
            if (Array.isArray(r.extensions)) return n + "." + this.pickone(r.extensions);
            if (r.extensions.constructor !== Object) throw new Error("Chance: Extensions must be an Array or Object");
            var i = r.extensions,
                A = Object.keys(i);
            return n + "." + this.pickone(i[this.pickone(A)]);
          }

          if (r.fileType) {
            var o = r.fileType;
            if (-1 !== a.indexOf(o)) return n + "." + this.pickone(this.get(t)[o]);
            throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
          }

          return n + "." + this.pickone(this.get(t)[this.pickone(a)]);
        }),
        text: "(UTC-12:00) International Date Line West",
        utc: ["Etc/GMT+12"]
      }, {
        name: "UTC-11",
        abbr: "U",
        offset: -11,
        isdst: !1,
        text: "(UTC-11:00) Coordinated Universal Time-11",
        utc: ["Etc/GMT+11", "Pacific/Midway", "Pacific/Niue", "Pacific/Pago_Pago"]
      }, {
        name: "Hawaiian Standard Time",
        abbr: "HST",
        offset: -10,
        isdst: !1,
        text: "(UTC-10:00) Hawaii",
        utc: ["Etc/GMT+10", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Rarotonga", "Pacific/Tahiti"]
      }, {
        name: "Alaskan Standard Time",
        abbr: "AKDT",
        offset: -8,
        isdst: !0,
        text: "(UTC-09:00) Alaska",
        utc: ["America/Anchorage", "America/Juneau", "America/Nome", "America/Sitka", "America/Yakutat"]
      }, {
        name: "Pacific Standard Time (Mexico)",
        abbr: "PDT",
        offset: -7,
        isdst: !0,
        text: "(UTC-08:00) Baja California",
        utc: ["America/Santa_Isabel"]
      }, {
        name: "Pacific Standard Time",
        abbr: "PDT",
        offset: -7,
        isdst: !0,
        text: "(UTC-08:00) Pacific Time (US & Canada)",
        utc: ["America/Dawson", "America/Los_Angeles", "America/Tijuana", "America/Vancouver", "America/Whitehorse", "PST8PDT"]
      }, {
        name: "US Mountain Standard Time",
        abbr: "UMST",
        offset: -7,
        isdst: !1,
        text: "(UTC-07:00) Arizona",
        utc: ["America/Creston", "America/Dawson_Creek", "America/Hermosillo", "America/Phoenix", "Etc/GMT+7"]
      }, {
        name: "Mountain Standard Time (Mexico)",
        abbr: "MDT",
        offset: -6,
        isdst: !0,
        text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
        utc: ["America/Chihuahua", "America/Mazatlan"]
      }, {
        name: "Mountain Standard Time",
        abbr: "MDT",
        offset: -6,
        isdst: !0,
        text: "(UTC-07:00) Mountain Time (US & Canada)",
        utc: ["America/Boise", "America/Cambridge_Bay", "America/Denver", "America/Edmonton", "America/Inuvik", "America/Ojinaga", "America/Yellowknife", "MST7MDT"]
      }, {
        name: "Central America Standard Time",
        abbr: "CAST",
        offset: -6,
        isdst: !1,
        text: "(UTC-06:00) Central America",
        utc: ["America/Belize", "America/Costa_Rica", "America/El_Salvador", "America/Guatemala", "America/Managua", "America/Tegucigalpa", "Etc/GMT+6", "Pacific/Galapagos"]
      }, {
        name: "Central Standard Time",
        abbr: "CDT",
        offset: -5,
        isdst: !0,
        text: "(UTC-06:00) Central Time (US & Canada)",
        utc: ["America/Chicago", "America/Indiana/Knox", "America/Indiana/Tell_City", "America/Matamoros", "America/Menominee", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Rainy_River", "America/Rankin_Inlet", "America/Resolute", "America/Winnipeg", "CST6CDT"]
      }, {
        name: "Central Standard Time (Mexico)",
        abbr: "CDT",
        offset: -5,
        isdst: !0,
        text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
        utc: ["America/Bahia_Banderas", "America/Cancun", "America/Merida", "America/Mexico_City", "America/Monterrey"]
      }, {
        name: "Canada Central Standard Time",
        abbr: "CCST",
        offset: -6,
        isdst: !1,
        text: "(UTC-06:00) Saskatchewan",
        utc: ["America/Regina", "America/Swift_Current"]
      }, {
        name: "SA Pacific Standard Time",
        abbr: "SPST",
        offset: -5,
        isdst: !1,
        text: "(UTC-05:00) Bogota, Lima, Quito",
        utc: ["America/Bogota", "America/Cayman", "America/Coral_Harbour", "America/Eirunepe", "America/Guayaquil", "America/Jamaica", "America/Lima", "America/Panama", "America/Rio_Branco", "Etc/GMT+5"]
      }, {
        name: "Eastern Standard Time",
        abbr: "EDT",
        offset: -4,
        isdst: !0,
        text: "(UTC-05:00) Eastern Time (US & Canada)",
        utc: ["America/Detroit", "America/Havana", "America/Indiana/Petersburg", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Iqaluit", "America/Kentucky/Monticello", "America/Louisville", "America/Montreal", "America/Nassau", "America/New_York", "America/Nipigon", "America/Pangnirtung", "America/Port-au-Prince", "America/Thunder_Bay", "America/Toronto", "EST5EDT"]
      }, {
        name: "US Eastern Standard Time",
        abbr: "UEDT",
        offset: -4,
        isdst: !0,
        text: "(UTC-05:00) Indiana (East)",
        utc: ["America/Indiana/Marengo", "America/Indiana/Vevay", "America/Indianapolis"]
      }, {
        name: "Venezuela Standard Time",
        abbr: "VST",
        offset: -4.5,
        isdst: !1,
        text: "(UTC-04:30) Caracas",
        utc: ["America/Caracas"]
      }, {
        name: "Paraguay Standard Time",
        abbr: "PST",
        offset: -4,
        isdst: !1,
        text: "(UTC-04:00) Asuncion",
        utc: ["America/Asuncion"]
      }, {
        name: "Atlantic Standard Time",
        abbr: "ADT",
        offset: -3,
        isdst: !0,
        text: "(UTC-04:00) Atlantic Time (Canada)",
        utc: ["America/Glace_Bay", "America/Goose_Bay", "America/Halifax", "America/Moncton", "America/Thule", "Atlantic/Bermuda"]
      }, {
        name: "Central Brazilian Standard Time",
        abbr: "CBST",
        offset: -4,
        isdst: !1,
        text: "(UTC-04:00) Cuiaba",
        utc: ["America/Campo_Grande", "America/Cuiaba"]
      }, {
        name: "SA Western Standard Time",
        abbr: "SWST",
        offset: -4,
        isdst: !1,
        text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
        utc: ["America/Anguilla", "America/Antigua", "America/Aruba", "America/Barbados", "America/Blanc-Sablon", "America/Boa_Vista", "America/Curacao", "America/Dominica", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guyana", "America/Kralendijk", "America/La_Paz", "America/Lower_Princes", "America/Manaus", "America/Marigot", "America/Martinique", "America/Montserrat", "America/Port_of_Spain", "America/Porto_Velho", "America/Puerto_Rico", "America/Santo_Domingo", "America/St_Barthelemy", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Tortola", "Etc/GMT+4"]
      }, {
        name: "Pacific SA Standard Time",
        abbr: "PSST",
        offset: -4,
        isdst: !1,
        text: "(UTC-04:00) Santiago",
        utc: ["America/Santiago", "Antarctica/Palmer"]
      }, {
        name: "Newfoundland Standard Time",
        abbr: "NDT",
        offset: -2.5,
        isdst: !0,
        text: "(UTC-03:30) Newfoundland",
        utc: ["America/St_Johns"]
      }, {
        name: "E. South America Standard Time",
        abbr: "ESAST",
        offset: -3,
        isdst: !1,
        text: "(UTC-03:00) Brasilia",
        utc: ["America/Sao_Paulo"]
      }, {
        name: "Argentina Standard Time",
        abbr: "AST",
        offset: -3,
        isdst: !1,
        text: "(UTC-03:00) Buenos Aires",
        utc: ["America/Argentina/La_Rioja", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Buenos_Aires", "America/Catamarca", "America/Cordoba", "America/Jujuy", "America/Mendoza"]
      }, {
        name: "SA Eastern Standard Time",
        abbr: "SEST",
        offset: -3,
        isdst: !1,
        text: "(UTC-03:00) Cayenne, Fortaleza",
        utc: ["America/Araguaina", "America/Belem", "America/Cayenne", "America/Fortaleza", "America/Maceio", "America/Paramaribo", "America/Recife", "America/Santarem", "Antarctica/Rothera", "Atlantic/Stanley", "Etc/GMT+3"]
      }, {
        name: "Greenland Standard Time",
        abbr: "GDT",
        offset: -2,
        isdst: !0,
        text: "(UTC-03:00) Greenland",
        utc: ["America/Godthab"]
      }, {
        name: "Montevideo Standard Time",
        abbr: "MST",
        offset: -3,
        isdst: !1,
        text: "(UTC-03:00) Montevideo",
        utc: ["America/Montevideo"]
      }, {
        name: "Bahia Standard Time",
        abbr: "BST",
        offset: -3,
        isdst: !1,
        text: "(UTC-03:00) Salvador",
        utc: ["America/Bahia"]
      }, {
        name: "UTC-02",
        abbr: "U",
        offset: -2,
        isdst: !1,
        text: "(UTC-02:00) Coordinated Universal Time-02",
        utc: ["America/Noronha", "Atlantic/South_Georgia", "Etc/GMT+2"]
      }, {
        name: "Mid-Atlantic Standard Time",
        abbr: "MDT",
        offset: -1,
        isdst: !0,
        text: "(UTC-02:00) Mid-Atlantic - Old"
      }, {
        name: "Azores Standard Time",
        abbr: "ADT",
        offset: 0,
        isdst: !0,
        text: "(UTC-01:00) Azores",
        utc: ["America/Scoresbysund", "Atlantic/Azores"]
      }, {
        name: "Cape Verde Standard Time",
        abbr: "CVST",
        offset: -1,
        isdst: !1,
        text: "(UTC-01:00) Cape Verde Is.",
        utc: ["Atlantic/Cape_Verde", "Etc/GMT+1"]
      }, {
        name: "Morocco Standard Time",
        abbr: "MDT",
        offset: 1,
        isdst: !0,
        text: "(UTC) Casablanca",
        utc: ["Africa/Casablanca", "Africa/El_Aaiun"]
      }, {
        name: "UTC",
        abbr: "CUT",
        offset: 0,
        isdst: !1,
        text: "(UTC) Coordinated Universal Time",
        utc: ["America/Danmarkshavn", "Etc/GMT"]
      }, {
        name: "GMT Standard Time",
        abbr: "GDT",
        offset: 1,
        isdst: !0,
        text: "(UTC) Dublin, Edinburgh, Lisbon, London",
        utc: ["Atlantic/Canary", "Atlantic/Faeroe", "Atlantic/Madeira", "Europe/Dublin", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Jersey", "Europe/Lisbon", "Europe/London"]
      }, {
        name: "Greenwich Standard Time",
        abbr: "GST",
        offset: 0,
        isdst: !1,
        text: "(UTC) Monrovia, Reykjavik",
        utc: ["Africa/Abidjan", "Africa/Accra", "Africa/Bamako", "Africa/Banjul", "Africa/Bissau", "Africa/Conakry", "Africa/Dakar", "Africa/Freetown", "Africa/Lome", "Africa/Monrovia", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Sao_Tome", "Atlantic/Reykjavik", "Atlantic/St_Helena"]
      }, {
        name: "W. Europe Standard Time",
        abbr: "WEDT",
        offset: 2,
        isdst: !0,
        text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
        utc: ["Arctic/Longyearbyen", "Europe/Amsterdam", "Europe/Andorra", "Europe/Berlin", "Europe/Busingen", "Europe/Gibraltar", "Europe/Luxembourg", "Europe/Malta", "Europe/Monaco", "Europe/Oslo", "Europe/Rome", "Europe/San_Marino", "Europe/Stockholm", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Zurich"]
      }, {
        name: "Central Europe Standard Time",
        abbr: "CEDT",
        offset: 2,
        isdst: !0,
        text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        utc: ["Europe/Belgrade", "Europe/Bratislava", "Europe/Budapest", "Europe/Ljubljana", "Europe/Podgorica", "Europe/Prague", "Europe/Tirane"]
      }, {
        name: "Romance Standard Time",
        abbr: "RDT",
        offset: 2,
        isdst: !0,
        text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
        utc: ["Africa/Ceuta", "Europe/Brussels", "Europe/Copenhagen", "Europe/Madrid", "Europe/Paris"]
      }, {
        name: "Central European Standard Time",
        abbr: "CEDT",
        offset: 2,
        isdst: !0,
        text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
        utc: ["Europe/Sarajevo", "Europe/Skopje", "Europe/Warsaw", "Europe/Zagreb"]
      }, {
        name: "W. Central Africa Standard Time",
        abbr: "WCAST",
        offset: 1,
        isdst: !1,
        text: "(UTC+01:00) West Central Africa",
        utc: ["Africa/Algiers", "Africa/Bangui", "Africa/Brazzaville", "Africa/Douala", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Luanda", "Africa/Malabo", "Africa/Ndjamena", "Africa/Niamey", "Africa/Porto-Novo", "Africa/Tunis", "Etc/GMT-1"]
      }, {
        name: "Namibia Standard Time",
        abbr: "NST",
        offset: 1,
        isdst: !1,
        text: "(UTC+01:00) Windhoek",
        utc: ["Africa/Windhoek"]
      }, {
        name: "GTB Standard Time",
        abbr: "GDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) Athens, Bucharest",
        utc: ["Asia/Nicosia", "Europe/Athens", "Europe/Bucharest", "Europe/Chisinau"]
      }, {
        name: "Middle East Standard Time",
        abbr: "MEDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) Beirut",
        utc: ["Asia/Beirut"]
      }, {
        name: "Egypt Standard Time",
        abbr: "EST",
        offset: 2,
        isdst: !1,
        text: "(UTC+02:00) Cairo",
        utc: ["Africa/Cairo"]
      }, {
        name: "Syria Standard Time",
        abbr: "SDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) Damascus",
        utc: ["Asia/Damascus"]
      }, {
        name: "E. Europe Standard Time",
        abbr: "EEDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) E. Europe"
      }, {
        name: "South Africa Standard Time",
        abbr: "SAST",
        offset: 2,
        isdst: !1,
        text: "(UTC+02:00) Harare, Pretoria",
        utc: ["Africa/Blantyre", "Africa/Bujumbura", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Kigali", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Etc/GMT-2"]
      }, {
        name: "FLE Standard Time",
        abbr: "FDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
        utc: ["Europe/Helsinki", "Europe/Kiev", "Europe/Mariehamn", "Europe/Riga", "Europe/Sofia", "Europe/Tallinn", "Europe/Uzhgorod", "Europe/Vilnius", "Europe/Zaporozhye"]
      }, {
        name: "Turkey Standard Time",
        abbr: "TDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) Istanbul",
        utc: ["Europe/Istanbul"]
      }, {
        name: "Israel Standard Time",
        abbr: "JDT",
        offset: 3,
        isdst: !0,
        text: "(UTC+02:00) Jerusalem",
        utc: ["Asia/Jerusalem"]
      }, {
        name: "Libya Standard Time",
        abbr: "LST",
        offset: 2,
        isdst: !1,
        text: "(UTC+02:00) Tripoli",
        utc: ["Africa/Tripoli"]
      }, {
        name: "Jordan Standard Time",
        abbr: "JST",
        offset: 3,
        isdst: !1,
        text: "(UTC+03:00) Amman",
        utc: ["Asia/Amman"]
      }, {
        name: "Arabic Standard Time",
        abbr: "AST",
        offset: 3,
        isdst: !1,
        text: "(UTC+03:00) Baghdad",
        utc: ["Asia/Baghdad"]
      }, {
        name: "Kaliningrad Standard Time",
        abbr: "KST",
        offset: 3,
        isdst: !1,
        text: "(UTC+03:00) Kaliningrad, Minsk",
        utc: ["Europe/Kaliningrad", "Europe/Minsk"]
      }, {
        name: "Arab Standard Time",
        abbr: "AST",
        offset: 3,
        isdst: !1,
        text: "(UTC+03:00) Kuwait, Riyadh",
        utc: ["Asia/Aden", "Asia/Bahrain", "Asia/Kuwait", "Asia/Qatar", "Asia/Riyadh"]
      }, {
        name: "E. Africa Standard Time",
        abbr: "EAST",
        offset: 3,
        isdst: !1,
        text: "(UTC+03:00) Nairobi",
        utc: ["Africa/Addis_Ababa", "Africa/Asmera", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Mogadishu", "Africa/Nairobi", "Antarctica/Syowa", "Etc/GMT-3", "Indian/Antananarivo", "Indian/Comoro", "Indian/Mayotte"]
      }, {
        name: "Iran Standard Time",
        abbr: "IDT",
        offset: 4.5,
        isdst: !0,
        text: "(UTC+03:30) Tehran",
        utc: ["Asia/Tehran"]
      }, {
        name: "Arabian Standard Time",
        abbr: "AST",
        offset: 4,
        isdst: !1,
        text: "(UTC+04:00) Abu Dhabi, Muscat",
        utc: ["Asia/Dubai", "Asia/Muscat", "Etc/GMT-4"]
      }, {
        name: "Azerbaijan Standard Time",
        abbr: "ADT",
        offset: 5,
        isdst: !0,
        text: "(UTC+04:00) Baku",
        utc: ["Asia/Baku"]
      }, {
        name: "Russian Standard Time",
        abbr: "RST",
        offset: 4,
        isdst: !1,
        text: "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
        utc: ["Europe/Moscow", "Europe/Samara", "Europe/Simferopol", "Europe/Volgograd"]
      }, {
        name: "Mauritius Standard Time",
        abbr: "MST",
        offset: 4,
        isdst: !1,
        text: "(UTC+04:00) Port Louis",
        utc: ["Indian/Mahe", "Indian/Mauritius", "Indian/Reunion"]
      }, {
        name: "Georgian Standard Time",
        abbr: "GST",
        offset: 4,
        isdst: !1,
        text: "(UTC+04:00) Tbilisi",
        utc: ["Asia/Tbilisi"]
      }, {
        name: "Caucasus Standard Time",
        abbr: "CST",
        offset: 4,
        isdst: !1,
        text: "(UTC+04:00) Yerevan",
        utc: ["Asia/Yerevan"]
      }, {
        name: "Afghanistan Standard Time",
        abbr: "AST",
        offset: 4.5,
        isdst: !1,
        text: "(UTC+04:30) Kabul",
        utc: ["Asia/Kabul"]
      }, {
        name: "West Asia Standard Time",
        abbr: "WAST",
        offset: 5,
        isdst: !1,
        text: "(UTC+05:00) Ashgabat, Tashkent",
        utc: ["Antarctica/Mawson", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Dushanbe", "Asia/Oral", "Asia/Samarkand", "Asia/Tashkent", "Etc/GMT-5", "Indian/Kerguelen", "Indian/Maldives"]
      }, {
        name: "Pakistan Standard Time",
        abbr: "PST",
        offset: 5,
        isdst: !1,
        text: "(UTC+05:00) Islamabad, Karachi",
        utc: ["Asia/Karachi"]
      }, {
        name: "India Standard Time",
        abbr: "IST",
        offset: 5.5,
        isdst: !1,
        text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        utc: ["Asia/Calcutta"]
      }, {
        name: "Sri Lanka Standard Time",
        abbr: "SLST",
        offset: 5.5,
        isdst: !1,
        text: "(UTC+05:30) Sri Jayawardenepura",
        utc: ["Asia/Colombo"]
      }, {
        name: "Nepal Standard Time",
        abbr: "NST",
        offset: 5.75,
        isdst: !1,
        text: "(UTC+05:45) Kathmandu",
        utc: ["Asia/Katmandu"]
      }, {
        name: "Central Asia Standard Time",
        abbr: "CAST",
        offset: 6,
        isdst: !1,
        text: "(UTC+06:00) Astana",
        utc: ["Antarctica/Vostok", "Asia/Almaty", "Asia/Bishkek", "Asia/Qyzylorda", "Asia/Urumqi", "Etc/GMT-6", "Indian/Chagos"]
      }, {
        name: "Bangladesh Standard Time",
        abbr: "BST",
        offset: 6,
        isdst: !1,
        text: "(UTC+06:00) Dhaka",
        utc: ["Asia/Dhaka", "Asia/Thimphu"]
      }, {
        name: "Ekaterinburg Standard Time",
        abbr: "EST",
        offset: 6,
        isdst: !1,
        text: "(UTC+06:00) Ekaterinburg",
        utc: ["Asia/Yekaterinburg"]
      }, {
        name: "Myanmar Standard Time",
        abbr: "MST",
        offset: 6.5,
        isdst: !1,
        text: "(UTC+06:30) Yangon (Rangoon)",
        utc: ["Asia/Rangoon", "Indian/Cocos"]
      }, {
        name: "SE Asia Standard Time",
        abbr: "SAST",
        offset: 7,
        isdst: !1,
        text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        utc: ["Antarctica/Davis", "Asia/Bangkok", "Asia/Hovd", "Asia/Jakarta", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Saigon", "Asia/Vientiane", "Etc/GMT-7", "Indian/Christmas"]
      }, {
        name: "N. Central Asia Standard Time",
        abbr: "NCAST",
        offset: 7,
        isdst: !1,
        text: "(UTC+07:00) Novosibirsk",
        utc: ["Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk"]
      }, {
        name: "China Standard Time",
        abbr: "CST",
        offset: 8,
        isdst: !1,
        text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        utc: ["Asia/Hong_Kong", "Asia/Macau", "Asia/Shanghai"]
      }, {
        name: "North Asia Standard Time",
        abbr: "NAST",
        offset: 8,
        isdst: !1,
        text: "(UTC+08:00) Krasnoyarsk",
        utc: ["Asia/Krasnoyarsk"]
      }, {
        name: "Singapore Standard Time",
        abbr: "MPST",
        offset: 8,
        isdst: !1,
        text: "(UTC+08:00) Kuala Lumpur, Singapore",
        utc: ["Asia/Brunei", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Makassar", "Asia/Manila", "Asia/Singapore", "Etc/GMT-8"]
      }, {
        name: "W. Australia Standard Time",
        abbr: "WAST",
        offset: 8,
        isdst: !1,
        text: "(UTC+08:00) Perth",
        utc: ["Antarctica/Casey", "Australia/Perth"]
      }, {
        name: "Taipei Standard Time",
        abbr: "TST",
        offset: 8,
        isdst: !1,
        text: "(UTC+08:00) Taipei",
        utc: ["Asia/Taipei"]
      }, {
        name: "Ulaanbaatar Standard Time",
        abbr: "UST",
        offset: 8,
        isdst: !1,
        text: "(UTC+08:00) Ulaanbaatar",
        utc: ["Asia/Choibalsan", "Asia/Ulaanbaatar"]
      }, {
        name: "North Asia East Standard Time",
        abbr: "NAEST",
        offset: 9,
        isdst: !1,
        text: "(UTC+09:00) Irkutsk",
        utc: ["Asia/Irkutsk"]
      }, {
        name: "Tokyo Standard Time",
        abbr: "TST",
        offset: 9,
        isdst: !1,
        text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
        utc: ["Asia/Dili", "Asia/Jayapura", "Asia/Tokyo", "Etc/GMT-9", "Pacific/Palau"]
      }, {
        name: "Korea Standard Time",
        abbr: "KST",
        offset: 9,
        isdst: !1,
        text: "(UTC+09:00) Seoul",
        utc: ["Asia/Pyongyang", "Asia/Seoul"]
      }, {
        name: "Cen. Australia Standard Time",
        abbr: "CAST",
        offset: 9.5,
        isdst: !1,
        text: "(UTC+09:30) Adelaide",
        utc: ["Australia/Adelaide", "Australia/Broken_Hill"]
      }, {
        name: "AUS Central Standard Time",
        abbr: "ACST",
        offset: 9.5,
        isdst: !1,
        text: "(UTC+09:30) Darwin",
        utc: ["Australia/Darwin"]
      }, {
        name: "E. Australia Standard Time",
        abbr: "EAST",
        offset: 10,
        isdst: !1,
        text: "(UTC+10:00) Brisbane",
        utc: ["Australia/Brisbane", "Australia/Lindeman"]
      }, {
        name: "AUS Eastern Standard Time",
        abbr: "AEST",
        offset: 10,
        isdst: !1,
        text: "(UTC+10:00) Canberra, Melbourne, Sydney",
        utc: ["Australia/Melbourne", "Australia/Sydney"]
      }, {
        name: "West Pacific Standard Time",
        abbr: "WPST",
        offset: 10,
        isdst: !1,
        text: "(UTC+10:00) Guam, Port Moresby",
        utc: ["Antarctica/DumontDUrville", "Etc/GMT-10", "Pacific/Guam", "Pacific/Port_Moresby", "Pacific/Saipan", "Pacific/Truk"]
      }, {
        name: "Tasmania Standard Time",
        abbr: "TST",
        offset: 10,
        isdst: !1,
        text: "(UTC+10:00) Hobart",
        utc: ["Australia/Currie", "Australia/Hobart"]
      }, {
        name: "Yakutsk Standard Time",
        abbr: "YST",
        offset: 10,
        isdst: !1,
        text: "(UTC+10:00) Yakutsk",
        utc: ["Asia/Chita", "Asia/Khandyga", "Asia/Yakutsk"]
      }, {
        name: "Central Pacific Standard Time",
        abbr: "CPST",
        offset: 11,
        isdst: !1,
        text: "(UTC+11:00) Solomon Is., New Caledonia",
        utc: ["Antarctica/Macquarie", "Etc/GMT-11", "Pacific/Efate", "Pacific/Guadalcanal", "Pacific/Kosrae", "Pacific/Noumea", "Pacific/Ponape"]
      }, {
        name: "Vladivostok Standard Time",
        abbr: "VST",
        offset: 11,
        isdst: !1,
        text: "(UTC+11:00) Vladivostok",
        utc: ["Asia/Sakhalin", "Asia/Ust-Nera", "Asia/Vladivostok"]
      }, {
        name: "New Zealand Standard Time",
        abbr: "NZST",
        offset: 12,
        isdst: !1,
        text: "(UTC+12:00) Auckland, Wellington",
        utc: ["Antarctica/McMurdo", "Pacific/Auckland"]
      }, {
        name: "UTC+12",
        abbr: "U",
        offset: 12,
        isdst: !1,
        text: "(UTC+12:00) Coordinated Universal Time+12",
        utc: ["Etc/GMT-12", "Pacific/Funafuti", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Nauru", "Pacific/Tarawa", "Pacific/Wake", "Pacific/Wallis"]
      }, {
        name: "Fiji Standard Time",
        abbr: "FST",
        offset: 12,
        isdst: !1,
        text: "(UTC+12:00) Fiji",
        utc: ["Pacific/Fiji"]
      }, {
        name: "Magadan Standard Time",
        abbr: "MST",
        offset: 12,
        isdst: !1,
        text: "(UTC+12:00) Magadan",
        utc: ["Asia/Anadyr", "Asia/Kamchatka", "Asia/Magadan", "Asia/Srednekolymsk"]
      }, {
        name: "Kamchatka Standard Time",
        abbr: "KDT",
        offset: 13,
        isdst: !0,
        text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old"
      }, {
        name: "Tonga Standard Time",
        abbr: "TST",
        offset: 13,
        isdst: !1,
        text: "(UTC+13:00) Nuku'alofa",
        utc: ["Etc/GMT-13", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Tongatapu"]
      }, {
        name: "Samoa Standard Time",
        abbr: "SST",
        offset: 13,
        isdst: !1,
        text: "(UTC+13:00) Samoa",
        utc: ["Pacific/Apia"]
      }],
      profession: ["Airline Pilot", "Academic Team", "Accountant", "Account Executive", "Actor", "Actuary", "Acquisition Analyst", "Administrative Asst.", "Administrative Analyst", "Administrator", "Advertising Director", "Aerospace Engineer", "Agent", "Agricultural Inspector", "Agricultural Scientist", "Air Traffic Controller", "Animal Trainer", "Anthropologist", "Appraiser", "Architect", "Art Director", "Artist", "Astronomer", "Athletic Coach", "Auditor", "Author", "Baker", "Banker", "Bankruptcy Attorney", "Benefits Manager", "Biologist", "Bio-feedback Specialist", "Biomedical Engineer", "Biotechnical Researcher", "Broadcaster", "Broker", "Building Manager", "Building Contractor", "Building Inspector", "Business Analyst", "Business Planner", "Business Manager", "Buyer", "Call Center Manager", "Career Counselor", "Cash Manager", "Ceramic Engineer", "Chief Executive Officer", "Chief Operation Officer", "Chef", "Chemical Engineer", "Chemist", "Child Care Manager", "Chief Medical Officer", "Chiropractor", "Cinematographer", "City Housing Manager", "City Manager", "Civil Engineer", "Claims Manager", "Clinical Research Assistant", "Collections Manager.", "Compliance Manager", "Comptroller", "Computer Manager", "Commercial Artist", "Communications Affairs Director", "Communications Director", "Communications Engineer", "Compensation Analyst", "Computer Programmer", "Computer Ops. Manager", "Computer Engineer", "Computer Operator", "Computer Graphics Specialist", "Construction Engineer", "Construction Manager", "Consultant", "Consumer Relations Manager", "Contract Administrator", "Copyright Attorney", "Copywriter", "Corporate Planner", "Corrections Officer", "Cosmetologist", "Credit Analyst", "Cruise Director", "Chief Information Officer", "Chief Technology Officer", "Customer Service Manager", "Cryptologist", "Dancer", "Data Security Manager", "Database Manager", "Day Care Instructor", "Dentist", "Designer", "Design Engineer", "Desktop Publisher", "Developer", "Development Officer", "Diamond Merchant", "Dietitian", "Direct Marketer", "Director", "Distribution Manager", "Diversity Manager", "Economist", "EEO Compliance Manager", "Editor", "Education Adminator", "Electrical Engineer", "Electro Optical Engineer", "Electronics Engineer", "Embassy Management", "Employment Agent", "Engineer Technician", "Entrepreneur", "Environmental Analyst", "Environmental Attorney", "Environmental Engineer", "Environmental Specialist", "Escrow Officer", "Estimator", "Executive Assistant", "Executive Director", "Executive Recruiter", "Facilities Manager", "Family Counselor", "Fashion Events Manager", "Fashion Merchandiser", "Fast Food Manager", "Film Producer", "Film Production Assistant", "Financial Analyst", "Financial Planner", "Financier", "Fine Artist", "Wildlife Specialist", "Fitness Consultant", "Flight Attendant", "Flight Engineer", "Floral Designer", "Food & Beverage Director", "Food Service Manager", "Forestry Technician", "Franchise Management", "Franchise Sales", "Fraud Investigator", "Freelance Writer", "Fund Raiser", "General Manager", "Geologist", "General Counsel", "Geriatric Specialist", "Gerontologist", "Glamour Photographer", "Golf Club Manager", "Gourmet Chef", "Graphic Designer", "Grounds Keeper", "Hazardous Waste Manager", "Health Care Manager", "Health Therapist", "Health Service Administrator", "Hearing Officer", "Home Economist", "Horticulturist", "Hospital Administrator", "Hotel Manager", "Human Resources Manager", "Importer", "Industrial Designer", "Industrial Engineer", "Information Director", "Inside Sales", "Insurance Adjuster", "Interior Decorator", "Internal Controls Director", "International Acct.", "International Courier", "International Lawyer", "Interpreter", "Investigator", "Investment Banker", "Investment Manager", "IT Architect", "IT Project Manager", "IT Systems Analyst", "Jeweler", "Joint Venture Manager", "Journalist", "Labor Negotiator", "Labor Organizer", "Labor Relations Manager", "Lab Services Director", "Lab Technician", "Land Developer", "Landscape Architect", "Law Enforcement Officer", "Lawyer", "Lead Software Engineer", "Lead Software Test Engineer", "Leasing Manager", "Legal Secretary", "Library Manager", "Litigation Attorney", "Loan Officer", "Lobbyist", "Logistics Manager", "Maintenance Manager", "Management Consultant", "Managed Care Director", "Managing Partner", "Manufacturing Director", "Manpower Planner", "Marine Biologist", "Market Res. Analyst", "Marketing Director", "Materials Manager", "Mathematician", "Membership Chairman", "Mechanic", "Mechanical Engineer", "Media Buyer", "Medical Investor", "Medical Secretary", "Medical Technician", "Mental Health Counselor", "Merchandiser", "Metallurgical Engineering", "Meteorologist", "Microbiologist", "MIS Manager", "Motion Picture Director", "Multimedia Director", "Musician", "Network Administrator", "Network Specialist", "Network Operator", "New Product Manager", "Novelist", "Nuclear Engineer", "Nuclear Specialist", "Nutritionist", "Nursing Administrator", "Occupational Therapist", "Oceanographer", "Office Manager", "Operations Manager", "Operations Research Director", "Optical Technician", "Optometrist", "Organizational Development Manager", "Outplacement Specialist", "Paralegal", "Park Ranger", "Patent Attorney", "Payroll Specialist", "Personnel Specialist", "Petroleum Engineer", "Pharmacist", "Photographer", "Physical Therapist", "Physician", "Physician Assistant", "Physicist", "Planning Director", "Podiatrist", "Political Analyst", "Political Scientist", "Politician", "Portfolio Manager", "Preschool Management", "Preschool Teacher", "Principal", "Private Banker", "Private Investigator", "Probation Officer", "Process Engineer", "Producer", "Product Manager", "Product Engineer", "Production Engineer", "Production Planner", "Professional Athlete", "Professional Coach", "Professor", "Project Engineer", "Project Manager", "Program Manager", "Property Manager", "Public Administrator", "Public Safety Director", "PR Specialist", "Publisher", "Purchasing Agent", "Publishing Director", "Quality Assurance Specialist", "Quality Control Engineer", "Quality Control Inspector", "Radiology Manager", "Railroad Engineer", "Real Estate Broker", "Recreational Director", "Recruiter", "Redevelopment Specialist", "Regulatory Affairs Manager", "Registered Nurse", "Rehabilitation Counselor", "Relocation Manager", "Reporter", "Research Specialist", "Restaurant Manager", "Retail Store Manager", "Risk Analyst", "Safety Engineer", "Sales Engineer", "Sales Trainer", "Sales Promotion Manager", "Sales Representative", "Sales Manager", "Service Manager", "Sanitation Engineer", "Scientific Programmer", "Scientific Writer", "Securities Analyst", "Security Consultant", "Security Director", "Seminar Presenter", "Ship's Officer", "Singer", "Social Director", "Social Program Planner", "Social Research", "Social Scientist", "Social Worker", "Sociologist", "Software Developer", "Software Engineer", "Software Test Engineer", "Soil Scientist", "Special Events Manager", "Special Education Teacher", "Special Projects Director", "Speech Pathologist", "Speech Writer", "Sports Event Manager", "Statistician", "Store Manager", "Strategic Alliance Director", "Strategic Planning Director", "Stress Reduction Specialist", "Stockbroker", "Surveyor", "Structural Engineer", "Superintendent", "Supply Chain Director", "System Engineer", "Systems Analyst", "Systems Programmer", "System Administrator", "Tax Specialist", "Teacher", "Technical Support Specialist", "Technical Illustrator", "Technical Writer", "Technology Director", "Telecom Analyst", "Telemarketer", "Theatrical Director", "Title Examiner", "Tour Escort", "Tour Guide Director", "Traffic Manager", "Trainer Translator", "Transportation Manager", "Travel Agent", "Treasurer", "TV Programmer", "Underwriter", "Union Representative", "University Administrator", "University Dean", "Urban Planner", "Veterinarian", "Vendor Relations Director", "Viticulturist", "Warehouse Manager"],
      animals: {
        ocean: ["Acantharea", "Anemone", "Angelfish King", "Ahi Tuna", "Albacore", "American Oyster", "Anchovy", "Armored Snail", "Arctic Char", "Atlantic Bluefin Tuna", "Atlantic Cod", "Atlantic Goliath Grouper", "Atlantic Trumpetfish", "Atlantic Wolffish", "Baleen Whale", "Banded Butterflyfish", "Banded Coral Shrimp", "Banded Sea Krait", "Barnacle", "Barndoor Skate", "Barracuda", "Basking Shark", "Bass", "Beluga Whale", "Bluebanded Goby", "Bluehead Wrasse", "Bluefish", "Bluestreak Cleaner-Wrasse", "Blue Marlin", "Blue Shark", "Blue Spiny Lobster", "Blue Tang", "Blue Whale", "Broadclub Cuttlefish", "Bull Shark", "Chambered Nautilus", "Chilean Basket Star", "Chilean Jack Mackerel", "Chinook Salmon", "Christmas Tree Worm", "Clam", "Clown Anemonefish", "Clown Triggerfish", "Cod", "Coelacanth", "Cockscomb Cup Coral", "Common Fangtooth", "Conch", "Cookiecutter Shark", "Copepod", "Coral", "Corydoras", "Cownose Ray", "Crab", "Crown-of-Thorns Starfish", "Cushion Star", "Cuttlefish", "California Sea Otters", "Dolphin", "Dolphinfish", "Dory", "Devil Fish", "Dugong", "Dumbo Octopus", "Dungeness Crab", "Eccentric Sand Dollar", "Edible Sea Cucumber", "Eel", "Elephant Seal", "Elkhorn Coral", "Emperor Shrimp", "Estuarine Crocodile", "Fathead Sculpin", "Fiddler Crab", "Fin Whale", "Flameback", "Flamingo Tongue Snail", "Flashlight Fish", "Flatback Turtle", "Flatfish", "Flying Fish", "Flounder", "Fluke", "French Angelfish", "Frilled Shark", "Fugu (also called Pufferfish)", "Gar", "Geoduck", "Giant Barrel Sponge", "Giant Caribbean Sea Anemone", "Giant Clam", "Giant Isopod", "Giant Kingfish", "Giant Oarfish", "Giant Pacific Octopus", "Giant Pyrosome", "Giant Sea Star", "Giant Squid", "Glowing Sucker Octopus", "Giant Tube Worm", "Goblin Shark", "Goosefish", "Great White Shark", "Greenland Shark", "Grey Atlantic Seal", "Grouper", "Grunion", "Guineafowl Puffer", "Haddock", "Hake", "Halibut", "Hammerhead Shark", "Hapuka", "Harbor Porpoise", "Harbor Seal", "Hatchetfish", "Hawaiian Monk Seal", "Hawksbill Turtle", "Hector's Dolphin", "Hermit Crab", "Herring", "Hoki", "Horn Shark", "Horseshoe Crab", "Humpback Anglerfish", "Humpback Whale", "Icefish", "Imperator Angelfish", "Irukandji Jellyfish", "Isopod", "Ivory Bush Coral", "Japanese Spider Crab", "Jellyfish", "John Dory", "Juan Fernandez Fur Seal", "Killer Whale", "Kiwa Hirsuta", "Krill", "Lagoon Triggerfish", "Lamprey", "Leafy Seadragon", "Leopard Seal", "Limpet", "Ling", "Lionfish", "Lions Mane Jellyfish", "Lobe Coral", "Lobster", "Loggerhead Turtle", "Longnose Sawshark", "Longsnout Seahorse", "Lophelia Coral", "Marrus Orthocanna", "Manatee", "Manta Ray", "Marlin", "Megamouth Shark", "Mexican Lookdown", "Mimic Octopus", "Moon Jelly", "Mollusk", "Monkfish", "Moray Eel", "Mullet", "Mussel", "Megaladon", "Napoleon Wrasse", "Nassau Grouper", "Narwhal", "Nautilus", "Needlefish", "Northern Seahorse", "North Atlantic Right Whale", "Northern Red Snapper", "Norway Lobster", "Nudibranch", "Nurse Shark", "Oarfish", "Ocean Sunfish", "Oceanic Whitetip Shark", "Octopus", "Olive Sea Snake", "Orange Roughy", "Ostracod", "Otter", "Oyster", "Pacific Angelshark", "Pacific Blackdragon", "Pacific Halibut", "Pacific Sardine", "Pacific Sea Nettle Jellyfish", "Pacific White Sided Dolphin", "Pantropical Spotted Dolphin", "Patagonian Toothfish", "Peacock Mantis Shrimp", "Pelagic Thresher Shark", "Penguin", "Peruvian Anchoveta", "Pilchard", "Pink Salmon", "Pinniped", "Plankton", "Porpoise", "Polar Bear", "Portuguese Man o' War", "Pycnogonid Sea Spider", "Quahog", "Queen Angelfish", "Queen Conch", "Queen Parrotfish", "Queensland Grouper", "Ragfish", "Ratfish", "Rattail Fish", "Ray", "Red Drum", "Red King Crab", "Ringed Seal", "Risso's Dolphin", "Ross Seals", "Sablefish", "Salmon", "Sand Dollar", "Sandbar Shark", "Sawfish", "Sarcastic Fringehead", "Scalloped Hammerhead Shark", "Seahorse", "Sea Cucumber", "Sea Lion", "Sea Urchin", "Seal", "Shark", "Shortfin Mako Shark", "Shovelnose Guitarfish", "Shrimp", "Silverside Fish", "Skipjack Tuna", "Slender Snipe Eel", "Smalltooth Sawfish", "Smelts", "Sockeye Salmon", "Southern Stingray", "Sponge", "Spotted Porcupinefish", "Spotted Dolphin", "Spotted Eagle Ray", "Spotted Moray", "Squid", "Squidworm", "Starfish", "Stickleback", "Stonefish", "Stoplight Loosejaw", "Sturgeon", "Swordfish", "Tan Bristlemouth", "Tasseled Wobbegong", "Terrible Claw Lobster", "Threespot Damselfish", "Tiger Prawn", "Tiger Shark", "Tilefish", "Toadfish", "Tropical Two-Wing Flyfish", "Tuna", "Umbrella Squid", "Velvet Crab", "Venus Flytrap Sea Anemone", "Vigtorniella Worm", "Viperfish", "Vampire Squid", "Vaquita", "Wahoo", "Walrus", "West Indian Manatee", "Whale", "Whale Shark", "Whiptail Gulper", "White-Beaked Dolphin", "White-Ring Garden Eel", "White Shrimp", "Wobbegong", "Wrasse", "Wreckfish", "Xiphosura", "Yellowtail Damselfish", "Yelloweye Rockfish", "Yellow Cup Black Coral", "Yellow Tube Sponge", "Yellowfin Tuna", "Zebrashark", "Zooplankton"],
        desert: ["Aardwolf", "Addax", "African Wild Ass", "Ant", "Antelope", "Armadillo", "Baboon", "Badger", "Bat", "Bearded Dragon", "Beetle", "Bird", "Black-footed Cat", "Boa", "Brown Bear", "Bustard", "Butterfly", "Camel", "Caracal", "Caracara", "Caterpillar", "Centipede", "Cheetah", "Chipmunk", "Chuckwalla", "Climbing Mouse", "Coati", "Cobra", "Cotton Rat", "Cougar", "Courser", "Crane Fly", "Crow", "Dassie Rat", "Dove", "Dunnart", "Eagle", "Echidna", "Elephant", "Emu", "Falcon", "Fly", "Fox", "Frogmouth", "Gecko", "Geoffroy's Cat", "Gerbil", "Grasshopper", "Guanaco", "Gundi", "Hamster", "Hawk", "Hedgehog", "Hyena", "Hyrax", "Jackal", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kowari", "Kultarr", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Oryx", "Ostrich", "Owl", "Pronghorn", "Python", "Rabbit", "Raccoon", "Rattlesnake", "Rhinoceros", "Sand Cat", "Spectacled Bear", "Spiny Mouse", "Starling", "Stick Bug", "Tarantula", "Tit", "Toad", "Tortoise", "Tyrant Flycatcher", "Viper", "Vulture", "Waxwing", "Xerus", "Zebra"],
        grassland: ["Aardvark", "Aardwolf", "Accentor", "African Buffalo", "African Wild Dog", "Alpaca", "Anaconda", "Ant", "Anteater", "Antelope", "Armadillo", "Baboon", "Badger", "Bandicoot", "Barbet", "Bat", "Bee", "Bee-eater", "Beetle", "Bird", "Bison", "Black-footed Cat", "Black-footed Ferret", "Bluebird", "Boa", "Bowerbird", "Brown Bear", "Bush Dog", "Bushshrike", "Bustard", "Butterfly", "Buzzard", "Caracal", "Caracara", "Cardinal", "Caterpillar", "Cheetah", "Chipmunk", "Civet", "Climbing Mouse", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Common Genet", "Cotton Rat", "Cougar", "Courser", "Coyote", "Crane", "Crane Fly", "Cricket", "Crow", "Culpeo", "Death Adder", "Deer", "Deer Mouse", "Dingo", "Dinosaur", "Dove", "Drongo", "Duck", "Duiker", "Dunnart", "Eagle", "Echidna", "Elephant", "Elk", "Emu", "Falcon", "Finch", "Flea", "Fly", "Flying Frog", "Fox", "Frog", "Frogmouth", "Garter Snake", "Gazelle", "Gecko", "Geoffroy's Cat", "Gerbil", "Giant Tortoise", "Giraffe", "Grasshopper", "Grison", "Groundhog", "Grouse", "Guanaco", "Guinea Pig", "Hamster", "Harrier", "Hartebeest", "Hawk", "Hedgehog", "Helmetshrike", "Hippopotamus", "Hornbill", "Hyena", "Hyrax", "Impala", "Jackal", "Jaguar", "Jaguarundi", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kultarr", "Ladybug", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Newt", "Oryx", "Ostrich", "Owl", "Pangolin", "Pheasant", "Prairie Dog", "Pronghorn", "Przewalski's Horse", "Python", "Quoll", "Rabbit", "Raven", "Rhinoceros", "Shelduck", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Tamandua", "Tasmanian Devil", "Thornbill", "Thrush", "Toad", "Tortoise"],
        forest: ["Agouti", "Anaconda", "Anoa", "Ant", "Anteater", "Antelope", "Armadillo", "Asian Black Bear", "Aye-aye", "Babirusa", "Baboon", "Badger", "Bandicoot", "Banteng", "Barbet", "Basilisk", "Bat", "Bearded Dragon", "Bee", "Bee-eater", "Beetle", "Bettong", "Binturong", "Bird-of-paradise", "Bongo", "Bowerbird", "Bulbul", "Bush Dog", "Bushbaby", "Bushshrike", "Butterfly", "Buzzard", "Caecilian", "Cardinal", "Cassowary", "Caterpillar", "Centipede", "Chameleon", "Chimpanzee", "Cicada", "Civet", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Colugo", "Cotinga", "Cotton Rat", "Cougar", "Crane Fly", "Cricket", "Crocodile", "Crow", "Cuckoo", "Cuscus", "Death Adder", "Deer", "Dhole", "Dingo", "Dinosaur", "Drongo", "Duck", "Duiker", "Eagle", "Echidna", "Elephant", "Finch", "Flat-headed Cat", "Flea", "Flowerpecker", "Fly", "Flying Frog", "Fossa", "Frog", "Frogmouth", "Gaur", "Gecko", "Gorilla", "Grison", "Hawaiian Honeycreeper", "Hawk", "Hedgehog", "Helmetshrike", "Hornbill", "Hyrax", "Iguana", "Jackal", "Jaguar", "Jaguarundi", "Kestrel", "Ladybug", "Lemur", "Leopard", "Lion", "Macaw", "Mandrill", "Margay", "Monkey", "Mouse", "Mouse Deer", "Newt", "Okapi", "Old World Flycatcher", "Orangutan", "Owl", "Pangolin", "Peafowl", "Pheasant", "Possum", "Python", "Quokka", "Rabbit", "Raccoon", "Red Panda", "Red River Hog", "Rhinoceros", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Sun Bear", "Tamandua", "Tamarin", "Tapir", "Tarantula", "Thrush", "Tiger", "Tit", "Toad", "Tortoise", "Toucan", "Trogon", "Trumpeter", "Turaco", "Turtle", "Tyrant Flycatcher", "Viper", "Vulture", "Wallaby", "Warbler", "Wasp", "Waxwing", "Weaver", "Weaver-finch", "Whistler", "White-eye", "Whydah", "Woodswallow", "Worm", "Wren", "Xenops", "Yellowjacket", "Accentor", "African Buffalo", "American Black Bear", "Anole", "Bird", "Bison", "Boa", "Brown Bear", "Chipmunk", "Common Genet", "Copperhead", "Coyote", "Deer Mouse", "Dormouse", "Elk", "Emu", "Fisher", "Fox", "Garter Snake", "Giant Panda", "Giant Tortoise", "Groundhog", "Grouse", "Guanaco", "Himalayan Tahr", "Kangaroo", "Koala", "Numbat", "Quoll", "Raccoon dog", "Tasmanian Devil", "Thornbill", "Turkey", "Vole", "Weasel", "Wildcat", "Wolf", "Wombat", "Woodchuck", "Woodpecker"],
        farm: ["Alpaca", "Buffalo", "Banteng", "Cow", "Cat", "Chicken", "Carp", "Camel", "Donkey", "Dog", "Duck", "Emu", "Goat", "Gayal", "Guinea", "Goose", "Horse", "Honey", "Llama", "Pig", "Pigeon", "Rhea", "Rabbit", "Sheep", "Silkworm", "Turkey", "Yak", "Zebu"],
        pet: ["Bearded Dragon", "Birds", "Burro", "Cats", "Chameleons", "Chickens", "Chinchillas", "Chinese Water Dragon", "Cows", "Dogs", "Donkey", "Ducks", "Ferrets", "Fish", "Geckos", "Geese", "Gerbils", "Goats", "Guinea Fowl", "Guinea Pigs", "Hamsters", "Hedgehogs", "Horses", "Iguanas", "Llamas", "Lizards", "Mice", "Mule", "Peafowl", "Pigs and Hogs", "Pigeons", "Ponies", "Pot Bellied Pig", "Rabbits", "Rats", "Sheep", "Skinks", "Snakes", "Stick Insects", "Sugar Gliders", "Tarantula", "Turkeys", "Turtles"],
        zoo: ["Aardvark", "African Wild Dog", "Aldabra Tortoise", "American Alligator", "American Bison", "Amur Tiger", "Anaconda", "Andean Condor", "Asian Elephant", "Baby Doll Sheep", "Bald Eagle", "Barred Owl", "Blue Iguana", "Boer Goat", "California Sea Lion", "Caribbean Flamingo", "Chinchilla", "Collared Lemur", "Coquerel's Sifaka", "Cuban Amazon Parrot", "Ebony Langur", "Fennec Fox", "Fossa", "Gelada", "Giant Anteater", "Giraffe", "Gorilla", "Grizzly Bear", "Henkel's Leaf-tailed Gecko", "Indian Gharial", "Indian Rhinoceros", "King Cobra", "King Vulture", "Komodo Dragon", "Linne's Two-toed Sloth", "Lion", "Little Penguin", "Madagascar Tree Boa", "Magellanic Penguin", "Malayan Tapir", "Malayan Tiger", "Matschies Tree Kangaroo", "Mini Donkey", "Monarch Butterfly", "Nile crocodile", "North American Porcupine", "Nubian Ibex", "Okapi", "Poison Dart Frog", "Polar Bear", "Pygmy Marmoset", "Radiated Tortoise", "Red Panda", "Red Ruffed Lemur", "Ring-tailed Lemur", "Ring-tailed Mongoose", "Rock Hyrax", "Small Clawed Asian Otter", "Snow Leopard", "Snowy Owl", "Southern White-faced Owl", "Southern White Rhinocerous", "Squirrel Monkey", "Tufted Puffin", "White Cheeked Gibbon", "White-throated Bee Eater", "Zebra"]
      },
      primes: [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997, 1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097, 1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099, 2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179, 2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297, 2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399, 2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477, 2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593, 2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699, 2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797, 2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897, 2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999, 3001, 3011, 3019, 3023, 3037, 3041, 3049, 3061, 3067, 3079, 3083, 3089, 3109, 3119, 3121, 3137, 3163, 3167, 3169, 3181, 3187, 3191, 3203, 3209, 3217, 3221, 3229, 3251, 3253, 3257, 3259, 3271, 3299, 3301, 3307, 3313, 3319, 3323, 3329, 3331, 3343, 3347, 3359, 3361, 3371, 3373, 3389, 3391, 3407, 3413, 3433, 3449, 3457, 3461, 3463, 3467, 3469, 3491, 3499, 3511, 3517, 3527, 3529, 3533, 3539, 3541, 3547, 3557, 3559, 3571, 3581, 3583, 3593, 3607, 3613, 3617, 3623, 3631, 3637, 3643, 3659, 3671, 3673, 3677, 3691, 3697, 3701, 3709, 3719, 3727, 3733, 3739, 3761, 3767, 3769, 3779, 3793, 3797, 3803, 3821, 3823, 3833, 3847, 3851, 3853, 3863, 3877, 3881, 3889, 3907, 3911, 3917, 3919, 3923, 3929, 3931, 3943, 3947, 3967, 3989, 4001, 4003, 4007, 4013, 4019, 4021, 4027, 4049, 4051, 4057, 4073, 4079, 4091, 4093, 4099, 4111, 4127, 4129, 4133, 4139, 4153, 4157, 4159, 4177, 4201, 4211, 4217, 4219, 4229, 4231, 4241, 4243, 4253, 4259, 4261, 4271, 4273, 4283, 4289, 4297, 4327, 4337, 4339, 4349, 4357, 4363, 4373, 4391, 4397, 4409, 4421, 4423, 4441, 4447, 4451, 4457, 4463, 4481, 4483, 4493, 4507, 4513, 4517, 4519, 4523, 4547, 4549, 4561, 4567, 4583, 4591, 4597, 4603, 4621, 4637, 4639, 4643, 4649, 4651, 4657, 4663, 4673, 4679, 4691, 4703, 4721, 4723, 4729, 4733, 4751, 4759, 4783, 4787, 4789, 4793, 4799, 4801, 4813, 4817, 4831, 4861, 4871, 4877, 4889, 4903, 4909, 4919, 4931, 4933, 4937, 4943, 4951, 4957, 4967, 4969, 4973, 4987, 4993, 4999, 5003, 5009, 5011, 5021, 5023, 5039, 5051, 5059, 5077, 5081, 5087, 5099, 5101, 5107, 5113, 5119, 5147, 5153, 5167, 5171, 5179, 5189, 5197, 5209, 5227, 5231, 5233, 5237, 5261, 5273, 5279, 5281, 5297, 5303, 5309, 5323, 5333, 5347, 5351, 5381, 5387, 5393, 5399, 5407, 5413, 5417, 5419, 5431, 5437, 5441, 5443, 5449, 5471, 5477, 5479, 5483, 5501, 5503, 5507, 5519, 5521, 5527, 5531, 5557, 5563, 5569, 5573, 5581, 5591, 5623, 5639, 5641, 5647, 5651, 5653, 5657, 5659, 5669, 5683, 5689, 5693, 5701, 5711, 5717, 5737, 5741, 5743, 5749, 5779, 5783, 5791, 5801, 5807, 5813, 5821, 5827, 5839, 5843, 5849, 5851, 5857, 5861, 5867, 5869, 5879, 5881, 5897, 5903, 5923, 5927, 5939, 5953, 5981, 5987, 6007, 6011, 6029, 6037, 6043, 6047, 6053, 6067, 6073, 6079, 6089, 6091, 6101, 6113, 6121, 6131, 6133, 6143, 6151, 6163, 6173, 6197, 6199, 6203, 6211, 6217, 6221, 6229, 6247, 6257, 6263, 6269, 6271, 6277, 6287, 6299, 6301, 6311, 6317, 6323, 6329, 6337, 6343, 6353, 6359, 6361, 6367, 6373, 6379, 6389, 6397, 6421, 6427, 6449, 6451, 6469, 6473, 6481, 6491, 6521, 6529, 6547, 6551, 6553, 6563, 6569, 6571, 6577, 6581, 6599, 6607, 6619, 6637, 6653, 6659, 6661, 6673, 6679, 6689, 6691, 6701, 6703, 6709, 6719, 6733, 6737, 6761, 6763, 6779, 6781, 6791, 6793, 6803, 6823, 6827, 6829, 6833, 6841, 6857, 6863, 6869, 6871, 6883, 6899, 6907, 6911, 6917, 6947, 6949, 6959, 6961, 6967, 6971, 6977, 6983, 6991, 6997, 7001, 7013, 7019, 7027, 7039, 7043, 7057, 7069, 7079, 7103, 7109, 7121, 7127, 7129, 7151, 7159, 7177, 7187, 7193, 7207, 7211, 7213, 7219, 7229, 7237, 7243, 7247, 7253, 7283, 7297, 7307, 7309, 7321, 7331, 7333, 7349, 7351, 7369, 7393, 7411, 7417, 7433, 7451, 7457, 7459, 7477, 7481, 7487, 7489, 7499, 7507, 7517, 7523, 7529, 7537, 7541, 7547, 7549, 7559, 7561, 7573, 7577, 7583, 7589, 7591, 7603, 7607, 7621, 7639, 7643, 7649, 7669, 7673, 7681, 7687, 7691, 7699, 7703, 7717, 7723, 7727, 7741, 7753, 7757, 7759, 7789, 7793, 7817, 7823, 7829, 7841, 7853, 7867, 7873, 7877, 7879, 7883, 7901, 7907, 7919, 7927, 7933, 7937, 7949, 7951, 7963, 7993, 8009, 8011, 8017, 8039, 8053, 8059, 8069, 8081, 8087, 8089, 8093, 8101, 8111, 8117, 8123, 8147, 8161, 8167, 8171, 8179, 8191, 8209, 8219, 8221, 8231, 8233, 8237, 8243, 8263, 8269, 8273, 8287, 8291, 8293, 8297, 8311, 8317, 8329, 8353, 8363, 8369, 8377, 8387, 8389, 8419, 8423, 8429, 8431, 8443, 8447, 8461, 8467, 8501, 8513, 8521, 8527, 8537, 8539, 8543, 8563, 8573, 8581, 8597, 8599, 8609, 8623, 8627, 8629, 8641, 8647, 8663, 8669, 8677, 8681, 8689, 8693, 8699, 8707, 8713, 8719, 8731, 8737, 8741, 8747, 8753, 8761, 8779, 8783, 8803, 8807, 8819, 8821, 8831, 8837, 8839, 8849, 8861, 8863, 8867, 8887, 8893, 8923, 8929, 8933, 8941, 8951, 8963, 8969, 8971, 8999, 9001, 9007, 9011, 9013, 9029, 9041, 9043, 9049, 9059, 9067, 9091, 9103, 9109, 9127, 9133, 9137, 9151, 9157, 9161, 9173, 9181, 9187, 9199, 9203, 9209, 9221, 9227, 9239, 9241, 9257, 9277, 9281, 9283, 9293, 9311, 9319, 9323, 9337, 9341, 9343, 9349, 9371, 9377, 9391, 9397, 9403, 9413, 9419, 9421, 9431, 9433, 9437, 9439, 9461, 9463, 9467, 9473, 9479, 9491, 9497, 9511, 9521, 9533, 9539, 9547, 9551, 9587, 9601, 9613, 9619, 9623, 9629, 9631, 9643, 9649, 9661, 9677, 9679, 9689, 9697, 9719, 9721, 9733, 9739, 9743, 9749, 9767, 9769, 9781, 9787, 9791, 9803, 9811, 9817, 9829, 9833, 9839, 9851, 9857, 9859, 9871, 9883, 9887, 9901, 9907, 9923, 9929, 9931, 9941, 9949, 9967, 9973, 10007]
    },
        _ = Object.prototype.hasOwnProperty,
        d = Object.keys || function (e) {
      var n = [];

      for (var r in e) {
        _.call(e, r) && n.push(r);
      }

      return n;
    };

    function p(e, n) {
      var r = Array.isArray(e),
          t = n || (r ? new Array(e.length) : {});
      return r ? function (e, n) {
        for (var r = 0, t = e.length; r < t; r++) {
          n[r] = e[r];
        }
      }(e, t) : function (e, n) {
        for (var r, t = d(e), a = 0, i = t.length; a < i; a++) {
          n[r = t[a]] = e[r] || n[r];
        }
      }(e, t), t;
    }

    s.prototype.get = function (e) {
      return p(c[e]);
    }, s.prototype.mac_address = function (e) {
      (e = g(e)).separator || (e.separator = e.networkVersion ? "." : ":");
      var n = "ABCDEF1234567890";
      return e.networkVersion ? this.n(this.string, 3, {
        pool: n,
        length: 4
      }).join(e.separator) : this.n(this.string, 6, {
        pool: n,
        length: 2
      }).join(e.separator);
    }, s.prototype.normal = function (e) {
      if (u((e = g(e, {
        mean: 0,
        dev: 1,
        pool: []
      })).pool.constructor !== Array, "Chance: The pool option must be a valid array."), u("number" != typeof e.mean, "Chance: Mean (mean) must be a number"), u("number" != typeof e.dev, "Chance: Standard deviation (dev) must be a number"), 0 < e.pool.length) return this.normal_pool(e);

      for (var n, r, t, a = e.mean, i = e.dev; 1 <= (n = (r = 2 * this.random() - 1) * r + (t = 2 * this.random() - 1) * t);) {
        ;
      }

      return i * (r * Math.sqrt(-2 * Math.log(n) / n)) + a;
    }, s.prototype.normal_pool = function (e) {
      var n = 0;

      do {
        var r = Math.round(this.normal({
          mean: e.mean,
          dev: e.dev
        }));
        if (r < e.pool.length && 0 <= r) return e.pool[r];
        n++;
      } while (n < 100);

      throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
    }, s.prototype.radio = function (e) {
      var n = "";

      switch ((e = g(e, {
        side: "?"
      })).side.toLowerCase()) {
        case "east":
        case "e":
          n = "W";
          break;

        case "west":
        case "w":
          n = "K";
          break;

        default:
          n = this.character({
            pool: "KW"
          });
      }

      return n + this.character({
        alpha: !0,
        casing: "upper"
      }) + this.character({
        alpha: !0,
        casing: "upper"
      }) + this.character({
        alpha: !0,
        casing: "upper"
      });
    }, s.prototype.set = function (e, n) {
      "string" == typeof e ? c[e] = n : c = p(e, c);
    }, s.prototype.tv = function (e) {
      return this.radio(e);
    }, s.prototype.cnpj = function () {
      var e = this.n(this.natural, 8, {
        max: 9
      }),
          n = 2 + 6 * e[7] + 7 * e[6] + 8 * e[5] + 9 * e[4] + 2 * e[3] + 3 * e[2] + 4 * e[1] + 5 * e[0];
      10 <= (n = 11 - n % 11) && (n = 0);
      var r = 2 * n + 3 + 7 * e[7] + 8 * e[6] + 9 * e[5] + 2 * e[4] + 3 * e[3] + 4 * e[2] + 5 * e[1] + 6 * e[0];
      return 10 <= (r = 11 - r % 11) && (r = 0), "" + e[0] + e[1] + "." + e[2] + e[3] + e[4] + "." + e[5] + e[6] + e[7] + "/0001-" + n + r;
    }, s.prototype.mersenne_twister = function (e) {
      return new m(e);
    }, s.prototype.blueimp_md5 = function () {
      return new h();
    };

    var m = function m(e) {
      void 0 === e && (e = Math.floor(Math.random() * Math.pow(10, 13))), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, this.init_genrand(e);
    };

    m.prototype.init_genrand = function (e) {
      for (this.mt[0] = e >>> 0, this.mti = 1; this.mti < this.N; this.mti++) {
        e = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30, this.mt[this.mti] = (1812433253 * ((4294901760 & e) >>> 16) << 16) + 1812433253 * (65535 & e) + this.mti, this.mt[this.mti] >>>= 0;
      }
    }, m.prototype.init_by_array = function (e, n) {
      var r,
          t,
          a = 1,
          i = 0;

      for (this.init_genrand(19650218), r = this.N > n ? this.N : n; r; r--) {
        t = this.mt[a - 1] ^ this.mt[a - 1] >>> 30, this.mt[a] = (this.mt[a] ^ (1664525 * ((4294901760 & t) >>> 16) << 16) + 1664525 * (65535 & t)) + e[i] + i, this.mt[a] >>>= 0, i++, ++a >= this.N && (this.mt[0] = this.mt[this.N - 1], a = 1), n <= i && (i = 0);
      }

      for (r = this.N - 1; r; r--) {
        t = this.mt[a - 1] ^ this.mt[a - 1] >>> 30, this.mt[a] = (this.mt[a] ^ (1566083941 * ((4294901760 & t) >>> 16) << 16) + 1566083941 * (65535 & t)) - a, this.mt[a] >>>= 0, ++a >= this.N && (this.mt[0] = this.mt[this.N - 1], a = 1);
      }

      this.mt[0] = 2147483648;
    }, m.prototype.genrand_int32 = function () {
      var e,
          n = new Array(0, this.MATRIX_A);

      if (this.mti >= this.N) {
        var r;

        for (this.mti === this.N + 1 && this.init_genrand(5489), r = 0; r < this.N - this.M; r++) {
          e = this.mt[r] & this.UPPER_MASK | this.mt[r + 1] & this.LOWER_MASK, this.mt[r] = this.mt[r + this.M] ^ e >>> 1 ^ n[1 & e];
        }

        for (; r < this.N - 1; r++) {
          e = this.mt[r] & this.UPPER_MASK | this.mt[r + 1] & this.LOWER_MASK, this.mt[r] = this.mt[r + (this.M - this.N)] ^ e >>> 1 ^ n[1 & e];
        }

        e = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ e >>> 1 ^ n[1 & e], this.mti = 0;
      }

      return e = this.mt[this.mti++], e ^= e >>> 11, e ^= e << 7 & 2636928640, e ^= e << 15 & 4022730752, (e ^= e >>> 18) >>> 0;
    }, m.prototype.genrand_int31 = function () {
      return this.genrand_int32() >>> 1;
    }, m.prototype.genrand_real1 = function () {
      return this.genrand_int32() * (1 / 4294967295);
    }, m.prototype.random = function () {
      return this.genrand_int32() * (1 / 4294967296);
    }, m.prototype.genrand_real3 = function () {
      return (this.genrand_int32() + .5) * (1 / 4294967296);
    }, m.prototype.genrand_res53 = function () {
      return 1 / 9007199254740992 * (67108864 * (this.genrand_int32() >>> 5) + (this.genrand_int32() >>> 6));
    };

    var h = function h() {};

    h.prototype.VERSION = "1.0.1", h.prototype.safe_add = function (e, n) {
      var r = (65535 & e) + (65535 & n);
      return (e >> 16) + (n >> 16) + (r >> 16) << 16 | 65535 & r;
    }, h.prototype.bit_roll = function (e, n) {
      return e << n | e >>> 32 - n;
    }, h.prototype.md5_cmn = function (e, n, r, t, a, i) {
      return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(n, e), this.safe_add(t, i)), a), r);
    }, h.prototype.md5_ff = function (e, n, r, t, a, i, A) {
      return this.md5_cmn(n & r | ~n & t, e, n, a, i, A);
    }, h.prototype.md5_gg = function (e, n, r, t, a, i, A) {
      return this.md5_cmn(n & t | r & ~t, e, n, a, i, A);
    }, h.prototype.md5_hh = function (e, n, r, t, a, i, A) {
      return this.md5_cmn(n ^ r ^ t, e, n, a, i, A);
    }, h.prototype.md5_ii = function (e, n, r, t, a, i, A) {
      return this.md5_cmn(r ^ (n | ~t), e, n, a, i, A);
    }, h.prototype.binl_md5 = function (e, n) {
      e[n >> 5] |= 128 << n % 32, e[14 + (n + 64 >>> 9 << 4)] = n;
      var r,
          t,
          a,
          i,
          A,
          o = 1732584193,
          s = -271733879,
          c = -1732584194,
          l = 271733878;

      for (r = 0; r < e.length; r += 16) {
        t = o, a = s, i = c, A = l, o = this.md5_ff(o, s, c, l, e[r], 7, -680876936), l = this.md5_ff(l, o, s, c, e[r + 1], 12, -389564586), c = this.md5_ff(c, l, o, s, e[r + 2], 17, 606105819), s = this.md5_ff(s, c, l, o, e[r + 3], 22, -1044525330), o = this.md5_ff(o, s, c, l, e[r + 4], 7, -176418897), l = this.md5_ff(l, o, s, c, e[r + 5], 12, 1200080426), c = this.md5_ff(c, l, o, s, e[r + 6], 17, -1473231341), s = this.md5_ff(s, c, l, o, e[r + 7], 22, -45705983), o = this.md5_ff(o, s, c, l, e[r + 8], 7, 1770035416), l = this.md5_ff(l, o, s, c, e[r + 9], 12, -1958414417), c = this.md5_ff(c, l, o, s, e[r + 10], 17, -42063), s = this.md5_ff(s, c, l, o, e[r + 11], 22, -1990404162), o = this.md5_ff(o, s, c, l, e[r + 12], 7, 1804603682), l = this.md5_ff(l, o, s, c, e[r + 13], 12, -40341101), c = this.md5_ff(c, l, o, s, e[r + 14], 17, -1502002290), s = this.md5_ff(s, c, l, o, e[r + 15], 22, 1236535329), o = this.md5_gg(o, s, c, l, e[r + 1], 5, -165796510), l = this.md5_gg(l, o, s, c, e[r + 6], 9, -1069501632), c = this.md5_gg(c, l, o, s, e[r + 11], 14, 643717713), s = this.md5_gg(s, c, l, o, e[r], 20, -373897302), o = this.md5_gg(o, s, c, l, e[r + 5], 5, -701558691), l = this.md5_gg(l, o, s, c, e[r + 10], 9, 38016083), c = this.md5_gg(c, l, o, s, e[r + 15], 14, -660478335), s = this.md5_gg(s, c, l, o, e[r + 4], 20, -405537848), o = this.md5_gg(o, s, c, l, e[r + 9], 5, 568446438), l = this.md5_gg(l, o, s, c, e[r + 14], 9, -1019803690), c = this.md5_gg(c, l, o, s, e[r + 3], 14, -187363961), s = this.md5_gg(s, c, l, o, e[r + 8], 20, 1163531501), o = this.md5_gg(o, s, c, l, e[r + 13], 5, -1444681467), l = this.md5_gg(l, o, s, c, e[r + 2], 9, -51403784), c = this.md5_gg(c, l, o, s, e[r + 7], 14, 1735328473), s = this.md5_gg(s, c, l, o, e[r + 12], 20, -1926607734), o = this.md5_hh(o, s, c, l, e[r + 5], 4, -378558), l = this.md5_hh(l, o, s, c, e[r + 8], 11, -2022574463), c = this.md5_hh(c, l, o, s, e[r + 11], 16, 1839030562), s = this.md5_hh(s, c, l, o, e[r + 14], 23, -35309556), o = this.md5_hh(o, s, c, l, e[r + 1], 4, -1530992060), l = this.md5_hh(l, o, s, c, e[r + 4], 11, 1272893353), c = this.md5_hh(c, l, o, s, e[r + 7], 16, -155497632), s = this.md5_hh(s, c, l, o, e[r + 10], 23, -1094730640), o = this.md5_hh(o, s, c, l, e[r + 13], 4, 681279174), l = this.md5_hh(l, o, s, c, e[r], 11, -358537222), c = this.md5_hh(c, l, o, s, e[r + 3], 16, -722521979), s = this.md5_hh(s, c, l, o, e[r + 6], 23, 76029189), o = this.md5_hh(o, s, c, l, e[r + 9], 4, -640364487), l = this.md5_hh(l, o, s, c, e[r + 12], 11, -421815835), c = this.md5_hh(c, l, o, s, e[r + 15], 16, 530742520), s = this.md5_hh(s, c, l, o, e[r + 2], 23, -995338651), o = this.md5_ii(o, s, c, l, e[r], 6, -198630844), l = this.md5_ii(l, o, s, c, e[r + 7], 10, 1126891415), c = this.md5_ii(c, l, o, s, e[r + 14], 15, -1416354905), s = this.md5_ii(s, c, l, o, e[r + 5], 21, -57434055), o = this.md5_ii(o, s, c, l, e[r + 12], 6, 1700485571), l = this.md5_ii(l, o, s, c, e[r + 3], 10, -1894986606), c = this.md5_ii(c, l, o, s, e[r + 10], 15, -1051523), s = this.md5_ii(s, c, l, o, e[r + 1], 21, -2054922799), o = this.md5_ii(o, s, c, l, e[r + 8], 6, 1873313359), l = this.md5_ii(l, o, s, c, e[r + 15], 10, -30611744), c = this.md5_ii(c, l, o, s, e[r + 6], 15, -1560198380), s = this.md5_ii(s, c, l, o, e[r + 13], 21, 1309151649), o = this.md5_ii(o, s, c, l, e[r + 4], 6, -145523070), l = this.md5_ii(l, o, s, c, e[r + 11], 10, -1120210379), c = this.md5_ii(c, l, o, s, e[r + 2], 15, 718787259), s = this.md5_ii(s, c, l, o, e[r + 9], 21, -343485551), o = this.safe_add(o, t), s = this.safe_add(s, a), c = this.safe_add(c, i), l = this.safe_add(l, A);
      }

      return [o, s, c, l];
    }, h.prototype.binl2rstr = function (e) {
      var n,
          r = "";

      for (n = 0; n < 32 * e.length; n += 8) {
        r += String.fromCharCode(e[n >> 5] >>> n % 32 & 255);
      }

      return r;
    }, h.prototype.rstr2binl = function (e) {
      var n,
          r = [];

      for (r[(e.length >> 2) - 1] = void 0, n = 0; n < r.length; n += 1) {
        r[n] = 0;
      }

      for (n = 0; n < 8 * e.length; n += 8) {
        r[n >> 5] |= (255 & e.charCodeAt(n / 8)) << n % 32;
      }

      return r;
    }, h.prototype.rstr_md5 = function (e) {
      return this.binl2rstr(this.binl_md5(this.rstr2binl(e), 8 * e.length));
    }, h.prototype.rstr_hmac_md5 = function (e, n) {
      var r,
          t,
          a = this.rstr2binl(e),
          i = [],
          A = [];

      for (i[15] = A[15] = void 0, 16 < a.length && (a = this.binl_md5(a, 8 * e.length)), r = 0; r < 16; r += 1) {
        i[r] = 909522486 ^ a[r], A[r] = 1549556828 ^ a[r];
      }

      return t = this.binl_md5(i.concat(this.rstr2binl(n)), 512 + 8 * n.length), this.binl2rstr(this.binl_md5(A.concat(t), 640));
    }, h.prototype.rstr2hex = function (e) {
      var n,
          r,
          t = "0123456789abcdef",
          a = "";

      for (r = 0; r < e.length; r += 1) {
        n = e.charCodeAt(r), a += t.charAt(n >>> 4 & 15) + t.charAt(15 & n);
      }

      return a;
    }, h.prototype.str2rstr_utf8 = function (e) {
      return unescape(encodeURIComponent(e));
    }, h.prototype.raw_md5 = function (e) {
      return this.rstr_md5(this.str2rstr_utf8(e));
    }, h.prototype.hex_md5 = function (e) {
      return this.rstr2hex(this.raw_md5(e));
    }, h.prototype.raw_hmac_md5 = function (e, n) {
      return this.rstr_hmac_md5(this.str2rstr_utf8(e), this.str2rstr_utf8(n));
    }, h.prototype.hex_hmac_md5 = function (e, n) {
      return this.rstr2hex(this.raw_hmac_md5(e, n));
    }, h.prototype.md5 = function (e, n, r) {
      return n ? r ? this.raw_hmac_md5(n, e) : this.hex_hmac_md5(n, e) : r ? this.raw_md5(e) : this.hex_md5(e);
    }, B.exports && (f = B.exports = s), f.Chance = s, "undefined" != typeof importScripts && (chance = new s(), self.Chance = s), "object" == typeof window && "object" == typeof window.document && (window.Chance = s, window.chance = new s());
  }();
}),
    chance_2 = chance_1.Chance,
    DustCanvas = posed.canvas({
  visible: {
    opacity: 1,
    transition: {
      duration: 2e3
    },
    filter: "blur(0)",
    y: 0,
    x: 0,
    rotate: 0
  },
  hidden: {
    opacity: 0,
    y: function y(e) {
      return e.y;
    },
    x: function x(e) {
      return e.x;
    },
    rotate: function rotate(e) {
      return e.rotate;
    },
    transition: {
      duration: 2e3
    },
    filter: "blur(2px)"
  }
});

function Dust(e) {
  return React__default.createElement(DustCanvas, _extends({}, e, {
    ref: e.forwardedRef
  }));
}

var chance$1 = new chance_1();

function weightedRandomDistrib(e, n) {
  for (var r = [], t = [], a = 0; a < n; a++) {
    r.push(Math.pow(n - Math.abs(e - a), 3)), t.push(a);
  }

  return chance$1.weighted(t, r);
}

function createBlankImageData(e, n) {
  for (var r = [], t = 0; t < n; t++) {
    for (var a = new Uint8ClampedArray(e.data), i = 0; i < a.length; i++) {
      a[i] = 0;
    }

    r.push(a);
  }

  return r;
}

function generateBlankCanvas(e, n, r, t) {
  for (var a = [], i = 0; i < r; i++) {
    var A = {
      key: i,
      style: {
        position: "absolute",
        zIndex: t - 1
      },
      pose: n,
      x: 75,
      y: -75,
      rotate: chance$1.integer({
        min: -20,
        max: 20
      }),
      forwardedRef: e.current[i]
    };
    a.push(React__default.createElement(Dust, _extends({}, A, {
      ref: e.current[i]
    })));
  }

  return a;
}

var canvasCount = 32,
    imageDataArray = [],
    CanvasContainer = posed.div({
  hidden: {
    delayChildren: 200,
    staggerChildren: 35,
    filter: "blur(1px)"
  },
  visible: {
    delayChildren: 200,
    staggerChildren: 35,
    filter: "blur(0)"
  }
}),
    OriginalElement = posed.div({
  visible: {
    opacity: 1,
    filter: "blur(0)",
    transition: {
      delay: 3320,
      duration: 1500
    }
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: 1e3
    },
    filter: "blur(1px)"
  }
});

function handleSnap(e, s, n, r, t, a) {
  t(!0), r ? 0 === imageDataArray.length ? html2canvas$1(e.current, {
    scale: 1,
    backgroundColor: null,
    proxy: a,
    useCORS: !0
  }).then(function (e) {
    var t = e.width,
        a = e.height,
        n = e.getContext("2d").getImageData(0, 0, t, a),
        r = n.data;
    imageDataArray = createBlankImageData(n, canvasCount);

    for (var i = 0; i <= r.length; i += 4) {
      var A = Math.floor(i / r.length * canvasCount),
          o = imageDataArray[weightedRandomDistrib(A, canvasCount)];
      o[i] = r[i], o[i + 1] = r[i + 1], o[i + 2] = r[i + 2], o[i + 3] = r[i + 3];
    }

    s.current.map(function (e, n) {
      var r = e.current.getContext("2d");
      e.current.width = t, e.current.height = a, r.putImageData(new ImageData(imageDataArray[n], t, a), 0, 0);
    });
  }).then(function () {
    n("hidden");
  }) : n("hidden") : n("visible");
}

function InfinityGauntlet(e) {
  var n = e.options,
      r = e.snap,
      t = (e.style, React.useRef()),
      a = _slicedToArray(React.useState("visible"), 2),
      i = a[0],
      A = a[1],
      o = _slicedToArray(React.useState(!0), 2),
      s = o[0],
      c = o[1],
      l = React.useRef(_toConsumableArray(Array(canvasCount)).map(function () {
    return React.createRef();
  })),
      u = n && n.zIndex || 2,
      _ = generateBlankCanvas(l, i, canvasCount, u);

  return React.useEffect(function () {
    handleSnap(t, l, A, r, c, n.proxy);
  }, [r]), React__default.createElement("div", {
    style: _objectSpread({
      position: "relative"
    }, e.style)
  }, React__default.createElement(OriginalElement, {
    pose: i,
    onPoseComplete: function onPoseComplete() {
      "visible" === i && c(!1);
    },
    ref: t,
    style: {
      position: "absolute",
      zIndex: u,
      width: "100%"
    }
  }, e.children), React__default.createElement(CanvasContainer, {
    style: {
      display: s ? "block" : "none"
    },
    key: 1,
    pose: i
  }, _));
}

InfinityGauntlet.defaultProps = {
  style: {},
  snap: !1,
  options: {
    zIndex: 2,
    proxy: null
  }
}, module.exports = InfinityGauntlet;